
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb844"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb844"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cxTnx", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

/*-----------------
    PAGE LOADER 
-----------------*/ var $342f7fe00eb414e4$exports = {};
const $342f7fe00eb414e4$var$app = {
    deepExtend: function(a, b) {
        for(const prop in b)if (typeof b[prop] === "object") {
            a[prop] = b[prop] instanceof Array ? [] : {};
            this.deepExtend(a[prop], b[prop]);
        } else a[prop] = b[prop];
    },
    query: function(options) {
        const config = {
            method: "GET",
            async: true,
            header: {
                type: "Content-type",
                value: "application/json"
            },
            data: ""
        };
        this.deepExtend(config, options);
        return new Promise(function(resolve, reject) {
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState !== 4) return;
                if (xhttp.status === 200) resolve(xhttp.responseText);
                else reject({
                    status: xhttp.status,
                    statusText: xhttp.statusText
                });
            };
            xhttp.open(config.method, config.url, config.async);
            xhttp.setRequestHeader(config.header.type, config.header.value);
            if (config.method === "GET") xhttp.send();
            else if (config.method === "POST") xhttp.send(config.data);
        });
    },
    querySelector: function(selector, callback) {
        const el = document.querySelectorAll(selector);
        if (el.length) callback(el);
    },
    liquidify: function(el) {
        const image = el.querySelector("img"), imageSrc = image.getAttribute("src");
        image.style.display = "none";
        el.style.background = `url("${imageSrc}") no-repeat center`;
        el.style.backgroundSize = "cover";
    },
    liquidifyStatic: function(figure, image) {
        image.style.display = "none";
        figure.style.background = `url("${image.getAttribute("src")}") no-repeat center`;
        figure.style.backgroundSize = "cover";
    },
    dateDiff: function(date1, date2 = new Date()) {
        const timeDiff = Math.abs(date1.getTime() - date2.getTime()), secondsDiff = Math.ceil(timeDiff / 1000), minutesDiff = Math.floor(timeDiff / 60000), hoursDiff = Math.floor(timeDiff / 3600000), daysDiff = Math.floor(timeDiff / 86400000), weeksDiff = Math.floor(timeDiff / 604800000), monthsDiff = Math.floor(timeDiff / 2419200000), yearsDiff = Math.floor(timeDiff / 29030400000);
        let unit;
        if (secondsDiff < 60) {
            unit = secondsDiff === 1 ? "second" : "seconds";
            return {
                unit: unit,
                value: secondsDiff
            };
        } else if (minutesDiff < 60) {
            unit = minutesDiff === 1 ? "minute" : "minutes";
            return {
                unit: unit,
                value: minutesDiff
            };
        } else if (hoursDiff < 24) {
            unit = hoursDiff === 1 ? "hour" : "hours";
            return {
                unit: unit,
                value: hoursDiff
            };
        } else if (daysDiff < 7) {
            unit = daysDiff === 1 ? "day" : "days";
            return {
                unit: unit,
                value: daysDiff
            };
        } else if (weeksDiff < 4) {
            unit = weeksDiff === 1 ? "week" : "weeks";
            return {
                unit: unit,
                value: weeksDiff
            };
        } else if (monthsDiff < 12) {
            unit = monthsDiff === 1 ? "month" : "months";
            return {
                unit: unit,
                value: monthsDiff
            };
        } else {
            unit = yearsDiff === 1 ? "year" : "years";
            return {
                unit: unit,
                value: yearsDiff
            };
        }
    }
};
$342f7fe00eb414e4$exports = $342f7fe00eb414e4$var$app;


$342f7fe00eb414e4$exports.querySelector(".page-loader", function(el) {
    const pageLoader = el[0];
    const hidePageLoader = function() {
        pageLoader.classList.add("hidden");
    };
    window.addEventListener("load", hidePageLoader);
});


/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ "use strict";
var $e1a4c6e14767f41c$exports = {};
"use strict";
var $a7e68d87528d04a9$exports = {};
"use strict";
var $1f3655405faf4b93$exports = {};
"use strict";
var $1f3655405faf4b93$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$1f3655405faf4b93$exports = // eslint-disable-next-line es/no-global-this -- safe
$1f3655405faf4b93$var$check(typeof globalThis == "object" && globalThis) || $1f3655405faf4b93$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$1f3655405faf4b93$var$check(typeof self == "object" && self) || $1f3655405faf4b93$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $1f3655405faf4b93$exports || Function("return this")();


var $c761b911d1948532$exports = {};
"use strict";
var $5c612855d4d64a1d$exports = {};
"use strict";
$5c612855d4d64a1d$exports = false;


var $e44b1d7dc99fa8dc$exports = {};
"use strict";

var $43431a1908021c5f$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $43431a1908021c5f$var$defineProperty = Object.defineProperty;
$43431a1908021c5f$exports = function(key, value) {
    try {
        $43431a1908021c5f$var$defineProperty($1f3655405faf4b93$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $1f3655405faf4b93$exports[key] = value;
    }
    return value;
};


var $e44b1d7dc99fa8dc$var$SHARED = "__core-js_shared__";
var $e44b1d7dc99fa8dc$var$store = $1f3655405faf4b93$exports[$e44b1d7dc99fa8dc$var$SHARED] || $43431a1908021c5f$exports($e44b1d7dc99fa8dc$var$SHARED, {});
$e44b1d7dc99fa8dc$exports = $e44b1d7dc99fa8dc$var$store;


($c761b911d1948532$exports = function(key, value) {
    return $e44b1d7dc99fa8dc$exports[key] || ($e44b1d7dc99fa8dc$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.33.1",
    mode: $5c612855d4d64a1d$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.33.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $7d2461ccc847d891$exports = {};
"use strict";
var $e5e00809db8eb123$exports = {};
"use strict";
var $c3c0a5f76e5e916e$exports = {};
"use strict";
var $1eae0a73b36f2464$exports = {};
"use strict";
$1eae0a73b36f2464$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


$c3c0a5f76e5e916e$exports = !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $e5e00809db8eb123$var$FunctionPrototype = Function.prototype;
var $e5e00809db8eb123$var$call = $e5e00809db8eb123$var$FunctionPrototype.call;
var $e5e00809db8eb123$var$uncurryThisWithBind = $c3c0a5f76e5e916e$exports && $e5e00809db8eb123$var$FunctionPrototype.bind.bind($e5e00809db8eb123$var$call, $e5e00809db8eb123$var$call);
$e5e00809db8eb123$exports = $c3c0a5f76e5e916e$exports ? $e5e00809db8eb123$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $e5e00809db8eb123$var$call.apply(fn, arguments);
    };
};


var $563602a94d4dc012$exports = {};
"use strict";
var $fb9649058d88e05e$exports = {};
"use strict";
var $c9cec627d9a032db$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c9cec627d9a032db$exports = function(it) {
    return it === null || it === undefined;
};


var $fb9649058d88e05e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$fb9649058d88e05e$exports = function(it) {
    if ($c9cec627d9a032db$exports(it)) throw new $fb9649058d88e05e$var$$TypeError("Can't call method on " + it);
    return it;
};


var $563602a94d4dc012$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$563602a94d4dc012$exports = function(argument) {
    return $563602a94d4dc012$var$$Object($fb9649058d88e05e$exports(argument));
};


var $7d2461ccc847d891$var$hasOwnProperty = $e5e00809db8eb123$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$7d2461ccc847d891$exports = Object.hasOwn || function hasOwn(it, key) {
    return $7d2461ccc847d891$var$hasOwnProperty($563602a94d4dc012$exports(it), key);
};


var $09622dafccffa283$exports = {};
"use strict";

var $09622dafccffa283$var$id = 0;
var $09622dafccffa283$var$postfix = Math.random();
var $09622dafccffa283$var$toString = $e5e00809db8eb123$exports(1.0.toString);
$09622dafccffa283$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $09622dafccffa283$var$toString(++$09622dafccffa283$var$id + $09622dafccffa283$var$postfix, 36);
};


var $6414afa0b3d0491a$exports = {};
"use strict";
var $e686f780cf055b91$exports = {};
"use strict";

var $e37ccc3a3c9edcb0$exports = {};
"use strict";
$e37ccc3a3c9edcb0$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $e686f780cf055b91$var$process = $1f3655405faf4b93$exports.process;
var $e686f780cf055b91$var$Deno = $1f3655405faf4b93$exports.Deno;
var $e686f780cf055b91$var$versions = $e686f780cf055b91$var$process && $e686f780cf055b91$var$process.versions || $e686f780cf055b91$var$Deno && $e686f780cf055b91$var$Deno.version;
var $e686f780cf055b91$var$v8 = $e686f780cf055b91$var$versions && $e686f780cf055b91$var$versions.v8;
var $e686f780cf055b91$var$match, $e686f780cf055b91$var$version;
if ($e686f780cf055b91$var$v8) {
    $e686f780cf055b91$var$match = $e686f780cf055b91$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e686f780cf055b91$var$version = $e686f780cf055b91$var$match[0] > 0 && $e686f780cf055b91$var$match[0] < 4 ? 1 : +($e686f780cf055b91$var$match[0] + $e686f780cf055b91$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e686f780cf055b91$var$version && $e37ccc3a3c9edcb0$exports) {
    $e686f780cf055b91$var$match = $e37ccc3a3c9edcb0$exports.match(/Edge\/(\d+)/);
    if (!$e686f780cf055b91$var$match || $e686f780cf055b91$var$match[1] >= 74) {
        $e686f780cf055b91$var$match = $e37ccc3a3c9edcb0$exports.match(/Chrome\/(\d+)/);
        if ($e686f780cf055b91$var$match) $e686f780cf055b91$var$version = +$e686f780cf055b91$var$match[1];
    }
}
$e686f780cf055b91$exports = $e686f780cf055b91$var$version;




var $6414afa0b3d0491a$var$$String = $1f3655405faf4b93$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$6414afa0b3d0491a$exports = !!Object.getOwnPropertySymbols && !$1eae0a73b36f2464$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$6414afa0b3d0491a$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e686f780cf055b91$exports && $e686f780cf055b91$exports < 41;
});


var $b44ec27087c1b405$exports = {};
"use strict";

$b44ec27087c1b405$exports = $6414afa0b3d0491a$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $a7e68d87528d04a9$var$Symbol = $1f3655405faf4b93$exports.Symbol;
var $a7e68d87528d04a9$var$WellKnownSymbolsStore = $c761b911d1948532$exports("wks");
var $a7e68d87528d04a9$var$createWellKnownSymbol = $b44ec27087c1b405$exports ? $a7e68d87528d04a9$var$Symbol["for"] || $a7e68d87528d04a9$var$Symbol : $a7e68d87528d04a9$var$Symbol && $a7e68d87528d04a9$var$Symbol.withoutSetter || $09622dafccffa283$exports;
$a7e68d87528d04a9$exports = function(name) {
    if (!$7d2461ccc847d891$exports($a7e68d87528d04a9$var$WellKnownSymbolsStore, name)) $a7e68d87528d04a9$var$WellKnownSymbolsStore[name] = $6414afa0b3d0491a$exports && $7d2461ccc847d891$exports($a7e68d87528d04a9$var$Symbol, name) ? $a7e68d87528d04a9$var$Symbol[name] : $a7e68d87528d04a9$var$createWellKnownSymbol("Symbol." + name);
    return $a7e68d87528d04a9$var$WellKnownSymbolsStore[name];
};


var $e1a4c6e14767f41c$var$TO_STRING_TAG = $a7e68d87528d04a9$exports("toStringTag");
var $e1a4c6e14767f41c$var$test = {};
$e1a4c6e14767f41c$var$test[$e1a4c6e14767f41c$var$TO_STRING_TAG] = "z";
$e1a4c6e14767f41c$exports = String($e1a4c6e14767f41c$var$test) === "[object z]";


var $bf5de196043a4fd2$exports = {};
"use strict";
var $9261b09349da61cf$exports = {};
"use strict";
var $944ab8dbcfc949c5$exports = {};
"use strict";
var $944ab8dbcfc949c5$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $944ab8dbcfc949c5$var$IS_HTMLDDA = typeof $944ab8dbcfc949c5$var$documentAll == "undefined" && $944ab8dbcfc949c5$var$documentAll !== undefined;
$944ab8dbcfc949c5$exports = {
    all: $944ab8dbcfc949c5$var$documentAll,
    IS_HTMLDDA: $944ab8dbcfc949c5$var$IS_HTMLDDA
};


var $9261b09349da61cf$var$documentAll = $944ab8dbcfc949c5$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$9261b09349da61cf$exports = $944ab8dbcfc949c5$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $9261b09349da61cf$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9ed44e563230b16a$export$2d1720544b23b823;
"use strict";
var $1b14517606367da3$exports = {};
"use strict";

// Detect IE8's incomplete defineProperty implementation
$1b14517606367da3$exports = !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $c6249751f0bc488c$exports = {};
"use strict";


var $af583e15a6d46412$exports = {};
"use strict";

var $2b8a0370e236b736$exports = {};
"use strict";


var $2b8a0370e236b736$var$documentAll = $944ab8dbcfc949c5$exports.all;
$2b8a0370e236b736$exports = $944ab8dbcfc949c5$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $9261b09349da61cf$exports(it) || it === $2b8a0370e236b736$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $9261b09349da61cf$exports(it);
};


var $af583e15a6d46412$var$document = $1f3655405faf4b93$exports.document;
// typeof document.createElement is 'object' in old IE
var $af583e15a6d46412$var$EXISTS = $2b8a0370e236b736$exports($af583e15a6d46412$var$document) && $2b8a0370e236b736$exports($af583e15a6d46412$var$document.createElement);
$af583e15a6d46412$exports = function(it) {
    return $af583e15a6d46412$var$EXISTS ? $af583e15a6d46412$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$c6249751f0bc488c$exports = !$1b14517606367da3$exports && !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($af583e15a6d46412$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $1981a0d5783b0827$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$1981a0d5783b0827$exports = $1b14517606367da3$exports && $1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $3843f2a291eb95b4$exports = {};
"use strict";

var $3843f2a291eb95b4$var$$String = String;
var $3843f2a291eb95b4$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3843f2a291eb95b4$exports = function(argument) {
    if ($2b8a0370e236b736$exports(argument)) return argument;
    throw new $3843f2a291eb95b4$var$$TypeError($3843f2a291eb95b4$var$$String(argument) + " is not an object");
};


var $eddfdd2f934c39a2$exports = {};
"use strict";
var $9224436324702004$exports = {};
"use strict";
var $52ac2d1f7b3fc221$exports = {};
"use strict";

var $52ac2d1f7b3fc221$var$call = Function.prototype.call;
$52ac2d1f7b3fc221$exports = $c3c0a5f76e5e916e$exports ? $52ac2d1f7b3fc221$var$call.bind($52ac2d1f7b3fc221$var$call) : function() {
    return $52ac2d1f7b3fc221$var$call.apply($52ac2d1f7b3fc221$var$call, arguments);
};



var $325cc76d61657af3$exports = {};
"use strict";
var $6bf58ff2790e62e4$exports = {};
"use strict";


var $6bf58ff2790e62e4$var$aFunction = function(argument) {
    return $9261b09349da61cf$exports(argument) ? argument : undefined;
};
$6bf58ff2790e62e4$exports = function(namespace, method) {
    return arguments.length < 2 ? $6bf58ff2790e62e4$var$aFunction($1f3655405faf4b93$exports[namespace]) : $1f3655405faf4b93$exports[namespace] && $1f3655405faf4b93$exports[namespace][method];
};



var $599d3f84718534dc$exports = {};
"use strict";

$599d3f84718534dc$exports = $e5e00809db8eb123$exports({}.isPrototypeOf);



var $325cc76d61657af3$var$$Object = Object;
$325cc76d61657af3$exports = $b44ec27087c1b405$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $6bf58ff2790e62e4$exports("Symbol");
    return $9261b09349da61cf$exports($Symbol) && $599d3f84718534dc$exports($Symbol.prototype, $325cc76d61657af3$var$$Object(it));
};


var $7449e8f88cb85375$exports = {};
"use strict";
var $828965f5bec31db8$exports = {};
"use strict";

var $4684c592a1598de6$exports = {};
"use strict";
var $4684c592a1598de6$var$$String = String;
$4684c592a1598de6$exports = function(argument) {
    try {
        return $4684c592a1598de6$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $828965f5bec31db8$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$828965f5bec31db8$exports = function(argument) {
    if ($9261b09349da61cf$exports(argument)) return argument;
    throw new $828965f5bec31db8$var$$TypeError($4684c592a1598de6$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$7449e8f88cb85375$exports = function(V, P) {
    var func = V[P];
    return $c9cec627d9a032db$exports(func) ? undefined : $828965f5bec31db8$exports(func);
};


var $8cb92c64da7bae7c$exports = {};
"use strict";



var $8cb92c64da7bae7c$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$8cb92c64da7bae7c$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $9261b09349da61cf$exports(fn = input.toString) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    if ($9261b09349da61cf$exports(fn = input.valueOf) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    if (pref !== "string" && $9261b09349da61cf$exports(fn = input.toString) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    throw new $8cb92c64da7bae7c$var$$TypeError("Can't convert object to primitive value");
};



var $9224436324702004$var$$TypeError = TypeError;
var $9224436324702004$var$TO_PRIMITIVE = $a7e68d87528d04a9$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$9224436324702004$exports = function(input, pref) {
    if (!$2b8a0370e236b736$exports(input) || $325cc76d61657af3$exports(input)) return input;
    var exoticToPrim = $7449e8f88cb85375$exports(input, $9224436324702004$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $52ac2d1f7b3fc221$exports(exoticToPrim, input, pref);
        if (!$2b8a0370e236b736$exports(result) || $325cc76d61657af3$exports(result)) return result;
        throw new $9224436324702004$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $8cb92c64da7bae7c$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$eddfdd2f934c39a2$exports = function(argument) {
    var key = $9224436324702004$exports(argument, "string");
    return $325cc76d61657af3$exports(key) ? key : key + "";
};


var $9ed44e563230b16a$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9ed44e563230b16a$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9ed44e563230b16a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9ed44e563230b16a$var$ENUMERABLE = "enumerable";
var $9ed44e563230b16a$var$CONFIGURABLE = "configurable";
var $9ed44e563230b16a$var$WRITABLE = "writable";
$9ed44e563230b16a$export$2d1720544b23b823 = $1b14517606367da3$exports ? $1981a0d5783b0827$exports ? function defineProperty(O, P, Attributes) {
    $3843f2a291eb95b4$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    $3843f2a291eb95b4$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $9ed44e563230b16a$var$WRITABLE in Attributes && !Attributes[$9ed44e563230b16a$var$WRITABLE]) {
        var current = $9ed44e563230b16a$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9ed44e563230b16a$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9ed44e563230b16a$var$CONFIGURABLE in Attributes ? Attributes[$9ed44e563230b16a$var$CONFIGURABLE] : current[$9ed44e563230b16a$var$CONFIGURABLE],
                enumerable: $9ed44e563230b16a$var$ENUMERABLE in Attributes ? Attributes[$9ed44e563230b16a$var$ENUMERABLE] : current[$9ed44e563230b16a$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9ed44e563230b16a$var$$defineProperty(O, P, Attributes);
} : $9ed44e563230b16a$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3843f2a291eb95b4$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    $3843f2a291eb95b4$exports(Attributes);
    if ($c6249751f0bc488c$exports) try {
        return $9ed44e563230b16a$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $9ed44e563230b16a$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $93b6f46cc432668a$exports = {};
"use strict";





var $93fac42f9e89a850$exports = {};
"use strict";


var $93fac42f9e89a850$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $93fac42f9e89a850$var$getDescriptor = $1b14517606367da3$exports && Object.getOwnPropertyDescriptor;
var $93fac42f9e89a850$var$EXISTS = $7d2461ccc847d891$exports($93fac42f9e89a850$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $93fac42f9e89a850$var$PROPER = $93fac42f9e89a850$var$EXISTS && (function something() {}).name === "something";
var $93fac42f9e89a850$var$CONFIGURABLE = $93fac42f9e89a850$var$EXISTS && (!$1b14517606367da3$exports || $1b14517606367da3$exports && $93fac42f9e89a850$var$getDescriptor($93fac42f9e89a850$var$FunctionPrototype, "name").configurable);
$93fac42f9e89a850$exports = {
    EXISTS: $93fac42f9e89a850$var$EXISTS,
    PROPER: $93fac42f9e89a850$var$PROPER,
    CONFIGURABLE: $93fac42f9e89a850$var$CONFIGURABLE
};


var $93b6f46cc432668a$require$CONFIGURABLE_FUNCTION_NAME = $93fac42f9e89a850$exports.CONFIGURABLE;
var $83eb0f09c907b53d$exports = {};
"use strict";



var $83eb0f09c907b53d$var$functionToString = $e5e00809db8eb123$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$9261b09349da61cf$exports($e44b1d7dc99fa8dc$exports.inspectSource)) $e44b1d7dc99fa8dc$exports.inspectSource = function(it) {
    return $83eb0f09c907b53d$var$functionToString(it);
};
$83eb0f09c907b53d$exports = $e44b1d7dc99fa8dc$exports.inspectSource;


var $b8c75d97df4614cd$exports = {};
"use strict";
var $b29a2b5771651d66$exports = {};
"use strict";


var $b29a2b5771651d66$var$WeakMap = $1f3655405faf4b93$exports.WeakMap;
$b29a2b5771651d66$exports = $9261b09349da61cf$exports($b29a2b5771651d66$var$WeakMap) && /native code/.test(String($b29a2b5771651d66$var$WeakMap));




var $11de2b231b2859ac$exports = {};
"use strict";


var $0606df0cd9938668$exports = {};
"use strict";
$0606df0cd9938668$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$11de2b231b2859ac$exports = $1b14517606367da3$exports ? function(object, key, value) {
    return $9ed44e563230b16a$export$2d1720544b23b823(object, key, $0606df0cd9938668$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $6f16eb1940d3afb7$exports = {};
"use strict";


var $6f16eb1940d3afb7$var$keys = $c761b911d1948532$exports("keys");
$6f16eb1940d3afb7$exports = function(key) {
    return $6f16eb1940d3afb7$var$keys[key] || ($6f16eb1940d3afb7$var$keys[key] = $09622dafccffa283$exports(key));
};


var $0796b0af43a3801a$exports = {};
"use strict";
$0796b0af43a3801a$exports = {};


var $b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $b8c75d97df4614cd$var$TypeError = $1f3655405faf4b93$exports.TypeError;
var $b8c75d97df4614cd$var$WeakMap = $1f3655405faf4b93$exports.WeakMap;
var $b8c75d97df4614cd$var$set, $b8c75d97df4614cd$var$get, $b8c75d97df4614cd$var$has;
var $b8c75d97df4614cd$var$enforce = function(it) {
    return $b8c75d97df4614cd$var$has(it) ? $b8c75d97df4614cd$var$get(it) : $b8c75d97df4614cd$var$set(it, {});
};
var $b8c75d97df4614cd$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$2b8a0370e236b736$exports(it) || (state = $b8c75d97df4614cd$var$get(it)).type !== TYPE) throw new $b8c75d97df4614cd$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($b29a2b5771651d66$exports || $e44b1d7dc99fa8dc$exports.state) {
    var $b8c75d97df4614cd$var$store = $e44b1d7dc99fa8dc$exports.state || ($e44b1d7dc99fa8dc$exports.state = new $b8c75d97df4614cd$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b8c75d97df4614cd$var$store.get = $b8c75d97df4614cd$var$store.get;
    $b8c75d97df4614cd$var$store.has = $b8c75d97df4614cd$var$store.has;
    $b8c75d97df4614cd$var$store.set = $b8c75d97df4614cd$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b8c75d97df4614cd$var$set = function(it, metadata) {
        if ($b8c75d97df4614cd$var$store.has(it)) throw new $b8c75d97df4614cd$var$TypeError($b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b8c75d97df4614cd$var$store.set(it, metadata);
        return metadata;
    };
    $b8c75d97df4614cd$var$get = function(it) {
        return $b8c75d97df4614cd$var$store.get(it) || {};
    };
    $b8c75d97df4614cd$var$has = function(it) {
        return $b8c75d97df4614cd$var$store.has(it);
    };
} else {
    var $b8c75d97df4614cd$var$STATE = $6f16eb1940d3afb7$exports("state");
    $0796b0af43a3801a$exports[$b8c75d97df4614cd$var$STATE] = true;
    $b8c75d97df4614cd$var$set = function(it, metadata) {
        if ($7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE)) throw new $b8c75d97df4614cd$var$TypeError($b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $11de2b231b2859ac$exports(it, $b8c75d97df4614cd$var$STATE, metadata);
        return metadata;
    };
    $b8c75d97df4614cd$var$get = function(it) {
        return $7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE) ? it[$b8c75d97df4614cd$var$STATE] : {};
    };
    $b8c75d97df4614cd$var$has = function(it) {
        return $7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE);
    };
}
$b8c75d97df4614cd$exports = {
    set: $b8c75d97df4614cd$var$set,
    get: $b8c75d97df4614cd$var$get,
    has: $b8c75d97df4614cd$var$has,
    enforce: $b8c75d97df4614cd$var$enforce,
    getterFor: $b8c75d97df4614cd$var$getterFor
};


var $93b6f46cc432668a$var$enforceInternalState = $b8c75d97df4614cd$exports.enforce;
var $93b6f46cc432668a$var$getInternalState = $b8c75d97df4614cd$exports.get;
var $93b6f46cc432668a$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $93b6f46cc432668a$var$defineProperty = Object.defineProperty;
var $93b6f46cc432668a$var$stringSlice = $e5e00809db8eb123$exports("".slice);
var $93b6f46cc432668a$var$replace = $e5e00809db8eb123$exports("".replace);
var $93b6f46cc432668a$var$join = $e5e00809db8eb123$exports([].join);
var $93b6f46cc432668a$var$CONFIGURABLE_LENGTH = $1b14517606367da3$exports && !$1eae0a73b36f2464$exports(function() {
    return $93b6f46cc432668a$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $93b6f46cc432668a$var$TEMPLATE = String(String).split("String");
var $93b6f46cc432668a$var$makeBuiltIn = $93b6f46cc432668a$exports = function(value, name, options) {
    if ($93b6f46cc432668a$var$stringSlice($93b6f46cc432668a$var$$String(name), 0, 7) === "Symbol(") name = "[" + $93b6f46cc432668a$var$replace($93b6f46cc432668a$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$7d2461ccc847d891$exports(value, "name") || $93b6f46cc432668a$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($1b14517606367da3$exports) $93b6f46cc432668a$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($93b6f46cc432668a$var$CONFIGURABLE_LENGTH && options && $7d2461ccc847d891$exports(options, "arity") && value.length !== options.arity) $93b6f46cc432668a$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $7d2461ccc847d891$exports(options, "constructor") && options.constructor) {
            if ($1b14517606367da3$exports) $93b6f46cc432668a$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $93b6f46cc432668a$var$enforceInternalState(value);
    if (!$7d2461ccc847d891$exports(state, "source")) state.source = $93b6f46cc432668a$var$join($93b6f46cc432668a$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $93b6f46cc432668a$var$makeBuiltIn(function toString() {
    return $9261b09349da61cf$exports(this) && $93b6f46cc432668a$var$getInternalState(this).source || $83eb0f09c907b53d$exports(this);
}, "toString");



$bf5de196043a4fd2$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($9261b09349da61cf$exports(value)) $93b6f46cc432668a$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $43431a1908021c5f$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $9ed44e563230b16a$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};


var $8952b1d34effcaa1$exports = {};
"use strict";

var $763328be10ae1b88$exports = {};
"use strict";


var $ad4a9d272ee83106$exports = {};
"use strict";

var $ad4a9d272ee83106$var$toString = $e5e00809db8eb123$exports({}.toString);
var $ad4a9d272ee83106$var$stringSlice = $e5e00809db8eb123$exports("".slice);
$ad4a9d272ee83106$exports = function(it) {
    return $ad4a9d272ee83106$var$stringSlice($ad4a9d272ee83106$var$toString(it), 8, -1);
};



var $763328be10ae1b88$var$TO_STRING_TAG = $a7e68d87528d04a9$exports("toStringTag");
var $763328be10ae1b88$var$$Object = Object;
// ES3 wrong here
var $763328be10ae1b88$var$CORRECT_ARGUMENTS = $ad4a9d272ee83106$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $763328be10ae1b88$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$763328be10ae1b88$exports = $e1a4c6e14767f41c$exports ? $ad4a9d272ee83106$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $763328be10ae1b88$var$tryGet(O = $763328be10ae1b88$var$$Object(it), $763328be10ae1b88$var$TO_STRING_TAG)) == "string" ? tag : $763328be10ae1b88$var$CORRECT_ARGUMENTS ? $ad4a9d272ee83106$exports(O) : (result = $ad4a9d272ee83106$exports(O)) === "Object" && $9261b09349da61cf$exports(O.callee) ? "Arguments" : result;
};


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$8952b1d34effcaa1$exports = $e1a4c6e14767f41c$exports ? ({}).toString : function toString() {
    return "[object " + $763328be10ae1b88$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$e1a4c6e14767f41c$exports) $bf5de196043a4fd2$exports(Object.prototype, "toString", $8952b1d34effcaa1$exports, {
    unsafe: true
});


"use strict";

var $c4006a704557e872$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$c4006a704557e872$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $9cd3082de33f3371$exports = {};
"use strict";

var $9cd3082de33f3371$var$classList = $af583e15a6d46412$exports("span").classList;
var $9cd3082de33f3371$var$DOMTokenListPrototype = $9cd3082de33f3371$var$classList && $9cd3082de33f3371$var$classList.constructor && $9cd3082de33f3371$var$classList.constructor.prototype;
$9cd3082de33f3371$exports = $9cd3082de33f3371$var$DOMTokenListPrototype === Object.prototype ? undefined : $9cd3082de33f3371$var$DOMTokenListPrototype;


var $c810527a3b1ac274$exports = {};
"use strict";
var $98ae5b7f82509981$exports = {};
"use strict";
var $87792ed211fa2876$exports = {};
"use strict";
var $6c22f7c638581f91$exports = {};
"use strict";


$6c22f7c638581f91$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($ad4a9d272ee83106$exports(fn) === "Function") return $e5e00809db8eb123$exports(fn);
};




var $87792ed211fa2876$var$bind = $6c22f7c638581f91$exports($6c22f7c638581f91$exports.bind);
// optional / simple context binding
$87792ed211fa2876$exports = function(fn, that) {
    $828965f5bec31db8$exports(fn);
    return that === undefined ? fn : $c3c0a5f76e5e916e$exports ? $87792ed211fa2876$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};



var $d8b1bffb46e6bac1$exports = {};
"use strict";



var $d8b1bffb46e6bac1$var$$Object = Object;
var $d8b1bffb46e6bac1$var$split = $e5e00809db8eb123$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$d8b1bffb46e6bac1$exports = $1eae0a73b36f2464$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d8b1bffb46e6bac1$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $ad4a9d272ee83106$exports(it) === "String" ? $d8b1bffb46e6bac1$var$split(it, "") : $d8b1bffb46e6bac1$var$$Object(it);
} : $d8b1bffb46e6bac1$var$$Object;



var $652464498d4572b8$exports = {};
"use strict";
var $7db5197aa28dc3ca$exports = {};
"use strict";
var $2d9dedc240706176$exports = {};
"use strict";
var $c0b433f218e21d2d$exports = {};
"use strict";
var $c0b433f218e21d2d$var$ceil = Math.ceil;
var $c0b433f218e21d2d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$c0b433f218e21d2d$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $c0b433f218e21d2d$var$floor : $c0b433f218e21d2d$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$2d9dedc240706176$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $c0b433f218e21d2d$exports(number);
};


var $7db5197aa28dc3ca$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$7db5197aa28dc3ca$exports = function(argument) {
    return argument > 0 ? $7db5197aa28dc3ca$var$min($2d9dedc240706176$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$652464498d4572b8$exports = function(obj) {
    return $7db5197aa28dc3ca$exports(obj.length);
};


var $25632a42f319a356$exports = {};
"use strict";
var $df2459b7b83fe558$exports = {};
"use strict";
var $27c252b86ccaeb0c$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$27c252b86ccaeb0c$exports = Array.isArray || function isArray(argument) {
    return $ad4a9d272ee83106$exports(argument) === "Array";
};


var $0dfeddf167d813f3$exports = {};
"use strict";






var $0dfeddf167d813f3$var$noop = function() {};
var $0dfeddf167d813f3$var$empty = [];
var $0dfeddf167d813f3$var$construct = $6bf58ff2790e62e4$exports("Reflect", "construct");
var $0dfeddf167d813f3$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $0dfeddf167d813f3$var$exec = $e5e00809db8eb123$exports($0dfeddf167d813f3$var$constructorRegExp.exec);
var $0dfeddf167d813f3$var$INCORRECT_TO_STRING = !$0dfeddf167d813f3$var$constructorRegExp.test($0dfeddf167d813f3$var$noop);
var $0dfeddf167d813f3$var$isConstructorModern = function isConstructor(argument) {
    if (!$9261b09349da61cf$exports(argument)) return false;
    try {
        $0dfeddf167d813f3$var$construct($0dfeddf167d813f3$var$noop, $0dfeddf167d813f3$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $0dfeddf167d813f3$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$9261b09349da61cf$exports(argument)) return false;
    switch($763328be10ae1b88$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $0dfeddf167d813f3$var$INCORRECT_TO_STRING || !!$0dfeddf167d813f3$var$exec($0dfeddf167d813f3$var$constructorRegExp, $83eb0f09c907b53d$exports(argument));
    } catch (error) {
        return true;
    }
};
$0dfeddf167d813f3$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$0dfeddf167d813f3$exports = !$0dfeddf167d813f3$var$construct || $1eae0a73b36f2464$exports(function() {
    var called;
    return $0dfeddf167d813f3$var$isConstructorModern($0dfeddf167d813f3$var$isConstructorModern.call) || !$0dfeddf167d813f3$var$isConstructorModern(Object) || !$0dfeddf167d813f3$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $0dfeddf167d813f3$var$isConstructorLegacy : $0dfeddf167d813f3$var$isConstructorModern;




var $df2459b7b83fe558$var$SPECIES = $a7e68d87528d04a9$exports("species");
var $df2459b7b83fe558$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$df2459b7b83fe558$exports = function(originalArray) {
    var C;
    if ($27c252b86ccaeb0c$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($0dfeddf167d813f3$exports(C) && (C === $df2459b7b83fe558$var$$Array || $27c252b86ccaeb0c$exports(C.prototype))) C = undefined;
        else if ($2b8a0370e236b736$exports(C)) {
            C = C[$df2459b7b83fe558$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $df2459b7b83fe558$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$25632a42f319a356$exports = function(originalArray, length) {
    return new ($df2459b7b83fe558$exports(originalArray))(length === 0 ? 0 : length);
};


var $98ae5b7f82509981$var$push = $e5e00809db8eb123$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $98ae5b7f82509981$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $563602a94d4dc012$exports($this);
        var self = $d8b1bffb46e6bac1$exports(O);
        var boundFunction = $87792ed211fa2876$exports(callbackfn, that);
        var length = $652464498d4572b8$exports(self);
        var index = 0;
        var create = specificCreate || $25632a42f319a356$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $98ae5b7f82509981$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $98ae5b7f82509981$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$98ae5b7f82509981$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $98ae5b7f82509981$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $98ae5b7f82509981$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $98ae5b7f82509981$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $98ae5b7f82509981$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $98ae5b7f82509981$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $98ae5b7f82509981$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $98ae5b7f82509981$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $98ae5b7f82509981$var$createMethod(7)
};


var $c810527a3b1ac274$require$$forEach = $98ae5b7f82509981$exports.forEach;
var $8913e86092e0a1cf$exports = {};
"use strict";

$8913e86092e0a1cf$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1eae0a73b36f2464$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $c810527a3b1ac274$var$STRICT_METHOD = $8913e86092e0a1cf$exports("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$c810527a3b1ac274$exports = !$c810527a3b1ac274$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $c810527a3b1ac274$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;



var $2d8d4832d52a8082$var$handlePrototype = function(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $c810527a3b1ac274$exports) try {
        $11de2b231b2859ac$exports(CollectionPrototype, "forEach", $c810527a3b1ac274$exports);
    } catch (error) {
        CollectionPrototype.forEach = $c810527a3b1ac274$exports;
    }
};
for(var $2d8d4832d52a8082$var$COLLECTION_NAME in $c4006a704557e872$exports)if ($c4006a704557e872$exports[$2d8d4832d52a8082$var$COLLECTION_NAME]) $2d8d4832d52a8082$var$handlePrototype($1f3655405faf4b93$exports[$2d8d4832d52a8082$var$COLLECTION_NAME] && $1f3655405faf4b93$exports[$2d8d4832d52a8082$var$COLLECTION_NAME].prototype);
$2d8d4832d52a8082$var$handlePrototype($9cd3082de33f3371$exports);


var $63282e8d41214218$exports = {};
var $63282e8d41214218$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$63282e8d41214218$exports = $63282e8d41214218$var$canUseDOM;


"use strict";
var $7058f76fc2e3a64a$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $8d274edd5ac8b4e3$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $5b404d3e79dbd64d$export$2d1720544b23b823;
"use strict";
var $5b404d3e79dbd64d$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5b404d3e79dbd64d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5b404d3e79dbd64d$var$NASHORN_BUG = $5b404d3e79dbd64d$var$getOwnPropertyDescriptor && !$5b404d3e79dbd64d$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$5b404d3e79dbd64d$export$2d1720544b23b823 = $5b404d3e79dbd64d$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5b404d3e79dbd64d$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5b404d3e79dbd64d$var$$propertyIsEnumerable;



var $90d3b62c7d13c648$exports = {};
"use strict";


$90d3b62c7d13c648$exports = function(it) {
    return $d8b1bffb46e6bac1$exports($fb9649058d88e05e$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$8d274edd5ac8b4e3$export$2d1720544b23b823 = $1b14517606367da3$exports ? $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $90d3b62c7d13c648$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    if ($c6249751f0bc488c$exports) try {
        return $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($7d2461ccc847d891$exports(O, P)) return $0606df0cd9938668$exports(!$52ac2d1f7b3fc221$exports($5b404d3e79dbd64d$export$2d1720544b23b823, O, P), O[P]);
};


var $7058f76fc2e3a64a$require$getOwnPropertyDescriptor = $8d274edd5ac8b4e3$export$2d1720544b23b823;



var $84231e3038cc1abd$exports = {};
"use strict";

var $05ddaa0c1772a48e$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $8fb63c1ae659eeb7$export$2d1720544b23b823;
"use strict";
var $34ed0f0fbefa4d2d$exports = {};
"use strict";



var $e663240c0e78013a$exports = {};
"use strict";

var $1dca9007867aa32d$exports = {};
"use strict";

var $1dca9007867aa32d$var$max = Math.max;
var $1dca9007867aa32d$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1dca9007867aa32d$exports = function(index, length) {
    var integer = $2d9dedc240706176$exports(index);
    return integer < 0 ? $1dca9007867aa32d$var$max(integer + length, 0) : $1dca9007867aa32d$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $e663240c0e78013a$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $90d3b62c7d13c648$exports($this);
        var length = $652464498d4572b8$exports(O);
        var index = $1dca9007867aa32d$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e663240c0e78013a$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e663240c0e78013a$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e663240c0e78013a$var$createMethod(false)
};


var $34ed0f0fbefa4d2d$require$indexOf = $e663240c0e78013a$exports.indexOf;

var $34ed0f0fbefa4d2d$var$push = $e5e00809db8eb123$exports([].push);
$34ed0f0fbefa4d2d$exports = function(object, names) {
    var O = $90d3b62c7d13c648$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$7d2461ccc847d891$exports($0796b0af43a3801a$exports, key) && $7d2461ccc847d891$exports(O, key) && $34ed0f0fbefa4d2d$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($7d2461ccc847d891$exports(O, key = names[i++])) ~$34ed0f0fbefa4d2d$require$indexOf(result, key) || $34ed0f0fbefa4d2d$var$push(result, key);
    return result;
};


var $24c31dabae1df012$exports = {};
"use strict";
// IE8- don't enum bug keys
$24c31dabae1df012$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $8fb63c1ae659eeb7$var$hiddenKeys = $24c31dabae1df012$exports.concat("length", "prototype");
$8fb63c1ae659eeb7$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $34ed0f0fbefa4d2d$exports(O, $8fb63c1ae659eeb7$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $644667aa7df66e73$export$2d1720544b23b823;
"use strict";
$644667aa7df66e73$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $05ddaa0c1772a48e$var$concat = $e5e00809db8eb123$exports([].concat);
// all object keys, includes non-enumerable and symbols
$05ddaa0c1772a48e$exports = $6bf58ff2790e62e4$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $8fb63c1ae659eeb7$export$2d1720544b23b823($3843f2a291eb95b4$exports(it));
    var getOwnPropertySymbols = $644667aa7df66e73$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $05ddaa0c1772a48e$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$84231e3038cc1abd$exports = function(target, source, exceptions) {
    var keys = $05ddaa0c1772a48e$exports(source);
    var defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $8d274edd5ac8b4e3$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$7d2461ccc847d891$exports(target, key) && !(exceptions && $7d2461ccc847d891$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $4bf0205249f743fe$exports = {};
"use strict";


var $4bf0205249f743fe$var$replacement = /#|\.prototype\./;
var $4bf0205249f743fe$var$isForced = function(feature, detection) {
    var value = $4bf0205249f743fe$var$data[$4bf0205249f743fe$var$normalize(feature)];
    return value === $4bf0205249f743fe$var$POLYFILL ? true : value === $4bf0205249f743fe$var$NATIVE ? false : $9261b09349da61cf$exports(detection) ? $1eae0a73b36f2464$exports(detection) : !!detection;
};
var $4bf0205249f743fe$var$normalize = $4bf0205249f743fe$var$isForced.normalize = function(string) {
    return String(string).replace($4bf0205249f743fe$var$replacement, ".").toLowerCase();
};
var $4bf0205249f743fe$var$data = $4bf0205249f743fe$var$isForced.data = {};
var $4bf0205249f743fe$var$NATIVE = $4bf0205249f743fe$var$isForced.NATIVE = "N";
var $4bf0205249f743fe$var$POLYFILL = $4bf0205249f743fe$var$isForced.POLYFILL = "P";
$4bf0205249f743fe$exports = $4bf0205249f743fe$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $7058f76fc2e3a64a$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $1f3655405faf4b93$exports;
    else if (STATIC) target = $1f3655405faf4b93$exports[TARGET] || $43431a1908021c5f$exports(TARGET, {});
    else target = ($1f3655405faf4b93$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $7058f76fc2e3a64a$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $4bf0205249f743fe$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $84231e3038cc1abd$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $11de2b231b2859ac$exports(sourceProperty, "sham", true);
        $bf5de196043a4fd2$exports(target, key, sourceProperty, options);
    }
};


var $9f1aba216e08c289$exports = {};
"use strict";



var $f598d5e3ccd5a756$exports = {};
"use strict";

var $f598d5e3ccd5a756$var$$String = String;
$f598d5e3ccd5a756$exports = function(argument) {
    if ($763328be10ae1b88$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $f598d5e3ccd5a756$var$$String(argument);
};


var $ecfcee94af05a9f4$exports = {};
"use strict";



var $5601671840cd67f7$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$5601671840cd67f7$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $ecfcee94af05a9f4$var$replace = $e5e00809db8eb123$exports("".replace);
var $ecfcee94af05a9f4$var$ltrim = RegExp("^[" + $5601671840cd67f7$exports + "]+");
var $ecfcee94af05a9f4$var$rtrim = RegExp("(^|[^" + $5601671840cd67f7$exports + "])[" + $5601671840cd67f7$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $ecfcee94af05a9f4$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $f598d5e3ccd5a756$exports($fb9649058d88e05e$exports($this));
        if (TYPE & 1) string = $ecfcee94af05a9f4$var$replace(string, $ecfcee94af05a9f4$var$ltrim, "");
        if (TYPE & 2) string = $ecfcee94af05a9f4$var$replace(string, $ecfcee94af05a9f4$var$rtrim, "$1");
        return string;
    };
};
$ecfcee94af05a9f4$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $ecfcee94af05a9f4$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $ecfcee94af05a9f4$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $ecfcee94af05a9f4$var$createMethod(3)
};


var $9f1aba216e08c289$require$trim = $ecfcee94af05a9f4$exports.trim;

var $9f1aba216e08c289$var$$parseInt = $1f3655405faf4b93$exports.parseInt;
var $9f1aba216e08c289$var$Symbol = $1f3655405faf4b93$exports.Symbol;
var $9f1aba216e08c289$var$ITERATOR = $9f1aba216e08c289$var$Symbol && $9f1aba216e08c289$var$Symbol.iterator;
var $9f1aba216e08c289$var$hex = /^[+-]?0x/i;
var $9f1aba216e08c289$var$exec = $e5e00809db8eb123$exports($9f1aba216e08c289$var$hex.exec);
var $9f1aba216e08c289$var$FORCED = $9f1aba216e08c289$var$$parseInt($5601671840cd67f7$exports + "08") !== 8 || $9f1aba216e08c289$var$$parseInt($5601671840cd67f7$exports + "0x16") !== 22 || $9f1aba216e08c289$var$ITERATOR && !$1eae0a73b36f2464$exports(function() {
    $9f1aba216e08c289$var$$parseInt(Object($9f1aba216e08c289$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$9f1aba216e08c289$exports = $9f1aba216e08c289$var$FORCED ? function parseInt(string, radix) {
    var S = $9f1aba216e08c289$require$trim($f598d5e3ccd5a756$exports(string));
    return $9f1aba216e08c289$var$$parseInt(S, radix >>> 0 || ($9f1aba216e08c289$var$exec($9f1aba216e08c289$var$hex, S) ? 16 : 10));
} : $9f1aba216e08c289$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$7058f76fc2e3a64a$exports({
    global: true,
    forced: parseInt !== $9f1aba216e08c289$exports
}, {
    parseInt: $9f1aba216e08c289$exports
});


"use strict";

var $0e602bd422a55539$exports = {};
"use strict";




var $d085f84bccf5724f$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$d085f84bccf5724f$exports = Object.keys || function keys(O) {
    return $34ed0f0fbefa4d2d$exports(O, $24c31dabae1df012$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $0e602bd422a55539$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $0e602bd422a55539$var$defineProperty = Object.defineProperty;
var $0e602bd422a55539$var$concat = $e5e00809db8eb123$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$0e602bd422a55539$exports = !$0e602bd422a55539$var$$assign || $1eae0a73b36f2464$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($1b14517606367da3$exports && $0e602bd422a55539$var$$assign({
        b: 1
    }, $0e602bd422a55539$var$$assign($0e602bd422a55539$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $0e602bd422a55539$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $0e602bd422a55539$var$$assign({}, A)[symbol] !== 7 || $d085f84bccf5724f$exports($0e602bd422a55539$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $563602a94d4dc012$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $644667aa7df66e73$export$2d1720544b23b823;
    var propertyIsEnumerable = $5b404d3e79dbd64d$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $d8b1bffb46e6bac1$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $0e602bd422a55539$var$concat($d085f84bccf5724f$exports(S), getOwnPropertySymbols(S)) : $d085f84bccf5724f$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$1b14517606367da3$exports || $52ac2d1f7b3fc221$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $0e602bd422a55539$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$7058f76fc2e3a64a$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $0e602bd422a55539$exports
}, {
    assign: $0e602bd422a55539$exports
});


"use strict";


var $839bbf505410b49f$require$$filter = $98ae5b7f82509981$exports.filter;
var $15dfa66ad776b7c1$exports = {};
"use strict";



var $15dfa66ad776b7c1$var$SPECIES = $a7e68d87528d04a9$exports("species");
$15dfa66ad776b7c1$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $e686f780cf055b91$exports >= 51 || !$1eae0a73b36f2464$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$15dfa66ad776b7c1$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $839bbf505410b49f$var$HAS_SPECIES_SUPPORT = $15dfa66ad776b7c1$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$7058f76fc2e3a64a$exports({
    target: "Array",
    proto: true,
    forced: !$839bbf505410b49f$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $839bbf505410b49f$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


var $bca41335d4cd4e50$exports = {};
"use strict";

var $a305c2f2db097323$exports = {};
"use strict";

var $d35380bd6dbffbb9$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $910222f1b5d18145$export$2d1720544b23b823;
"use strict";






$910222f1b5d18145$export$2d1720544b23b823 = $1b14517606367da3$exports && !$1981a0d5783b0827$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $3843f2a291eb95b4$exports(O);
    var props = $90d3b62c7d13c648$exports(Properties);
    var keys = $d085f84bccf5724f$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$9ed44e563230b16a$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $24506fe4729da444$exports = {};
"use strict";

$24506fe4729da444$exports = $6bf58ff2790e62e4$exports("document", "documentElement");




var $d35380bd6dbffbb9$var$GT = ">";
var $d35380bd6dbffbb9$var$LT = "<";
var $d35380bd6dbffbb9$var$PROTOTYPE = "prototype";
var $d35380bd6dbffbb9$var$SCRIPT = "script";
var $d35380bd6dbffbb9$var$IE_PROTO = $6f16eb1940d3afb7$exports("IE_PROTO");
var $d35380bd6dbffbb9$var$EmptyConstructor = function() {};
var $d35380bd6dbffbb9$var$scriptTag = function(content) {
    return $d35380bd6dbffbb9$var$LT + $d35380bd6dbffbb9$var$SCRIPT + $d35380bd6dbffbb9$var$GT + content + $d35380bd6dbffbb9$var$LT + "/" + $d35380bd6dbffbb9$var$SCRIPT + $d35380bd6dbffbb9$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $d35380bd6dbffbb9$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($d35380bd6dbffbb9$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $d35380bd6dbffbb9$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $af583e15a6d46412$exports("iframe");
    var JS = "java" + $d35380bd6dbffbb9$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $24506fe4729da444$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($d35380bd6dbffbb9$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $d35380bd6dbffbb9$var$activeXDocument;
var $d35380bd6dbffbb9$var$NullProtoObject = function() {
    try {
        $d35380bd6dbffbb9$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $d35380bd6dbffbb9$var$NullProtoObject = typeof document != "undefined" ? document.domain && $d35380bd6dbffbb9$var$activeXDocument ? $d35380bd6dbffbb9$var$NullProtoObjectViaActiveX($d35380bd6dbffbb9$var$activeXDocument) // old IE
     : $d35380bd6dbffbb9$var$NullProtoObjectViaIFrame() : $d35380bd6dbffbb9$var$NullProtoObjectViaActiveX($d35380bd6dbffbb9$var$activeXDocument); // WSH
    var length = $24c31dabae1df012$exports.length;
    while(length--)delete $d35380bd6dbffbb9$var$NullProtoObject[$d35380bd6dbffbb9$var$PROTOTYPE][$24c31dabae1df012$exports[length]];
    return $d35380bd6dbffbb9$var$NullProtoObject();
};
$0796b0af43a3801a$exports[$d35380bd6dbffbb9$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$d35380bd6dbffbb9$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $d35380bd6dbffbb9$var$EmptyConstructor[$d35380bd6dbffbb9$var$PROTOTYPE] = $3843f2a291eb95b4$exports(O);
        result = new $d35380bd6dbffbb9$var$EmptyConstructor();
        $d35380bd6dbffbb9$var$EmptyConstructor[$d35380bd6dbffbb9$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$d35380bd6dbffbb9$var$IE_PROTO] = O;
    } else result = $d35380bd6dbffbb9$var$NullProtoObject();
    return Properties === undefined ? result : $910222f1b5d18145$export$2d1720544b23b823(result, Properties);
};



var $a305c2f2db097323$require$defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;
var $a305c2f2db097323$var$UNSCOPABLES = $a7e68d87528d04a9$exports("unscopables");
var $a305c2f2db097323$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($a305c2f2db097323$var$ArrayPrototype[$a305c2f2db097323$var$UNSCOPABLES] === undefined) $a305c2f2db097323$require$defineProperty($a305c2f2db097323$var$ArrayPrototype, $a305c2f2db097323$var$UNSCOPABLES, {
    configurable: true,
    value: $d35380bd6dbffbb9$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$a305c2f2db097323$exports = function(key) {
    $a305c2f2db097323$var$ArrayPrototype[$a305c2f2db097323$var$UNSCOPABLES][key] = true;
};


var $f6f11c774c61dbb7$exports = {};
"use strict";
$f6f11c774c61dbb7$exports = {};




var $bca41335d4cd4e50$require$defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;
var $da18b377eac22cad$exports = {};
"use strict";





var $f39e220a7f9fad0d$exports = {};
"use strict";
var $d507f0efaaa4807b$exports = {};
"use strict";




var $951d54f043f3f719$exports = {};
"use strict";




var $82586d87c638eac7$exports = {};
"use strict";

$82586d87c638eac7$exports = !$1eae0a73b36f2464$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $951d54f043f3f719$var$IE_PROTO = $6f16eb1940d3afb7$exports("IE_PROTO");
var $951d54f043f3f719$var$$Object = Object;
var $951d54f043f3f719$var$ObjectPrototype = $951d54f043f3f719$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$951d54f043f3f719$exports = $82586d87c638eac7$exports ? $951d54f043f3f719$var$$Object.getPrototypeOf : function(O) {
    var object = $563602a94d4dc012$exports(O);
    if ($7d2461ccc847d891$exports(object, $951d54f043f3f719$var$IE_PROTO)) return object[$951d54f043f3f719$var$IE_PROTO];
    var constructor = object.constructor;
    if ($9261b09349da61cf$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $951d54f043f3f719$var$$Object ? $951d54f043f3f719$var$ObjectPrototype : null;
};





var $d507f0efaaa4807b$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
var $d507f0efaaa4807b$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $d507f0efaaa4807b$var$IteratorPrototype, $d507f0efaaa4807b$var$PrototypeOfArrayIteratorPrototype, $d507f0efaaa4807b$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $d507f0efaaa4807b$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $d507f0efaaa4807b$var$arrayIterator)) $d507f0efaaa4807b$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $d507f0efaaa4807b$var$PrototypeOfArrayIteratorPrototype = $951d54f043f3f719$exports($951d54f043f3f719$exports($d507f0efaaa4807b$var$arrayIterator));
        if ($d507f0efaaa4807b$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $d507f0efaaa4807b$var$IteratorPrototype = $d507f0efaaa4807b$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $d507f0efaaa4807b$var$NEW_ITERATOR_PROTOTYPE = !$2b8a0370e236b736$exports($d507f0efaaa4807b$var$IteratorPrototype) || $1eae0a73b36f2464$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $d507f0efaaa4807b$var$IteratorPrototype[$d507f0efaaa4807b$var$ITERATOR].call(test) !== test;
});
if ($d507f0efaaa4807b$var$NEW_ITERATOR_PROTOTYPE) $d507f0efaaa4807b$var$IteratorPrototype = {};
else if ($5c612855d4d64a1d$exports) $d507f0efaaa4807b$var$IteratorPrototype = $d35380bd6dbffbb9$exports($d507f0efaaa4807b$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$9261b09349da61cf$exports($d507f0efaaa4807b$var$IteratorPrototype[$d507f0efaaa4807b$var$ITERATOR])) $bf5de196043a4fd2$exports($d507f0efaaa4807b$var$IteratorPrototype, $d507f0efaaa4807b$var$ITERATOR, function() {
    return this;
});
$d507f0efaaa4807b$exports = {
    IteratorPrototype: $d507f0efaaa4807b$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $d507f0efaaa4807b$var$BUGGY_SAFARI_ITERATORS
};


var $f39e220a7f9fad0d$require$IteratorPrototype = $d507f0efaaa4807b$exports.IteratorPrototype;


var $38ffa0ebcf4c6151$exports = {};
"use strict";

var $38ffa0ebcf4c6151$require$defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;


var $38ffa0ebcf4c6151$var$TO_STRING_TAG = $a7e68d87528d04a9$exports("toStringTag");
$38ffa0ebcf4c6151$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$7d2461ccc847d891$exports(target, $38ffa0ebcf4c6151$var$TO_STRING_TAG)) $38ffa0ebcf4c6151$require$defineProperty(target, $38ffa0ebcf4c6151$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $f39e220a7f9fad0d$var$returnThis = function() {
    return this;
};
$f39e220a7f9fad0d$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $d35380bd6dbffbb9$exports($f39e220a7f9fad0d$require$IteratorPrototype, {
        next: $0606df0cd9938668$exports(+!ENUMERABLE_NEXT, next)
    });
    $38ffa0ebcf4c6151$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $f6f11c774c61dbb7$exports[TO_STRING_TAG] = $f39e220a7f9fad0d$var$returnThis;
    return IteratorConstructor;
};



var $c80041da578fc824$exports = {};
"use strict";
var $ada59f4c44628248$exports = {};
"use strict";


$ada59f4c44628248$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $e5e00809db8eb123$exports($828965f5bec31db8$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $3467e6917c15b912$exports = {};
"use strict";

var $3467e6917c15b912$var$$String = String;
var $3467e6917c15b912$var$$TypeError = TypeError;
$3467e6917c15b912$exports = function(argument) {
    if (typeof argument == "object" || $9261b09349da61cf$exports(argument)) return argument;
    throw new $3467e6917c15b912$var$$TypeError("Can't set " + $3467e6917c15b912$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$c80041da578fc824$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $ada59f4c44628248$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $3843f2a291eb95b4$exports(O);
        $3467e6917c15b912$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $da18b377eac22cad$var$PROPER_FUNCTION_NAME = $93fac42f9e89a850$exports.PROPER;
var $da18b377eac22cad$var$CONFIGURABLE_FUNCTION_NAME = $93fac42f9e89a850$exports.CONFIGURABLE;
var $da18b377eac22cad$var$IteratorPrototype = $d507f0efaaa4807b$exports.IteratorPrototype;
var $da18b377eac22cad$var$BUGGY_SAFARI_ITERATORS = $d507f0efaaa4807b$exports.BUGGY_SAFARI_ITERATORS;
var $da18b377eac22cad$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
var $da18b377eac22cad$var$KEYS = "keys";
var $da18b377eac22cad$var$VALUES = "values";
var $da18b377eac22cad$var$ENTRIES = "entries";
var $da18b377eac22cad$var$returnThis = function() {
    return this;
};
$da18b377eac22cad$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $f39e220a7f9fad0d$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$da18b377eac22cad$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $da18b377eac22cad$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $da18b377eac22cad$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $da18b377eac22cad$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$da18b377eac22cad$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$da18b377eac22cad$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $951d54f043f3f719$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$5c612855d4d64a1d$exports && $951d54f043f3f719$exports(CurrentIteratorPrototype) !== $da18b377eac22cad$var$IteratorPrototype) {
                if ($c80041da578fc824$exports) $c80041da578fc824$exports(CurrentIteratorPrototype, $da18b377eac22cad$var$IteratorPrototype);
                else if (!$9261b09349da61cf$exports(CurrentIteratorPrototype[$da18b377eac22cad$var$ITERATOR])) $bf5de196043a4fd2$exports(CurrentIteratorPrototype, $da18b377eac22cad$var$ITERATOR, $da18b377eac22cad$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $38ffa0ebcf4c6151$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($5c612855d4d64a1d$exports) $f6f11c774c61dbb7$exports[TO_STRING_TAG] = $da18b377eac22cad$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($da18b377eac22cad$var$PROPER_FUNCTION_NAME && DEFAULT === $da18b377eac22cad$var$VALUES && nativeIterator && nativeIterator.name !== $da18b377eac22cad$var$VALUES) {
        if (!$5c612855d4d64a1d$exports && $da18b377eac22cad$var$CONFIGURABLE_FUNCTION_NAME) $11de2b231b2859ac$exports(IterablePrototype, "name", $da18b377eac22cad$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $52ac2d1f7b3fc221$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($da18b377eac22cad$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($da18b377eac22cad$var$KEYS),
            entries: getIterationMethod($da18b377eac22cad$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($da18b377eac22cad$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $bf5de196043a4fd2$exports(IterablePrototype, KEY, methods[KEY]);
        } else $7058f76fc2e3a64a$exports({
            target: NAME,
            proto: true,
            forced: $da18b377eac22cad$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$5c612855d4d64a1d$exports || FORCED) && IterablePrototype[$da18b377eac22cad$var$ITERATOR] !== defaultIterator) $bf5de196043a4fd2$exports(IterablePrototype, $da18b377eac22cad$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $f6f11c774c61dbb7$exports[NAME] = defaultIterator;
    return methods;
};


var $c7aa0547b97bf262$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$c7aa0547b97bf262$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $bca41335d4cd4e50$var$ARRAY_ITERATOR = "Array Iterator";
var $bca41335d4cd4e50$var$setInternalState = $b8c75d97df4614cd$exports.set;
var $bca41335d4cd4e50$var$getInternalState = $b8c75d97df4614cd$exports.getterFor($bca41335d4cd4e50$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$bca41335d4cd4e50$exports = $da18b377eac22cad$exports(Array, "Array", function(iterated, kind) {
    $bca41335d4cd4e50$var$setInternalState(this, {
        type: $bca41335d4cd4e50$var$ARRAY_ITERATOR,
        target: $90d3b62c7d13c648$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $bca41335d4cd4e50$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $c7aa0547b97bf262$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $c7aa0547b97bf262$exports(index, false);
        case "values":
            return $c7aa0547b97bf262$exports(target[index], false);
    }
    return $c7aa0547b97bf262$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $bca41335d4cd4e50$var$values = $f6f11c774c61dbb7$exports.Arguments = $f6f11c774c61dbb7$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$a305c2f2db097323$exports("keys");
$a305c2f2db097323$exports("values");
$a305c2f2db097323$exports("entries");
// V8 ~ Chrome 45- bug
if (!$5c612855d4d64a1d$exports && $1b14517606367da3$exports && $bca41335d4cd4e50$var$values.name !== "values") try {
    $bca41335d4cd4e50$require$defineProperty($bca41335d4cd4e50$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $4dc1d913e18f4646$exports = {};
"use strict";




var $4dc1d913e18f4646$var$charAt = $e5e00809db8eb123$exports("".charAt);
var $4dc1d913e18f4646$var$charCodeAt = $e5e00809db8eb123$exports("".charCodeAt);
var $4dc1d913e18f4646$var$stringSlice = $e5e00809db8eb123$exports("".slice);
var $4dc1d913e18f4646$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $f598d5e3ccd5a756$exports($fb9649058d88e05e$exports($this));
        var position = $2d9dedc240706176$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $4dc1d913e18f4646$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $4dc1d913e18f4646$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $4dc1d913e18f4646$var$charAt(S, position) : first : CONVERT_TO_STRING ? $4dc1d913e18f4646$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$4dc1d913e18f4646$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $4dc1d913e18f4646$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $4dc1d913e18f4646$var$createMethod(true)
};


var $0dcbfe9fc93c5c1a$require$charAt = $4dc1d913e18f4646$exports.charAt;




var $0dcbfe9fc93c5c1a$var$STRING_ITERATOR = "String Iterator";
var $0dcbfe9fc93c5c1a$var$setInternalState = $b8c75d97df4614cd$exports.set;
var $0dcbfe9fc93c5c1a$var$getInternalState = $b8c75d97df4614cd$exports.getterFor($0dcbfe9fc93c5c1a$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$da18b377eac22cad$exports(String, "String", function(iterated) {
    $0dcbfe9fc93c5c1a$var$setInternalState(this, {
        type: $0dcbfe9fc93c5c1a$var$STRING_ITERATOR,
        string: $f598d5e3ccd5a756$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $0dcbfe9fc93c5c1a$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $c7aa0547b97bf262$exports(undefined, true);
    point = $0dcbfe9fc93c5c1a$require$charAt(string, index);
    state.index += point.length;
    return $c7aa0547b97bf262$exports(point, false);
});


"use strict";
"use strict";
var $e3150732006e094d$exports = {};
"use strict";

$e3150732006e094d$exports = !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $97155cb1792eff1d$exports = {};
"use strict";

$97155cb1792eff1d$exports = function(target, src, options) {
    for(var key in src)$bf5de196043a4fd2$exports(target, key, src[key], options);
    return target;
};


var $ed6c57276cb56f85$exports = {};
"use strict";






var $ed6c57276cb56f85$require$defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $24e1d80f43696b0e$export$2d1720544b23b823;
"use strict";



var $24e1d80f43696b0e$require$$getOwnPropertyNames = $8fb63c1ae659eeb7$export$2d1720544b23b823;
var $24124c3f1339dee4$exports = {};
"use strict";


var $94dac7182baf7420$exports = {};
"use strict";



$94dac7182baf7420$exports = function(object, key, value) {
    var propertyKey = $eddfdd2f934c39a2$exports(key);
    if (propertyKey in object) $9ed44e563230b16a$export$2d1720544b23b823(object, propertyKey, $0606df0cd9938668$exports(0, value));
    else object[propertyKey] = value;
};


var $24124c3f1339dee4$var$$Array = Array;
var $24124c3f1339dee4$var$max = Math.max;
$24124c3f1339dee4$exports = function(O, start, end) {
    var length = $652464498d4572b8$exports(O);
    var k = $1dca9007867aa32d$exports(start, length);
    var fin = $1dca9007867aa32d$exports(end === undefined ? length : end, length);
    var result = $24124c3f1339dee4$var$$Array($24124c3f1339dee4$var$max(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$94dac7182baf7420$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $24e1d80f43696b0e$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $24e1d80f43696b0e$var$getWindowNames = function(it) {
    try {
        return $24e1d80f43696b0e$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $24124c3f1339dee4$exports($24e1d80f43696b0e$var$windowNames);
    }
};
$24e1d80f43696b0e$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $24e1d80f43696b0e$var$windowNames && $ad4a9d272ee83106$exports(it) === "Window" ? $24e1d80f43696b0e$var$getWindowNames(it) : $24e1d80f43696b0e$require$$getOwnPropertyNames($90d3b62c7d13c648$exports(it));
};


var $0918bdb976604544$exports = {};
"use strict";



var $9c310a96e655cd16$exports = {};
"use strict";

$9c310a96e655cd16$exports = $1eae0a73b36f2464$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $0918bdb976604544$var$$isExtensible = Object.isExtensible;
var $0918bdb976604544$var$FAILS_ON_PRIMITIVES = $1eae0a73b36f2464$exports(function() {
    $0918bdb976604544$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$0918bdb976604544$exports = $0918bdb976604544$var$FAILS_ON_PRIMITIVES || $9c310a96e655cd16$exports ? function isExtensible(it) {
    if (!$2b8a0370e236b736$exports(it)) return false;
    if ($9c310a96e655cd16$exports && $ad4a9d272ee83106$exports(it) === "ArrayBuffer") return false;
    return $0918bdb976604544$var$$isExtensible ? $0918bdb976604544$var$$isExtensible(it) : true;
} : $0918bdb976604544$var$$isExtensible;




var $ed6c57276cb56f85$var$REQUIRED = false;
var $ed6c57276cb56f85$var$METADATA = $09622dafccffa283$exports("meta");
var $ed6c57276cb56f85$var$id = 0;
var $ed6c57276cb56f85$var$setMetadata = function(it) {
    $ed6c57276cb56f85$require$defineProperty(it, $ed6c57276cb56f85$var$METADATA, {
        value: {
            objectID: "O" + $ed6c57276cb56f85$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $ed6c57276cb56f85$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$2b8a0370e236b736$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$7d2461ccc847d891$exports(it, $ed6c57276cb56f85$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$0918bdb976604544$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $ed6c57276cb56f85$var$setMetadata(it);
    // return object ID
    }
    return it[$ed6c57276cb56f85$var$METADATA].objectID;
};
var $ed6c57276cb56f85$var$getWeakData = function(it, create) {
    if (!$7d2461ccc847d891$exports(it, $ed6c57276cb56f85$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$0918bdb976604544$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $ed6c57276cb56f85$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$ed6c57276cb56f85$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $ed6c57276cb56f85$var$onFreeze = function(it) {
    if ($e3150732006e094d$exports && $ed6c57276cb56f85$var$REQUIRED && $0918bdb976604544$exports(it) && !$7d2461ccc847d891$exports(it, $ed6c57276cb56f85$var$METADATA)) $ed6c57276cb56f85$var$setMetadata(it);
    return it;
};
var $ed6c57276cb56f85$var$enable = function() {
    $ed6c57276cb56f85$var$meta.enable = function() {};
    $ed6c57276cb56f85$var$REQUIRED = true;
    var getOwnPropertyNames = $8fb63c1ae659eeb7$export$2d1720544b23b823;
    var splice = $e5e00809db8eb123$exports([].splice);
    var test = {};
    test[$ed6c57276cb56f85$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $8fb63c1ae659eeb7$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $ed6c57276cb56f85$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $7058f76fc2e3a64a$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $24e1d80f43696b0e$export$2d1720544b23b823
        });
    }
};
var $ed6c57276cb56f85$var$meta = $ed6c57276cb56f85$exports = {
    enable: $ed6c57276cb56f85$var$enable,
    fastKey: $ed6c57276cb56f85$var$fastKey,
    getWeakData: $ed6c57276cb56f85$var$getWeakData,
    onFreeze: $ed6c57276cb56f85$var$onFreeze
};
$0796b0af43a3801a$exports[$ed6c57276cb56f85$var$METADATA] = true;


var $f4fae5104155afc6$exports = {};
"use strict";






var $1e214212824de653$exports = {};
"use strict";




var $29385f80572bc7d8$exports = {};
"use strict";


var $29385f80572bc7d8$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
var $29385f80572bc7d8$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$29385f80572bc7d8$exports = function(it) {
    return it !== undefined && ($f6f11c774c61dbb7$exports.Array === it || $29385f80572bc7d8$var$ArrayPrototype[$29385f80572bc7d8$var$ITERATOR] === it);
};




var $0e4ac3d1a2d852c5$exports = {};
"use strict";




var $f69aedf2ea9f43c2$exports = {};
"use strict";





var $f69aedf2ea9f43c2$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
$f69aedf2ea9f43c2$exports = function(it) {
    if (!$c9cec627d9a032db$exports(it)) return $7449e8f88cb85375$exports(it, $f69aedf2ea9f43c2$var$ITERATOR) || $7449e8f88cb85375$exports(it, "@@iterator") || $f6f11c774c61dbb7$exports[$763328be10ae1b88$exports(it)];
};


var $0e4ac3d1a2d852c5$var$$TypeError = TypeError;
$0e4ac3d1a2d852c5$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $f69aedf2ea9f43c2$exports(argument) : usingIterator;
    if ($828965f5bec31db8$exports(iteratorMethod)) return $3843f2a291eb95b4$exports($52ac2d1f7b3fc221$exports(iteratorMethod, argument));
    throw new $0e4ac3d1a2d852c5$var$$TypeError($4684c592a1598de6$exports(argument) + " is not iterable");
};



var $12abcabd6fb2858a$exports = {};
"use strict";



$12abcabd6fb2858a$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $3843f2a291eb95b4$exports(iterator);
    try {
        innerResult = $7449e8f88cb85375$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $52ac2d1f7b3fc221$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $3843f2a291eb95b4$exports(innerResult);
    return value;
};


var $1e214212824de653$var$$TypeError = TypeError;
var $1e214212824de653$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $1e214212824de653$var$ResultPrototype = $1e214212824de653$var$Result.prototype;
$1e214212824de653$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $87792ed211fa2876$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $12abcabd6fb2858a$exports(iterator, "normal", condition);
        return new $1e214212824de653$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $3843f2a291eb95b4$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $f69aedf2ea9f43c2$exports(iterable);
        if (!iterFn) throw new $1e214212824de653$var$$TypeError($4684c592a1598de6$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($29385f80572bc7d8$exports(iterFn)) {
            for(index = 0, length = $652464498d4572b8$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $599d3f84718534dc$exports($1e214212824de653$var$ResultPrototype, result)) return result;
            }
            return new $1e214212824de653$var$Result(false);
        }
        iterator = $0e4ac3d1a2d852c5$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $52ac2d1f7b3fc221$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $12abcabd6fb2858a$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $599d3f84718534dc$exports($1e214212824de653$var$ResultPrototype, result)) return result;
    }
    return new $1e214212824de653$var$Result(false);
};


var $ee172f7b4262d5a1$exports = {};
"use strict";

var $ee172f7b4262d5a1$var$$TypeError = TypeError;
$ee172f7b4262d5a1$exports = function(it, Prototype) {
    if ($599d3f84718534dc$exports(Prototype, it)) return it;
    throw new $ee172f7b4262d5a1$var$$TypeError("Incorrect invocation");
};






var $f1443222c3183811$exports = {};
"use strict";

var $f1443222c3183811$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
var $f1443222c3183811$var$SAFE_CLOSING = false;
try {
    var $f1443222c3183811$var$called = 0;
    var $f1443222c3183811$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$f1443222c3183811$var$called++
            };
        },
        "return": function() {
            $f1443222c3183811$var$SAFE_CLOSING = true;
        }
    };
    $f1443222c3183811$var$iteratorWithReturn[$f1443222c3183811$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($f1443222c3183811$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$f1443222c3183811$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$f1443222c3183811$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$f1443222c3183811$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $5ff6c21263ff21a2$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$5ff6c21263ff21a2$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $c80041da578fc824$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $9261b09349da61cf$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $2b8a0370e236b736$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $c80041da578fc824$exports($this, NewTargetPrototype);
    return $this;
};


$f4fae5104155afc6$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $1f3655405faf4b93$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $e5e00809db8eb123$exports(NativePrototype[KEY]);
        $bf5de196043a4fd2$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$2b8a0370e236b736$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$2b8a0370e236b736$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$2b8a0370e236b736$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $4bf0205249f743fe$exports(CONSTRUCTOR_NAME, !$9261b09349da61cf$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1eae0a73b36f2464$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $ed6c57276cb56f85$exports.enable();
    } else if ($4bf0205249f743fe$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1eae0a73b36f2464$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $f1443222c3183811$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1eae0a73b36f2464$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $ee172f7b4262d5a1$exports(dummy, NativePrototype);
                var that = $5ff6c21263ff21a2$exports(new NativeConstructor(), dummy, Constructor);
                if (!$c9cec627d9a032db$exports(iterable)) $1e214212824de653$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $7058f76fc2e3a64a$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $38ffa0ebcf4c6151$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $d4fa85d5732141d3$exports = {};
"use strict";



var $d4fa85d5732141d3$require$getWeakData = $ed6c57276cb56f85$exports.getWeakData;








var $d4fa85d5732141d3$var$setInternalState = $b8c75d97df4614cd$exports.set;
var $d4fa85d5732141d3$var$internalStateGetterFor = $b8c75d97df4614cd$exports.getterFor;
var $d4fa85d5732141d3$var$find = $98ae5b7f82509981$exports.find;
var $d4fa85d5732141d3$var$findIndex = $98ae5b7f82509981$exports.findIndex;
var $d4fa85d5732141d3$var$splice = $e5e00809db8eb123$exports([].splice);
var $d4fa85d5732141d3$var$id = 0;
// fallback for uncaught frozen keys
var $d4fa85d5732141d3$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $d4fa85d5732141d3$var$UncaughtFrozenStore());
};
var $d4fa85d5732141d3$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $d4fa85d5732141d3$var$findUncaughtFrozen = function(store, key) {
    return $d4fa85d5732141d3$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$d4fa85d5732141d3$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $d4fa85d5732141d3$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$d4fa85d5732141d3$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $d4fa85d5732141d3$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $d4fa85d5732141d3$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $d4fa85d5732141d3$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$d4fa85d5732141d3$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $ee172f7b4262d5a1$exports(that, Prototype);
            $d4fa85d5732141d3$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $d4fa85d5732141d3$var$id++,
                frozen: undefined
            });
            if (!$c9cec627d9a032db$exports(iterable)) $1e214212824de653$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $d4fa85d5732141d3$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $d4fa85d5732141d3$require$getWeakData($3843f2a291eb95b4$exports(key), true);
            if (data === true) $d4fa85d5732141d3$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $97155cb1792eff1d$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$2b8a0370e236b736$exports(key)) return false;
                var data = $d4fa85d5732141d3$require$getWeakData(key);
                if (data === true) return $d4fa85d5732141d3$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $7d2461ccc847d891$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$2b8a0370e236b736$exports(key)) return false;
                var data = $d4fa85d5732141d3$require$getWeakData(key);
                if (data === true) return $d4fa85d5732141d3$var$uncaughtFrozenStore(state).has(key);
                return data && $7d2461ccc847d891$exports(data, state.id);
            }
        });
        $97155cb1792eff1d$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($2b8a0370e236b736$exports(key)) {
                    var data = $d4fa85d5732141d3$require$getWeakData(key);
                    if (data === true) return $d4fa85d5732141d3$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $8fef7f1094929f30$require$enforceInternalState = $b8c75d97df4614cd$exports.enforce;


var $8fef7f1094929f30$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $8fef7f1094929f30$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $8fef7f1094929f30$var$isExtensible = $8fef7f1094929f30$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $8fef7f1094929f30$var$isFrozen = $8fef7f1094929f30$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $8fef7f1094929f30$var$isSealed = $8fef7f1094929f30$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $8fef7f1094929f30$var$freeze = $8fef7f1094929f30$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $8fef7f1094929f30$var$seal = $8fef7f1094929f30$var$$Object.seal;
var $8fef7f1094929f30$var$FROZEN = {};
var $8fef7f1094929f30$var$SEALED = {};
var $8fef7f1094929f30$var$IS_IE11 = !$1f3655405faf4b93$exports.ActiveXObject && "ActiveXObject" in $1f3655405faf4b93$exports;
var $8fef7f1094929f30$var$InternalWeakMap;
var $8fef7f1094929f30$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $8fef7f1094929f30$var$$WeakMap = $f4fae5104155afc6$exports("WeakMap", $8fef7f1094929f30$var$wrapper, $d4fa85d5732141d3$exports);
var $8fef7f1094929f30$var$WeakMapPrototype = $8fef7f1094929f30$var$$WeakMap.prototype;
var $8fef7f1094929f30$var$nativeSet = $e5e00809db8eb123$exports($8fef7f1094929f30$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $8fef7f1094929f30$var$hasMSEdgeFreezingBug = function() {
    return $e3150732006e094d$exports && $1eae0a73b36f2464$exports(function() {
        var frozenArray = $8fef7f1094929f30$var$freeze([]);
        $8fef7f1094929f30$var$nativeSet(new $8fef7f1094929f30$var$$WeakMap(), frozenArray, 1);
        return !$8fef7f1094929f30$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($b29a2b5771651d66$exports) {
    if ($8fef7f1094929f30$var$IS_IE11) {
        $8fef7f1094929f30$var$InternalWeakMap = $d4fa85d5732141d3$exports.getConstructor($8fef7f1094929f30$var$wrapper, "WeakMap", true);
        $ed6c57276cb56f85$exports.enable();
        var $8fef7f1094929f30$var$nativeDelete = $e5e00809db8eb123$exports($8fef7f1094929f30$var$WeakMapPrototype["delete"]);
        var $8fef7f1094929f30$var$nativeHas = $e5e00809db8eb123$exports($8fef7f1094929f30$var$WeakMapPrototype.has);
        var $8fef7f1094929f30$var$nativeGet = $e5e00809db8eb123$exports($8fef7f1094929f30$var$WeakMapPrototype.get);
        $97155cb1792eff1d$exports($8fef7f1094929f30$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($2b8a0370e236b736$exports(key) && !$8fef7f1094929f30$var$isExtensible(key)) {
                    var state = $8fef7f1094929f30$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8fef7f1094929f30$var$InternalWeakMap();
                    return $8fef7f1094929f30$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $8fef7f1094929f30$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($2b8a0370e236b736$exports(key) && !$8fef7f1094929f30$var$isExtensible(key)) {
                    var state = $8fef7f1094929f30$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8fef7f1094929f30$var$InternalWeakMap();
                    return $8fef7f1094929f30$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $8fef7f1094929f30$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($2b8a0370e236b736$exports(key) && !$8fef7f1094929f30$var$isExtensible(key)) {
                    var state = $8fef7f1094929f30$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8fef7f1094929f30$var$InternalWeakMap();
                    return $8fef7f1094929f30$var$nativeHas(this, key) ? $8fef7f1094929f30$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $8fef7f1094929f30$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($2b8a0370e236b736$exports(key) && !$8fef7f1094929f30$var$isExtensible(key)) {
                    var state = $8fef7f1094929f30$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8fef7f1094929f30$var$InternalWeakMap();
                    $8fef7f1094929f30$var$nativeHas(this, key) ? $8fef7f1094929f30$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $8fef7f1094929f30$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($8fef7f1094929f30$var$hasMSEdgeFreezingBug()) $97155cb1792eff1d$exports($8fef7f1094929f30$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($8fef7f1094929f30$var$isArray(key)) {
                if ($8fef7f1094929f30$var$isFrozen(key)) arrayIntegrityLevel = $8fef7f1094929f30$var$FROZEN;
                else if ($8fef7f1094929f30$var$isSealed(key)) arrayIntegrityLevel = $8fef7f1094929f30$var$SEALED;
            }
            $8fef7f1094929f30$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel === $8fef7f1094929f30$var$FROZEN) $8fef7f1094929f30$var$freeze(key);
            if (arrayIntegrityLevel === $8fef7f1094929f30$var$SEALED) $8fef7f1094929f30$var$seal(key);
            return this;
        }
    });
}




"use strict";






var $537d4b510ac9cf80$var$ITERATOR = $a7e68d87528d04a9$exports("iterator");
var $537d4b510ac9cf80$var$TO_STRING_TAG = $a7e68d87528d04a9$exports("toStringTag");
var $537d4b510ac9cf80$var$ArrayValues = $bca41335d4cd4e50$exports.values;
var $537d4b510ac9cf80$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$537d4b510ac9cf80$var$ITERATOR] !== $537d4b510ac9cf80$var$ArrayValues) try {
            $11de2b231b2859ac$exports(CollectionPrototype, $537d4b510ac9cf80$var$ITERATOR, $537d4b510ac9cf80$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$537d4b510ac9cf80$var$ITERATOR] = $537d4b510ac9cf80$var$ArrayValues;
        }
        if (!CollectionPrototype[$537d4b510ac9cf80$var$TO_STRING_TAG]) $11de2b231b2859ac$exports(CollectionPrototype, $537d4b510ac9cf80$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($c4006a704557e872$exports[COLLECTION_NAME]) for(var METHOD_NAME in $bca41335d4cd4e50$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $bca41335d4cd4e50$exports[METHOD_NAME]) try {
                $11de2b231b2859ac$exports(CollectionPrototype, METHOD_NAME, $bca41335d4cd4e50$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $bca41335d4cd4e50$exports[METHOD_NAME];
            }
        }
    }
};
for(var $537d4b510ac9cf80$var$COLLECTION_NAME in $c4006a704557e872$exports)$537d4b510ac9cf80$var$handlePrototype($1f3655405faf4b93$exports[$537d4b510ac9cf80$var$COLLECTION_NAME] && $1f3655405faf4b93$exports[$537d4b510ac9cf80$var$COLLECTION_NAME].prototype, $537d4b510ac9cf80$var$COLLECTION_NAME);
$537d4b510ac9cf80$var$handlePrototype($9cd3082de33f3371$exports, "DOMTokenList");


var $7244391317ff913c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $7244391317ff913c$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $7244391317ff913c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $7244391317ff913c$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $7244391317ff913c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $7244391317ff913c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $7244391317ff913c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $7244391317ff913c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $7244391317ff913c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $7244391317ff913c$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $7244391317ff913c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7244391317ff913c$var$root = $7244391317ff913c$var$freeGlobal || $7244391317ff913c$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $7244391317ff913c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7244391317ff913c$var$objectToString = $7244391317ff913c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7244391317ff913c$var$nativeMax = Math.max, $7244391317ff913c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7244391317ff913c$var$now = function() {
    return $7244391317ff913c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $7244391317ff913c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($7244391317ff913c$var$FUNC_ERROR_TEXT);
    wait = $7244391317ff913c$var$toNumber(wait) || 0;
    if ($7244391317ff913c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $7244391317ff913c$var$nativeMax($7244391317ff913c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $7244391317ff913c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7244391317ff913c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7244391317ff913c$var$now());
    }
    function debounced() {
        var time = $7244391317ff913c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $7244391317ff913c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($7244391317ff913c$var$FUNC_ERROR_TEXT);
    if ($7244391317ff913c$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $7244391317ff913c$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7244391317ff913c$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7244391317ff913c$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7244391317ff913c$var$isSymbol(value) {
    return typeof value == "symbol" || $7244391317ff913c$var$isObjectLike(value) && $7244391317ff913c$var$objectToString.call(value) == $7244391317ff913c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $7244391317ff913c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($7244391317ff913c$var$isSymbol(value)) return $7244391317ff913c$var$NAN;
    if ($7244391317ff913c$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $7244391317ff913c$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($7244391317ff913c$var$reTrim, "");
    var isBinary = $7244391317ff913c$var$reIsBinary.test(value);
    return isBinary || $7244391317ff913c$var$reIsOctal.test(value) ? $7244391317ff913c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $7244391317ff913c$var$reIsBadHex.test(value) ? $7244391317ff913c$var$NAN : +value;
}
$7244391317ff913c$exports = $7244391317ff913c$var$throttle;


var $3a60d30aee96367f$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $3a60d30aee96367f$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $3a60d30aee96367f$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $3a60d30aee96367f$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $3a60d30aee96367f$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $3a60d30aee96367f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $3a60d30aee96367f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $3a60d30aee96367f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $3a60d30aee96367f$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $3a60d30aee96367f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $3a60d30aee96367f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3a60d30aee96367f$var$root = $3a60d30aee96367f$var$freeGlobal || $3a60d30aee96367f$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $3a60d30aee96367f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3a60d30aee96367f$var$objectToString = $3a60d30aee96367f$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3a60d30aee96367f$var$nativeMax = Math.max, $3a60d30aee96367f$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $3a60d30aee96367f$var$now = function() {
    return $3a60d30aee96367f$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $3a60d30aee96367f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($3a60d30aee96367f$var$FUNC_ERROR_TEXT);
    wait = $3a60d30aee96367f$var$toNumber(wait) || 0;
    if ($3a60d30aee96367f$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $3a60d30aee96367f$var$nativeMax($3a60d30aee96367f$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $3a60d30aee96367f$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $3a60d30aee96367f$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($3a60d30aee96367f$var$now());
    }
    function debounced() {
        var time = $3a60d30aee96367f$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3a60d30aee96367f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3a60d30aee96367f$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3a60d30aee96367f$var$isSymbol(value) {
    return typeof value == "symbol" || $3a60d30aee96367f$var$isObjectLike(value) && $3a60d30aee96367f$var$objectToString.call(value) == $3a60d30aee96367f$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $3a60d30aee96367f$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($3a60d30aee96367f$var$isSymbol(value)) return $3a60d30aee96367f$var$NAN;
    if ($3a60d30aee96367f$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $3a60d30aee96367f$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($3a60d30aee96367f$var$reTrim, "");
    var isBinary = $3a60d30aee96367f$var$reIsBinary.test(value);
    return isBinary || $3a60d30aee96367f$var$reIsOctal.test(value) ? $3a60d30aee96367f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $3a60d30aee96367f$var$reIsBadHex.test(value) ? $3a60d30aee96367f$var$NAN : +value;
}
$3a60d30aee96367f$exports = $3a60d30aee96367f$var$debounce;


var $56b633a9b4c6e1e1$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $56b633a9b4c6e1e1$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $56b633a9b4c6e1e1$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $56b633a9b4c6e1e1$var$funcTag = "[object Function]", $56b633a9b4c6e1e1$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $56b633a9b4c6e1e1$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $56b633a9b4c6e1e1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $56b633a9b4c6e1e1$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $56b633a9b4c6e1e1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $56b633a9b4c6e1e1$var$root = $56b633a9b4c6e1e1$var$freeGlobal || $56b633a9b4c6e1e1$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $56b633a9b4c6e1e1$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $56b633a9b4c6e1e1$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $56b633a9b4c6e1e1$var$arrayProto = Array.prototype, $56b633a9b4c6e1e1$var$funcProto = Function.prototype, $56b633a9b4c6e1e1$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $56b633a9b4c6e1e1$var$coreJsData = $56b633a9b4c6e1e1$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $56b633a9b4c6e1e1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($56b633a9b4c6e1e1$var$coreJsData && $56b633a9b4c6e1e1$var$coreJsData.keys && $56b633a9b4c6e1e1$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $56b633a9b4c6e1e1$var$funcToString = $56b633a9b4c6e1e1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $56b633a9b4c6e1e1$var$hasOwnProperty = $56b633a9b4c6e1e1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $56b633a9b4c6e1e1$var$objectToString = $56b633a9b4c6e1e1$var$objectProto.toString;
/** Used to detect if a method is native. */ var $56b633a9b4c6e1e1$var$reIsNative = RegExp("^" + $56b633a9b4c6e1e1$var$funcToString.call($56b633a9b4c6e1e1$var$hasOwnProperty).replace($56b633a9b4c6e1e1$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $56b633a9b4c6e1e1$var$splice = $56b633a9b4c6e1e1$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $56b633a9b4c6e1e1$var$Map = $56b633a9b4c6e1e1$var$getNative($56b633a9b4c6e1e1$var$root, "Map"), $56b633a9b4c6e1e1$var$nativeCreate = $56b633a9b4c6e1e1$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $56b633a9b4c6e1e1$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $56b633a9b4c6e1e1$var$hashClear() {
    this.__data__ = $56b633a9b4c6e1e1$var$nativeCreate ? $56b633a9b4c6e1e1$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56b633a9b4c6e1e1$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $56b633a9b4c6e1e1$var$hashGet(key) {
    var data = this.__data__;
    if ($56b633a9b4c6e1e1$var$nativeCreate) {
        var result = data[key];
        return result === $56b633a9b4c6e1e1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $56b633a9b4c6e1e1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $56b633a9b4c6e1e1$var$hashHas(key) {
    var data = this.__data__;
    return $56b633a9b4c6e1e1$var$nativeCreate ? data[key] !== undefined : $56b633a9b4c6e1e1$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $56b633a9b4c6e1e1$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $56b633a9b4c6e1e1$var$nativeCreate && value === undefined ? $56b633a9b4c6e1e1$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$56b633a9b4c6e1e1$var$Hash.prototype.clear = $56b633a9b4c6e1e1$var$hashClear;
$56b633a9b4c6e1e1$var$Hash.prototype["delete"] = $56b633a9b4c6e1e1$var$hashDelete;
$56b633a9b4c6e1e1$var$Hash.prototype.get = $56b633a9b4c6e1e1$var$hashGet;
$56b633a9b4c6e1e1$var$Hash.prototype.has = $56b633a9b4c6e1e1$var$hashHas;
$56b633a9b4c6e1e1$var$Hash.prototype.set = $56b633a9b4c6e1e1$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $56b633a9b4c6e1e1$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $56b633a9b4c6e1e1$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56b633a9b4c6e1e1$var$listCacheDelete(key) {
    var data = this.__data__, index = $56b633a9b4c6e1e1$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $56b633a9b4c6e1e1$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $56b633a9b4c6e1e1$var$listCacheGet(key) {
    var data = this.__data__, index = $56b633a9b4c6e1e1$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $56b633a9b4c6e1e1$var$listCacheHas(key) {
    return $56b633a9b4c6e1e1$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $56b633a9b4c6e1e1$var$listCacheSet(key, value) {
    var data = this.__data__, index = $56b633a9b4c6e1e1$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$56b633a9b4c6e1e1$var$ListCache.prototype.clear = $56b633a9b4c6e1e1$var$listCacheClear;
$56b633a9b4c6e1e1$var$ListCache.prototype["delete"] = $56b633a9b4c6e1e1$var$listCacheDelete;
$56b633a9b4c6e1e1$var$ListCache.prototype.get = $56b633a9b4c6e1e1$var$listCacheGet;
$56b633a9b4c6e1e1$var$ListCache.prototype.has = $56b633a9b4c6e1e1$var$listCacheHas;
$56b633a9b4c6e1e1$var$ListCache.prototype.set = $56b633a9b4c6e1e1$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $56b633a9b4c6e1e1$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $56b633a9b4c6e1e1$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $56b633a9b4c6e1e1$var$Hash,
        "map": new ($56b633a9b4c6e1e1$var$Map || $56b633a9b4c6e1e1$var$ListCache),
        "string": new $56b633a9b4c6e1e1$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56b633a9b4c6e1e1$var$mapCacheDelete(key) {
    return $56b633a9b4c6e1e1$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $56b633a9b4c6e1e1$var$mapCacheGet(key) {
    return $56b633a9b4c6e1e1$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $56b633a9b4c6e1e1$var$mapCacheHas(key) {
    return $56b633a9b4c6e1e1$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $56b633a9b4c6e1e1$var$mapCacheSet(key, value) {
    $56b633a9b4c6e1e1$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$56b633a9b4c6e1e1$var$MapCache.prototype.clear = $56b633a9b4c6e1e1$var$mapCacheClear;
$56b633a9b4c6e1e1$var$MapCache.prototype["delete"] = $56b633a9b4c6e1e1$var$mapCacheDelete;
$56b633a9b4c6e1e1$var$MapCache.prototype.get = $56b633a9b4c6e1e1$var$mapCacheGet;
$56b633a9b4c6e1e1$var$MapCache.prototype.has = $56b633a9b4c6e1e1$var$mapCacheHas;
$56b633a9b4c6e1e1$var$MapCache.prototype.set = $56b633a9b4c6e1e1$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $56b633a9b4c6e1e1$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($56b633a9b4c6e1e1$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $56b633a9b4c6e1e1$var$baseIsNative(value) {
    if (!$56b633a9b4c6e1e1$var$isObject(value) || $56b633a9b4c6e1e1$var$isMasked(value)) return false;
    var pattern = $56b633a9b4c6e1e1$var$isFunction(value) || $56b633a9b4c6e1e1$var$isHostObject(value) ? $56b633a9b4c6e1e1$var$reIsNative : $56b633a9b4c6e1e1$var$reIsHostCtor;
    return pattern.test($56b633a9b4c6e1e1$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $56b633a9b4c6e1e1$var$getMapData(map, key) {
    var data = map.__data__;
    return $56b633a9b4c6e1e1$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $56b633a9b4c6e1e1$var$getNative(object, key) {
    var value = $56b633a9b4c6e1e1$var$getValue(object, key);
    return $56b633a9b4c6e1e1$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $56b633a9b4c6e1e1$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $56b633a9b4c6e1e1$var$isMasked(func) {
    return !!$56b633a9b4c6e1e1$var$maskSrcKey && $56b633a9b4c6e1e1$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $56b633a9b4c6e1e1$var$toSource(func) {
    if (func != null) {
        try {
            return $56b633a9b4c6e1e1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $56b633a9b4c6e1e1$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($56b633a9b4c6e1e1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($56b633a9b4c6e1e1$var$memoize.Cache || $56b633a9b4c6e1e1$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$56b633a9b4c6e1e1$var$memoize.Cache = $56b633a9b4c6e1e1$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $56b633a9b4c6e1e1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $56b633a9b4c6e1e1$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $56b633a9b4c6e1e1$var$isObject(value) ? $56b633a9b4c6e1e1$var$objectToString.call(value) : "";
    return tag == $56b633a9b4c6e1e1$var$funcTag || tag == $56b633a9b4c6e1e1$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $56b633a9b4c6e1e1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
$56b633a9b4c6e1e1$exports = $56b633a9b4c6e1e1$var$memoize;


var $2ef4223b53facd9e$export$402e76927ebf6a24 = [];


var $91c64e42b59fb77c$export$63c81bd924f89474 = function() {
    return (0, $2ef4223b53facd9e$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $5f99020e4b6246f4$export$8ca35300535e324d = function() {
    return (0, $2ef4223b53facd9e$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $8c06244d3632a652$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $8c06244d3632a652$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $8c06244d3632a652$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $8c06244d3632a652$var$msg;
    }
    window.dispatchEvent(event);
};



var $afdeadd51e6a0c26$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($afdeadd51e6a0c26$export$416d111b83cd1483 || ($afdeadd51e6a0c26$export$416d111b83cd1483 = {}));


var $e2b3070e930a38fc$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $2f8f567c478e6a47$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $e2b3070e930a38fc$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $ec122edb1e8640f6$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $e2b3070e930a38fc$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $aefa790a39bc0418$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $aefa790a39bc0418$export$ee695c13482bb5dd = function(target) {
    if ($aefa790a39bc0418$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $aefa790a39bc0418$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $aefa790a39bc0418$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $6a42b041d62a1824$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $72c4bf2312834c69$var$cache = new WeakMap();
var $72c4bf2312834c69$var$scrollRegexp = /auto|scroll/;
var $72c4bf2312834c69$var$verticalRegexp = /^tb|vertical/;
var $72c4bf2312834c69$var$IE = /msie|trident/i.test((0, $6a42b041d62a1824$export$90b4d2ff6acb88af).navigator && (0, $6a42b041d62a1824$export$90b4d2ff6acb88af).navigator.userAgent);
var $72c4bf2312834c69$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $72c4bf2312834c69$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $2f8f567c478e6a47$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $72c4bf2312834c69$var$zeroBoxes = (0, $e2b3070e930a38fc$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $72c4bf2312834c69$var$size(),
    borderBoxSize: $72c4bf2312834c69$var$size(),
    contentBoxSize: $72c4bf2312834c69$var$size(),
    contentRect: new (0, $ec122edb1e8640f6$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $72c4bf2312834c69$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($72c4bf2312834c69$var$cache.has(target) && !forceRecalculation) return $72c4bf2312834c69$var$cache.get(target);
    if ((0, $aefa790a39bc0418$export$ee695c13482bb5dd)(target)) {
        $72c4bf2312834c69$var$cache.set(target, $72c4bf2312834c69$var$zeroBoxes);
        return $72c4bf2312834c69$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $aefa790a39bc0418$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$72c4bf2312834c69$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $72c4bf2312834c69$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $72c4bf2312834c69$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $72c4bf2312834c69$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $72c4bf2312834c69$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $72c4bf2312834c69$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $72c4bf2312834c69$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $e2b3070e930a38fc$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $72c4bf2312834c69$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $72c4bf2312834c69$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $72c4bf2312834c69$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $ec122edb1e8640f6$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $72c4bf2312834c69$var$cache.set(target, boxes);
    return boxes;
};
var $72c4bf2312834c69$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $72c4bf2312834c69$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $afdeadd51e6a0c26$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $afdeadd51e6a0c26$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $4595459028d6748e$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $72c4bf2312834c69$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $e2b3070e930a38fc$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $e2b3070e930a38fc$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $e2b3070e930a38fc$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $0901b6a89bc433f0$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $aefa790a39bc0418$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $67f25cbbec8bdab3$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $2ef4223b53facd9e$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $4595459028d6748e$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $0901b6a89bc433f0$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $72c4bf2312834c69$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $fe79f90acd68ccdf$export$9c17b8913a2a3572 = function(depth) {
    (0, $2ef4223b53facd9e$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $0901b6a89bc433f0$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $6ac119b910eb5cc3$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $fe79f90acd68ccdf$export$9c17b8913a2a3572)(depth);
    while((0, $91c64e42b59fb77c$export$63c81bd924f89474)()){
        depth = (0, $67f25cbbec8bdab3$export$9cac928141e5443b)();
        (0, $fe79f90acd68ccdf$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $5f99020e4b6246f4$export$8ca35300535e324d)()) (0, $8c06244d3632a652$export$888cb69481582149)();
    return depth > 0;
};



var $a07a493cd96fef37$var$trigger;
var $a07a493cd96fef37$var$callbacks = [];
var $a07a493cd96fef37$var$notify = function() {
    return $a07a493cd96fef37$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $a07a493cd96fef37$export$4c995d4933c4abb = function(callback) {
    if (!$a07a493cd96fef37$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $a07a493cd96fef37$var$notify();
        }).observe(el_1, config);
        $a07a493cd96fef37$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $a07a493cd96fef37$var$callbacks.push(callback);
    $a07a493cd96fef37$var$trigger();
};


var $f4ef987da33f502b$export$5755c7b572e34c6 = function(cb) {
    (0, $a07a493cd96fef37$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $9489a4ef27c40126$var$watching = 0;
var $9489a4ef27c40126$var$isWatching = function() {
    return !!$9489a4ef27c40126$var$watching;
};
var $9489a4ef27c40126$var$CATCH_PERIOD = 250;
var $9489a4ef27c40126$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $9489a4ef27c40126$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $9489a4ef27c40126$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $9489a4ef27c40126$var$scheduled = false;
var $9489a4ef27c40126$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $9489a4ef27c40126$var$CATCH_PERIOD;
        if ($9489a4ef27c40126$var$scheduled) return;
        $9489a4ef27c40126$var$scheduled = true;
        var until = $9489a4ef27c40126$var$time(timeout);
        (0, $f4ef987da33f502b$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $6ac119b910eb5cc3$export$e54fe5b0f43758f7)();
            } finally{
                $9489a4ef27c40126$var$scheduled = false;
                timeout = until - $9489a4ef27c40126$var$time();
                if (!$9489a4ef27c40126$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $9489a4ef27c40126$var$observerConfig);
        };
        document.body ? cb() : (0, $6a42b041d62a1824$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $9489a4ef27c40126$var$events.forEach(function(name) {
                return (0, $6a42b041d62a1824$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $9489a4ef27c40126$var$events.forEach(function(name) {
                return (0, $6a42b041d62a1824$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $9489a4ef27c40126$export$d30788f2c20241cd = new $9489a4ef27c40126$var$Scheduler();
var $9489a4ef27c40126$export$1f18a74d42722835 = function(n) {
    !$9489a4ef27c40126$var$watching && n > 0 && $9489a4ef27c40126$export$d30788f2c20241cd.start();
    $9489a4ef27c40126$var$watching += n;
    !$9489a4ef27c40126$var$watching && $9489a4ef27c40126$export$d30788f2c20241cd.stop();
};





var $b4b9ff4b69cd43f6$var$skipNotifyOnElement = function(target) {
    return !(0, $aefa790a39bc0418$export$165b39ed277223c2)(target) && !(0, $aefa790a39bc0418$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $b4b9ff4b69cd43f6$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $afdeadd51e6a0c26$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $72c4bf2312834c69$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($b4b9ff4b69cd43f6$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $0d692aec0be0ecb0$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $a887a55102143459$var$observerMap = new WeakMap();
var $a887a55102143459$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $a887a55102143459$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $0d692aec0be0ecb0$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $a887a55102143459$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $a887a55102143459$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($a887a55102143459$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $2ef4223b53facd9e$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $b4b9ff4b69cd43f6$export$fea412043713122)(target, options && options.box));
            (0, $9489a4ef27c40126$export$1f18a74d42722835)(1);
            (0, $9489a4ef27c40126$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $a887a55102143459$var$observerMap.get(resizeObserver);
        var index = $a887a55102143459$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $2ef4223b53facd9e$export$402e76927ebf6a24).splice((0, $2ef4223b53facd9e$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $9489a4ef27c40126$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $a887a55102143459$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $2061ef5f080bbd7a$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $a887a55102143459$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $aefa790a39bc0418$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $a887a55102143459$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $aefa790a39bc0418$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $a887a55102143459$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $a887a55102143459$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






"use strict";

var $d95d06967f21bc9e$exports = {};
"use strict";




var $d95d06967f21bc9e$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $d95d06967f21bc9e$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $828965f5bec31db8$exports(callbackfn);
        var O = $563602a94d4dc012$exports(that);
        var self = $d8b1bffb46e6bac1$exports(O);
        var length = $652464498d4572b8$exports(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $d95d06967f21bc9e$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$d95d06967f21bc9e$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $d95d06967f21bc9e$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $d95d06967f21bc9e$var$createMethod(true)
};


var $f48a6c593cdcbc72$require$$reduce = $d95d06967f21bc9e$exports.left;


var $a7cfd674760c920c$exports = {};
"use strict";


$a7cfd674760c920c$exports = $ad4a9d272ee83106$exports($1f3655405faf4b93$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $f48a6c593cdcbc72$var$CHROME_BUG = !$a7cfd674760c920c$exports && $e686f780cf055b91$exports > 79 && $e686f780cf055b91$exports < 83;
var $f48a6c593cdcbc72$var$FORCED = $f48a6c593cdcbc72$var$CHROME_BUG || !$8913e86092e0a1cf$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$7058f76fc2e3a64a$exports({
    target: "Array",
    proto: true,
    forced: $f48a6c593cdcbc72$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $f48a6c593cdcbc72$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $0c87d36a66868813$exports = {};
"use strict";



var $3a153e2acfc103dd$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$3a153e2acfc103dd$exports = function() {
    var that = $3843f2a291eb95b4$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $2f960d170caa6b71$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $2f960d170caa6b71$var$$RegExp = $1f3655405faf4b93$exports.RegExp;
var $2f960d170caa6b71$var$UNSUPPORTED_Y = $1eae0a73b36f2464$exports(function() {
    var re = $2f960d170caa6b71$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $2f960d170caa6b71$var$MISSED_STICKY = $2f960d170caa6b71$var$UNSUPPORTED_Y || $1eae0a73b36f2464$exports(function() {
    return !$2f960d170caa6b71$var$$RegExp("a", "y").sticky;
});
var $2f960d170caa6b71$var$BROKEN_CARET = $2f960d170caa6b71$var$UNSUPPORTED_Y || $1eae0a73b36f2464$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $2f960d170caa6b71$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$2f960d170caa6b71$exports = {
    BROKEN_CARET: $2f960d170caa6b71$var$BROKEN_CARET,
    MISSED_STICKY: $2f960d170caa6b71$var$MISSED_STICKY,
    UNSUPPORTED_Y: $2f960d170caa6b71$var$UNSUPPORTED_Y
};





var $0c87d36a66868813$require$getInternalState = $b8c75d97df4614cd$exports.get;
var $dd9676fb23ecf87f$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $dd9676fb23ecf87f$var$$RegExp = $1f3655405faf4b93$exports.RegExp;
$dd9676fb23ecf87f$exports = $1eae0a73b36f2464$exports(function() {
    var re = $dd9676fb23ecf87f$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $db39c5249bba45a9$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $db39c5249bba45a9$var$$RegExp = $1f3655405faf4b93$exports.RegExp;
$db39c5249bba45a9$exports = $1eae0a73b36f2464$exports(function() {
    var re = $db39c5249bba45a9$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $0c87d36a66868813$var$nativeReplace = $c761b911d1948532$exports("native-string-replace", String.prototype.replace);
var $0c87d36a66868813$var$nativeExec = RegExp.prototype.exec;
var $0c87d36a66868813$var$patchedExec = $0c87d36a66868813$var$nativeExec;
var $0c87d36a66868813$var$charAt = $e5e00809db8eb123$exports("".charAt);
var $0c87d36a66868813$var$indexOf = $e5e00809db8eb123$exports("".indexOf);
var $0c87d36a66868813$var$replace = $e5e00809db8eb123$exports("".replace);
var $0c87d36a66868813$var$stringSlice = $e5e00809db8eb123$exports("".slice);
var $0c87d36a66868813$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $52ac2d1f7b3fc221$exports($0c87d36a66868813$var$nativeExec, re1, "a");
    $52ac2d1f7b3fc221$exports($0c87d36a66868813$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $0c87d36a66868813$var$UNSUPPORTED_Y = $2f960d170caa6b71$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $0c87d36a66868813$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $0c87d36a66868813$var$PATCH = $0c87d36a66868813$var$UPDATES_LAST_INDEX_WRONG || $0c87d36a66868813$var$NPCG_INCLUDED || $0c87d36a66868813$var$UNSUPPORTED_Y || $dd9676fb23ecf87f$exports || $db39c5249bba45a9$exports;
if ($0c87d36a66868813$var$PATCH) $0c87d36a66868813$var$patchedExec = function exec(string) {
    var re = this;
    var state = $0c87d36a66868813$require$getInternalState(re);
    var str = $f598d5e3ccd5a756$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $52ac2d1f7b3fc221$exports($0c87d36a66868813$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $0c87d36a66868813$var$UNSUPPORTED_Y && re.sticky;
    var flags = $52ac2d1f7b3fc221$exports($3a153e2acfc103dd$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $0c87d36a66868813$var$replace(flags, "y", "");
        if ($0c87d36a66868813$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $0c87d36a66868813$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $0c87d36a66868813$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($0c87d36a66868813$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($0c87d36a66868813$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $52ac2d1f7b3fc221$exports($0c87d36a66868813$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $0c87d36a66868813$var$stringSlice(match.input, charsAdded);
            match[0] = $0c87d36a66868813$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($0c87d36a66868813$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($0c87d36a66868813$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $52ac2d1f7b3fc221$exports($0c87d36a66868813$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $d35380bd6dbffbb9$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$0c87d36a66868813$exports = $0c87d36a66868813$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$7058f76fc2e3a64a$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $0c87d36a66868813$exports
}, {
    exec: $0c87d36a66868813$exports
});


"use strict";

var $eadada8e36b63559$exports = {};
"use strict";







var $eadada8e36b63559$var$SPECIES = $a7e68d87528d04a9$exports("species");
var $eadada8e36b63559$var$RegExpPrototype = RegExp.prototype;
$eadada8e36b63559$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $a7e68d87528d04a9$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1eae0a73b36f2464$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1eae0a73b36f2464$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$eadada8e36b63559$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $6c22f7c638581f91$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $6c22f7c638581f91$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $0c87d36a66868813$exports || $exec === $eadada8e36b63559$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $bf5de196043a4fd2$exports(String.prototype, KEY, methods[0]);
        $bf5de196043a4fd2$exports($eadada8e36b63559$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $11de2b231b2859ac$exports($eadada8e36b63559$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $3b69c791682cda84$exports = {};
"use strict";

var $3b69c791682cda84$require$charAt = $4dc1d913e18f4646$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$3b69c791682cda84$exports = function(S, index, unicode) {
    return index + (unicode ? $3b69c791682cda84$require$charAt(S, index).length : 1);
};


var $e4ed30f15025c84b$exports = {};
"use strict";





var $e4ed30f15025c84b$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$e4ed30f15025c84b$exports = function(R, S) {
    var exec = R.exec;
    if ($9261b09349da61cf$exports(exec)) {
        var result = $52ac2d1f7b3fc221$exports(exec, R, S);
        if (result !== null) $3843f2a291eb95b4$exports(result);
        return result;
    }
    if ($ad4a9d272ee83106$exports(R) === "RegExp") return $52ac2d1f7b3fc221$exports($0c87d36a66868813$exports, R, S);
    throw new $e4ed30f15025c84b$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$eadada8e36b63559$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $fb9649058d88e05e$exports(this);
            var matcher = $c9cec627d9a032db$exports(regexp) ? undefined : $7449e8f88cb85375$exports(regexp, MATCH);
            return matcher ? $52ac2d1f7b3fc221$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($f598d5e3ccd5a756$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $3843f2a291eb95b4$exports(this);
            var S = $f598d5e3ccd5a756$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $e4ed30f15025c84b$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $e4ed30f15025c84b$exports(rx, S)) !== null){
                var matchStr = $f598d5e3ccd5a756$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $3b69c791682cda84$exports(S, $7db5197aa28dc3ca$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";


var $1862c7e026083456$require$FUNCTION_NAME_EXISTS = $93fac42f9e89a850$exports.EXISTS;

var $c4afc0259ed968b5$exports = {};
"use strict";


$c4afc0259ed968b5$exports = function(target, name, descriptor) {
    if (descriptor.get) $93b6f46cc432668a$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $93b6f46cc432668a$exports(descriptor.set, name, {
        setter: true
    });
    return $9ed44e563230b16a$export$2d1720544b23b823(target, name, descriptor);
};


var $1862c7e026083456$var$FunctionPrototype = Function.prototype;
var $1862c7e026083456$var$functionToString = $e5e00809db8eb123$exports($1862c7e026083456$var$FunctionPrototype.toString);
var $1862c7e026083456$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $1862c7e026083456$var$regExpExec = $e5e00809db8eb123$exports($1862c7e026083456$var$nameRE.exec);
var $1862c7e026083456$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($1b14517606367da3$exports && !$1862c7e026083456$require$FUNCTION_NAME_EXISTS) $c4afc0259ed968b5$exports($1862c7e026083456$var$FunctionPrototype, $1862c7e026083456$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $1862c7e026083456$var$regExpExec($1862c7e026083456$var$nameRE, $1862c7e026083456$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $86c2d867bf58e5bf$exports = {};
"use strict";

var $86c2d867bf58e5bf$var$FunctionPrototype = Function.prototype;
var $86c2d867bf58e5bf$var$apply = $86c2d867bf58e5bf$var$FunctionPrototype.apply;
var $86c2d867bf58e5bf$var$call = $86c2d867bf58e5bf$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$86c2d867bf58e5bf$exports = typeof Reflect == "object" && Reflect.apply || ($c3c0a5f76e5e916e$exports ? $86c2d867bf58e5bf$var$call.bind($86c2d867bf58e5bf$var$apply) : function() {
    return $86c2d867bf58e5bf$var$call.apply($86c2d867bf58e5bf$var$apply, arguments);
});















var $736994426c500672$exports = {};
"use strict";


var $736994426c500672$var$floor = Math.floor;
var $736994426c500672$var$charAt = $e5e00809db8eb123$exports("".charAt);
var $736994426c500672$var$replace = $e5e00809db8eb123$exports("".replace);
var $736994426c500672$var$stringSlice = $e5e00809db8eb123$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $736994426c500672$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $736994426c500672$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$736994426c500672$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $736994426c500672$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $563602a94d4dc012$exports(namedCaptures);
        symbols = $736994426c500672$var$SUBSTITUTION_SYMBOLS;
    }
    return $736994426c500672$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($736994426c500672$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $736994426c500672$var$stringSlice(str, 0, position);
            case "'":
                return $736994426c500672$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$736994426c500672$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $736994426c500672$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $736994426c500672$var$charAt(ch, 1) : captures[f - 1] + $736994426c500672$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $4416b523b1b43223$var$REPLACE = $a7e68d87528d04a9$exports("replace");
var $4416b523b1b43223$var$max = Math.max;
var $4416b523b1b43223$var$min = Math.min;
var $4416b523b1b43223$var$concat = $e5e00809db8eb123$exports([].concat);
var $4416b523b1b43223$var$push = $e5e00809db8eb123$exports([].push);
var $4416b523b1b43223$var$stringIndexOf = $e5e00809db8eb123$exports("".indexOf);
var $4416b523b1b43223$var$stringSlice = $e5e00809db8eb123$exports("".slice);
var $4416b523b1b43223$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $4416b523b1b43223$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $4416b523b1b43223$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$4416b523b1b43223$var$REPLACE]) return /./[$4416b523b1b43223$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $4416b523b1b43223$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1eae0a73b36f2464$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$eadada8e36b63559$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $4416b523b1b43223$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $fb9649058d88e05e$exports(this);
            var replacer = $c9cec627d9a032db$exports(searchValue) ? undefined : $7449e8f88cb85375$exports(searchValue, $4416b523b1b43223$var$REPLACE);
            return replacer ? $52ac2d1f7b3fc221$exports(replacer, searchValue, O, replaceValue) : $52ac2d1f7b3fc221$exports(nativeReplace, $f598d5e3ccd5a756$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $3843f2a291eb95b4$exports(this);
            var S = $f598d5e3ccd5a756$exports(string);
            if (typeof replaceValue == "string" && $4416b523b1b43223$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $4416b523b1b43223$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $9261b09349da61cf$exports(replaceValue);
            if (!functionalReplace) replaceValue = $f598d5e3ccd5a756$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $e4ed30f15025c84b$exports(rx, S);
                if (result === null) break;
                $4416b523b1b43223$var$push(results, result);
                if (!global) break;
                var matchStr = $f598d5e3ccd5a756$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $3b69c791682cda84$exports(S, $7db5197aa28dc3ca$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $f598d5e3ccd5a756$exports(result[0]);
                var position = $4416b523b1b43223$var$max($4416b523b1b43223$var$min($2d9dedc240706176$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$4416b523b1b43223$var$push(captures, $4416b523b1b43223$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $4416b523b1b43223$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $4416b523b1b43223$var$push(replacerArgs, namedCaptures);
                    replacement = $f598d5e3ccd5a756$exports($86c2d867bf58e5bf$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $736994426c500672$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $4416b523b1b43223$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $4416b523b1b43223$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$4416b523b1b43223$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$4416b523b1b43223$var$REPLACE_KEEPS_$0 || $4416b523b1b43223$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


// Helper function to retrieve options from element attributes
var $1d67f44e32b66f1f$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
function $1d67f44e32b66f1f$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $1d67f44e32b66f1f$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $1d67f44e32b66f1f$var$cachedScrollbarWidth = null;
var $1d67f44e32b66f1f$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($63282e8d41214218$exports))) window.addEventListener("resize", function() {
    if ($1d67f44e32b66f1f$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $1d67f44e32b66f1f$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $1d67f44e32b66f1f$var$cachedScrollbarWidth = null;
    }
});
function $1d67f44e32b66f1f$var$scrollbarWidth(el) {
    if ($1d67f44e32b66f1f$var$cachedScrollbarWidth === null) {
        var document1 = $1d67f44e32b66f1f$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $1d67f44e32b66f1f$var$cachedScrollbarWidth = 0;
            return $1d67f44e32b66f1f$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $1d67f44e32b66f1f$var$cachedScrollbarWidth = width;
    }
    return $1d67f44e32b66f1f$var$cachedScrollbarWidth;
}
var $1d67f44e32b66f1f$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $1d67f44e32b66f1f$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $1d67f44e32b66f1f$var$getElementDocument(_this.el);
            var elWindow = $1d67f44e32b66f1f$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($7244391317ff913c$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($7244391317ff913c$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($3a60d30aee96367f$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($3a60d30aee96367f$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($56b633a9b4c6e1e1$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $1d67f44e32b66f1f$var$getElementDocument(el);
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($63282e8d41214218$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $2061ef5f080bbd7a$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $1d67f44e32b66f1f$var$getElementDocument(this.el);
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $1d67f44e32b66f1f$var$scrollbarWidth(this.el);
        } catch (e) {
            return $1d67f44e32b66f1f$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $1d67f44e32b66f1f$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$1d67f44e32b66f1f$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$1d67f44e32b66f1f$var$SimpleBar.instances = new WeakMap();
$1d67f44e32b66f1f$var$SimpleBar.initDOMLoadedElements = function() {
    document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements);
    window.removeEventListener("load", this.initDOMLoadedElements);
    Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function(el) {
        if (el.getAttribute("data-simplebar") !== "init" && !$1d67f44e32b66f1f$var$SimpleBar.instances.has(el)) new $1d67f44e32b66f1f$var$SimpleBar(el, $1d67f44e32b66f1f$var$getOptions(el.attributes));
    });
};
$1d67f44e32b66f1f$var$SimpleBar.removeObserver = function() {
    this.globalObserver.disconnect();
};
$1d67f44e32b66f1f$var$SimpleBar.initHtmlApi = function() {
    this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this); // MutationObserver is IE11+
    if (typeof MutationObserver !== "undefined") {
        // Mutation observer to observe dynamically added elements
        this.globalObserver = new MutationObserver($1d67f44e32b66f1f$var$SimpleBar.handleMutations);
        this.globalObserver.observe(document, {
            childList: true,
            subtree: true
        });
    } // Taken from jQuery `ready` function
    // Instantiate elements already present on the page
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
    window.setTimeout(this.initDOMLoadedElements);
    else {
        document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements);
        window.addEventListener("load", this.initDOMLoadedElements);
    }
};
$1d67f44e32b66f1f$var$SimpleBar.handleMutations = function(mutations) {
    mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function(addedNode) {
            if (addedNode.nodeType === 1) {
                if (addedNode.hasAttribute("data-simplebar")) !$1d67f44e32b66f1f$var$SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new $1d67f44e32b66f1f$var$SimpleBar(addedNode, $1d67f44e32b66f1f$var$getOptions(addedNode.attributes));
                else Array.prototype.forEach.call(addedNode.querySelectorAll("[data-simplebar]"), function(el) {
                    if (el.getAttribute("data-simplebar") !== "init" && !$1d67f44e32b66f1f$var$SimpleBar.instances.has(el) && document.documentElement.contains(el)) new $1d67f44e32b66f1f$var$SimpleBar(el, $1d67f44e32b66f1f$var$getOptions(el.attributes));
                });
            }
        });
        Array.prototype.forEach.call(mutation.removedNodes, function(removedNode) {
            if (removedNode.nodeType === 1) {
                if (removedNode.getAttribute("data-simplebar") === "init") $1d67f44e32b66f1f$var$SimpleBar.instances.has(removedNode) && !document.documentElement.contains(removedNode) && $1d67f44e32b66f1f$var$SimpleBar.instances.get(removedNode).unMount();
                else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                    $1d67f44e32b66f1f$var$SimpleBar.instances.has(el) && !document.documentElement.contains(el) && $1d67f44e32b66f1f$var$SimpleBar.instances.get(el).unMount();
                });
            }
        });
    });
};
$1d67f44e32b66f1f$var$SimpleBar.getOptions = $1d67f44e32b66f1f$var$getOptions;
/**
 * HTML API
 * Called only in a browser env.
 */ if (0, (/*@__PURE__*/$parcel$interopDefault($63282e8d41214218$exports))) $1d67f44e32b66f1f$var$SimpleBar.initHtmlApi();
var $1d67f44e32b66f1f$export$2e2bcd8739ae039 = $1d67f44e32b66f1f$var$SimpleBar;


var $007db0a3d89c8a26$exports = {};
"use strict";
function $0b57f21fded9e412$var$_typeof(t) {
    return ($0b57f21fded9e412$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $0b57f21fded9e412$export$2e2bcd8739ae039(t) {
    var W = {
        type: "title",
        direction: "top",
        align: "center",
        offset: 20,
        tooltipSelector: [
            "xm-tooltip"
        ],
        textSelector: "xm-tooltip-text",
        eventHandler: "hover",
        animation: {
            type: "static",
            ease: "ease-in-out",
            speed: 0.3,
            translateOffset: 10
        }
    }, h = {}, i = function() {
        var t = document.querySelectorAll(W.container);
        o(t[0], W.container), h.tooltips = [], t.forEach(function(t) {
            var i = {}, e = document.createElement("div"), a = !0, n = !1, o = void 0;
            try {
                for(var r, l = W.tooltipSelector[Symbol.iterator](); !(a = (r = l.next()).done); a = !0){
                    var s = r.value;
                    e.classList.add(s);
                }
            } catch (t) {
                n = !0, o = t;
            } finally{
                try {
                    a || null == l.return || l.return();
                } finally{
                    if (n) throw o;
                }
            }
            if ("title" === W.type) {
                var m = document.createElement("p");
                m.classList.add(W.textSelector), m.innerHTML = t.getAttribute("data-title"), e.append(m);
            } else W.type = "html", e.innerHTML = W.htmlContent;
            void 0 !== W.parent ? t.parentElement.append(e) : t.append(e), i.containerElement = t, i.tooltipWrap = {
                item: e,
                visible: !1
            }, h.tooltips.push(i);
        });
    }, e = function() {
        var t = !0, i = !1, e = void 0;
        try {
            for(var a, n = h.tooltips[Symbol.iterator](); !(t = (a = n.next()).done); t = !0){
                var o = a.value;
                void 0 !== W.parent ? o.containerElement.parentElement.style.position = "relative" : o.containerElement.style.position = "relative", o.tooltipWrap.item.style.whiteSpace = "nowrap", o.tooltipWrap.item.style.position = "absolute", o.tooltipWrap.item.style.zIndex = 99999;
                var r = 0;
                "top" === W.direction || "bottom" === W.direction ? r += o.tooltipWrap.item.offsetHeight : "left" !== W.direction && "right" !== W.direction || (r += o.tooltipWrap.item.offsetWidth);
                var l = -W.offset - r;
                o.tooltipWrap.item.style[W.direction] = "".concat(l, "px"), "center" === W.align ? "top" === W.direction || "bottom" === W.direction ? (o.tooltipWrap.item.style.left = "50%", o.tooltipWrap.item.style.marginLeft = "-".concat(o.tooltipWrap.item.offsetWidth / 2, "px")) : "left" !== W.direction && "right" !== W.direction || (o.tooltipWrap.item.style.top = "50%", o.tooltipWrap.item.style.marginTop = "-".concat(o.tooltipWrap.item.offsetHeight / 2, "px")) : o.tooltipWrap.item.style[W.align] = 0;
            }
        } catch (t) {
            i = !0, e = t;
        } finally{
            try {
                t || null == n.return || n.return();
            } finally{
                if (i) throw e;
            }
        }
    }, a = function() {
        var t = !0, i = !1, e = void 0;
        try {
            for(var a, n = function() {
                var t = a.value;
                "static" === W.animation.type ? t.tooltipWrap.item.style.display = "none" : "fade" === W.animation.type ? (t.tooltipWrap.item.style.visibility = "hidden", t.tooltipWrap.item.style.opacity = 0) : "zoom" === W.animation.type ? (t.tooltipWrap.item.style.visibility = "hidden", t.tooltipWrap.item.style.transform = "scale(0)") : "zoom-fade" === W.animation.type ? (t.tooltipWrap.item.style.visibility = "hidden", t.tooltipWrap.item.style.opacity = 0, t.tooltipWrap.item.style.transform = "scale(0)") : "translate-in" === W.animation.type ? (t.tooltipWrap.item.style.visibility = "hidden", "top" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.tooltipWrap.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.tooltipWrap.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)"))) : "translate-out" === W.animation.type ? (t.tooltipWrap.item.style.visibility = "hidden", "top" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.tooltipWrap.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.tooltipWrap.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)"))) : "translate-in-fade" === W.animation.type ? (t.tooltipWrap.item.style.opacity = 0, t.tooltipWrap.item.style.visibility = "hidden", "top" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.tooltipWrap.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.tooltipWrap.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)"))) : "translate-out-fade" === W.animation.type && (t.tooltipWrap.item.style.opacity = 0, t.tooltipWrap.item.style.visibility = "hidden", "top" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.tooltipWrap.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.tooltipWrap.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.tooltipWrap.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)"))), window.setTimeout(function() {
                    t.tooltipWrap.item.style.transition = "all ".concat(W.animation.speed, "s ").concat(W.animation.ease);
                }, 300);
            }, o = h.tooltips[Symbol.iterator](); !(t = (a = o.next()).done); t = !0)n();
        } catch (t) {
            i = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (i) throw e;
            }
        }
    }, n = function() {
        if ("hover" === W.eventHandler) {
            var t = !0, i = !1, e = void 0;
            try {
                for(var a, n = function() {
                    var t = a.value;
                    t.containerElement.addEventListener("mouseenter", function() {
                        O(t.tooltipWrap);
                    }), t.containerElement.addEventListener("mouseleave", function() {
                        w(t.tooltipWrap);
                    });
                }, o = h.tooltips[Symbol.iterator](); !(t = (a = o.next()).done); t = !0)n();
            } catch (t) {
                i = !0, e = t;
            } finally{
                try {
                    t || null == o.return || o.return();
                } finally{
                    if (i) throw e;
                }
            }
        } else if ("click" === W.eventHandler) {
            var r = !0, l = !1, s = void 0;
            try {
                for(var m, p = function() {
                    var t = m.value;
                    t.containerElement.addEventListener("click", function() {
                        x(t.tooltipWrap);
                    });
                }, c = h.tooltips[Symbol.iterator](); !(r = (m = c.next()).done); r = !0)p();
            } catch (t) {
                l = !0, s = t;
            } finally{
                try {
                    r || null == c.return || c.return();
                } finally{
                    if (l) throw s;
                }
            }
            window.addEventListener("click", function() {
                var t = !0, i = !1, e = void 0;
                try {
                    for(var a, n = h.tooltips[Symbol.iterator](); !(t = (a = n.next()).done); t = !0){
                        var o = a.value;
                        o.tooltipWrap.visible && w(o.tooltipWrap);
                    }
                } catch (t) {
                    i = !0, e = t;
                } finally{
                    try {
                        t || null == n.return || n.return();
                    } finally{
                        if (i) throw e;
                    }
                }
            }), window.addEventListener("keydown", function(t) {
                if (27 === t.keyCode) {
                    var i = !0, e = !1, a = void 0;
                    try {
                        for(var n, o = h.tooltips[Symbol.iterator](); !(i = (n = o.next()).done); i = !0){
                            var r = n.value;
                            r.tooltipWrap.visible && w(r.tooltipWrap);
                        }
                    } catch (t) {
                        e = !0, a = t;
                    } finally{
                        try {
                            i || null == o.return || o.return();
                        } finally{
                            if (e) throw a;
                        }
                    }
                }
            });
        } else if ("clickTemp" === W.eventHandler) {
            var f = !0, y = !1, d = void 0;
            try {
                for(var v, u = function() {
                    var i = v.value;
                    i.containerElement.addEventListener("click", function(t) {
                        O(i.tooltipWrap), window.setTimeout(function() {
                            w(i.tooltipWrap);
                        }, 2e3);
                    });
                }, b = h.tooltips[Symbol.iterator](); !(f = (v = b.next()).done); f = !0)u();
            } catch (t) {
                y = !0, d = t;
            } finally{
                try {
                    f || null == b.return || b.return();
                } finally{
                    if (y) throw d;
                }
            }
        }
    }, x = function(t) {
        t.visible ? w(t) : O(t);
    }, O = function(t) {
        "static" === W.animation.type ? t.item.style.display = "block" : "fade" === W.animation.type ? (t.item.style.visibility = "visible", t.item.style.opacity = 1) : "zoom" === W.animation.type ? (t.item.style.visibility = "visible", t.item.style.transform = "scale(1)") : "zoom-fade" === W.animation.type ? (t.item.style.visibility = "visible", t.item.style.opacity = 1, t.item.style.transform = "scale(1)") : "translate-in" === W.animation.type || "translate-out" === W.animation.type ? (t.item.style.visibility = "visible", t.item.style.transform = "translate(0, 0)") : "translate-in-fade" !== W.animation.type && "translate-out-fade" !== W.animation.type || (t.item.style.visibility = "visible", t.item.style.opacity = 1, t.item.style.transform = "translate(0, 0)"), window.setTimeout(function() {
            t.visible = !0;
        }, W.animation.speed);
    }, w = function(t) {
        "static" === W.animation.type ? t.item.style.display = "none" : "fade" === W.animation.type ? (t.item.style.visibility = "hidden", t.item.style.opacity = 0) : "zoom" === W.animation.type ? (t.item.style.visibility = "hidden", t.item.style.transform = "scale(0)") : "zoom-fade" === W.animation.type ? (t.item.style.visibility = "hidden", t.item.style.opacity = 0, t.item.style.transform = "scale(0)") : "translate-in" === W.animation.type ? (t.item.style.visibility = "hidden", "top" === W.direction ? t.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)"))) : "translate-out" === W.animation.type ? (t.item.style.visibility = "hidden", "top" === W.direction ? t.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)"))) : "translate-in-fade" === W.animation.type ? (t.item.style.opacity = 0, t.item.style.visibility = "hidden", "top" === W.direction ? t.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)"))) : "translate-out-fade" === W.animation.type && (t.item.style.opacity = 0, t.item.style.visibility = "hidden", "top" === W.direction ? t.item.style.transform = "translate(0, ".concat(W.animation.translateOffset, "px)") : "bottom" === W.direction ? t.item.style.transform = "translate(0, -".concat(W.animation.translateOffset, "px)") : "right" === W.direction ? t.item.style.transform = "translate(-".concat(W.animation.translateOffset, "px, 0)") : "left" === W.direction && (t.item.style.transform = "translate(".concat(W.animation.translateOffset, "px, 0)"))), window.setTimeout(function() {
            t.visible = !1;
        }, W.animation.speed);
    }, o = function(t, i, e) {
        var a = 2 < arguments.length && void 0 !== e && e;
        if (!t) throw a ? new Error("Can't find ".concat(i, " inside ").concat(a)) : new Error("Can't find ".concat(i, " in the DOM"));
    };
    (function t(i, e) {
        var a;
        for(var n in e)"object" !== $0b57f21fded9e412$var$_typeof(e[n]) || e[n] instanceof Date ? e[n] instanceof Date ? i[n] = new Date(e[n].getTime()) : i[n] = e[n] : (a = e[n] instanceof Array ? [] : {}, void 0 === i[n] && (i[n] = a), t(i[n], e[n]));
    })(W, t), i(), e(), a(), n();
}


"use strict";
function $e49978d96d48b386$var$_typeof(t) {
    return ($e49978d96d48b386$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $e49978d96d48b386$export$2e2bcd8739ae039(t) {
    function n() {
        "static" === s.overlay.animation.type ? r.overlay.style.display = "block" : "fade" === s.overlay.animation.type && (r.overlay.style.opacity = 1, r.overlay.style.visibility = "visible"), r.visible = !0, s.sticky || (r.popupContainer.style.top = "".concat(s.offset.top + window.scrollY, "px")), "fade" === s.animation.type ? (r.popupContainer.style.opacity = 1, r.popupContainer.style.visibility = "visible") : "translate-in" === s.animation.type || "translate-out" === s.animation.type ? (r.popupContainer.style.visibility = "visible", r.popupContainer.style.transform = "translate(0, 0)") : "zoom" === s.animation.type ? (r.popupContainer.style.visibility = "visible", r.popupContainer.style.transform = "scale(1)") : "translate-in-fade" === s.animation.type || "translate-out-fade" === s.animation.type ? (r.popupContainer.style.opacity = 1, r.popupContainer.style.visibility = "visible", r.popupContainer.style.transform = "translate(0, 0)") : "zoom-fade" === s.animation.type && (r.popupContainer.style.opacity = 1, r.popupContainer.style.visibility = "visible", r.popupContainer.style.transform = "scale(1)"), r.open = !0;
    }
    function p() {
        r.open ? f() : n();
    }
    var s = {
        overlay: {
            color: "0, 0, 0",
            opacity: 0.8,
            closeOnClick: !0,
            animation: {
                type: "fade",
                ease: "ease-in-out",
                speed: 0.3
            }
        },
        align: "center",
        sticky: !1,
        offset: {
            top: 100
        },
        animation: {
            type: "fade",
            ease: "ease-in-out",
            speed: 0.3,
            translateOffset: 100
        },
        closeOnKey: 27
    }, r = {}, e = function() {
        r.overlay = document.createElement("div"), o(), document.body.appendChild(r.overlay);
    }, o = function() {
        r.overlay.style.width = "100%", r.overlay.style.height = "100%", r.overlay.style.backgroundColor = "rgba(".concat(s.overlay.color, ", ").concat(s.overlay.opacity, ")"), r.overlay.style.position = "fixed", r.overlay.style.top = 0, r.overlay.style.left = 0, r.overlay.style.zIndex = 1e5, a(), i();
    }, i = function() {
        "fade" === s.overlay.animation.type && (r.overlay.style.transition = "opacity ".concat(s.overlay.animation.speed, "s ").concat(s.overlay.animation.ease, ", \n      visibility ").concat(s.overlay.animation.speed, "s ").concat(s.overlay.animation.ease));
    }, a = function() {
        "static" === s.overlay.animation.type ? r.overlay.style.display = "none" : "fade" === s.overlay.animation.type && (r.overlay.style.opacity = 0, r.overlay.style.visibility = "hidden");
    }, l = function() {
        if (r.popupContainer = document.querySelector(s.container), !r.popupContainer) throw new Error("Couldn't find ".concat(s.container, " in the DOM"));
        y();
    }, y = function() {
        r.popupContainer.style.position = s.sticky ? "fixed" : "absolute", r.popupContainer.style.left = "50%", r.popupContainer.style.zIndex = 100001, f(), u();
    }, c = function() {
        var t = window.innerHeight - r.popupContainer.offsetHeight, n = t < 0 ? 0 : t / 2, e = t < 0 ? 0 : t;
        "center" === s.align ? r.popupContainer.style.top = "".concat(n, "px") : "top" === s.align ? r.popupContainer.style.top = "".concat(s.offset.top, "px") : "bottom" === s.align && (r.popupContainer.style.top = "".concat(e, "px")), s.sticky || (r.visible ? r.popupContainer.style.top = "".concat(s.offset.top + window.scrollY, "px") : r.popupContainer.style.top = "0"), r.popupContainer.style.marginLeft = "-".concat(r.popupContainer.offsetWidth / 2, "px");
    }, u = function() {
        "fade" === s.animation.type ? r.popupContainer.style.transition = "opacity ".concat(s.animation.speed, "s ").concat(s.animation.ease, ", \n      visibility ").concat(s.animation.speed, "s ").concat(s.animation.ease) : "translate-in" === s.animation.type || "translate-out" === s.animation.type || "zoom" === s.animation.type ? r.popupContainer.style.transition = "transform ".concat(s.animation.speed, "s ").concat(s.animation.ease, ", \n      visibility ").concat(s.animation.speed, "s ").concat(s.animation.ease) : "translate-in-fade" !== s.animation.type && "translate-out-fade" !== s.animation.type && "zoom-fade" !== s.animation.type || (r.popupContainer.style.transition = "transform ".concat(s.animation.speed, "s ").concat(s.animation.ease, ", \n      opacity ").concat(s.animation.speed, "s ").concat(s.animation.ease, ", visibility ").concat(s.animation.speed, "s ").concat(s.animation.ease));
    }, f = function() {
        r.visible = !1, "fade" === s.animation.type ? (r.popupContainer.style.opacity = 0, r.popupContainer.style.visibility = "hidden") : "translate-in" === s.animation.type ? (r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "translate(0, -".concat(s.animation.translateOffset, "px)")) : "translate-out" === s.animation.type ? (r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "translate(0, ".concat(s.animation.translateOffset, "px)")) : "zoom" === s.animation.type ? (r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "scale(0)") : "translate-in-fade" === s.animation.type ? (r.popupContainer.style.opacity = 0, r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "translate(0, -".concat(s.animation.translateOffset, "px)")) : "translate-out-fade" === s.animation.type ? (r.popupContainer.style.opacity = 0, r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "translate(0, ".concat(s.animation.translateOffset, "px)")) : "zoom-fade" === s.animation.type && (r.popupContainer.style.opacity = 0, r.popupContainer.style.visibility = "hidden", r.popupContainer.style.transform = "scale(0)"), window.setTimeout(function() {
            s.sticky || (r.popupContainer.style.top = "0");
        }, 1e3 * s.animation.speed), a(), r.open = !1;
    }, m = function() {
        var t = document.querySelectorAll(s.trigger);
        if (!t.length) throw new Error("Couldn't find ".concat(s.trigger, " in the DOM"));
        var n = !0, e = !1, o = void 0;
        try {
            for(var i, a = t[Symbol.iterator](); !(n = (i = a.next()).done); n = !0)i.value.addEventListener("click", p);
        } catch (t) {
            e = !0, o = t;
        } finally{
            try {
                n || null == a.return || a.return();
            } finally{
                if (e) throw o;
            }
        }
        s.overlay.closeOnClick && r.overlay.addEventListener("click", f), s.closeOnKey && window.addEventListener("keydown", function(t) {
            t.keyCode === s.closeOnKey && r.open && f();
        });
    };
    return function t(n, e) {
        var o;
        for(var i in e)"object" !== $e49978d96d48b386$var$_typeof(e[i]) || e[i] instanceof Date ? e[i] instanceof Date ? n[i] = new Date(e[i].getTime()) : n[i] = e[i] : (o = e[i] instanceof Array ? [] : {}, void 0 === n[i] && (n[i] = o), t(n[i], e[i]));
    }(s, t), e(), l(), m(), c(), window.addEventListener("resize", c), r;
}


"use strict";
function $271884305fc975b4$var$_typeof(e) {
    return ($271884305fc975b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function $271884305fc975b4$export$2e2bcd8739ae039(h) {
    function e(e, t) {
        var n = t[0], i = t.substring(1);
        "." === n && e.setAttribute("class", i), "#" === n && e.setAttribute("id", i);
    }
    var p = {
        height: 6,
        lineColor: "#ebebeb",
        lineCap: "round",
        buttEnd: !1,
        animation: {
            easing: !0
        },
        animateOnScroll: !1,
        controlAnimation: !1,
        speed: 50,
        scale: {
            start: 0,
            end: 1,
            stop: 1
        },
        invertedProgress: !1,
        reverse: !1,
        linkText: !1,
        innerLink: !0,
        linkToContainer: ".bar-progress-wrap",
        linkTo: ".bar-progress-text",
        extraLinkTo: [],
        linkUnits: "%",
        linkUnitsSelector: ".bar-progress-unit",
        innerTextFollowsProgress: !1,
        decimalPoints: 0,
        barTextStyle: {
            primaryColor: "#fff",
            secondaryColor: "#363636",
            font: "bold 10px Exo, sans-serif"
        }
    }, o = document.createElement("canvas"), r = o.getContext("2d"), l = this, f = function(e) {
        var t = document.createElement("div");
        t.style.width = "".concat(e.partWidth + 2 * e.width, "px"), t.style.height = "".concat(p.height + 2 * e.width, "px"), t.style.border = "".concat(e.width, "px solid ").concat(e.color), t.style.borderRadius = "200px", t.style.position = "absolute", t.style.top = "-".concat(e.width, "px"), t.style.left = "".concat(e.offset, "px"), l.container.append(t);
    }, u = function() {
        if (l.container = document.querySelector(p.container), !l.container) throw Error('Unable to find "'.concat(p.container, '" on the DOM'));
        o.width = p.width, o.height = p.height, o.style.position = "absolute", o.style.top = 0, o.style.left = 0, l.container.style.width = "".concat(p.width, "px"), l.container.style.height = "".concat(p.height, "px"), l.container.style.position = "relative", l.container.append(o);
    }, m = function() {
        var e = 1 / 0;
        for(var t in p.breakpoints)window.innerWidth <= t && (e = t < e ? t : e);
        e !== 1 / 0 && (p.width = p.breakpoints[e].width, p.height = p.breakpoints[e].height);
    }, g = function() {
        var e = 1 / 0;
        for(var t in p.breakpoints)window.innerWidth <= t && (e = t < e ? t : e);
        w(e === 1 / 0 ? p.originalDimensions : p.breakpoints[e]);
    }, w = function(e) {
        void 0 === e && ((e = {}).width = p.width, e.height = p.height), o.width = e.width, o.height = e.height, l.container.style.width = "".concat(e.width, "px"), l.container.style.height = "".concat(e.height, "px");
        var t = p.scale.stop / p.scale.end * e.width;
        if (a(t), p.linkElContainer && p.innerTextFollowsProgress && (p.linkElContainer.style.left = "".concat(t, "px")), k(), 0 != t) {
            if (r.beginPath(), "butt" === p.lineCap && (r.moveTo(0, e.height / 2), r.lineTo(t, e.height / 2)), "round" === p.lineCap) {
                var n = r.lineWidth / 2, i = t - n;
                p.reverse ? (r.moveTo(e.width - n, e.height / 2), e.width - t <= n ? r.lineTo(n, e.height / 2) : r.lineTo(e.width - t, e.height / 2)) : (r.moveTo(n, e.height / 2), i < n ? r.lineTo(n, e.height / 2) : r.lineTo(i, e.height / 2));
            }
            r.stroke();
        }
    }, T = function() {
        p.linkText && (p.innerLink && (p.linkElContainer = l.container.parentElement.querySelector(p.linkToContainer), p.linkElContainer || (p.linkElContainer = document.createElement("div"), e(p.linkElContainer, p.linkToContainer), l.container.append(p.linkElContainer)), p.linkEl = l.container.parentElement.querySelector(p.linkTo), p.linkEl || (p.linkEl = document.createElement("p"), e(p.linkEl, p.linkTo), p.linkElContainer.append(p.linkEl)), p.innerTextFollowsProgress && (p.linkElContainer.style.position = "absolute"), p.linkUnits && (p.linkUnitsEl = document.createElement("span"), e(p.linkUnitsEl, p.linkUnitsSelector), p.linkUnitsEl.innerHTML = p.linkUnits)), 0 < p.extraLinkTo.length && (p.extraLinkEl = [], p.extraLinkTo.forEach(function(e) {
            if (!document.querySelector(e)) throw Error('Unable to find "'.concat(e, '" on the DOM'));
            p.extraLinkEl.push(document.querySelector(e));
        })));
    }, a = function(e) {
        if (p.linkText) {
            var t = (e / p.width * p.scale.end).toFixed(p.decimalPoints);
            p.invertedProgress && (t = p.scale.end - t), p.innerLink && (p.linkEl.innerHTML = t, p.linkUnits && p.linkEl.append(p.linkUnitsEl), "/" === p.linkUnits && (p.linkEl.innerHTML += p.scale.end), p.innerTextFollowsProgress && (p.linkElContainer.style.left = "".concat(e, "px"))), 0 < p.extraLinkTo.length && p.extraLinkEl.forEach(function(e) {
                e.innerHTML = t;
            });
        }
    }, y = function() {
        p.speed = 100 < p.speed ? 100 : p.speed, p.speed = p.speed < 1 ? 1 : p.speed, p.animation.step = p.speed * p.width / 2e3, p.animation.currentProgress = 0;
    };
    function k() {
        if (p.gradient) {
            var e = r.createLinearGradient(0, p.height, p.width, 0);
            e.addColorStop(0, p.gradient.colors[0]), e.addColorStop(1, p.gradient.colors[1]), r.strokeStyle = e;
        } else r.strokeStyle = p.lineColor;
        r.lineCap = p.lineCap, r.lineWidth = p.height;
    }
    function v() {
        for(var e = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) + window.innerHeight, t = o, n = t.offsetTop; t = t.offsetParent;)n += t.offsetTop;
        return n <= e;
    }
    function x() {
        p.animation.currentProgress < p.stopPoint && (p.animation.easing ? (p.animation.currentProgress += 0.06 * (p.stopPoint - p.animation.currentProgress), p.animation.currentProgress >= p.stopPoint - 1 && (p.animation.currentProgress = p.stopPoint, l.done = !0)) : (p.animation.currentProgress += p.animation.step, p.animation.currentProgress >= p.stopPoint && (p.animation.currentProgress = p.stopPoint, l.done = !0))), E(p.animation.currentProgress), l.done || window.requestAnimationFrame(x);
    }
    var E = function(e) {
        var t = 0 < arguments.length && void 0 !== e ? e : p.stopPoint;
        if (a(t), r.clearRect(0, 0, p.width, p.height), 0 === t) return p.emptyText && (p.emptyTextContainer ? p.emptyTextEl = document.querySelector(p.emptyTextContainer) : p.emptyTextEl = p.linkEl.parentElement, p.emptyTextEl.innerHTML = p.emptyText), void (l.done = !0);
        if (r.beginPath(), "butt" === p.lineCap && (r.moveTo(0, p.height / 2), r.lineTo(t, p.height / 2), r.stroke()), "round" === p.lineCap) {
            var n = r.lineWidth / 2, i = t - n;
            p.reverse ? (r.moveTo(p.width - n, p.height / 2), p.width - t <= n ? r.lineTo(n, p.height / 2) : r.lineTo(p.width - t, p.height / 2)) : (r.moveTo(n, p.height / 2), i < n ? r.lineTo(n, p.height / 2) : r.lineTo(i, p.height / 2)), r.stroke(), p.buttEnd && (r.lineCap = "butt", p.reverse ? (r.moveTo(p.width - t, p.height / 2), r.lineTo(p.width - t - n, p.height / 2)) : (r.moveTo(i, p.height / 2), r.lineTo(t, p.height / 2)), r.stroke(), r.lineCap = "round");
        }
        p.barText && s(t), p.completeText && t === p.width && (p.completeTextContainer ? p.completeTextEl = document.querySelector(p.completeTextContainer) : p.completeTextEl = p.linkEl.parentElement, p.completeTextEl.innerHTML = p.completeText);
    }, s = function(e) {
        var t = 0;
        r.font = p.barTextStyle.font;
        for(var n = 0; n < p.barText.length; n++)r.fillStyle = p.barTextStyle.primaryColor, e < t + 12 && (r.fillStyle = p.barTextStyle.secondaryColor), r.fillText(p.barText[n], 12 + t, 4 + p.height / 2), t += r.measureText(p.barText[n]).width;
    };
    l.render = function(e) {
        e = (e = (e = e > p.scale.end ? p.scale.end : e) < p.scale.start ? p.scale.start : e) / p.scale.end * p.width, E(e);
    };
    var b = function e(t, n) {
        var i;
        for(var o in n)"object" !== $271884305fc975b4$var$_typeof(n[o]) || n[o] instanceof Date ? n[o] instanceof Date ? t[o] = new Date(n[o].getTime()) : t[o] = n[o] : (i = n[o] instanceof Array ? [] : {}, void 0 === t[o] && (t[o] = i), e(t[o], n[o]));
    };
    !function() {
        if (b(p, h), "auto" === p.width || void 0 === p.width) {
            var e = document.querySelector(p.container).parentElement;
            p.width = e.offsetWidth, window.addEventListener("resize", function() {
                p.width = e.offsetWidth, w();
            });
        }
        if (p.originalDimensions = {
            width: p.width,
            height: p.height
        }, m(), h.scale && (p.scale.stop = p.scale.stop > p.scale.end ? p.scale.end : p.scale.stop, p.scale.stop = p.scale.stop < p.scale.start ? p.scale.start : p.scale.stop, p.scale.stop = void 0 !== h.scale.stop ? p.scale.stop : p.scale.end), p.stopPoint = p.scale.stop / p.scale.end * p.width, u(), T(), k(), y(), p.animateOnScroll ? v() ? window.requestAnimationFrame(x) : window.addEventListener("scroll", function e() {
            v() && (window.requestAnimationFrame(x), window.removeEventListener("scroll", e));
        }) : p.controlAnimation || E(), void 0 !== p.split) {
            if (void 0 !== p.split.parts) for(var t = (p.width - p.split.gap * (p.split.parts - 1)) / p.split.parts, n = -p.split.gap, i = 0; i < p.split.parts; i++)f({
                width: p.split.gap,
                color: p.split.color,
                offset: n,
                partWidth: t
            }), n += t + p.split.gap;
            else if (void 0 !== p.split.partItems) {
                var o = 0, r = !0, l = !1, a = void 0;
                try {
                    for(var s, c = p.split.partItems[Symbol.iterator](); !(r = (s = c.next()).done); r = !0){
                        var d = s.value;
                        o -= d.gap, f({
                            width: d.gap,
                            color: p.split.color,
                            offset: o,
                            partWidth: d.width
                        }), o += d.width + 2 * d.gap;
                    }
                } catch (e) {
                    l = !0, a = e;
                } finally{
                    try {
                        r || null == c.return || c.return();
                    } finally{
                        if (l) throw a;
                    }
                }
            }
        }
        p.breakpoints && window.addEventListener("resize", function() {
            g();
        });
    }();
}


"use strict";
function $3adef5426d1c9ba3$var$_typeof(t) {
    return ($3adef5426d1c9ba3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $3adef5426d1c9ba3$export$2e2bcd8739ae039(t) {
    var c, g = {
        container: ".dropdown",
        trigger: ".dropdown-trigger",
        activeClass: "active",
        triggerEvent: "click",
        offset: {},
        animation: {
            type: "static",
            speed: 0.4,
            ease: "ease-in-out",
            zIndex: 9999,
            translateOffset: {
                horizontal: 40,
                vertical: 40
            }
        },
        absolute: !1,
        closeOnWindowClick: !0,
        closeOnDropdownClick: !1,
        linkDropdowns: !0,
        controlToggle: !1
    }, b = [], n = {}, e = function() {
        if (g.controlToggle) {
            var t = [];
            void 0 !== g.containerElement ? t.push(g.containerElement) : t = document.querySelectorAll(g.container);
            var n = !0, e = !1, r = void 0;
            try {
                for(var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done); n = !0){
                    var a = o.value, l = {};
                    l.parent = a.parentElement, l.container = a, b.push(l);
                }
            } catch (t) {
                e = !0, r = t;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (e) throw r;
                }
            }
        } else {
            var c = [];
            void 0 !== g.triggerElement ? c.push(g.triggerElement) : c = document.querySelectorAll(g.trigger);
            var f = !0, s = !1, u = void 0;
            try {
                for(var y, v = c[Symbol.iterator](); !(f = (y = v.next()).done); f = !0){
                    var d = y.value, m = void 0;
                    m = void 0 !== g.containerElement ? g.containerElement : d.parentElement.querySelector(g.container);
                    var p = {};
                    p.parent = m.parentElement, p.trigger = d, p.container = m, b.push(p);
                }
            } catch (t) {
                s = !0, u = t;
            } finally{
                try {
                    f || null == v.return || v.return();
                } finally{
                    if (s) throw u;
                }
            }
        }
    }, r = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                a(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, a = function(t) {
        for(var n in t.parent.style.position = g.absolute ? "absolute" : "relative", E(t.container, {
            position: "absolute",
            zIndex: g.animation.zIndex
        }), g.offset)t.container.style[n] = "".concat(g.offset[n], "px");
    }, o = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                l(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, l = function(t) {
        "translate-top" !== g.animation.type && "translate-bottom" !== g.animation.type || (t.container.style.transition = "transform ".concat(g.animation.speed, "s ").concat(g.animation.ease, ",\n                                             opacity ").concat(g.animation.speed, "s ").concat(g.animation.ease, ",\n                                             visibility ").concat(g.animation.speed, "s ").concat(g.animation.ease));
    }, i = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                f(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, f = function(t) {
        "click" === g.triggerEvent ? t.trigger.addEventListener("click", function() {
            v(t);
        }) : "hover" === g.triggerEvent && (t.trigger.addEventListener("mouseenter", function() {
            p(t);
        }), t.trigger.addEventListener("mouseleave", function() {
            m(t);
        }));
    }, s = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                u(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, u = function(t) {
        t.container.addEventListener("click", function() {
            m(t);
        });
    }, y = function() {
        window.addEventListener("click", function(t) {
            if (c) {
                var n = t.target;
                do {
                    var e = !0, r = !1, o = void 0;
                    try {
                        for(var i, a = b[Symbol.iterator](); !(e = (i = a.next()).done); e = !0){
                            var l = i.value;
                            if (n === l.trigger || n === l.container) return;
                        }
                    } catch (t) {
                        r = !0, o = t;
                    } finally{
                        try {
                            e || null == a.return || a.return();
                        } finally{
                            if (r) throw o;
                        }
                    }
                }while (n = n.parentElement);
                d();
            }
        });
    }, v = function(t) {
        (t.active ? m : p)(t);
    }, d = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                m(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, m = function(t) {
        h(t), g.controlToggle || function(t) {
            t.trigger.classList.remove(g.activeClass);
        }(t), t.active = !1, c = !1;
    }, p = function(t) {
        g.linkDropdowns && d(), w(t), g.controlToggle || function(t) {
            t.trigger.classList.add(g.activeClass);
        }(t), t.active = !0, c = !0;
    }, h = function(t) {
        "static" === g.animation.type ? E(t.container, {
            display: "none"
        }) : "translate-top" === g.animation.type ? E(t.container, {
            opacity: 0,
            visibility: "hidden",
            transform: "translate(0, -".concat(g.animation.translateOffset.vertical, "px)")
        }) : "translate-bottom" === g.animation.type && E(t.container, {
            opacity: 0,
            visibility: "hidden",
            transform: "translate(0, ".concat(g.animation.translateOffset.vertical, "px)")
        });
    }, w = function(t) {
        "static" === g.animation.type ? E(t.container, {
            display: "block"
        }) : "translate-top" !== g.animation.type && "translate-bottom" !== g.animation.type || E(t.container, {
            opacity: 1,
            visibility: "visible",
            transform: "translate(0, 0)"
        });
    }, E = function(t, n) {
        for(var e in n)t.style[e] = n[e];
    };
    return function t(n, e) {
        var r;
        for(var o in e)"object" !== $3adef5426d1c9ba3$var$_typeof(e[o]) || e[o] instanceof Date || e[o] instanceof HTMLElement ? e[o] instanceof Date ? n[o] = new Date(e[o].getTime()) : n[o] = e[o] : (r = e[o] instanceof Array ? [] : {}, void 0 === n[o] && (n[o] = r), t(n[o], e[o]));
    }(g, t), e(), r(), g.controlToggle || i(), g.closeOnDropdownClick && s(), g.closeOnWindowClick && y(), d(), window.setTimeout(o, 300), n.showDropdowns = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var r, o = b[Symbol.iterator](); !(t = (r = o.next()).done); t = !0){
                var i = r.value;
                p(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (n) throw e;
            }
        }
    }, n.hideDropdowns = d, n;
}


"use strict";
function $cf19bbea2ba9bc68$var$_typeof(t) {
    return ($cf19bbea2ba9bc68$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $cf19bbea2ba9bc68$export$2e2bcd8739ae039(t) {
    var p = {
        width: 100,
        height: 110,
        lineWidth: 6,
        lineColor: "#fff",
        lineCap: "square",
        buttEnd: !1,
        fill: !1,
        clip: !1,
        roundedCorners: !1,
        roundedCornerRadius: 4,
        animation: {
            easing: !0
        },
        animateOnScroll: !1,
        controlAnimation: !1,
        speed: 50,
        scale: {
            start: 0,
            end: 1,
            stop: 1
        },
        invertedProgress: !1,
        reverse: !1,
        linkText: !1,
        innerLink: !0,
        linkToContainer: ".bar-progress-wrap",
        linkTo: ".bar-progress-text",
        extraLinkTo: [],
        linkUnits: "%",
        linkUnitsSelector: ".bar-progress-unit",
        innerTextFollowsProgress: !1,
        decimalPoints: 0,
        barTextStyle: {
            primaryColor: "#fff",
            secondaryColor: "#363636",
            font: "bold 10px Exo, sans-serif"
        }
    }, h = [], v = {}, i = function() {
        var t = [];
        if (void 0 !== p.containerElement) t.push(p.containerElement);
        else if (!(t = document.querySelectorAll(p.container)).length) throw Error('Unable to find "'.concat(p.container, '" on the DOM'));
        var i = !0, e = !1, n = void 0;
        try {
            for(var r, o = t[Symbol.iterator](); !(i = (r = o.next()).done); i = !0){
                var a = r.value, d = {};
                d.container = a, d.imageSrc = a.getAttribute("data-src"), d.canvas = document.createElement("canvas"), d.ctx = d.canvas.getContext("2d"), d.finishedDrawing = !1, d.canvas.width = p.width, d.canvas.height = p.height, d.canvas.style.position = "absolute", d.canvas.style.top = 0, d.canvas.style.left = 0, d.container.style.width = "".concat(p.width, "px"), d.container.style.height = "".concat(p.height, "px"), d.container.style.position = "relative", d.container.append(d.canvas), h.push(d);
            }
        } catch (t) {
            e = !0, n = t;
        } finally{
            try {
                i || null == o.return || o.return();
            } finally{
                if (e) throw n;
            }
        }
    }, e = function() {
        t.scale && (p.scale.stop = p.scale.stop > p.scale.end ? p.scale.end : p.scale.stop, p.scale.stop = p.scale.stop < p.scale.start ? p.scale.start : p.scale.stop, p.scale.stop = void 0 !== t.scale.stop ? p.scale.stop : p.scale.end), v.sideWidth = o(p.width, p.height), v.perimeter = 6 * v.sideWidth, v.lineLength = p.scale.stop / p.scale.end * v.perimeter, v.sideCount = Math.floor(v.lineLength / v.sideWidth), p.stopPoint = p.scale.stop;
    }, n = function() {
        var t = !0, i = !1, e = void 0;
        try {
            for(var n, r = h[Symbol.iterator](); !(t = (n = r.next()).done); t = !0){
                var o = n.value;
                if (p.gradient) {
                    var a = o.ctx.createLinearGradient(0, p.height, p.width, 0);
                    a.addColorStop(0, p.gradient.colors[0]), a.addColorStop(1, p.gradient.colors[1]), o.ctx.strokeStyle = a, o.ctx.fillStyle = a;
                } else o.ctx.strokeStyle = p.lineColor, o.ctx.fillStyle = p.lineColor;
                o.ctx.lineCap = p.lineCap, o.ctx.lineWidth = p.lineWidth;
            }
        } catch (t) {
            i = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (i) throw e;
            }
        }
    }, r = function() {
        var t = !0, i = !1, e = void 0;
        try {
            for(var n, r = h[Symbol.iterator](); !(t = (n = r.next()).done); t = !0){
                var o = n.value;
                p.speed = 100 < p.speed ? 100 : p.speed, p.speed = p.speed < 1 ? 1 : p.speed, o.animation = {}, o.animation.easing = p.animation.easing, o.animation.speed = p.speed, o.animation.step = o.animation.speed * p.width / 2e3, o.animation.currentProgress = 0;
            }
        } catch (t) {
            i = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (i) throw e;
            }
        }
    };
    function a(t) {
        for(var i = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) + window.innerHeight, e = t.canvas, n = e.offsetTop; e = e.offsetParent;)n += e.offsetTop;
        return n <= i;
    }
    function d(t) {
        t.animation.currentProgress < p.stopPoint && (t.animation.easing ? (t.animation.currentProgress += 0.06 * (p.stopPoint - t.animation.currentProgress), t.animation.currentProgress >= p.stopPoint - 1 && (t.animation.currentProgress = p.stopPoint, t.finishedDrawing = !0)) : (t.animation.currentProgress += t.animation.step, t.animation.currentProgress >= p.stopPoint && (t.animation.currentProgress = p.stopPoint, t.finishedDrawing = !0))), s(t, t.animation.currentProgress), t.finishedDrawing || window.requestAnimationFrame(d);
    }
    function m(t, i) {
        return Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2));
    }
    function T(t, i, e) {
        var n = m(t, i), r = Math.min(e, n), o = function(t, i, e) {
            var n = i.x - t.x, r = i.y - t.y, o = m(t, i), a = n / o, d = r / o;
            return {
                x: t.x + e * a,
                y: t.y + e * d
            };
        }(t, i, r);
        return {
            x: o.x,
            y: o.y,
            distance: r
        };
    }
    var o = function(t, i) {
        return (-i / 2 + Math.sqrt(Math.pow(i, 2) + 0.75 * Math.pow(t, 2))) / 1.5;
    }, s = function(n, t) {
        var i = 1 < arguments.length && void 0 !== t ? t : p.stopPoint;
        if (n.ctx.clearRect(0, 0, p.width, p.height), 0 !== i) {
            if (n.ctx.beginPath(), p.roundedCorners) {
                var e = p.fill || p.clip ? 0 : p.lineWidth / 2, r = function(t) {
                    var i = (p.height - v.sideWidth) / p.width;
                    return (t - (v.sideWidth - p.height) / 2) / i;
                }(p.roundedCornerRadius) - p.width / 2, o = function(t) {
                    return (p.height - v.sideWidth) / p.width * t + (v.sideWidth - p.height) / 2;
                }(p.width - r);
                if (p.clip || p.fill) n.ctx.moveTo(p.width / 2 - r, p.roundedCornerRadius + e), n.ctx.quadraticCurveTo(p.width / 2, 0 + e, p.width / 2 + r, p.roundedCornerRadius + e), n.ctx.lineTo(p.width - e - r, o), n.ctx.quadraticCurveTo(p.width - e, (p.height - v.sideWidth) / 2, p.width - e, (p.height - v.sideWidth) / 2 + r), n.ctx.lineTo(p.width - e, p.height - (p.height - v.sideWidth) / 2 - r), n.ctx.quadraticCurveTo(p.width - e, p.height - (p.height - v.sideWidth) / 2, p.width - e - r, p.height - o), n.ctx.lineTo(p.width / 2 + r, p.height - e - p.roundedCornerRadius), n.ctx.quadraticCurveTo(p.width / 2, p.height - e, p.width / 2 - r, p.height - e - p.roundedCornerRadius), n.ctx.lineTo(0 + e + r, p.height - o), n.ctx.quadraticCurveTo(0 + e, p.height - (p.height - v.sideWidth) / 2, 0 + e, p.height - (p.height - v.sideWidth) / 2 - r), n.ctx.lineTo(0 + e, (p.height - v.sideWidth) / 2 + r), n.ctx.quadraticCurveTo(0 + e, (p.height - v.sideWidth) / 2, 0 + e + r, o), n.ctx.lineTo(p.width / 2 - r, p.roundedCornerRadius + e);
                else for(;;){
                    var a = {
                        x: p.width / 2 - r,
                        y: p.roundedCornerRadius + e
                    }, d = {
                        x: p.width / 2,
                        y: 0 + e
                    }, h = {
                        x: p.width / 2 + r,
                        y: p.roundedCornerRadius + e
                    }, s = m(a, d) + m(d, h), c = {
                        x: p.width / 2,
                        y: 0 + e
                    }, l = {
                        x: p.width / 2 + r,
                        y: p.roundedCornerRadius + e
                    }, u = m(c, l), f = v.lineLength - u - s, g = void 0, x = void 0, w = void 0;
                    if (g = {
                        x: p.width / 2 + r,
                        y: p.roundedCornerRadius + e
                    }, x = {
                        x: p.width - e - r,
                        y: o
                    }, w = T(g, x, f), n.ctx.moveTo(p.width / 2 + r, p.roundedCornerRadius + e), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i <= 1 / 6) break;
                    if (n.ctx.quadraticCurveTo(p.width - e, (p.height - v.sideWidth) / 2, p.width - e, (p.height - v.sideWidth) / 2 + r), (f -= s) <= 0) break;
                    if (g = {
                        x: p.width - e,
                        y: (p.height - v.sideWidth) / 2 + r
                    }, x = {
                        x: p.width - e,
                        y: p.height - (p.height - v.sideWidth) / 2 - r
                    }, w = T(g, x, f), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i <= 2 / 6) break;
                    if (n.ctx.quadraticCurveTo(p.width - e, p.height - (p.height - v.sideWidth) / 2, p.width - e - r, p.height - o), (f -= s) <= 0) break;
                    if (g = {
                        x: p.width - e - r,
                        y: p.height - o
                    }, x = {
                        x: p.width / 2 + r,
                        y: p.height - e - p.roundedCornerRadius
                    }, w = T(g, x, f), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i <= 0.5) break;
                    if (n.ctx.quadraticCurveTo(p.width / 2, p.height - e, p.width / 2 - r, p.height - e - p.roundedCornerRadius), (f -= s) <= 0) break;
                    if (g = {
                        x: p.width / 2 - r,
                        y: p.height - e - p.roundedCornerRadius
                    }, x = {
                        x: 0 + e + r,
                        y: p.height - o
                    }, w = T(g, x, f), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i <= 4 / 6) break;
                    if (n.ctx.quadraticCurveTo(0 + e, p.height - (p.height - v.sideWidth) / 2, 0 + e, p.height - (p.height - v.sideWidth) / 2 - r), (f -= s) <= 0) break;
                    if (g = {
                        x: 0 + e,
                        y: p.height - (p.height - v.sideWidth) / 2 - r
                    }, x = {
                        x: 0 + e,
                        y: (p.height - v.sideWidth) / 2 + r
                    }, w = T(g, x, f), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i <= 5 / 6) break;
                    if (n.ctx.quadraticCurveTo(0 + e, (p.height - v.sideWidth) / 2, 0 + e + r, o), (f -= s) <= 0) break;
                    if (g = {
                        x: 0 + e + r,
                        y: o
                    }, x = {
                        x: p.width / 2 - r,
                        y: p.roundedCornerRadius + e
                    }, w = T(g, x, f), n.ctx.lineTo(w.x, w.y), (f -= w.distance) <= 0) break;
                    if (i < 1) break;
                    n.ctx.quadraticCurveTo(p.width / 2, 0 + e, p.width / 2 + r, p.roundedCornerRadius + e);
                    break;
                }
            } else p.clip || p.fill ? (n.ctx.moveTo(p.width / 2, 0), n.ctx.lineTo(p.width, (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width, p.height - (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width / 2, p.height), n.ctx.lineTo(0, p.height - (p.height - v.sideWidth) / 2), n.ctx.lineTo(0, (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width / 2, 0)) : (n.ctx.moveTo(p.width / 2, 0 + p.lineWidth / 2), n.ctx.lineTo(p.width - p.lineWidth / 2, (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width - p.lineWidth / 2, p.height - (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width / 2, p.height - p.lineWidth / 2), n.ctx.lineTo(0 + p.lineWidth / 2, p.height - (p.height - v.sideWidth) / 2), n.ctx.lineTo(0 + p.lineWidth / 2, (p.height - v.sideWidth) / 2), n.ctx.lineTo(p.width / 2, 0 + p.lineWidth / 2));
            if (p.clip) {
                if (n.ctx.clip(), n.imageSrc) {
                    var y = new Image();
                    y.src = n.imageSrc, y.addEventListener("load", function() {
                        var t = Math.max(p.width, p.height), i = ((p.width, p.height), p.width < p.height ? (p.width - p.height) / 2 : 0), e = p.height < p.width ? (p.height - p.width) / 2 : 0;
                        n.ctx.drawImage(y, i, e, t, t);
                    });
                }
            } else p.fill ? n.ctx.fill() : n.ctx.stroke();
        } else n.finishedDrawing = !0;
    };
    this.render = function(t) {
        t = (t = (t = t > p.scale.end ? p.scale.end : t) < p.scale.start ? p.scale.start : t) / p.scale.end * p.width, s(t);
    }, function t(i, e) {
        var n;
        for(var r in e)"object" !== $cf19bbea2ba9bc68$var$_typeof(e[r]) || e[r] instanceof Date || e[r] instanceof HTMLElement ? e[r] instanceof Date ? i[r] = new Date(e[r].getTime()) : i[r] = e[r] : (n = e[r] instanceof Array ? [] : {}, void 0 === i[r] && (i[r] = n), t(i[r], e[r]));
    }(p, t), i(), e(), n(), r(), function() {
        var t = !0, i = !1, e = void 0;
        try {
            for(var n, r = function() {
                var i = n.value;
                p.animateOnScroll ? a(i) ? window.requestAnimationFrame(function() {
                    d(i);
                }) : window.addEventListener("scroll", function t() {
                    a(i) && (window.requestAnimationFrame(function() {
                        d(i);
                    }), window.removeEventListener("scroll", t));
                }) : p.controlAnimation || s(i);
            }, o = h[Symbol.iterator](); !(t = (n = o.next()).done); t = !0)r();
        } catch (t) {
            i = !0, e = t;
        } finally{
            try {
                t || null == o.return || o.return();
            } finally{
                if (i) throw e;
            }
        }
    }();
}


"use strict";
function $fba6a719fb8ca21f$var$_typeof(t) {
    return ($fba6a719fb8ca21f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $fba6a719fb8ca21f$export$2e2bcd8739ae039(n) {
    var a = {
        triggers: "",
        elements: "",
        startOpen: 1,
        animation: {
            type: "static",
            speed: 0.6,
            easing: "ease-in-out"
        },
        triggerActiveClass: "active",
        triggerEvent: "click",
        onTabChange: function(t) {}
    }, s = {}, e = function() {
        return 1366 <= window.innerWidth ? "desktop" : "mobile";
    }, i = function() {
        return s.triggers = document.querySelectorAll(a.triggers), s.triggers.length;
    }, r = function() {
        return s.elements = document.querySelectorAll(a.elements), s.elements.length;
    }, o = function() {
        for(var t = function(t) {
            var n = s.triggers[t];
            n.addEventListener(a.triggerEvent, function() {
                c(n) || u(t);
            });
        }, n = 0; n < s.triggers.length; n++)t(n);
    }, l = function() {
        for(var t = 0; t < s.elements.length; t++)f(t);
    }, c = function(t) {
        return t.classList.contains(a.triggerActiveClass);
    }, f = function(t) {
        !function(t) {
            t.classList.remove(a.triggerActiveClass);
        }(s.triggers[t]), w(s.elements[t]);
    }, u = function(t) {
        l(), function(t) {
            t.classList.add(a.triggerActiveClass);
        }(s.triggers[t]), h(s.elements[t]), "static" !== a.animation.type ? window.setTimeout(function() {
            a.onTabChange(s.elements[t]);
        }, 300) : a.onTabChange(s.elements[t]);
    }, y = function(t) {
        t.style.transition = "all ".concat(a.animation.speed, "s ").concat(a.animation.easing);
    }, m = function(t) {
        t.style.transition = "none";
    }, g = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var i, r = s.elements[Symbol.iterator](); !(t = (i = r.next()).done); t = !0){
                var o = i.value;
                p(o);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (n) throw e;
            }
        }
        "static" !== a.animation.type && window.setTimeout(function() {
            !function() {
                var t = !0, n = !1, e = void 0;
                try {
                    for(var i, r = s.elements[Symbol.iterator](); !(t = (i = r.next()).done); t = !0){
                        var o = i.value;
                        y(o);
                    }
                } catch (t) {
                    n = !0, e = t;
                } finally{
                    try {
                        t || null == r.return || r.return();
                    } finally{
                        if (n) throw e;
                    }
                }
            }();
        }, 300);
    }, v = function() {
        !function() {
            var t = !0, n = !1, e = void 0;
            try {
                for(var i, r = s.elements[Symbol.iterator](); !(t = (i = r.next()).done); t = !0){
                    var o = i.value;
                    m(o);
                }
            } catch (t) {
                n = !0, e = t;
            } finally{
                try {
                    t || null == r.return || r.return();
                } finally{
                    if (n) throw e;
                }
            }
        }();
        var t = !0, n = !1, e = void 0;
        try {
            for(var i, r = s.elements[Symbol.iterator](); !(t = (i = r.next()).done); t = !0){
                var o = i.value;
                b(o);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (n) throw e;
            }
        }
    }, d = function() {
        for(var t = 0; t < s.triggers.length; t++){
            var n = s.triggers[t];
            c(n) && (l(), u(t));
        }
    }, p = function(t) {
        "slide-in-right" === a.animation.type && S(t, {
            position: "absolute",
            left: "0",
            zIndex: 1
        });
    }, b = function(t) {
        "static" === a.animation.type ? S(t, {
            display: "block"
        }) : "slide-in-right" === s.animationType && S(t, {
            position: "static",
            transform: "translate(0, 0)",
            opacity: 1,
            visibility: "visible"
        });
    }, h = function(t) {
        if ("static" === a.animation.type) S(t, {
            display: "block"
        });
        else if ("slide-in-right" === a.animation.type) {
            for(var n = t; n && !(n = (n = n.previousElementSibling) || s.elements[s.elements.length - 1]).classList.contains(a.elements.substring(1)););
            S(t, {
                transform: "translate(0, 0)",
                opacity: 1,
                visibility: "visible",
                zIndex: 2
            }), w(n);
        }
    }, w = function(t) {
        "static" === a.animation.type ? S(t, {
            display: "none"
        }) : "slide-in-right" === a.animation.type && S(t, {
            transform: "translate(50%, 0)",
            opacity: 0,
            visibility: "hidden",
            zIndex: 1
        });
    }, S = function(t, n) {
        for(var e in n)t.style[e] = n[e];
    }, T = function t(n, e) {
        var i;
        for(var r in e)"object" !== $fba6a719fb8ca21f$var$_typeof(e[r]) || e[r] instanceof Date ? e[r] instanceof Date ? n[r] = new Date(e[r].getTime()) : n[r] = e[r] : (i = e[r] instanceof Array ? [] : {}, void 0 === n[r] && (n[r] = i), t(n[r], e[r]));
    };
    return function() {
        if (T(a, n), r() && i()) {
            s.animationType = a.animation.type, window.innerWidth < 1366 && (a.animation.type = "static"), l(), u(a.startOpen - 1), g(), o();
            var t = e();
            window.addEventListener("resize", function() {
                window.innerWidth < 1366 && "desktop" === t ? (v(), a.animation.type = "static", d(), g()) : 1366 <= window.innerWidth && "mobile" === t && (v(), a.animation.type = s.animationType, d(), g()), t = e();
            });
        }
    }(), {};
}


"use strict";
function $e65781730ccf193e$var$_typeof(t) {
    return ($e65781730ccf193e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $e65781730ccf193e$export$2e2bcd8739ae039(t) {
    var s = {
        triggerSelector: ".accordion-trigger",
        contentSelector: ".accordion-content",
        animation: {
            type: "all",
            speed: 0.3,
            ease: "ease-in-out"
        },
        paddingAnimation: !1,
        startOpenClass: "accordion-open",
        selectedClass: "selected",
        linkTriggers: !1
    }, d = {}, n = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var o, r = d.accordions[Symbol.iterator](); !(t = (o = r.next()).done); t = !0){
                var i = o.value;
                i.open && (i.content.style.height = "auto", i.content.style.height = "".concat(i.content.scrollHeight, "px"));
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (n) throw e;
            }
        }
    }, e = function() {
        var t = document.querySelectorAll(s.triggerSelector);
        if (!t.length) throw new Error("Couldn't find ".concat(s.triggerSelector, " in the DOM"));
        var n = !0, e = (d.accordions = [], false), o = void 0;
        try {
            for(var r, i = t[Symbol.iterator](); !(n = (r = i.next()).done); n = !0){
                var a = r.value, c = a.querySelector(s.contentSelector);
                if (!c && !(c = a.parentElement.querySelector(s.contentSelector))) throw new Error("Couldn't find ".concat(s.contentSelector, " in ").concat(s.triggerSelector, " nor as it's sibling"));
                if (s.paddingAnimation) d.accordions.push({
                    trigger: a,
                    content: c,
                    padding: c.style.padding,
                    open: !0,
                    startOpen: c.classList.contains(s.startOpenClass)
                });
                else {
                    var l = document.createElement("div");
                    c.parentElement.appendChild(l), l.appendChild(c), d.accordions.push({
                        trigger: a,
                        content: l,
                        open: !0,
                        startOpen: c.classList.contains(s.startOpenClass)
                    });
                }
            }
        } catch (t) {
            e = !0, o = t;
        } finally{
            try {
                n || null == i.return || i.return();
            } finally{
                if (e) throw o;
            }
        }
    }, o = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var o, r = d.accordions[Symbol.iterator](); !(t = (o = r.next()).done); t = !0){
                var i = o.value;
                i.content.style.overflow = "hidden", i.startOpen ? (i.content.style.height = "".concat(i.content.scrollHeight, "px"), i.content.parentElement.classList.add(s.selectedClass)) : f(i);
            }
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (n) throw e;
            }
        }
    }, r = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var o, r = d.accordions[Symbol.iterator](); !(t = (o = r.next()).done); t = !0)o.value.content.style.transition = "".concat(s.animation.type, " ").concat(s.animation.speed, "s ").concat(s.animation.ease);
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == r.return || r.return();
            } finally{
                if (n) throw e;
            }
        }
    }, i = function() {
        var t = !0, n = !1, e = void 0;
        try {
            for(var o, r = function() {
                var c = o.value;
                c.trigger.addEventListener("click", function() {
                    if (s.linkTriggers) {
                        var t = c.open ? f : y, n = !0, e = !1, o = void 0;
                        try {
                            for(var r, i = d.accordions[Symbol.iterator](); !(n = (r = i.next()).done); n = !0){
                                var a = r.value;
                                f(a);
                            }
                        } catch (t) {
                            e = !0, o = t;
                        } finally{
                            try {
                                n || null == i.return || i.return();
                            } finally{
                                if (e) throw o;
                            }
                        }
                        s.triggerOpens ? y(c) : t(c);
                    } else l(c);
                });
            }, i = d.accordions[Symbol.iterator](); !(t = (o = i.next()).done); t = !0)r();
        } catch (t) {
            n = !0, e = t;
        } finally{
            try {
                t || null == i.return || i.return();
            } finally{
                if (n) throw e;
            }
        }
    }, l = function(t) {
        t.open ? f(t) : y(t);
    }, y = function(t) {
        t.open || (t.open = !0, t.content.style.height = "".concat(t.content.scrollHeight, "px"), t.content.parentElement.classList.add(s.selectedClass), s.paddingAnimation && (t.content.style.padding = t.padding));
    }, f = function(t) {
        t.open && (t.open = !1, t.content.style.height = 0, t.content.parentElement.classList.remove(s.selectedClass), s.paddingAnimation && (t.content.style.padding = 0));
    };
    return function t(n, e) {
        var o;
        for(var r in e)"object" !== $e65781730ccf193e$var$_typeof(e[r]) || e[r] instanceof Date ? e[r] instanceof Date ? n[r] = new Date(e[r].getTime()) : n[r] = e[r] : (o = e[r] instanceof Array ? [] : {}, void 0 === n[r] && (n[r] = o), t(n[r], e[r]));
    }(s, t), e(), o(), r(), i(), window.addEventListener("resize", n), d;
}


// Object.keys
var $2d8ef14f99485540$var$win = window;
var $2d8ef14f99485540$export$27f233d61a9e2fa4 = $2d8ef14f99485540$var$win.requestAnimationFrame || $2d8ef14f99485540$var$win.webkitRequestAnimationFrame || $2d8ef14f99485540$var$win.mozRequestAnimationFrame || $2d8ef14f99485540$var$win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};


var $6514445469a71f92$var$win = window;
var $6514445469a71f92$export$75aab3dbee8deceb = $6514445469a71f92$var$win.cancelAnimationFrame || $6514445469a71f92$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};


function $3d1c8fec3657292d$export$8b58be045bf06082() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}


function $ccb8eefb57837483$export$79d1167a24e4e930(value) {
    return [
        "true",
        "false"
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


function $3706cb3f1e8084d6$export$1f73f60bdb811cb1(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}


function $ee495b53d308c5dd$export$ff0ccbbb2d1923f6() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return "tns" + window.tnsId;
}


// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 
function $66207682783d5ef7$export$135b49d4bc2964c6() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement("body");
        body.fake = true;
    }
    return body;
}


var $2710207825c81db1$export$9dfbf2fa8806212d = document.documentElement;


function $c8d5f1486f0a7960$export$4078b67b5eba0c5(body) {
    var docOverflow = "";
    if (body.fake) {
        docOverflow = (0, $2710207825c81db1$export$9dfbf2fa8806212d).style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = "";
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = (0, $2710207825c81db1$export$9dfbf2fa8806212d).style.overflow = "hidden";
        (0, $2710207825c81db1$export$9dfbf2fa8806212d).appendChild(body);
    }
    return docOverflow;
}



function $d1aa1c44abdf9e76$export$81b27fa331809b9b(body, docOverflow) {
    if (body.fake) {
        body.remove();
        (0, $2710207825c81db1$export$9dfbf2fa8806212d).style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        (0, $2710207825c81db1$export$9dfbf2fa8806212d).offsetHeight;
    }
}


function $1727e925d02e9a37$export$42bfa9b2d4dad91a() {
    var doc = document, body = (0, $66207682783d5ef7$export$135b49d4bc2964c6)(), docOverflow = (0, $c8d5f1486f0a7960$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), result = false;
    body.appendChild(div);
    try {
        var str = "(10px * 10)", vals = [
            "calc" + str,
            "-moz-calc" + str,
            "-webkit-calc" + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, "");
                break;
            }
        }
    } catch (e) {}
    body.fake ? (0, $d1aa1c44abdf9e76$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return result;
}


// get subpixel support value
// @return - boolean



function $4ca7ae84ba10cc0e$export$7b334bfa4e585549() {
    // check subpixel layout supporting
    var doc = document, body = (0, $66207682783d5ef7$export$135b49d4bc2964c6)(), docOverflow = (0, $c8d5f1486f0a7960$export$4078b67b5eba0c5)(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "", count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += "<div></div>";
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? (0, $d1aa1c44abdf9e76$export$81b27fa331809b9b)(body, docOverflow) : wrapper.remove();
    return supported;
}





function $e0b3898cfe58711a$export$48976c233ddfebe2() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = (0, $66207682783d5ef7$export$135b49d4bc2964c6)(), docOverflow = (0, $c8d5f1486f0a7960$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", position;
    style.type = "text/css";
    div.className = "tns-mq-test";
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle["position"];
    body.fake ? (0, $d1aa1c44abdf9e76$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return position === "absolute";
}


// create and append style sheet
function $7003170980d03aa5$export$d07d6a5154e3b470(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector("head").appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}


// cross browsers addRule method

function $ffae77d33f8aad94$export$bf97e331026f75ba(sheet, selector, rules, index) {
    // return raf(function() {
    "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
// });
}


// cross browsers addRule method

function $5e360b60a080e998$export$271e480b8a432c4a(sheet, index) {
    // return raf(function() {
    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
// });
}


function $680163ae164c78b9$export$ccd7e907f4f59892(sheet) {
    var rule = "insertRule" in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}


function $1580d4de876cf5e0$export$c796d9d3e501591f(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}


function $e10fcc21ed01ec62$export$83b6d73568c72b60(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = "horizontal";
    else if (gap <= range) direction = "vertical";
    return direction;
}


// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $bac2b251a2409032$export$4b80e395e36b5a56(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}


var $f92109d09b413dcd$export$8b753db5fc454027 = "classList" in document.createElement("_");


var $1cf80cd5abfef804$export$4ea3d958472af68f = (0, $f92109d09b413dcd$export$8b753db5fc454027) ? function(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};



var $e860798111c762f5$export$d2cf6cd1dc7067d3 = (0, $f92109d09b413dcd$export$8b753db5fc454027) ? function(el, str) {
    if (!(0, $1cf80cd5abfef804$export$4ea3d958472af68f)(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!(0, $1cf80cd5abfef804$export$4ea3d958472af68f)(el, str)) el.className += " " + str;
};



var $6ea99e3d40b41ad9$export$c2255604a80b4506 = (0, $f92109d09b413dcd$export$8b753db5fc454027) ? function(el, str) {
    if ((0, $1cf80cd5abfef804$export$4ea3d958472af68f)(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ((0, $1cf80cd5abfef804$export$4ea3d958472af68f)(el, str)) el.className = el.className.replace(str, "");
};


function $a3d0de7777ea39bf$export$5608640b1bf2f6d7(el, attr) {
    return el.hasAttribute(attr);
}


function $955992224a80f66e$export$6a93fe6b2b4c71a0(el, attr) {
    return el.getAttribute(attr);
}


function $176fa2ae87bd38c0$export$ff45fc08c57bb9d0(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}


function $17ac71bfe480d82f$export$7e45664a2081efb1(els, attrs) {
    els = (0, $176fa2ae87bd38c0$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== "[object Object]") return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}



function $5729cb11f0bd4578$export$711225beb0f1ef57(els, attrs) {
    els = (0, $176fa2ae87bd38c0$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}


function $02a4d5bf06ec64f8$export$19b645cc08e75c7c(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}


function $55991d37ef474d49$export$7669482c90f5c50f(el, forceHide) {
    if (el.style.display !== "none") el.style.display = "none";
}


function $595e63bb0710ea46$export$998191bfdf710c72(el, forceHide) {
    if (el.style.display === "none") el.style.display = "";
}


function $9dfdf59ab63931b0$export$795910f5f15a9633(el) {
    return window.getComputedStyle(el).display !== "none";
}


function $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6(props) {
    if (typeof props === "string") {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            "Webkit",
            "Moz",
            "ms",
            "O"
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== "ms" || props === "transform") arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement("fakeelement"), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}





function $3bd2f4443d90bde9$export$c0585cbcaae92b06(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = (0, $66207682783d5ef7$export$135b49d4bc2964c6)(), docOverflow = (0, $c8d5f1486f0a7960$export$4078b67b5eba0c5)(body), el = doc.createElement("p"), has3d, cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
    cssTF += "transform";
    // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = "translate3d(1px,1px,1px)";
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? (0, $d1aa1c44abdf9e76$export$81b27fa331809b9b)(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}


// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $f34f6bd5ed9cce52$export$41e71ffeacbff65e(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = "webkit" + propOut + "End";
    else if (/^O/.test(propIn)) endProp = "o" + propOut + "End";
    else if (propIn) endProp = propOut.toLowerCase() + "end";
    return endProp;
}


// Test via a getter in the options object to see if the passive property is accessed
var $69f812acd6183525$var$supportsPassive = false;
try {
    var $69f812acd6183525$var$opts = Object.defineProperty({}, "passive", {
        get: function() {
            $69f812acd6183525$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $69f812acd6183525$var$opts);
} catch (e) {}
var $69f812acd6183525$export$555390bf67cc3262 = $69f812acd6183525$var$supportsPassive ? {
    passive: true
} : false;


function $b4ea3be63c1a5fdd$export$aadfb65bee660f96(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 && !preventScrolling ? (0, $69f812acd6183525$export$555390bf67cc3262) : false;
        el.addEventListener(prop, obj[prop], option);
    }
}



function $ef6aa38632f2f7dc$export$da5f6eb3bb522cd(el, obj) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 ? (0, $69f812acd6183525$export$555390bf67cc3262) : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}


function $e14426b61f93a42c$export$ada873a34909da65() {
    return {
        topics: {},
        on: function(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}


function $e927623c4ef8b275$export$e2705a83c013f564(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}


if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $a89f8de1938e5fc3$export$51fe319e24d9d8c9 = function(options) {
    options = (0, $3d1c8fec3657292d$export$8b58be045bf06082)({
        container: ".slider",
        mode: "carousel",
        axis: "horizontal",
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: "top",
        controlsText: [
            "prev",
            "next"
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: "top",
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: "top",
        autoplayTimeout: 5000,
        autoplayDirection: "forward",
        autoplayText: [
            "start",
            "stop"
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: "tns-fadeIn",
        animateOut: "tns-fadeOut",
        animateNormal: "tns-normal",
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: ".tns-lazy-img",
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date;
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage["tnsApp"] && tnsStorage["tnsApp"] !== browserInfo) [
                "tC",
                "tPL",
                "tMQ",
                "tTf",
                "t3D",
                "tTDu",
                "tTDe",
                "tADu",
                "tADe",
                "tTE",
                "tAE"
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
            // update browserInfo
            localStorage["tnsApp"] = browserInfo;
        }
    }
    var CALC = tnsStorage["tC"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tC"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tC", (0, $1727e925d02e9a37$export$42bfa9b2d4dad91a)(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage["tPL"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tPL"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tPL", (0, $4ca7ae84ba10cc0e$export$7b334bfa4e585549)(), localStorageAccess), CSSMQ = tnsStorage["tMQ"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tMQ"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tMQ", (0, $e0b3898cfe58711a$export$48976c233ddfebe2)(), localStorageAccess), TRANSFORM = tnsStorage["tTf"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tTf"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tTf", (0, $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6)("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage["t3D"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["t3D"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "t3D", (0, $3bd2f4443d90bde9$export$c0585cbcaae92b06)(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage["tTDu"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tTDu"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tTDu", (0, $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6)("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage["tTDe"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tTDe"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tTDe", (0, $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6)("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage["tADu"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tADu"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tADu", (0, $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6)("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage["tADe"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tADe"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tADe", (0, $7b6d9f94ad33ac7d$export$d7ea39ebd37f24a6)("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage["tTE"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tTE"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tTE", (0, $f34f6bd5ed9cce52$export$41e71ffeacbff65e)(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage["tAE"] ? (0, $ccb8eefb57837483$export$79d1167a24e4e930)(tnsStorage["tAE"]) : (0, $3706cb3f1e8084d6$export$1f73f60bdb811cb1)(tnsStorage, "tAE", (0, $f34f6bd5ed9cce52$export$41e71ffeacbff65e)(ANIMATIONDURATION, "Animation"), localStorageAccess);
    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        "container",
        "controlsContainer",
        "prevButton",
        "nextButton",
        "navContainer",
        "autoplayButton"
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === "string") {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn("Can't find", options[item]);
                return;
            }
        }
    });
    // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn("No slides found in", options.container);
        return;
    }
    // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === "carousel" ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = (0, $3d1c8fec3657292d$export$8b58be045bf06082)(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key];
            // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === "number" ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    }
    // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === "slideBy") obj[key] = "page";
                if (key === "edgePadding") obj[key] = false;
                if (key === "autoHeight") obj[key] = false;
            }
            // update responsive options
            if (key === "responsive") updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
    // === define and set variables ===
    if (!carousel) {
        options.axis = "horizontal";
        options.slideBy = "page";
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === "horizontal" ? true : false, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += " tns-vpfix";
    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = !autoWidth ? Math.floor(getOption("items")) : 1, slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = (0, $7003170980d03aa5$export$d07d6a5154e3b470)(null, getOption("nonce")), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption("startIndex")), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, // resize
    resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? "?" : true, running = false, onInit = options.onInit, events = new (0, $e14426b61f93a42c$export$ada873a34909da65)(), // id, class
    newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || (0, $ee495b53d308c5dd$export$ff0ccbbb2d1923f6)(), disable = getOption("disable"), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        "click": onControlsClick,
        "keydown": onControlsKeydown
    }, navEvents = {
        "click": onNavClick,
        "keydown": onNavKeydown
    }, hoverEvents = {
        "mouseover": mouseoverPause,
        "mouseout": mouseoutRestart
    }, visibilityEvent = {
        "visibilitychange": onVisibilityChange
    }, docmentKeydownEvent = {
        "keydown": onDocumentKeydown
    }, touchEvents = {
        "touchstart": onPanStart,
        "touchmove": onPanMove,
        "touchend": onPanEnd,
        "touchcancel": onPanEnd
    }, dragEvents = {
        "mousedown": onPanStart,
        "mousemove": onPanMove,
        "mouseup": onPanEnd,
        "mouseleave": onPanEnd
    }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", slideClonedClass = "tns-slide-cloned", imgCompleteClass = "tns-complete", imgEvents = {
        "load": onImgLoaded,
        "error": onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === "force" ? true : false;
    // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "", prevIsButton, nextIsButton;
    // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
    // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === "forward" ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = [
        "<span class='tns-visually-hidden'>",
        " animation</span>"
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
    // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = "translate";
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? "3d(" : "3d(0px, ";
            transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)";
        } else {
            transformPrefix += horizontal ? "X(" : "Y(";
            transformPostfix = ")";
        }
    }
    if (carousel) container.className = container.className.replace("tns-vpfix", "");
    initStructure();
    initSheet();
    initSliderTransform();
    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
        else {
            var str = fixedWidth ? "fixedWidth" : "items", arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption("edgePadding") ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === "top" ? "afterbegin" : "beforeend";
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement("div"), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    }
    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === "items" && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === "slideBy" && result === "page") result = getOption("items");
            if (!carousel && (item === "slideBy" || item === "items")) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + "(" + i * 100 + "% / " + slideCountNew + ")" : i * 100 / slideCountNew + "%";
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = "";
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = "-" + gutterTem + "px", dir = horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0";
            str = "margin: 0 " + dir + ";";
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + "px";
        else return CALC ? CALC + "(" + slideCountNew * 100 + "% / " + itemsTem + ")" : slideCountNew * 100 / itemsTem + "%";
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + "px";
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
        }
        width = "width:" + width;
        // inner slider: overwrite outer slider styles
        return nested !== "inner" ? width + ";" : width + " !important;";
    }
    function getSlideGutterStyle(gutterTem) {
        var str = "";
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? "padding-" : "margin-", dir = horizontal ? "right" : "bottom";
            str = prop + dir + ": " + gutterTem + "px;";
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = "-" + prefix + "-";
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed / 1000 + "s;";
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed / 1000 + "s;";
    }
    function initStructure() {
        var classOuter = "tns-outer", classInner = "tns-inner", hasGutter = hasOption("gutter");
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + "-ow";
        innerWrapper.id = slideId + "-iw";
        // set container properties
        if (container.id === "") container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel";
        newContainerClasses += CALC ? " tns-calc" : " tns-no-calc";
        if (autoWidth) newContainerClasses += " tns-autowidth";
        newContainerClasses += " tns-" + options.axis;
        container.className += newContainerClasses;
        // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement("div");
            middleWrapper.id = slideId + "-mw";
            middleWrapper.className = "tns-ovh";
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += " tns-ah";
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        // add id, class, aria attributes
        // before clone slides
        (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, "tns-item");
            if (!item.id) item.id = slideId + "-item" + i;
            if (!carousel && animateNormal) (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, animateNormal);
            (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(item, {
                "aria-hidden": "true",
                "tabindex": "-1"
            });
        });
        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(cloneFirst, slideClonedClass);
                (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(cloneFirst, "id");
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(cloneLast, slideClonedClass);
                    (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(cloneLast, "id");
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption("autoHeight") || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll("img");
            // add img load event listener
            (0, $bac2b251a2409032$export$4b80e395e36b5a56)(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf("data:image") < 0) {
                        img.src = "";
                        (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(img, imgEvents);
                        (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(img, "loading");
                        img.src = src;
                    // data img
                    } else imgLoaded(img);
                }
            });
            // set imgsComplete
            (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $02a4d5bf06ec64f8$export$19b645cc08e75c7c)(imgs), function() {
                    imgsComplete = true;
                });
            });
            // reset imgs for auto height: check visible imgs only
            if (hasOption("autoHeight")) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $02a4d5bf06ec64f8$export$19b645cc08e75c7c)(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
            // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        }
        // set container transform property
        if (carousel) doContainerTransformSilent();
        // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + "%";
            (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, animateIn);
            (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateNormal);
        }
        // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", "font-size:" + win.getComputedStyle(slideItems[0]).fontSize + ";", (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
                (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId, "font-size:0;", (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
            } else if (carousel) (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : "";
                (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + "-mw", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
            }
            // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + "-iw", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
            // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "";
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId, str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
            }
            // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "";
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
            // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration();
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
            // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
            if (gutter) str += getSlideGutterStyle(gutter);
            // append to the last line
            if (str) (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
        }
        // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = "", middleWrapperStr = "", innerWrapperStr = "", containerStr = "", slideStr = "", itemsBP = !autoWidth ? getOption("items", bp) : null, fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption("autoHeight", bp) && "speed" in opts) middleWrapperStr = "#" + slideId + "-mw{" + getTransitionDurationStyle(speedBP) + "}";
            // inner wrapper string
            if ("edgePadding" in opts || "gutter" in opts) innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}";
            // container string
            if (carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts)) containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";";
            if (TRANSITIONDURATION && "speed" in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = "#" + slideId + "{" + containerStr + "}";
            // slide string
            if ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ("gutter" in opts) slideStr += getSlideGutterStyle(gutterBP);
            // set gallery items transition-duration
            if (!carousel && "speed" in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}";
            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus();
        // == live region ==
        outerWrapper.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + "</span>  of " + slideCount + "</div>");
        liveregionCurrent = outerWrapper.querySelector(".tns-liveregion .current");
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? "stop" : "start";
            if (autoplayButton) (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(autoplayButton, {
                "data-action": txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>");
                autoplayButton = outerWrapper.querySelector("[data-action]");
            }
            // add event
            if (autoplayButton) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(autoplayButton, {
                "click": toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, hoverEvents);
                if (autoplayResetOnVisibility) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, visibilityEvent);
            }
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(navContainer, {
                    "aria-label": "Carousel Pagination"
                });
                navItems = navContainer.children;
                (0, $bac2b251a2409032$export$4b80e395e36b5a56)(navItems, function(item, i) {
                    (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(item, {
                        "data-nav": i,
                        "tabindex": "-1",
                        "aria-label": navStr + (i + 1),
                        "aria-controls": slideId
                    });
                });
            // generated nav
            } else {
                var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>";
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector(".tns-nav");
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1000 + "s";
                if (prefix) str = "-" + prefix + "-" + str;
                (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "[aria-controls^=" + slideId + "-item]", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
            }
            (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(navItems[navCurrentIndex], {
                "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(navItems[navCurrentIndex], "tabindex");
            (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(navItems[navCurrentIndex], navActiveClass);
            // add events
            (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(navContainer, navEvents);
        }
        // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + "</button></div>");
                controlsContainer = outerWrapper.querySelector(".tns-controls");
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(controlsContainer, {
                "aria-label": "Carousel Navigation",
                "tabindex": "0"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) (0, $17ac71bfe480d82f$export$7e45664a2081efb1)([
                prevButton,
                nextButton
            ], {
                "aria-controls": slideId,
                "tabindex": "-1"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(prevButton, {
                    "data-controls": "prev"
                });
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(nextButton, {
                    "data-controls": "next"
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            if (controlsContainer) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(controlsContainer, controlsEvents);
            else {
                (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(prevButton, controlsEvents);
                (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(nextButton, controlsEvents);
            }
        }
        // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, eve);
        }
        if (touch) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, dragEvents);
        if (arrowKeys) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(doc, docmentKeydownEvent);
        if (nested === "inner") events.on("outerResized", function() {
            resizeTasks();
            events.emit("innerLoaded", info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(win, {
            "resize": onResize
        });
        if (autoHeight) {
            if (nested === "outer") events.on("innerLoaded", doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on("indexChanged", additionalUpdates);
        if (nested === "inner") events.emit("innerLoaded", info());
        if (typeof onInit === "function") onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
        // remove win event listeners
        (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(win, {
            "resize": onResize
        });
        // arrowKeys, controls, nav
        if (arrowKeys) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controlsContainer) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(controlsContainer, controlsEvents);
        if (navContainer) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(navContainer, navEvents);
        // autoplay
        (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, hoverEvents);
        (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, visibilityEvent);
        if (autoplayButton) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(autoplayButton, {
            "click": toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
        // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, eve);
        }
        if (touch) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag) (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, dragEvents);
        // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === "container" ? outerWrapper : options[item];
            if (typeof el === "object" && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        });
        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== "rebuild") this[a] = null;
        isOn = false;
    }
    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === "outer") events.emit("outerResized", info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone;
            // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit("newBreakpointStart", info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption("arrowKeys");
        controls = getOption("controls");
        nav = getOption("nav");
        touch = getOption("touch");
        center = getOption("center");
        mouseDrag = getOption("mouseDrag");
        autoplay = getOption("autoplay");
        autoplayHoverPause = getOption("autoplayHoverPause");
        autoplayResetOnVisibility = getOption("autoplayResetOnVisibility");
        if (bpChanged) {
            disable = getOption("disable");
            fixedWidth = getOption("fixedWidth");
            speed = getOption("speed");
            autoHeight = getOption("autoHeight");
            controlsText = getOption("controlsText");
            autoplayText = getOption("autoplayText");
            autoplayTimeout = getOption("autoplayTimeout");
            if (!CSSMQ) {
                edgePadding = getOption("edgePadding");
                gutter = getOption("gutter");
            }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption("items");
            slideBy = getOption("slideBy");
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(doc, docmentKeydownEvent) : (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) (0, $595e63bb0710ea46$export$998191bfdf710c72)(controlsContainer);
                else {
                    if (prevButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(prevButton);
                    if (nextButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(nextButton);
                }
            } else if (controlsContainer) (0, $55991d37ef474d49$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                (0, $595e63bb0710ea46$export$998191bfdf710c72)(navContainer);
                updateNavVisibility();
            } else (0, $55991d37ef474d49$export$7669482c90f5c50f)(navContainer);
        }
        if (touch !== touchTem) touch ? (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch) : (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, dragEvents) : (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(container, hoverEvents) : (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(doc, visibilityEvent) : (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = "";
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit("indexChanged", info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                    // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    (0, $5e360b60a080e998$export$271e480b8a432c4a)(sheet, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet) - 1);
                    (0, $ffae77d33f8aad94$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $680163ae164c78b9$export$ccd7e907f4f59892)(sheet));
                }
            }
            // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit("newBreakpointEnd", info(e));
    }
    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? // loop + carousel
        function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy;
            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : // loop + gallery
        function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : // non-loop
        function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(autoplayButton);
        if (!nav && navContainer) (0, $55991d37ef474d49$export$7669482c90f5c50f)(navContainer);
        if (!controls) {
            if (controlsContainer) (0, $55991d37ef474d49$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $55991d37ef474d49$export$7669482c90f5c50f)(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(autoplayButton);
        if (nav && navContainer) (0, $595e63bb0710ea46$export$998191bfdf710c72)(navContainer);
        if (controls) {
            if (controlsContainer) (0, $595e63bb0710ea46$export$998191bfdf710c72)(controlsContainer);
            else {
                if (prevButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(prevButton);
                if (nextButton) (0, $595e63bb0710ea46$export$998191bfdf710c72)(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
        // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = "0px";
        // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(slideItems[i], str);
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = "";
        // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(slideItems[i], str);
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), "");
        (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(container, [
            "style"
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $55991d37ef474d49$export$7669482c90f5c50f)(slideItems[j]);
            (0, $55991d37ef474d49$export$7669482c90f5c50f)(slideItems[slideCountNew - j - 1]);
        }
        // vertical slider
        if (!horizontal || !carousel) (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(innerWrapper, [
            "style"
        ]);
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(item, [
                "style"
            ]);
            (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateIn);
            (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateNormal);
        }
        // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $595e63bb0710ea46$export$998191bfdf710c72)(slideItems[j]);
            (0, $595e63bb0710ea46$export$998191bfdf710c72)(slideItems[slideCountNew - j - 1]);
        }
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + "%";
            (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, classN);
        }
        // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + "" : start + " to " + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend;
        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
        // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        });
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!(0, $1cf80cd5abfef804$export$4ea3d958472af68f)(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(img, eve);
                    (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(img, imgEvents);
                    // update src
                    img.src = (0, $955992224a80f66e$export$6a93fe6b2b4c71a0)(img, "data-src");
                    // update srcset
                    var srcset = (0, $955992224a80f66e$export$6a93fe6b2b4c71a0)(img, "data-srcset");
                    if (srcset) img.srcset = srcset;
                    (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(img, "loading");
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(img, "loaded");
        imgCompleted(img);
    }
    function imgFailed(img) {
        (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(img, "failed");
        imgCompleted(img);
    }
    function imgCompleted(img) {
        (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(img, imgCompleteClass);
        (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(img, "loading");
        (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = "img";
        while(start <= end){
            (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
        // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ((0, $1cf80cd5abfef804$export$4ea3d958472af68f)(img, imgCompleteClass)) imgs.splice(index, 1);
        });
        // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
        // otherwise execute this functiona again
        (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + "s";
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + "px";
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? "left" : "top", attr2 = horizontal ? "right" : "bottom", base = slideItems[0].getBoundingClientRect()[attr];
        (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
            // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    }
    // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ((0, $a3d0de7777ea39bf$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                    (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(item, [
                        "aria-hidden",
                        "tabindex"
                    ]);
                    (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, slideActiveClass);
                }
            } else if (!(0, $a3d0de7777ea39bf$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(item, {
                    "aria-hidden": "true",
                    "tabindex": "-1"
                });
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, slideActiveClass);
            }
        });
    }
    // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, "tns-moving");
                item.style.left = (i - index) * 100 / items + "%";
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, animateIn);
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = "";
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, animateNormal);
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateIn);
            }
            // remove outlet animation
            (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateOut);
        }
        // removing '.tns-moving'
        setTimeout(function() {
            (0, $bac2b251a2409032$export$4b80e395e36b5a56)(slideItems, function(el) {
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(el, "tns-moving");
            });
        }, 300);
    }
    // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(navPrev, {
                    "tabindex": "-1",
                    "aria-label": navStr + (navCurrentIndexCached + 1)
                });
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(navPrev, navActiveClass);
                (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(navCurrent, {
                    "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                (0, $5729cb11f0bd4578$export$711225beb0f1ef57)(navCurrent, "tabindex");
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === "button";
    }
    function isAriaDisabled(el) {
        return el.getAttribute("aria-disabled") === "true";
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute("aria-disabled", val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? "%" : "px";
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, "0s");
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + "%";
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + "s";
            (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, classOut);
            (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, "");
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform();
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !(0, $9dfdf59ab63931b0$export$795910f5f15a9633)(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            (0, $e927623c4ef8b275$export$e2705a83c013f564)(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(slideItems[indexCached], eve);
            (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !(0, $9dfdf59ab63931b0$export$795910f5f15a9633)(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit("indexChanged", info());
            events.emit("transitionStart", info());
            if (autoHeight) doAutoHeight();
            // pause autoplay when click or keydown from user
            if (animating && e && [
                "click",
                "keydown"
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, "");
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit("transitionEnd", info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = "";
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = "";
                    item.style[TRANSITIONDELAY] = "";
                }
                (0, $6ea99e3d40b41ad9$export$c2255604a80b4506)(item, animateOut);
                (0, $e860798111c762f5$export$d2cf6cd1dc7067d3)(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit("indexChanged", info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === "inner") events.emit("innerLoaded", info());
                running = false;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === "prev") onControlsClick(e, -1);
        else if (targetIndex === "next") onControlsClick(e, 1);
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === "first") indexGap = -absIndex;
            else if (targetIndex === "last") indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== "number") targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            }
            // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap;
            // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            }
            // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo("last", e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo("first", e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
            // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === "keydown" ? e : null);
        }
    }
    // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex;
        // find the clicked nav item
        while(target !== navContainer && !(0, $a3d0de7777ea39bf$export$5608640b1bf2f6d7)(target, "data-nav"))target = target.parentNode;
        if ((0, $a3d0de7777ea39bf$export$5608640b1bf2f6d7)(target, "data-nav")) {
            var navIndex = navClicked = Number((0, $955992224a80f66e$export$6a93fe6b2b4c71a0)(target, "data-nav")), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        (0, $17ac71bfe480d82f$export$7e45664a2081efb1)(autoplayButton, {
            "data-action": action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("stop", autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("start", autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
    // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    }
    // set focus
    function setFocus(el) {
        el.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!(0, $a3d0de7777ea39bf$export$5608640b1bf2f6d7)(curElement, "data-nav")) return;
        // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number((0, $955992224a80f66e$export$6a93fe6b2b4c71a0)(curElement, "data-nav"));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf("touch") >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return (0, $e10fcc21ed01ec62$export$83b6d73568c72b60)((0, $1580d4de876cf5e0$export$c796d9d3e501591f)(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            (0, $6514445469a71f92$export$75aab3dbee8deceb)(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e));
        if (!isTouchEvent(e) && [
            "img",
            "a"
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ""));
            resetDuration(container, "0s");
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== "boolean" || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        (0, $6514445469a71f92$export$75aab3dbee8deceb)(rafIndex);
        if (panStart) rafIndex = (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += "px";
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += "%";
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                (0, $6514445469a71f92$export$75aab3dbee8deceb)(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, "");
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    (0, $b4ea3be63c1a5fdd$export$aadfb65bee660f96)(target, {
                        "click": function preventClick(e) {
                            preventDefaultBehavior(e);
                            (0, $ef6aa38632f2f7dc$export$da5f6eb3bb522cd)(target, {
                                "click": preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = (0, $2d8ef14f99485540$export$27f233d61a9e2fa4)(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        }
        // reset
        if (options.preventScrollOnTouch === "auto") preventScroll = false;
        if (swipeAngle) moveDirectionExpected = "?";
        if (autoplay && !animating) setAutoplayTimer();
    }
    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + "px";
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = (0, $595e63bb0710ea46$export$998191bfdf710c72);
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = (0, $55991d37ef474d49$export$7669482c90f5c50f);
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            }
            // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: "2.9.4",
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function() {
            return $a89f8de1938e5fc3$export$51fe319e24d9d8c9((0, $3d1c8fec3657292d$export$8b58be045bf06082)(options, optionsElements));
        }
    };
};


var $55d01a33b9caa568$exports = {};

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    $55d01a33b9caa568$exports = factory(function() {
        try {
            return (parcelRequire("cxTnx"));
        } catch (e) {}
    }());
})($55d01a33b9caa568$exports, function(moment) {
    "use strict";
    moment = moment && moment.hasOwnProperty("default") ? moment["default"] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n["default"] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: "rgb"
            },
            hsl: {
                channels: 3,
                labels: "hsl"
            },
            hsv: {
                channels: 3,
                labels: "hsv"
            },
            hwb: {
                channels: 3,
                labels: "hwb"
            },
            cmyk: {
                channels: 4,
                labels: "cmyk"
            },
            xyz: {
                channels: 3,
                labels: "xyz"
            },
            lab: {
                channels: 3,
                labels: "lab"
            },
            lch: {
                channels: 3,
                labels: "lch"
            },
            hex: {
                channels: 1,
                labels: [
                    "hex"
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    "keyword"
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    "ansi16"
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    "ansi256"
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    "h",
                    "c",
                    "g"
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    "r16",
                    "g16",
                    "b16"
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    "gray"
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!("channels" in convert[model])) throw new Error("missing channels property: " + model);
            if (!("labels" in convert[model])) throw new Error("missing channel labels property: " + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], "channels", {
                value: channels
            });
            Object.defineProperty(convert[model], "labels", {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
                return char + char;
            }).join("");
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], "labels", {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === "string") {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues("rgb", vals);
            else if (vals = colorString.getHsla(obj)) this.setValues("hsl", vals);
            else if (vals = colorString.getHwb(obj)) this.setValues("hwb", vals);
        } else if (typeof obj === "object") {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues("rgb", vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues("hsl", vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues("hsv", vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues("hwb", vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues("cmyk", vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace("rgb", arguments);
        },
        hsl: function() {
            return this.setSpace("hsl", arguments);
        },
        hsv: function() {
            return this.setSpace("hsv", arguments);
        },
        hwb: function() {
            return this.setSpace("hwb", arguments);
        },
        cmyk: function() {
            return this.setSpace("cmyk", arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues("alpha", val);
            return this;
        },
        red: function(val) {
            return this.setChannel("rgb", 0, val);
        },
        green: function(val) {
            return this.setChannel("rgb", 1, val);
        },
        blue: function(val) {
            return this.setChannel("rgb", 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel("hsl", 0, val);
        },
        saturation: function(val) {
            return this.setChannel("hsl", 1, val);
        },
        lightness: function(val) {
            return this.setChannel("hsl", 2, val);
        },
        saturationv: function(val) {
            return this.setChannel("hsv", 1, val);
        },
        whiteness: function(val) {
            return this.setChannel("hwb", 1, val);
        },
        blackness: function(val) {
            return this.setChannel("hwb", 2, val);
        },
        value: function(val) {
            return this.setChannel("hsv", 2, val);
        },
        cyan: function(val) {
            return this.setChannel("cmyk", 0, val);
        },
        magenta: function(val) {
            return this.setChannel("cmyk", 1, val);
        },
        yellow: function(val) {
            return this.setChannel("cmyk", 2, val);
        },
        black: function(val) {
            return this.setChannel("cmyk", 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return "AAA";
            return contrastRatio >= 4.5 ? "AA" : "";
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues("rgb", rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues("rgb", [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues("hsl", hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === "[object Array]") target[prop] = value.slice(0);
                else if (type === "[object Number]") target[prop] = value;
                else console.error("unexpected color value:", value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            "red",
            "green",
            "blue"
        ],
        hsl: [
            "hue",
            "saturation",
            "lightness"
        ],
        hsv: [
            "hue",
            "saturation",
            "value"
        ],
        hwb: [
            "hue",
            "whiteness",
            "blackness"
        ],
        cmyk: [
            "cyan",
            "magenta",
            "yellow",
            "black"
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === "alpha") alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === "alpha") return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === "number") vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== "undefined") window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            "__proto__",
            "prototype",
            "constructor"
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === "undefined";
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === "[object Object]";
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === "number" || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === "undefined" ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty("constructor") ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === "object") {
                type = style.toString();
                if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case "triangle":
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case "rectRounded":
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case "rect":
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case "rectRot":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case "crossRot":
                    rad += QUARTER_PI;
                /* falls through */ case "cross":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "star":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "line":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case "dash":
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === "middle") {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === "after" && !flip || stepped !== "after" && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set("global", {
        defaultColor: "rgba(0,0,0,0.1)",
        defaultFontColor: "#666",
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: "normal",
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ("" + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === "normal") return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case "px":
                    return value;
                case "%":
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ""
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === "function") {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === "center") return align;
                return align === "right" ? "left" : "right";
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === "ltr" || direction === "rtl") {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue("direction"),
                style.getPropertyPriority("direction")
            ];
            style.setProperty("direction", direction, "important");
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty("direction", original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === "_") continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === "string") {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: "",
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "animationObject", {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "chartInstance", {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set("global", {
        animation: {
            duration: 1000,
            easing: "easeOutQuart",
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        "push",
        "pop",
        "shift",
        "splice",
        "unshift"
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, "_chartjs", {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = "onData" + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === "function") object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth"
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "pointStyle"
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== "_meta" && key !== "data") helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? "hover" + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set("global", {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: "#fff",
                borderWidth: 2,
                borderAlign: "center"
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === "inner";
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = "round";
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = "bevel";
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: "arc",
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === "inner" ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: "line",
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            point: {
                radius: 3,
                pointStyle: "circle",
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: "point",
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: "bottom",
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, "left", "right");
        } else if (vm.base < vm.y) edge = swap(edge, "bottom", "top");
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: "rectangle",
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill("evenodd");
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set("bar", {
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: "linear"
                }
            ]
        }
    });
    core_defaults._set("global", {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderSkipped",
            "borderWidth",
            "barPercentage",
            "barThickness",
            "categoryPercentage",
            "maxBarThickness",
            "minBarLength"
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated("bar chart", scaleOpts.barPercentage, "scales.[x/y]Axes.barPercentage", "dataset.barPercentage");
            deprecated("bar chart", scaleOpts.barThickness, "scales.[x/y]Axes.barThickness", "dataset.barThickness");
            deprecated("bar chart", scaleOpts.categoryPercentage, "scales.[x/y]Axes.categoryPercentage", "dataset.categoryPercentage");
            deprecated("bar chart", me._getValueScale().options.minBarLength, "scales.[x/y]Axes.minBarLength", "dataset.minBarLength");
            deprecated("bar chart", scaleOpts.maxBarThickness, "scales.[x/y]Axes.maxBarThickness", "dataset.maxBarThickness");
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set("bubble", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom",
                    id: "x-axis-0" // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    position: "left",
                    id: "y-axis-0"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return "";
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || "";
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ": (" + item.xLabel + ", " + item.yLabel + ", " + dataPoint.r + ")";
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth",
            "hoverRadius",
            "hitRadius",
            "pointStyle",
            "rotation"
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === "object" ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set("doughnut", {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: "single"
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== "inner") {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set("horizontalBar", {
        hover: {
            mode: "index",
            axis: "y"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    type: "category",
                    position: "left",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: "left"
            }
        },
        tooltips: {
            mode: "index",
            axis: "y"
        }
    });
    core_defaults._set("global", {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set("line", {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    id: "x-axis-0"
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    id: "y-axis-0"
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth",
            "cubicInterpolationMode",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === "object" ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === "line" && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === "monotone") helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set("polarArea", {
        scale: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(item, data) {
                    return data.labels[item.index] + ": " + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set("pie", helpers$1.clone(core_defaults.doughnut));
    core_defaults._set("pie", {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set("radar", {
        spanGaps: false,
        scale: {
            type: "radialLinear"
        },
        elements: {
            line: {
                fill: "start",
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderWidth",
            "borderColor",
            "borderCapStyle",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set("scatter", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    id: "x-axis-1",
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    id: "y-axis-1",
                    type: "linear",
                    position: "left"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ""; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return "(" + item.xLabel + ", " + item.yLabel + ")";
                }
            }
        }
    });
    core_defaults._set("global", {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf("x") !== -1;
        var useY = axis.indexOf("y") !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || "x";
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ "x-axis": function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, "right"));
        var top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, "chartArea"),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right");
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom");
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos("top");
        chartArea.x += updatePos("left");
        updatePos("right");
        updatePos("bottom");
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            "left",
            "right"
        ]) : marginForPositions([
            "top",
            "bottom"
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set("global", {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || "top";
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                "fullWidth",
                "position",
                "weight"
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext("2d") || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n	from { opacity: 0.99; }\r\n	to { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n	animation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n	position: absolute;\r\n	direction: ltr;\r\n	left: 0;\r\n	top: 0;\r\n	right: 0;\r\n	bottom: 0;\r\n	overflow: hidden;\r\n	pointer-events: none;\r\n	visibility: hidden;\r\n	z-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n	position: absolute;\r\n	width: 1000000px;\r\n	height: 1000000px;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n	position: absolute;\r\n	width: 200%;\r\n	height: 200%;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        "default": platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = "$chartjs";
    var CSS_PREFIX = "chartjs-";
    var CSS_SIZE_MONITOR = CSS_PREFIX + "size-monitor";
    var CSS_RENDER_MONITOR = CSS_PREFIX + "render-monitor";
    var CSS_RENDER_ANIMATION = CSS_PREFIX + "render-animation";
    var ANIMATION_START_EVENTS = [
        "animationstart",
        "webkitAnimationStart"
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        pointerenter: "mouseenter",
        pointerdown: "mousedown",
        pointermove: "mousemove",
        pointerup: "mouseup",
        pointerleave: "mouseout",
        pointerout: "mouseout"
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute("height");
        var renderWidth = canvas.getAttribute("width");
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || "block";
        if (renderWidth === null || renderWidth === "") {
            var displayWidth = readUsedSize(canvas, "width");
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === "") {
            if (canvas.style.height === "") // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, "height");
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, "passive", {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener("e", null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement("div");
        el.className = cls || "";
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + "-expand");
        var shrink = createDiv(CSS_SIZE_MONITOR + "-shrink");
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, "scroll", onScroll.bind(expand, "expand"));
        addListener(shrink, "scroll", onScroll.bind(shrink, "shrink"));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent("resize", chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent("resize", chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = "/* Chart.js */\n" + css;
            var style = document.createElement("style");
            style.setAttribute("type", "text/css");
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== "undefined" && typeof document !== "undefined",
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === "string") item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext("2d");
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                "height",
                "width"
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + "_" + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + "_" + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set("global", {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === "function") {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set("global", {
        tooltips: {
            enabled: true,
            custom: null,
            mode: "nearest",
            position: "average",
            intersect: true,
            backgroundColor: "rgba(0,0,0,0.8)",
            titleFontStyle: "bold",
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: "#fff",
            titleAlign: "left",
            bodySpacing: 2,
            bodyFontColor: "#fff",
            bodyAlign: "left",
            footerFontStyle: "bold",
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: "#fff",
            footerAlign: "left",
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: "#fff",
            displayColors: true,
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = "";
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || "";
                    if (label) label += ": ";
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : "",
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : "",
            label: indexScale ? "" + indexScale.getLabelForIndex(index, datasetIndex) : "",
            value: valueScale ? "" + valueScale.getLabelForIndex(index, datasetIndex) : "",
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = "center";
        var yAlign = "center";
        if (model.y < size.height) yAlign = "top";
        else if (model.y > chart.height - size.height) yAlign = "bottom";
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === "center") {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? "top" : "bottom";
        };
        if (lf(model.x)) {
            xAlign = "left";
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = "right";
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === "right") x -= size.width;
        else if (xAlign === "center") {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === "top") y += paddingAndSize;
        else if (yAlign === "bottom") y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === "center") {
            if (xAlign === "left") x += paddingAndSize;
            else if (xAlign === "right") x -= paddingAndSize;
        } else if (xAlign === "left") x -= radiusAndPadding;
        else if (xAlign === "right") x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === "center" ? vm.x + vm.width / 2 : align === "right" ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === "center") {
                y2 = ptY + height / 2;
                if (xAlign === "left") {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === "left") {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === "right") {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === "top") {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = "middle";
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, "left") : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = "middle";
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = "middle";
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === "top") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === "bottom") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === "mouseout") me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        elements: {},
        events: [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ],
        hover: {
            onHover: null,
            mode: "nearest",
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === "xAxes" || key === "yAxes") {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === "xAxes" ? "category" : "linear");
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === "scales") // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === "scale") // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === "top" || position === "bottom";
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, "data", {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, "beforeInit");
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, "afterInit");
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + "px";
            canvas.style.height = newHeight + "px";
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, "resize", [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, "x-axis-", index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, "y-axis-", index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || "scale";
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: "category",
                    dposition: "bottom"
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: "linear",
                    dposition: "left"
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: "radialLinear",
                isDefault: true,
                dposition: "chartArea"
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, "beforeUpdate") === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, "afterUpdate");
            me._layers.sort(compare2Level("z", "_idx"));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeLayout") === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, "afterScaleUpdate");
            core_plugins.notify(me, "afterLayout");
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeDatasetsUpdate") === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, "afterDatasetsUpdate");
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, "beforeDatasetUpdate", [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, "afterDatasetUpdate", [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, "beforeRender") === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, "afterRender");
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, "beforeDraw", [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, "afterDraw", [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level("order", "index"));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, "beforeDatasetsDraw", [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, "afterDatasetsDraw", [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeDatasetDraw", [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, "afterDatasetDraw", [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeTooltipDraw", [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, "afterTooltipDraw", [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes["x-axis"](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === "function") return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === "boolean" ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, "destroy");
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, "resize", listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? "set" : "remove";
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + "HoverStyle"](element);
            }
            if (mode === "dataset") this.getDatasetMeta(elements[0]._datasetIndex).controller["_" + prefix + "DatasetHoverStyle"]();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, "beforeEvent", [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, "afterEvent", [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === "mouseout") me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === "mouseup" || e.type === "click") {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === "undefined") return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, "padding-left"));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, "padding-top"));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, "padding-right"));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, "padding-bottom"));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === "string") {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== "none";
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return "none";
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, "max-width", "clientWidth");
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, "max-height", "clientHeight");
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf("%") > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, "padding-left", clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, "padding-right", clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, "padding-top", clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, "padding-bottom", clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== "undefined" && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + "px";
                canvas.style.width = width + "px";
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + " " + pixelSize + "px " + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error("Color.js not found!");
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : "" + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = "";
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = "0"; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return "0";
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return "";
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set("scale", {
        display: true,
        position: "left",
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: "rgba(0,0,0,0.25)",
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: "",
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== "undefined") filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto") ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === "bottom";
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === "number" || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return "[" + v.start + ", " + v.end + "]";
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== "auto") return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === "top") {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === "bottom") {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === "left") {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, "rgba(0,0,0,0.1)");
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === "top") {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? "center" : "left";
            } else if (position === "bottom") {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? "center" : "right";
            } else if (position === "left") {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? "left" : "right";
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? "right" : "left";
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === "top" ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = "middle";
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText("" + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === "bottom" ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === "left";
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: "bottom"
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === "string") return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: "left",
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : "",
            meta.stack
        ].join(".");
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: "left",
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : "",
                        meta.stack
                    ].join(".");
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: "rgba(255,255,255,0.75)",
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return "center";
        else if (angle < 180) return "left";
        return "right";
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = "middle";
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : "";
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === "linear" || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === "function") value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === "string" ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === "function") {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === "week" ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, "isoWeek", weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? "day" : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === "ticks") ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, "time", ticks[0], "pos");
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, "time", ticks[1], "pos") - first) / 2;
            last = interpolate$1(table, "time", ticks[ticks.length - 1], "pos");
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, "time", ticks[ticks.length - 2], "pos")) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: "bottom",
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: "linear",
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: "auto",
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1("time scale", time.format, "time.format", "time.parser");
            deprecated$1("time scale", time.min, "time.min", "ticks.min");
            deprecated$1("time scale", time.max, "time.max", "ticks.max");
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || "day";
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === "data" || source === "auto" && distribution === "series") timestamps = timestamps.data;
            else if (source === "labels") timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === "ticks" && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : "";
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === "string") return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, "time", time, "pos");
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, "pos", pos, "time");
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    core_adapters._date.override(typeof moment === "function" ? {
        _id: "moment",
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === "string" && typeof format === "string") value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === "isoWeek") return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set("global", {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return "origin";
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === "-" || fill[0] === "+") target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case "bottom":
                return "start";
            case "top":
                return "end";
            case "zero":
                return "origin";
            // supported boundaries
            case "origin":
            case "start":
            case "end":
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === "start") target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === "end") target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === "start" || fill === "end" ? scale.getPointPositionForValue(i, fill === "start" ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = "dataset";
        if (fill === false) return null;
        if (!isFinite(fill)) type = "boundary";
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: "filler",
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        legend: {
            display: true,
            position: "top",
            align: "center",
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === "top" || this.options.position === "bottom";
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign("left");
            ctx.textBaseline = "middle";
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case "start":
                        return labelOpts.padding;
                    case "end":
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === "mouseup" ? "click" : e.type;
            var hoveredItem;
            if (type === "mousemove") {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === "click") {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === "click") {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: "legend",
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set("global", {
        title: {
            display: false,
            fontStyle: "bold",
            fullWidth: true,
            padding: 10,
            position: "top",
            text: "",
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === "left" ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === "left" ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: "title",
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== "undefined") window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        "Bar",
        "Bubble",
        "Doughnut",
        "Line",
        "PolarArea",
        "Radar",
        "Scatter"
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});


const $007db0a3d89c8a26$var$existsInDOM = function(selector) {
    return document.querySelectorAll(selector).length;
};
const $007db0a3d89c8a26$var$plugins = {
    createTab: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.triggers) && $007db0a3d89c8a26$var$existsInDOM(options.elements)) return new (0, $fba6a719fb8ca21f$export$2e2bcd8739ae039)(options);
    },
    createHexagon: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.container) || typeof options.containerElement !== "undefined") return new (0, $cf19bbea2ba9bc68$export$2e2bcd8739ae039)(options);
    },
    createProgressBar: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.container)) return new (0, $271884305fc975b4$export$2e2bcd8739ae039)(options);
    },
    createDropdown: function(options) {
        if (($007db0a3d89c8a26$var$existsInDOM(options.container) || typeof options.containerElement !== "undefined") && options.controlToggle || ($007db0a3d89c8a26$var$existsInDOM(options.trigger) || typeof options.triggerElement !== "undefined") && ($007db0a3d89c8a26$var$existsInDOM(options.container) || typeof options.containerElement !== "undefined")) return new (0, $3adef5426d1c9ba3$export$2e2bcd8739ae039)(options);
    },
    createTooltip: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.container)) return new (0, $0b57f21fded9e412$export$2e2bcd8739ae039)(options);
    },
    createSlider: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.container)) return (0, $a89f8de1938e5fc3$export$51fe319e24d9d8c9)(options);
    },
    createPopup: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.container) && $007db0a3d89c8a26$var$existsInDOM(options.trigger)) return new (0, $e49978d96d48b386$export$2e2bcd8739ae039)(options);
    },
    createAccordion: function(options) {
        if ($007db0a3d89c8a26$var$existsInDOM(options.triggerSelector) && $007db0a3d89c8a26$var$existsInDOM(options.contentSelector)) return new (0, $e65781730ccf193e$export$2e2bcd8739ae039)(options);
    },
    createChart: function(ctx, options) {
        return new $55d01a33b9caa568$exports(ctx, options);
    }
};
$007db0a3d89c8a26$exports = $007db0a3d89c8a26$var$plugins;


$007db0a3d89c8a26$exports.createTooltip({
    container: ".text-tooltip-tfr",
    offset: 4,
    direction: "right",
    animation: {
        type: "translate-in-fade"
    }
});
$007db0a3d89c8a26$exports.createTooltip({
    container: ".text-tooltip-tft",
    offset: 4,
    direction: "top",
    animation: {
        type: "translate-out-fade"
    }
});
$007db0a3d89c8a26$exports.createTooltip({
    container: ".text-tooltip-tft-medium",
    offset: 8,
    direction: "top",
    animation: {
        type: "translate-out-fade"
    }
});




$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-video",
    trigger: ".popup-video-trigger",
    sticky: true,
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-picture",
    trigger: ".popup-picture-trigger",
    sticky: true,
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-album-creation",
    trigger: ".popup-album-creation-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-event-creation",
    trigger: ".popup-event-creation-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-event-information",
    trigger: ".popup-event-information-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-manage-group",
    trigger: ".popup-manage-group-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-manage-item",
    trigger: ".popup-manage-item-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
$007db0a3d89c8a26$exports.createPopup({
    container: ".popup-review",
    trigger: ".popup-review-trigger",
    overlay: {
        color: "21, 21, 31",
        opacity: .96
    },
    animation: {
        type: "translate-in-fade",
        speed: .3,
        translateOffset: 40
    }
});
/*--------------------------
    PICTURE POPUP RESIZE
--------------------------*/ $342f7fe00eb414e4$exports.querySelector(".popup-picture", function(el) {
    const popup = el[0], widgetBoxScrollable = popup.querySelector(".widget-box-scrollable"), postCommentForm = popup.querySelector(".post-comment-form");
    const updateWidgetBoxScrollableDimensions = function() {
        widgetBoxScrollable.style.height = `${popup.offsetHeight - postCommentForm.offsetHeight}px`;
    };
    updateWidgetBoxScrollableDimensions();
    window.addEventListener("resize", updateWidgetBoxScrollableDimensions);
});



$007db0a3d89c8a26$exports.createAccordion({
    triggerSelector: ".accordion-trigger",
    contentSelector: ".accordion-content",
    startOpenClass: "accordion-open",
    selectedClass: "selected",
    linkTriggers: false
});
$007db0a3d89c8a26$exports.createAccordion({
    triggerSelector: ".accordion-trigger-linked",
    contentSelector: ".accordion-content-linked",
    startOpenClass: "accordion-open",
    selectedClass: "selected",
    linkTriggers: true
});


const $2a0228d744e2e035$var$svgWrap = document.createElement("div"), $2a0228d744e2e035$var$svgData = `
  <!-- SVG FACEBOOK -->
  <svg style="display: none;">
    <symbol id="svg-facebook" viewBox="0 0 18 18" preserveAspectRatio="xMinYMin meet">
      <path d="M16.313,18h-4.504v-6.192h3.087V8.671h-3.087V7.135V6.831V6.814l0,0c0.01-0.328,0.277-0.591,0.607-0.591h0.067h1.113h1.62V3.086h-2.733l0,0l-0.009,0.018h-0.092c-2.051,0-3.712,1.661-3.712,3.711v0.911v0.945H6.191v3.137h2.479V18H1.687C0.755,18,0,17.242,0,16.313V1.686C0,0.754,0.755,0,1.687,0h14.626C17.244,0,18,0.754,18,1.686v14.627C18,17.242,17.244,18,16.313,18z"/>
    </symbol>
  </svg>
  <!-- /SVG FACEBOOK -->

  <!-- SVG TWITTER -->
  <svg style="display: none;">
    <symbol id="svg-twitter" viewBox="0 0 18 18" preserveAspectRatio="xMinYMin meet">
        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
    </symbol>
  </svg>
  <!-- /SVG TWITTER -->

  <!-- SVG TWITCH -->
  <svg style="display: none;">
    <symbol id="svg-twitch" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M6.179,0L0,17.964V87.81h24.714V100h15.789L52.86,87.81h18.993L100,60.527V0H6.179z M90.39,57.645L74.828,72.504H49.885L37.299,84.703V72.504H15.561V9.094H90.39V57.645z M49.885,27.051h-9.382v27.27h9.382V27.051z M74.828,27.051h-9.382v27.27h9.382V27.051z"/>
    </symbol>
 </svg>
 <svg style="display: none;"><symbol id="svg-linkedin" viewBox="0 0 24 24" preserveAspectRatio="xMinYMin meet"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path></symbol></svg>
 <!-- /SVG TWITCH -->

  <!-- SVG YOUTUBE -->
  <svg style="display: none;">
    <symbol id="svg-youtube" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M97.911,24.557c-1.149-4.549-4.538-8.13-8.842-9.347C81.271,13,49.999,13,49.999,13s-31.271,0-39.07,2.21c-4.302,1.216-7.69,4.798-8.84,9.347C0,32.8,0,50.001,0,50.001s0,17.2,2.089,25.443c1.15,4.549,4.538,8.132,8.84,9.348C18.729,87,49.999,87,49.999,87s31.271,0,39.07-2.208c4.304-1.216,7.692-4.799,8.842-9.348C100,67.201,100,50.001,100,50.001S100,32.8,97.911,24.557z M39.999,65.858V34.144L65.98,50.001L39.999,65.858z"/>
    </symbol>
  </svg>
  <!-- /SVG YOUTUBE -->

  <!-- SVG INSTAGRAM -->
  <svg style="display: none;">
    <symbol id="svg-instagram" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M72.402,0H27.595C12.379,0,0,12.381,0,27.597v44.809C0,87.619,12.379,100,27.595,100h44.807C87.621,100,100,87.619,100,72.406V27.597C100,12.381,87.621,0,72.402,0z M88.691,71.078c0,9.711-7.902,17.613-17.615,17.613H28.923c-9.712,0-17.613-7.902-17.613-17.613V28.926c0-9.715,7.901-17.618,17.613-17.618h42.153c9.713,0,17.615,7.903,17.615,17.618V71.078z M50.001,26.779c-12.804,0-23.22,10.426-23.22,23.22c0,12.804,10.416,23.22,23.22,23.22c12.801,0,23.217-10.416,23.217-23.22C73.219,37.205,62.803,26.779,50.001,26.779z M50.001,63.689c-7.548,0-13.688-6.139-13.688-13.691c0-7.545,6.14-13.684,13.688-13.684c7.545,0,13.686,6.139,13.686,13.684C63.688,57.551,57.547,63.689,50.001,63.689z M75.658,17.864c-1.711,0-4.383,0.724-5.711,2.056c-1.332,1.328-2.098,3.178-2.098,5.065c0,1.882,0.766,3.727,2.098,5.063c1.326,1.325,3.172,2.098,5.051,2.098c1.885,0,3.723-0.772,5.055-2.098c1.332-1.336,2.094-3.184,2.094-5.063c0-1.888-0.762-3.737-2.094-5.065C78.729,18.587,77.373,17.864,75.658,17.864z"/>
    </symbol>
  </svg>
  <!-- /SVG INSTAGRAM -->

  <!-- SVG DISCORD -->
  <svg style="display: none;">
    <symbol id="svg-discord" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M87.671,23.75C75.993,15.223,64.855,15,63.707,15c-0.061,0-0.093,0-0.093,0l-1.2,1.332c14.556,4.332,21.32,10.582,21.32,10.582c-8.906-4.749-17.639-7.083-25.771-8c-2.7-0.291-5.353-0.422-7.926-0.422c-3.287,0-6.437,0.216-9.371,0.591c-0.512,0-0.941,0.084-1.456,0.165c-2.994,0.252-10.273,1.334-19.434,5.249c-3.167,1.417-5.052,2.417-5.052,2.417s7.107-6.583,22.518-10.915L36.387,15c0,0-0.032,0-0.098,0c-1.144,0-12.283,0.223-23.96,8.75C12.329,23.75,0,45.498,0,72.333c0,0,7.19,12.081,26.114,12.667c0,0,3.166-3.752,5.734-6.919c-10.873-3.168-14.981-9.831-14.981-9.831s0.854,0.582,2.397,1.414l0.343,0.25l0.769,0.419c2.14,1.163,4.282,2.084,6.251,2.833c3.511,1.334,7.706,2.663,12.584,3.585c3.51,0.633,7.349,1.047,11.451,1.047c3.408,0,6.999-0.284,10.728-0.964c4.021-0.67,8.129-1.836,12.415-3.585c2.991-1.083,6.333-2.665,9.845-4.916c0,0-4.287,6.831-15.5,9.915C70.717,81.414,73.805,85,73.805,85C92.722,84.414,100,72.333,100,72.333C100,45.498,87.671,23.75,87.671,23.75z M34.869,66.745c-5.046,0-9.136-4.056-9.136-9.059c0-5.002,4.09-9.059,9.136-9.059c5.045,0,9.137,4.057,9.137,9.059C44.006,62.689,39.914,66.745,34.869,66.745z M67.758,66.745c-5.045,0-9.135-4.056-9.135-9.059c0-5.002,4.09-9.059,9.135-9.059c5.046,0,9.137,4.057,9.137,9.059C76.895,62.689,72.804,66.745,67.758,66.745z"/>
    </symbol>
  </svg>
  <!-- /SVG DISCORD -->

  <!-- SVG PATREON -->
  <svg style="display: none;">
    <symbol id="svg-patreon" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M0,100h16.667V0H0V100z M62.5,0C41.79,0,25,16.788,25,37.5c0,20.71,16.789,37.503,37.5,37.503c20.711,0,37.5-16.793,37.5-37.503C100,16.788,83.211,0,62.5,0z"/>
    </symbol>
  </svg>
  <!-- /SVG PATREON -->

  <!-- SVG GOOGLE -->
  <svg style="display: none;">
    <symbol id="svg-google" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M100,47.82H89.963v9.785H79.927V47.82H69.89v-9.784h10.037v-9.784h10.036v9.784H100V47.82z M32.358,83C14.487,83,0,68.226,0,50c0-18.226,14.487-33,32.358-33c8.594,0,16.384,3.437,22.173,9.013l-0.6,0.612L45,35.734c-3.349-3.087-7.773-4.984-12.642-4.984c-10.426,0-18.877,8.619-18.877,19.25c0,10.632,8.451,19.25,18.877,19.25c8.046,0,14.898-5.143,17.614-12.375l-15.21,0.729V42.927l28.606,0.199v1.375v12.375v2.516C59.4,73.038,47.028,83,32.358,83z"/>
    </symbol>
  </svg>
  <!-- /SVG GOOGLE -->

  <!-- SVG BEHANCE -->
  <svg style="display: none;">
    <symbol id="svg-behance" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M99.827,61.223H68.064c0,3.648,0.755,10.949,10.776,10.949s9.643-6.916,9.643-6.916H99.26c0,18.249-20.986,16.713-20.986,16.713c-24.012,0-23.822-20.746-23.822-20.746
    c0-5.668-0.095-27.087,24.39-27.087S99.827,61.223,99.827,61.223z M78.273,43.356c-9.714,0-10.209,9.221-10.209,9.221h19.852C87.916,52.577,87.987,43.356,78.273,43.356z M64.661,21.458h26.091v8.067H64.661V21.458z M35.166,80.799v0.016H0V18h34.032c0,0,0.024,0,0.062,0h1.072v0.054c3.628,0.299,14.748,2.292,14.748,15.506c0,0,1.144,10.259-7.661,12.951
    c4.671,0.871,9.93,4.394,9.93,15.863C52.183,62.373,53.762,80.43,35.166,80.799z M33.465,29.525H14.748V42.78h18.15c0,0,3.97-1.057,3.97-6.915C36.868,30.006,33.465,29.525,33.465,29.525z M34.032,53.154H14.748V69.29h18.717c0,0,5.672-1.249,5.672-8.067C39.137,54.402,34.032,53.154,34.032,53.154z"/>
    </symbol>
  </svg>
  <!-- /SVG BEHANCE -->

  <!-- SVG DEVIANTART -->
  <svg style="display: none;">
    <symbol id="svg-deviantart" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M83,80.77H48.107L37.204,100H17V82.052l21.362-37.18H17V20.513h35.356L64.143,0H83v19.231L61.918,56.41H83V80.77z"/>
    </symbol>
  </svg>
  <!-- /SVG DEVIANTART -->

  <!-- SVG ARTSTATION -->
  <svg style="display: none;">
    <symbol id="svg-artstation" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
      <path d="M0,77.114l8.412,16.545c1.7,3.754,5.102,6.341,8.981,6.341h56.038l-11.62-22.886H0z M98.391,71.002L65.502,6.122C63.797,2.47,60.491,0,56.617,0H39.224l50.755,99.889l8.035-15.79c1.515-3.001,1.986-4.29,1.986-6.877C100,74.967,99.432,72.819,98.391,71.002z M31,16.217L8.315,60.799h45.276L31,16.217z"/>
    </symbol>
  </svg>
  <!-- /SVG ARTSTATION -->

  <!-- SVG CROSS -->
  <svg style="display: none;">
    <symbol id="svg-cross" viewBox="0 0 12 12" preserveAspectRatio="xMinYMin meet">
      <path d="M12,9.6L9.6,12L6,8.399L2.4,12L0,9.6L3.6,6L0,2.4L2.4,0L6,3.6L9.6,0L12,2.4L8.399,6L12,9.6z"/>
    </symbol>
  </svg>
  <!-- /SVG CROSS -->

  <!-- SVG LOGO VIKINGER -->
  <svg style="display: none;">
    <symbol id="svg-logo-vikinger" viewBox="0 0 28 40" preserveAspectRatio="xMinYMin meet">
      <path d="M27.18,24.038c-0.141-0.095-0.244-0.146-0.244-0.146l-0.005-0.049C25.489,22.783,23.103,22,23.103,22c1.542,0,2.582-0.563,3.501-1.334c-0.049-0.055,0.7-0.666,0.7-0.666c0.146-8.251-4.477-12.745-7.001-14.667C18.15,9.564,16.802,14,16.802,14c-0.219-4.426,0.243-8.072,0.7-10.667c-0.85-0.452-1.956-0.698-2.296-1.537C14.865,0.957,14.015,0,14.015,0L14,0.014L13.985,0c0,0-0.85,0.957-1.19,1.796c-0.34,0.839-1.445,1.085-2.295,1.537C10.957,5.928,11.418,9.574,11.2,14c0,0-1.349-4.436-3.501-8.667C5.174,7.255,0.551,11.749,0.697,20c0,0,0.75,0.611,0.701,0.666C2.316,21.437,3.357,22,4.898,22c0,0-2.387,0.783-3.829,1.844l-0.005,0.049c0,0-0.104,0.051-0.244,0.146c-0.48,0.397-0.806,0.828-0.819,1.269c-0.023,0.521,0.263,1.181,1.233,1.973c0,0,0.136,9.259,9.69,11.29c0,0,0.212,0.815,0.975,1.431L14,38l2.102,2c0.763-0.615,0.975-1.431,0.975-1.431c9.555-2.031,9.689-11.29,9.689-11.29
      c0.971-0.792,1.256-1.451,1.233-1.973C27.986,24.866,27.659,24.436,27.18,24.038z M4.198,26c2.362,0.121,3.517,1.473,5.602,4c0.799,0.969,2.059,0.83,2.059,0.83L11.899,34C5.249,34,4.198,26,4.198,26z M14,28.162l-2.97-2.828l2.101-2.001l-2.101-2l2.101-2l-2.101-2L14,14.505l2.972,2.828l-2.102,2l2.102,2l-2.102,2l2.102,2.001L14,28.162z M16.102,34l0.041-3.17
      c0,0,1.26,0.139,2.059-0.83c2.085-2.527,3.239-3.879,5.602-4C23.803,26,22.752,34,16.102,34z M13.3,26h1.4v-1.333h-1.4V26z M13.3,22h1.4v-1.334h-1.4V22z M13.3,18h1.4v-1.333h-1.4V18z"/>
    </symbol>
  </svg>
  <!-- /SVG LOGO VIKINGER -->

  <!-- SVG GRID -->
  <svg style="display: none;">
    <symbol id="svg-grid" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M7,0H2C0.896,0,0,0.895,0,2v5c0,1.104,0.896,2,2,2h5c1.104,0,2-0.896,2-2V2C9,0.895,8.104,0,7,0z M7,7H2V2h5V7z M7,11H2c-1.104,0-2,0.896-2,1.999v5C0,19.104,0.896,20,2,20h5c1.104,0,2-0.896,2-2.001v-5C9,11.896,8.104,11,7,11z M7,17.999H2v-5h5V17.999z M18,0h-5c-1.104,0-2,0.895-2,2v5c0,1.104,0.896,2,2,2h5c1.104,0,2-0.896,2-2V2C20,0.895,19.104,0,18,0z M18,7h-5V2h5V7z M18,11h-5c-1.104,0-2,0.896-2,1.999v5C11,19.104,11.896,20,13,20h5c1.104,0,2-0.896,2-2.001v-5C20,11.896,19.104,11,18,11z M18,17.999h-5v-5h5V17.999z"/>
    </symbol>
  </svg>
  <!-- /SVG GRID -->

  <!-- SVG DOTS -->
  <svg style="display: none;">
    <symbol id="svg-dots" viewBox="0 0 10 2" preserveAspectRatio="xMinYMin meet">
      <path d="M0,2h2V0H0V2z M4,2h2V0H4V2z M8,0v2h2V0H8z"/>
    </symbol>
  </svg>
  <!-- /SVG DOTS -->

  <!-- SVG MAGNIFYING GLASS -->
  <svg style="display: none;">
    <symbol id="svg-magnifying-glass" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M8,2c3.309,0,6,2.691,6,6s-2.691,6-6,6s-6-2.691-6-6S4.691,2,8,2 M8,0C3.582,0,0,3.582,0,8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8C16,3.582,12.418,0,8,0L8,0z"/>
      <path d="M19.171,15.168l-3.134-3.134c-0.309,0.613-0.679,1.19-1.113,1.714l2.833,2.834c0.323,0.324,0.323,0.851,0,1.175C17.545,17.969,17.298,18,17.17,18c-0.129,0-0.376-0.031-0.588-0.243l-2.834-2.833c-0.523,0.435-1.101,0.805-1.714,1.113l3.134,3.134C15.721,19.724,16.445,20,17.169,20c0.725,0,1.449-0.276,2.002-0.829C20.276,18.065,20.276,16.273,19.171,15.168z"/>
    </symbol>
  </svg>
  <!-- /SVG MAGNIFYING GLASS -->

  <!-- SVG COMMENT -->
  <svg style="display: none;">
    <symbol id="svg-comment" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15,2c1.654,0,3,1.257,3,2.803v6.404c0,1.546-1.346,2.803-3,2.803H7.98H7.508l-0.422,0.211L2,16.764v-5.557V10V4.803C2,3.257,3.346,2,5,2H15 M15,0H5C2.238,0,0,2.15,0,4.803V10v1.207V20l7.98-3.99H15c2.762,0,5-2.15,5-4.803V4.803C20,2.15,17.762,0,15,0L15,0z"/>
      <g>
        <path d="M14,5H6C5.447,5,5,5.448,5,6c0,0.553,0.447,1,1,1h8c0.553,0,1-0.447,1-1C15,5.448,14.553,5,14,5z M10,9H6c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S10.553,9,10,9z"/>
      </g>
    </symbol>
  </svg>
  <!-- /SVG COMMENT -->

  <!-- SVG THUMBS UP -->
  <svg style="display: none;">
    <symbol id="svg-thumbs-up" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15.896,19.999c-0.01,0-0.021,0-0.03,0H2.826C1.268,19.999,0,18.743,0,17.201v-6.302c0-1.543,1.269-2.797,2.826-2.797h2.096l3.391-7.515C8.473,0.229,8.83,0,9.223,0c2.063,0,3.742,1.659,3.742,3.698l0.026,2.3h4.996c0.152-0.003-0.149-0.023,0,0c0.753,0.111,1.962,0.245,1.999,1c0.037,0.757-0.011,2.143,0,3.003l-1.295,7.624C18.483,18.982,17.284,19.999,15.896,19.999z M6.995,18.005h8.881c0.003,0,0.007,0,0.01,0c0.418,0,0.77-0.292,0.83-0.684l1.262-8.106c0.031-0.205-0.02-0.412-0.145-0.583c-0.132-0.178-0.621-0.601-0.845-0.634c-0.045-0.008,0.045-0.006,0,0h-4.996c-0.553,0-1-1.451-1-2.001l-0.026-2.3c0-0.733-0.477-1.36-1.144-1.6l-2.828,6.9V18.005z M2.997,10c-0.456,0-0.999,0.457-0.999,0.899v6.302c0,0.442,0.371,0.804,0.827,0.804h2.17V10H2.997z"/>
    </symbol>
  </svg>
  <!-- /SVG THUMBS UP -->

  <!-- SVG FRIEND -->
  <svg style="display: none;">
    <symbol id="svg-friend" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,0C4.477,0,0,4.478,0,10c0,5.523,4.477,10,10,10c5.522,0,10-4.477,10-10C20,4.478,15.522,0,10,0z M10,18c-4.418,0-8-3.582-8-8c0-4.418,3.582-8,8-8s8,3.582,8,8
        C18,14.418,14.418,18,10,18z M10,13c-1.305,0-2.403-0.838-2.816-2H5.101c0.464,2.282,2.48,4,4.899,4s4.436-1.718,4.899-4h-2.083C12.403,12.162,11.305,13,10,13z M7,7H5v2h2V7z M13,9h2V7h-2V9z"/>
    </symbol>
  </svg>
  <!-- /SVG FRIEND -->

  <!-- SVG GROUP -->
  <svg style="display: none;">
    <symbol id="svg-group" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,2c1.654,0,3,1.346,3,3s-1.346,3-3,3S7,6.654,7,5S8.346,2,10,2 M10,0C7.238,0,5,2.238,5,5s2.238,5,5,5s5-2.238,5-5S12.762,0,10,0L10,0z"/>
      <path d="M3,20v-2c0-2.205,1.794-4,4-4h6c2.206,0,4,1.795,4,4v2h2v-2c0-3.313-2.687-6-6-6H7c-3.313,0-6,2.687-6,6v2H3z"/>
      <path d="M20,8.05c-1.13,0-2.05-0.919-2.05-2.05S18.87,3.95,20,3.95v-2c-2.236,0-4.05,1.813-4.05,4.05s1.813,4.05,4.05,4.05V8.05z"/>
      <path d="M0,8.05C1,8.05,2.05,7.13,2.05,6S1,3.95,0,3.95v-2c2,0,4.05,1.813,4.05,4.05S2,10.05,0,10.05V8.05z"/>
    </symbol>
  </svg>
  <!-- /SVG GROUP -->

  <!-- SVG MARKETPLACE -->
  <svg style="display: none;">
    <symbol id="svg-marketplace" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M18,6h-0.5L16,0h-4v2h2.438l1,4H4.562l1-4H8V0H4L2.5,6H2C0.896,6,0,6.896,0,8v2c0,0.738,0.405,1.376,1,1.723v0.276C1,12,1,12,1,12l1,6c0,1.104,0.896,2,2,2h12c1.104,0,2-0.896,2-2l1-6v-0.277c0.596-0.347,1-0.984,1-1.723V8C20,6.896,19.104,6,18,6z M2,8h16v2h-0.999H17H3H2.999H2V8z M16.027,17.671L16,17.834V18H4v-0.165l-0.027-0.164L3.028,12h13.945L16.027,17.671z"/>
    </symbol>
  </svg>
  <!-- /SVG MARKETPLACE -->

  <!-- SVG ADD FRIEND -->
  <svg style="display: none;">
    <symbol id="svg-add-friend" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,13c-1.305,0-2.403-0.838-2.816-2H5.101c0.464,2.282,2.48,4,4.899,4s4.436-1.718,4.899-4h-2.083C12.403,12.162,11.305,13,10,13z M7,7H5v2h2V7z M13,7v2h2V7H13z"/>
      <polygon points="20,2 18,2 18,0 16,0 16,2 14,2 14,4 16,4 16,6 18,6 18,4 20,4"/>
      <path d="M17.738,8C17.903,8.64,18,9.308,18,10c0,4.418-3.582,8-8,8s-8-3.582-8-8c0-4.418,3.582-8,8-8c0.692,0,1.359,0.097,2,0.262V0.201C11.354,0.07,10.685,0,10,0C4.477,0,0,4.478,0,10
      c0,5.523,4.477,10,10,10c5.522,0,10-4.477,10-10c0-0.685-0.069-1.354-0.201-2H17.738z"/>
    </symbol>
  </svg>
  <!-- /SVG ADD FRIEND -->

  <!-- SVG REMOVE FRIEND -->
  <svg style="display: none;">
    <symbol id="svg-remove-friend" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,13c-1.305,0-2.403-0.838-2.816-2H5.101c0.464,2.282,2.48,4,4.899,4s4.436-1.718,4.899-4h-2.083C12.403,12.162,11.305,13,10,13z M7,7H5v2h2V7z M13,7v2h2V7H13z"/>
      <path d="M17.738,8C17.903,8.64,18,9.308,18,10c0,4.418-3.582,8-8,8s-8-3.582-8-8c0-4.418,3.582-8,8-8c0.692,0,1.359,0.097,2,0.262V0.201C11.354,0.07,10.685,0,10,0C4.477,0,0,4.478,0,10
      c0,5.523,4.477,10,10,10c5.522,0,10-4.477,10-10c0-0.685-0.069-1.354-0.201-2H17.738z"/>
      <rect x="14" y="2" width="6" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG REMOVE FRIEND -->

  <!-- SVG DELETE -->
  <svg style="display: none;">
    <symbol id="svg-delete" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,20C4.477,20,0,15.523,0,10C0,4.478,4.477,0,10,0C15.522,0,20,4.478,20,10C20,15.523,15.522,20,10,20z M10,2c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8s8-3.582,8-8
      C18,5.582,14.418,2,10,2z M12.662,13.994L10,11.332l-2.662,2.662l-1.331-1.33l2.662-2.663L6.007,7.339l1.331-1.331L10,8.67l2.662-2.662l1.331,1.331l-2.662,2.662l2.662,2.663L12.662,13.994z"/>
    </symbol>
  </svg>
  <!-- /SVG DELETE -->

  <!-- SVG MESSAGES -->
  <svg style="display: none;">
    <symbol id="svg-messages" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M12,2c1.103,0,2,0.897,2,2v5c0,1.103-0.897,2-2,2H8H7.754l-0.239,0.06L2,12.438V9V4c0-1.103,0.897-2,2-2H12M12,0H4C1.791,0,0,1.791,0,4v5v6l8-2h4c2.209,0,4-1.791,4-4V4C16,1.791,14.209,0,12,0L12,0z"/>
      <path d="M12,5.012C12,5.558,11.558,6,11.013,6H4.987C4.442,6,4,5.558,4,5.012V4.988C4,4.442,4.442,4,4.987,4h6.025C11.558,4,12,4.442,12,4.988V5.012z"/>
      <path d="M10,8.047C10,8.574,9.573,9,9.047,9H4.953C4.427,9,4,8.574,4,8.047V7.953C4,7.426,4.427,7,4.953,7h4.094C9.573,7,10,7.426,10,7.953V8.047z"/>
      <path d="M17,5.142v2.136C17.595,7.625,18,8.263,18,9v5v3.438l-5.516-1.379L12.246,16H12H8c-0.737,0-1.375-0.405-1.722-1H4.142C4.588,16.722,6.139,18,8,18h4l8,2v-6V9C20,7.139,18.722,5.588,17,5.142z"/>
    </symbol>
  </svg>
  <!-- /SVG MESSAGES -->

  <!-- SVG SEND MESSAGE -->
  <svg style="display: none;">
    <symbol id="svg-send-message" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M19.993,0.94c-0.005-0.091-0.022-0.179-0.052-0.265c-0.011-0.031-0.021-0.062-0.035-0.093  c-0.049-0.107-0.109-0.208-0.195-0.294s-0.188-0.147-0.294-0.195c-0.031-0.014-0.062-0.024-0.093-0.035c-0.086-0.03-0.173-0.046-0.263-0.052C19.034,0.005,19.009,0,18.981,0c-0.104,0.002-0.207,0.017-0.308,0.052L0.67,6.353C0.283,6.488,0.018,6.846,0.001,7.256C-0.016,7.666,0.22,8.044,0.594,8.21l7.75,3.446l3.444,7.75C11.948,19.769,12.308,20,12.702,20
      c0.014,0,0.027,0,0.041-0.002c0.409-0.016,0.768-0.28,0.903-0.668l6.302-18.003c0.035-0.101,0.05-0.206,0.052-0.309C20,0.991,19.994,0.967,19.993,0.94z M15.197,3.388L8.88,9.706L3.711,7.408L15.197,3.388z M12.592,16.288l-2.298-5.169l6.317-6.316L12.592,16.288z"/>
    </symbol>
  </svg>
  <!-- /SVG SEND MESSAGE -->

  <!-- SVG BACK ARROW -->
  <svg style="display: none;">
    <symbol id="svg-back-arrow" viewBox="0 0 14 10" preserveAspectRatio="xMinYMin meet">
      <path d="M14,6H3.364l2.644,2.75L4.806,10L1.202,6.25l0,0L0,5L4.806,0l1.201,1.25L3.364,4H14V6z"/>
    </symbol>
  </svg>
  <!-- /SVG BACK ARROW -->

  <!-- SVG SHOPPING BAG -->
  <svg style="display: none;">
    <symbol id="svg-shopping-bag" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15.904,6c0.148,0.117,0.347,0.386,0.406,0.557l0.001,0.017l0.676,11.421c-0.005,0.003-0.01,0.005-0.013,0.006H3.029c-0.004-0.001-0.01-0.003-0.016-0.006L3.689,6.573L3.69,6.556C3.749,6.386,3.947,6.117,4.095,6H15.904 M16.075,4H3.924C2.806,4,1.692,5.563,1.692,6.455L1,18.154C1,19.048,1.906,20,3.024,20h13.95C18.093,20,19,19.048,19,18.154L18.308,6.455C18.308,5.563,17.193,4,16.075,4L16.075,4z"/>
      <path d="M8,8V3.893C8,2.849,8.849,2,9.893,2H10h0.054C11.098,2,12,2.849,12,3.893V8h2V3.893C14,1.743,12.257,0,10.107,0H9.893C7.743,0,6,1.743,6,3.893V8H8z"/>
    </symbol>
  </svg>
  <!-- /SVG SHOPPING BAG -->

  <!-- SVG NOTIFICATION -->
  <svg style="display: none;">
    <symbol id="svg-notification" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M18.583,14.127c-0.023-0.018-2.241-1.758-2.241-7.52C16.342,2.964,13.497,0,10.004,0C6.511,0,3.668,2.964,3.668,6.607c0,5.762-2.22,7.502-2.228,7.508c-0.365,0.254-0.525,0.725-0.397,1.158c0.129,0.434,0.517,0.73,0.957,0.73h16.007c0.433,0,0.81-0.293,0.943-0.719C19.086,14.861,18.932,14.389,18.583,14.127zM4.086,13.939C4.873,12.527,5.67,10.21,5.67,6.607c0-2.505,1.945-4.542,4.334-4.542c2.391,0,4.335,2.038,4.335,4.542c0,3.603,0.796,5.92,1.583,7.333H4.086z M12.418,17.146c-0.57-0.283-1.293-0.115-1.619,0.381c-0.126,0.191-0.327,0.326-0.567,0.383c-0.234,0.051-0.478,0.023-0.688-0.084c-0.138-0.07-0.255-0.174-0.336-0.297c-0.325-0.496-1.05-0.668-1.618-0.385c-0.568,0.283-0.766,0.914-0.44,1.408c0.286,0.438,0.7,0.803,1.194,1.055C8.854,19.867,9.421,20,9.997,20c0.281,0,0.564-0.031,0.843-0.096c0.856-0.197,1.573-0.676,2.016-1.348C13.182,18.061,12.984,17.432,12.418,17.146z"/>
    </symbol>
  </svg>
  <!-- /SVG NOTIFICATION -->

  <!-- SVG SETTINGS -->
  <svg style="display: none;">
    <symbol id="svg-settings" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,7c-1.657,0-3,1.343-3,3c0,1.655,1.343,2.999,3,2.999c1.656,0,3-1.344,3-2.999C13,8.343,11.656,7,10,7zM10,11c-0.552,0-1-0.449-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C11,10.551,10.552,11,10,11z M17.363,12.638C18.817,12.638,20,11.453,20,10s-1.183-2.637-2.637-2.637h-0.135c-0.106,0-0.205-0.049-0.27-0.129 c-0.014-0.054-0.032-0.106-0.055-0.158c-0.059-0.132-0.031-0.283,0.111-0.429c0.498-0.499,0.772-1.161,0.772-1.865c0-0.704-0.274-1.367-0.773-1.865c-0.997-0.997-2.693-1.035-3.769,0.042c-0.102,0.1-0.24,0.135-0.397,0.066c-0.129-0.055-0.212-0.18-0.212-0.391C12.637,1.182,11.454,0,10,0S7.363,1.182,7.363,2.636v0.135c0,0.106-0.049,0.206-0.129,0.271C7.181,3.056,7.128,3.073,7.077,3.096c-0.128,0.058-0.264,0.052-0.43-0.113c-0.996-0.994-2.731-0.995-3.73,0.003c-1.026,1.028-1.025,2.701,0.044,3.77C3.062,6.858,3.089,7.01,3.007,7.2c-0.05,0.136-0.176,0.227-0.371,0.229C1.183,7.429,0,8.612,0,10.065c0,1.454,1.183,2.637,2.636,2.637h0.138c0.138,0,0.263,0.083,0.322,0.222c0.058,0.132,0.03,0.284-0.113,0.429c-0.497,0.498-0.771,1.161-0.771,1.865c0.001,0.705,0.276,1.367,0.773,1.863c0.996,0.996,2.689,1.038,3.771-0.042c0.101-0.099,0.142-0.173,0.443-0.046c0.136,0.049,0.226,0.176,0.229,0.37
      c0,1.454,1.183,2.637,2.637,2.637s2.637-1.183,2.637-2.637v-0.137c0-0.139,0.083-0.263,0.222-0.322c0.129-0.058,0.263-0.051,0.428,0.112c0.999,0.995,2.735,0.996,3.73-0.002c0.498-0.499,0.771-1.162,0.771-1.866c-0.001-0.704-0.275-1.366-0.813-1.903c-0.101-0.104-0.129-0.256-0.064-0.398C17.029,12.72,17.154,12.638,17.363,12.638zM15.666,14.7c0.121,0.12,0.188,0.279,0.188,0.449s-0.067,0.33-0.188,0.453c-0.239,0.241-0.605,0.295-0.956-0.058c-0.677-0.662-1.742-0.845-2.582-0.475c-0.864,0.369-1.423,1.214-1.425,2.153v0.14c0,0.352-0.286,0.636-0.637,0.636s-0.637-0.284-0.637-0.733c-0.023-0.97-0.627-1.815-1.479-2.125C7.649,15.007,7.329,14.939,7,14.939c-0.618,0-1.202,0.238-1.7,0.728c-0.24,0.24-0.66,0.241-0.901-0.002c-0.248-0.246-0.248-0.65,0.058-0.957c0.675-0.69,0.859-1.709,0.474-2.58c-0.368-0.864-1.214-1.424-2.154-1.426h-0.14C2.285,10.702,2,10.416,2,10.065
      s0.285-0.637,0.733-0.637c0.971-0.023,1.815-0.626,2.127-1.48c0.39-0.884,0.205-1.9-0.527-2.648C4.085,5.052,4.085,4.647,4.334,4.398c0.24-0.24,0.603-0.298,0.957,0.058C5.92,5.07,6.871,5.282,7.694,5c0.084-0.013,0.167-0.036,0.245-0.07c0.861-0.37,1.42-1.214,1.424-2.155v-0.14C9.363,2.285,9.649,2,10,2s0.637,0.285,0.637,0.712c0.002,0.937,0.561,1.782,1.414,2.148c0.865,0.38,1.884,0.222,2.649-0.527c0.241-0.24,0.656-0.243,0.901,0.001c0.12,0.12,0.187,0.279,0.187,0.449c0,0.169-0.066,0.331-0.242,0.507c-0.629,0.642-0.834,1.566-0.545,2.405
      c0.013,0.083,0.035,0.165,0.069,0.244c0.369,0.862,1.213,1.421,2.154,1.425h0.139C17.715,9.364,18,9.649,18,10c0,0.351-0.285,0.637-0.712,0.637c-0.938,0.002-1.783,0.561-2.146,1.411C14.749,12.933,14.933,13.951,15.666,14.7z"/>
    </symbol>
  </svg>
  <!-- /SVG SETTINGS -->

  <!-- SVG CROSS THIN -->
  <svg style="display: none;">
    <symbol id="svg-cross-thin" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M18,16.547L16.545,18L10,11.455L3.455,18L2,16.547L8.545,10L2,3.455L3.455,2L10,8.546L16.545,2L18,3.455L11.455,10L18,16.547z"/>
    </symbol>
  </svg>
  <!-- /SVG CROSS THIN -->

  <!-- SVG NEWSFEED -->
  <svg style="display: none;">
    <symbol id="svg-newsfeed" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.791,0,4v8c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V4C20,1.791,18.209,0,16,0zM18,12c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V12z"/>
      <path d="M0,10v2h20v-2H0z M5,20h10v-2H5V20z"/>
    </symbol>
  </svg>
  <!-- /SVG NEWSFEED -->

  <!-- SVG OVERVIEW -->
  <svg style="display: none;">
    <symbol id="svg-overview" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M18,8v10h-2V8H18 M18,6h-2c-1.104,0-2,0.896-2,2v10c0,1.104,0.896,2,2,2h2c1.104,0,2-0.896,2-2V8C20,6.896,19.104,6,18,6L18,6z"/>
      <path d="M11,2v16H9V2H11 M11,0H9C7.896,0,7,0.896,7,2v16c0,1.104,0.896,2,2,2h2c1.104,0,2-0.896,2-2V2C13,0.896,12.104,0,11,0L11,0z"/>
      <path d="M4,14v4H2v-4H4 M4,12H2c-1.104,0-2,0.896-2,2v4c0,1.104,0.896,2,2,2h2c1.104,0,2-0.896,2-2v-4C6,12.896,5.104,12,4,12L4,12z"/>
    </symbol>
  </svg>
  <!-- /SVG OVERVIEW -->

  <!-- SVG MEMBERS -->
  <svg style="display: none;">
    <symbol id="svg-members" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,10c2.762,0,5-2.238,5-5c0-2.762-2.238-5-5-5S5,2.238,5,5C5,7.761,7.238,10,10,10z M10,2c1.654,0,3,1.346,3,3s-1.346,3-3,3S7,6.654,7,5S8.346,2,10,2z M13,12H7c-3.313,0-6,2.686-6,6v2h2v-2c0-2.205,1.794-4,4-4h6c2.206,0,4,1.795,4,4v2h2v-2C19,14.686,16.313,12,13,12z"/>
    </symbol>
  </svg>
  <!-- /SVG MEMBERS -->

  <!-- SVG BADGES -->
  <svg style="display: none;">
    <symbol id="svg-badges" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,8c2.757,0,5,2.243,5,5s-2.243,5-5,5s-5-2.243-5-5S7.243,8,10,8 M10,6c-3.866,0-7,3.134-7,7s3.134,7,7,7c3.865,0,7-3.134,7-7S13.865,6,10,6L10,6z"/>
      <path d="M3.906,6.391L2.651,2h3.84l0.701,2.453c0.627-0.206,1.283-0.347,1.963-0.41L8,0H0l2.36,8.26C2.79,7.568,3.31,6.941,3.906,6.391z"/>
      <path d="M12.808,4.453L13.509,2h3.84l-1.255,4.391C16.689,6.94,17.21,7.568,17.64,8.26L20,0h-8l-1.155,4.043C11.524,4.106,12.181,4.247,12.808,4.453z"/>
    </symbol>
  </svg>
  <!-- /SVG BADGES -->

  <!-- SVG QUESTS -->
  <svg style="display: none;">
    <symbol id="svg-quests" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,2.708l1.774,3.813l0.452,0.97l1.058,0.163l4.138,0.637l-3.07,3.175l-0.697,0.721l0.16,0.989l0.7,4.326l-3.494-1.947l-0.965-0.538L10,15.048l-0.055-0.03L8.98,15.556l-3.494,1.947l0.7-4.326l0.16-0.989l-0.697-0.721L2.578,8.292l4.138-0.637l1.058-0.163l0.451-0.97L10,2.708 M10.029-0.004C10.019-0.004,10.01-0.002,10,0C9.99-0.002,9.981-0.004,9.971-0.004
      c-0.558,0-1.066,0.326-1.303,0.834L6.412,5.678L1.223,6.477c-0.534,0.082-0.977,0.46-1.148,0.976c-0.172,0.517-0.042,1.086,0.334,1.474l3.802,3.932l-0.882,5.453c-0.089,0.548,0.141,1.1,0.591,1.42c0.248,0.176,0.539,0.266,0.83,0.266c0.24,0,0.479-0.061,0.697-0.182l4.507-2.512L10,17.328l0.046-0.025l4.506,2.512c0.219,0.121,0.457,0.182,0.697,0.182c0.291,0,0.582-0.09,0.83-0.266c0.45-0.32,0.68-0.872,0.591-1.42l-0.882-5.453l3.802-3.932c0.376-0.387,0.507-0.957,0.335-1.474c-0.172-0.515-0.614-0.894-1.148-0.976l-5.189-0.798l-2.256-4.848C11.095,0.322,10.586-0.004,10.029-0.004L10.029-0.004z"/>
      <rect x="7" y="9" width="2" height="2"/>
      <rect x="11" y="9" width="2" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG QUESTS -->

  <!-- SVG STREAMS -->
  <svg style="display: none;">
    <symbol id="svg-streams" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,3c1.103,0,2,0.897,2,2v10c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V5c0-1.103,0.897-2,2-2H16 M16,1H4C1.791,1,0,2.791,0,5v10c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V5C20,2.791,18.209,1,16,1L16,1z"/>
      <path d="M8.405,7c0.102,0,0.219,0.037,0.347,0.115l3.908,2.4c0.439,0.267,0.462,0.704,0.021,0.971l-3.928,2.4C8.624,12.964,8.507,13,8.405,13C8.157,13,8,12.782,8,12.408V7.593C8,7.217,8.157,7,8.405,7 M8.405,5C7.034,5,6,6.115,6,7.593v4.815C6,13.886,7.034,15,8.405,15c0.477,0,0.943-0.137,1.386-0.405l3.932-2.402c0.796-0.481,1.276-1.297,1.277-2.177c0.001-0.888-0.486-1.715-1.304-2.21L9.798,5.411C9.348,5.137,8.881,5,8.405,5L8.405,5z"/>
    </symbol>
  </svg>
  <!-- /SVG STREAMS -->

  <!-- SVG EVENTS -->
  <svg style="display: none;">
    <symbol id="svg-events" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,2H4C1.791,2,0,3.791,0,6v10c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V6C20,3.791,18.209,2,16,2zM18,16c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V6c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V16z"/>
      <path d="M0,8v2h20V8H0z M7,0H5v6h2V0z M15,0h-2v6h2V0z"/>
    </symbol>
  </svg>
  <!-- /SVG EVENTS -->

  <!-- SVG FORUMS -->
  <svg style="display: none;">
    <symbol id="svg-forums" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.592,0,3.556V6v2v4.444C0,14.408,1.791,16,4,16h2l4,4l4-4h2c2.209,0,4-1.592,4-3.556V8V6V3.556C20,1.592,18.209,0,16,0z M18,12.444C18,13.287,17.084,14,16,14h-2h-0.828l-0.586,0.586L10,17.172l-2.586-2.586L6.829,14H6H4c-1.084,0-2-0.713-2-1.556V8h16V12.444z M2,6V3.556C2,2.712,2.916,2,4,2h12c1.084,0,2,0.712,2,1.556V6H2z"/>
      <rect x="4" y="3" width="2" height="2"/>
      <rect x="10" y="3" width="2" height="2"/>
      <rect x="7" y="3" width="2" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG FORUMS -->

  <!-- SVG SMALL ARROW -->
  <svg style="display: none;">
    <symbol id="svg-small-arrow" viewBox="0 0 6 8" preserveAspectRatio="xMinYMin meet">
      <path d="M6,4L1.5,8L0,6.665L3,4L0,1.333L1.5,0l3,2.666l0,0L6,4z"/>
    </symbol>
  </svg>
  <!-- /SVG SMALL ARROW -->

  <!-- SVG BIG ARROW -->
  <svg style="display: none;">
    <symbol id="svg-big-arrow" viewBox="0 0 8 12" preserveAspectRatio="xMinYMin meet">
      <path d="M6.399,7.5L6.399,7.5L1.6,12L0,10.5L4.8,6L0,1.5L1.6,0L8,6L6.399,7.5z"/>
    </symbol>
  </svg>
  <!-- /SVG BIG ARROW -->

  <!-- SVG PUBLIC -->
  <svg style="display: none;">
    <symbol id="svg-public" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M20,10c0-5.522-4.478-10-10-10C4.477,0,0,4.478,0,10c0,5.523,4.477,10,10,10
      c1.566,0,3.043-0.37,4.362-1.013l0.01,0.018c0.051-0.028,0.086-0.059,0.135-0.087C17.763,17.27,20,13.9,20,10z M16.155,15.108c-0.648-1.745-2.802-3.14-4.653-3.408c-0.751-0.109-0.829-0.433-0.858-0.555C10.497,10.532,11,9.499,11.679,9.021c1.482-1.044,4.529-0.504,6.252-0.025C17.972,9.325,18,9.659,18,10C18,11.942,17.307,13.723,16.155,15.108z M14.715,3.547c-0.012,0-0.022,0.003-0.034,0.003c-1.374,0-2.609-0.561-3.518-1.456C12.479,2.286,13.688,2.796,14.715,3.547z M2,10
      c0-2.277,0.956-4.328,2.483-5.785c1.26,0.272,2.644,0.845,2.87,1.36C7.373,5.62,7.425,5.74,7.222,6.051c-0.295,0.451-0.603,0.88-0.896,1.29c-1.389,1.937-2.963,4.131-0.647,6.169c0.537,0.472,0.805,1.243,0.624,1.793c-0.184,0.557-0.815,0.773-1.402,0.86C3.128,14.695,2,12.479,2,10z M7.065,17.437c0.671-0.479,0.993-1.077,1.135-1.507c0.432-1.308-0.063-2.92-1.201-3.922c-0.814-0.716-0.672-1.24,0.951-3.502c0.31-0.432,0.633-0.883,0.944-1.359c0.66-1.009,0.521-1.85,0.289-2.377c-0.428-0.972-1.522-1.606-2.57-2.01C7.251,2.46,7.934,2.244,8.65,2.122c1.236,2.047,3.469,3.428,6.03,3.428c0.618,0,1.206-0.106,1.776-0.259c0.339,0.463,0.631,0.961,0.865,1.492c-1.979-0.428-4.906-0.729-6.795,0.603c-1.195,0.84-2.204,2.651-1.828,4.224c0.268,1.122,1.185,1.876,2.516,2.068c1.409,0.205,2.963,1.352,3.137,2.314c0.028,0.156,0.1,0.618-0.781,1.158C12.495,17.689,11.285,18,10,18C8.963,18,7.975,17.796,7.065,17.437z"/>
    </symbol>
  </svg>
  <!-- /SVG PUBLIC -->

  <!-- SVG PRIVATE -->
  <svg style="display: none;">
    <symbol id="svg-private" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M11,11H9c-0.553,0-1,0.447-1,1s0.447,1,1,1v1c0,0.553,0.447,1,1,1s1-0.447,1-1v-1c0.553,0,1-0.447,1-1S11.553,11,11,11z"/>
      <path d="M16,6.142V6c0-3.313-2.687-6-6-6S4,2.687,4,6v0.142C2.278,6.588,1,8.139,1,10v6c0,2.209,1.791,4,4,4h10c2.209,0,4-1.791,4-4v-6C19,8.139,17.722,6.588,16,6.142z M10,2c2.206,0,4,1.794,4,4H6C6,3.794,7.794,2,10,2z M17,16c0,1.103-0.897,2-2,2H5c-1.103,0-2-0.897-2-2v-6c0-1.103,0.897-2,2-2h10c1.103,0,2,0.897,2,2V16z"/>
    </symbol>
  </svg>
  <!-- /SVG PRIVATE -->

  <!-- SVG JOIN GROUP -->
  <svg style="display: none;">
    <symbol id="svg-join-group" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,9.999c2.762,0,5-2.238,5-5s-2.238-5-5-5s-5,2.238-5,5S7.238,9.999,10,9.999z M10,1.999c1.654,0,3,1.346,3,3s-1.346,3-3,3s-3-1.346-3-3S8.346,1.999,10,1.999z M20,3.949v-2c-2.236,0-4.05,1.813-4.05,4.05c0,2.236,1.813,4.05,4.05,4.05v-2c-1.13,0-2.05-0.92-2.05-2.05C17.95,4.869,18.87,3.949,20,3.949z M4.05,5.999C4.05,3.762,2,1.949,0,1.949v2c1,0,2.05,0.919,2.05,2.05c0,1.13-1.05,2.05-2.05,2.05v2C2,10.049,4.05,8.235,4.05,5.999zM11,13.999H9v2H7v2h2v2h2v-2h2v-2h-2V13.999z M7,11.999c-3.313,0-6,2.687-6,6v2h2v-2c0-2.205,1.794-4,4-4V11.999z M13,11.999v2c2.206,0,4,1.795,4,4v2h2v-2C19,14.686,16.313,11.999,13,11.999z"/>
    </symbol>
  </svg>
  <!-- /SVG JOIN GROUP -->

  <!-- SVG LEAVE GROUP -->
  <svg style="display: none;">
    <symbol id="svg-leave-group" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,9.999c2.762,0,5-2.238,5-5s-2.238-5-5-5s-5,2.238-5,5S7.238,9.999,10,9.999z M10,1.999c1.654,0,3,1.346,3,3s-1.346,3-3,3s-3-1.346-3-3S8.346,1.999,10,1.999z M20,3.949v-2c-2.236,0-4.05,1.813-4.05,4.05c0,2.236,1.813,4.05,4.05,4.05v-2c-1.13,0-2.05-0.92-2.05-2.05C17.95,4.869,18.87,3.949,20,3.949z M4.05,5.999C4.05,3.762,2,1.949,0,1.949v2c1,0,2.05,0.919,2.05,2.05c0,1.13-1.05,2.05-2.05,2.05v2C2,10.049,4.05,8.235,4.05,5.999z M7,17.999h6v-2H7V17.999z M7,11.999c-3.313,0-6,2.687-6,6v2h2v-2c0-2.205,1.794-4,4-4V11.999z M13,11.999v2c2.206,0,4,1.795,4,4v2h2v-2C19,14.686,16.313,11.999,13,11.999z"/>
    </symbol>
  </svg>
  <!-- /SVG LEAVE GROUP -->

  <!-- SVG MORE DOTS -->
  <svg style="display: none;">
    <symbol id="svg-more-dots" viewBox="0 0 22 6" preserveAspectRatio="xMinYMin meet">
      <path d="M19,6c-1.657,0-3-1.344-3-3c0-1.656,1.343-3,3-3s3,1.344,3,3C22,4.656,20.657,6,19,6z M19,2c-0.553,0-1,0.447-1,1c0,0.552,0.447,1,1,1c0.552,0,1-0.449,1-1C20,2.447,19.552,2,19,2z M11,6C9.343,6,8,4.656,8,3c0-1.656,1.343-3,3-3s3,1.344,3,3C14,4.656,12.657,6,11,6z M11,2c-0.553,0-1,0.447-1,1c0,0.552,0.447,1,1,1c0.552,0,1-0.449,1-1C12,2.447,11.552,2,11,2z M3,6C1.343,6,0,4.656,0,3c0-1.656,1.343-3,3-3c1.656,0,3,1.344,3,3C6,4.656,4.656,6,3,6z M3,2C2.447,2,2,2.447,2,3c0,0.552,0.447,1,1,1c0.552,0,1-0.449,1-1C4,2.447,3.552,2,3,2z"/>
    </symbol>
  </svg>
  <!-- /SVG MORE DOTS -->

  <!-- SVG PROFILE -->
  <svg style="display: none;">
    <symbol id="svg-profile" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,2c4.418,0,8,3.582,8,8c0,4.418-3.582,8-8,8c-4.418,0-8-3.582-8-8C2,5.582,5.582,2,10,2 M10,0C4.486,0,0,4.486,0,10c0,5.514,4.486,10,10,10c5.514,0,10-4.486,10-10C20,4.486,15.514,0,10,0L10,0z"/>
      <path d="M10,7c0.551,0,1,0.449,1,1s-0.449,1-1,1S9,8.551,9,8S9.449,7,10,7 M10,5C8.343,5,7,6.343,7,8c0,1.656,1.343,3,3,3c1.656,0,3-1.344,3-3C13,6.343,11.656,5,10,5L10,5z"/>
      <path d="M14.866,15.025C14.43,13.29,12.871,12,11,12H9c-1.871,0-3.43,1.29-3.866,3.025C5.678,15.553,6.308,15.988,7,16.317V16c0-1.104,0.897-2,2-2h2c1.103,0,2,0.896,2,2v0.317C13.692,15.988,14.322,15.553,14.866,15.025z"/>
    </symbol>
  </svg>
  <!-- /SVG PROFILE -->

  <!-- SVG TIMELINE -->
  <svg style="display: none;">
    <symbol id="svg-timeline" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.791,0,4v12c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V4C20,1.791,18.209,0,16,0zM18,16c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V16z"/>
      <polygon points="18,5 2,5 2,7 5,7 5,20 7,20 7,7 13,7 13,20 15,20 15,7 18,7"/>
    </symbol>
  </svg>
  <!-- /SVG TIMELINE -->

  <!-- SVG PHOTOS -->
  <svg style="display: none;">
    <symbol id="svg-photos" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.791,0,4v12c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V4C20,1.791,18.209,0,16,0zM4,2h12c1.103,0,2,0.897,2,2v6.407L16.703,9.11c-0.75-0.751-1.734-1.126-2.718-1.126c-0.984,0-1.968,0.375-2.719,1.126l-2.98,2.98l-0.259-0.259c-0.563-0.563-1.301-0.844-2.039-0.844s-1.476,0.282-2.04,0.844L2,13.782V4C2,2.897,2.897,2,4,2z M16,18H4c-0.918,0-1.686-0.625-1.919-1.47l3.282-3.283c0.226-0.226,0.489-0.259,0.626-0.259c0.137,0,0.399,0.033,0.625,0.258l0.259,0.259l1.414,1.414L9.7,13.505l2.981-2.981c0.348-0.348,0.811-0.54,1.304-0.54c0.492,0,0.955,0.192,1.304,0.541L18,13.234V16C18,17.103,17.103,18,16,18z"/>
      <path d="M6,9c1.657,0,3-1.344,3-3c0-1.657-1.343-3-3-3S3,4.343,3,6C3,7.656,4.343,9,6,9z M6,5c0.551,0,1,0.449,1,1c0,0.552-0.449,1-1,1S5,6.552,5,6C5,5.449,5.449,5,6,5z"/>
    </symbol>
  </svg>
  <!-- /SVG PHOTOS -->

  <!-- SVG VIDEOS -->
  <svg style="display: none;">
    <symbol id="svg-videos" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.791,0,4v12c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V4C20,1.791,18.209,0,16,0zM18,4v1h-2V2C17.103,2,18,2.897,18,4z M4,13H2V7h2V13z M16,7h2v6h-2V7z M14,2v16H6V2H14z M4,2v3H2V4C2,2.897,2.897,2,4,2z M2,16v-1h2v3C2.897,18,2,17.103,2,16z M16,18v-3h2v1C18,17.103,17.103,18,16,18z"/>
    </symbol>
  </svg>
  <!-- /SVG VIDEOS -->

  <!-- SVG BLOG POSTS -->
  <svg style="display: none;">
    <symbol id="svg-blog-posts" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15,0H5C2.791,0,1,1.791,1,4v3v2v7c0,2.209,1.791,4,4,4h10c2.209,0,4-1.791,4-4V9V7V4C19,1.791,17.209,0,15,0z M17,16c0,1.103-0.897,2-2,2H5c-1.103,0-2-0.897-2-2V9h14V16z M3,7V4c0-1.103,0.897-2,2-2h10c1.103,0,2,0.897,2,2v3H3z"/>
      <rect x="5" y="11" width="10" height="2"/>
      <rect x="13" y="14" width="2" height="2"/>
      <rect x="5" y="14" width="6" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG BLOG POSTS -->

  <!-- SVG FORUM -->
  <svg style="display: none;">
    <symbol id="svg-forum" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10.969,0H5C2.791,0,1,1.791,1,4v12c0,2.209,1.791,4,4,4h10c2.209,0,4-1.791,4-4V8.125L10.969,0z M11,2.877L16.064,8H13c-1.104,0-2-0.897-2-2V2.877z M15,18H5c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h4v4c0,2.209,1.791,4,4,4h4v6C17,17.103,16.103,18,15,18z"/>
      <path d="M13,14H7c-0.553,0-1,0.447-1,1s0.447,1,1,1h6c0.552,0,1-0.447,1-1S13.552,14,13,14z"/>
    </symbol>
  </svg>
  <!-- /SVG FORUM -->

  <!-- SVG STORE -->
  <svg style="display: none;">
    <symbol id="svg-store" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M19.411,4.288l-1.894-3.301C17.174,0.378,16.537,0,15.855,0H4.047C3.37,0,2.734,0.376,2.39,0.981L0.492,4.288C-0.18,5.459-0.227,6.949,0.37,8.177C0.737,8.933,1.314,9.494,2,9.826V16c0,2.209,1.791,4,4,4h8c2.209,0,4-1.791,4-4V9.766c0.642-0.338,1.184-0.871,1.532-1.586C20.13,6.953,20.084,5.462,19.411,4.288z M2.227,5.289L4.047,2h11.732l1.896,3.289c0.343,0.598,0.365,1.388,0.059,2.018c-0.136,0.277-0.452,0.755-1.073,0.845c-0.567,0.088-1.203-0.159-1.624-0.674l-0.772-0.943L13.49,7.477c-0.725,0.883-2.046,0.883-2.767,0.001L9.95,6.532L9.176,7.477C8.452,8.361,7.13,8.359,6.41,7.478L5.636,6.531L4.862,7.478c-0.421,0.515-0.973,0.773-1.639,0.67C2.62,8.06,2.303,7.583,2.168,7.306C1.862,6.675,1.885,5.885,2.227,5.289zM4,10.11c0.582-0.086,1.148-0.295,1.636-0.641c1.263,0.9,3.046,0.9,4.313,0c1.265,0.9,3.046,0.901,4.315,0c0.518,0.368,1.113,0.592,1.736,0.665V14H4V10.11z M14,18H6c-1.103,0-2-0.897-2-2h12C16,17.103,15.103,18,14,18z"/>
    </symbol>
  </svg>
  <!-- /SVG STORE -->

  <!-- SVG STAR -->
  <svg style="display: none;">
    <symbol id="svg-star" viewBox="0 0 9 8" preserveAspectRatio="xMinYMin meet">
      <path d="M4.5,0l1.482,2.515L9,3.056L6.899,5.151L7.28,8L4.5,6.78L1.719,8L2.1,5.151L0,3.056l3.017-0.541L4.5,0"/>
    </symbol>
  </svg>
  <!-- /SVG STAR -->

  <!-- SVG library -->
  <svg style="display: none;">
    <symbol id="library" viewBox="0 0 48 48" preserveAspectRatio="xMinYMin meet">
    <path d="M11 42H5C4.20435 42 3.44129 41.6839 2.87868 41.1213C2.31607 40.5587 2 39.7956 2 39V9C2 8.20435 2.31607 7.44129 2.87868 6.87868C3.44129 6.31607 4.20435 6 5 6H11C11.7956 6 12.5587 6.31607 13.1213 6.87868C13.6839 7.44129 14 8.20435 14 9V39C14 39.7956 13.6839 40.5587 13.1213 41.1213C12.5587 41.6839 11.7956 42 11 42ZM5 8C4.73478 8 4.48043 8.10536 4.29289 8.29289C4.10536 8.48043 4 8.73478 4 9V39C4 39.2652 4.10536 39.5196 4.29289 39.7071C4.48043 39.8946 4.73478 40 5 40H11C11.2652 40 11.5196 39.8946 11.7071 39.7071C11.8946 39.5196 12 39.2652 12 39V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8H5Z" />
    <path d="M10 14H6C5.73478 14 5.48043 13.8946 5.29289 13.7071C5.10536 13.5196 5 13.2652 5 13C5 12.7348 5.10536 12.4804 5.29289 12.2929C5.48043 12.1054 5.73478 12 6 12H10C10.2652 12 10.5196 12.1054 10.7071 12.2929C10.8946 12.4804 11 12.7348 11 13C11 13.2652 10.8946 13.5196 10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14Z" />
    <path d="M10 36H6C5.73478 36 5.48043 35.8946 5.29289 35.7071C5.10536 35.5196 5 35.2652 5 35C5 34.7348 5.10536 34.4804 5.29289 34.2929C5.48043 34.1054 5.73478 34 6 34H10C10.2652 34 10.5196 34.1054 10.7071 34.2929C10.8946 34.4804 11 34.7348 11 35C11 35.2652 10.8946 35.5196 10.7071 35.7071C10.5196 35.8946 10.2652 36 10 36Z" />
    <path d="M24 42H18C17.2044 42 16.4413 41.6839 15.8787 41.1213C15.3161 40.5587 15 39.7956 15 39V9C15 8.20435 15.3161 7.44129 15.8787 6.87868C16.4413 6.31607 17.2044 6 18 6H24C24.7956 6 25.5587 6.31607 26.1213 6.87868C26.6839 7.44129 27 8.20435 27 9V39C27 39.7956 26.6839 40.5587 26.1213 41.1213C25.5587 41.6839 24.7956 42 24 42ZM18 8C17.7348 8 17.4804 8.10536 17.2929 8.29289C17.1054 8.48043 17 8.73478 17 9V39C17 39.2652 17.1054 39.5196 17.2929 39.7071C17.4804 39.8946 17.7348 40 18 40H24C24.2652 40 24.5196 39.8946 24.7071 39.7071C24.8946 39.5196 25 39.2652 25 39V9C25 8.73478 24.8946 8.48043 24.7071 8.29289C24.5196 8.10536 24.2652 8 24 8H18Z" />
    <path d="M23 14H19C18.7348 14 18.4804 13.8946 18.2929 13.7071C18.1054 13.5196 18 13.2652 18 13C18 12.7348 18.1054 12.4804 18.2929 12.2929C18.4804 12.1054 18.7348 12 19 12H23C23.2652 12 23.5196 12.1054 23.7071 12.2929C23.8946 12.4804 24 12.7348 24 13C24 13.2652 23.8946 13.5196 23.7071 13.7071C23.5196 13.8946 23.2652 14 23 14Z" />
    <path d="M23 36H19C18.7348 36 18.4804 35.8946 18.2929 35.7071C18.1054 35.5196 18 35.2652 18 35C18 34.7348 18.1054 34.4804 18.2929 34.2929C18.4804 34.1054 18.7348 34 19 34H23C23.2652 34 23.5196 34.1054 23.7071 34.2929C23.8946 34.4804 24 34.7348 24 35C24 35.2652 23.8946 35.5196 23.7071 35.7071C23.5196 35.8946 23.2652 36 23 36Z" />
    <path d="M38.2 42C37.5406 41.9984 36.9 41.7796 36.3774 41.3774C35.8549 40.9752 35.4794 40.4121 35.309 39.775L27.542 10.8C27.3361 10.0315 27.4439 9.21277 27.8417 8.52378C28.2394 7.83479 28.8946 7.332 29.663 7.126L35.458 5.573C36.2265 5.36931 37.0444 5.47805 37.733 5.87547C38.4216 6.27288 38.9249 6.92667 39.133 7.694L46.9 36.67C47.1059 37.4385 46.9981 38.2572 46.6003 38.9462C46.2026 39.6352 45.5474 40.138 44.779 40.344L38.98 41.9C38.7255 41.9671 38.4632 42.0007 38.2 42ZM36.234 7.469C36.1469 7.46905 36.0602 7.48048 35.976 7.503L30.181 9.056C30.054 9.0899 29.9349 9.14851 29.8306 9.22847C29.7263 9.30843 29.6387 9.40818 29.573 9.522C29.5067 9.6353 29.4636 9.76073 29.4465 9.8909C29.4293 10.0211 29.4383 10.1534 29.473 10.28L37.237 39.258C37.271 39.3849 37.3297 39.5038 37.4096 39.608C37.4896 39.7122 37.5893 39.7996 37.7031 39.8652C37.8168 39.9309 37.9424 39.9735 38.0726 39.9906C38.2028 40.0077 38.3351 39.999 38.462 39.965L44.262 38.413C44.389 38.379 44.508 38.3203 44.6123 38.2403C44.7165 38.1603 44.804 38.0604 44.8697 37.9466C44.9353 37.8327 44.9779 37.707 44.995 37.5767C45.012 37.4463 45.0032 37.3139 44.969 37.187L37.2 8.21C37.143 7.99739 37.0174 7.80953 36.8428 7.67555C36.6681 7.54158 36.4541 7.46897 36.234 7.469V7.469Z" />
    <path d="M32.439 14.627C32.1965 14.6266 31.9624 14.5381 31.7803 14.378C31.5981 14.2179 31.4804 13.9971 31.449 13.7566C31.4175 13.5162 31.4746 13.2725 31.6094 13.0709C31.7443 12.8694 31.9477 12.7237 32.182 12.661L36.046 11.625C36.1731 11.5903 36.3057 11.5812 36.4364 11.5979C36.567 11.6147 36.6931 11.6571 36.8073 11.7228C36.9215 11.7884 37.0216 11.8759 37.1018 11.9804C37.1821 12.0848 37.241 12.204 37.275 12.3313C37.3091 12.4585 37.3176 12.5912 37.3003 12.7218C37.2829 12.8524 37.2399 12.9782 37.1737 13.0921C37.1075 13.206 37.0195 13.3057 36.9147 13.3855C36.8099 13.4652 36.6904 13.5235 36.563 13.557L32.7 14.592C32.615 14.6154 32.5272 14.6272 32.439 14.627V14.627Z" />
    <path d="M38.134 35.877C37.8914 35.8769 37.6571 35.7886 37.4748 35.6285C37.2925 35.4685 37.1746 35.2476 37.143 35.0071C37.1115 34.7666 37.1684 34.5228 37.3033 34.3211C37.4381 34.1195 37.6417 33.9737 37.876 33.911L41.739 32.876C41.9952 32.8073 42.2682 32.8432 42.4979 32.9758C42.7277 33.1084 42.8953 33.3268 42.964 33.583C43.0327 33.8392 42.9968 34.1122 42.8642 34.3419C42.7316 34.5717 42.5132 34.7393 42.257 34.808L38.394 35.843C38.3092 35.8655 38.2218 35.877 38.134 35.877V35.877Z" />
        </symbol>
  </svg>
 
  <!-- /SVG library -->
  <svg style="display: none;">
    <symbol id="svg-windows" viewBox="0 0 48 48" preserveAspectRatio="xMinYMin meet">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24ZM12 15.4085L12.009 23.5892L21.8123 23.5334L21.808 14.0728L12 15.4085ZM12.0071 24.5599L21.8034 24.6234L21.811 34.0923L12.0076 32.7445L12.0071 24.5599ZM22.9923 13.898V23.5163L35.997 23.4131V12L22.9923 13.898ZM22.9741 24.6912L36 24.7125L35.9969 36.0742L22.9923 34.2387L22.9741 24.6912Z"/>
    </symbol>
  </svg>

  <svg style="display: none;">
    <symbol id="svg-linux" viewBox="0 0 128 128" preserveAspectRatio="xMinYMin meet">
      <path fill-rule="evenodd" d="M113.823 104.595c-1.795-1.478-3.629-2.921-5.308-4.525-1.87-1.785-3.045-3.944-2.789-6.678.147-1.573-.216-2.926-2.113-3.452.446-1.154.864-1.928 1.033-2.753.188-.92.178-1.887.204-2.834.264-9.96-3.334-18.691-8.663-26.835-2.454-3.748-5.017-7.429-7.633-11.066-4.092-5.688-5.559-12.078-5.633-18.981-.036-3.166-.41-6.38-1.081-9.475-1.313-6.04-4.549-10.763-10.418-13.296-4.497-1.942-9.152-2.327-13.901-1.084-6.901 1.805-11.074 6.934-10.996 14.088.074 6.885.417 13.779.922 20.648.288 3.893-.312 7.252-2.895 10.34-2.484 2.969-4.706 6.172-6.858 9.397-1.229 1.844-2.317 3.853-3.077 5.931-2.07 5.663-3.973 11.373-7.276 16.5-1.224 1.9-1.363 4.026-.494 6.199.225.563.363 1.429.089 1.882-2.354 3.907-5.011 7.345-10.066 8.095-3.976.591-4.172 1.314-4.051 5.413.1 3.337.061 6.705-.28 10.021-.363 3.555.008 4.521 3.442 5.373 7.924 1.968 15.913 3.647 23.492 6.854 3.227 1.365 6.465.891 9.064-1.763 2.713-2.771 6.141-3.855 9.844-3.859 6.285-.005 12.572.298 18.86.369 1.702.02 2.679.653 3.364 2.199.84 1.893 2.26 3.284 4.445 3.526 4.193.462 8.013-.16 11.19-3.359 3.918-3.948 8.436-7.066 13.615-9.227 1.482-.619 2.878-1.592 4.103-2.648 2.231-1.922 2.113-3.146-.135-5zm-51.397-80.475c.758-2.601 2.537-4.289 5.243-4.801 2.276-.43 4.203.688 5.639 3.246 1.546 2.758 2.054 5.64.734 8.658-1.083 2.474-1.591 2.707-4.123 1.868-.474-.157-.937-.343-1.777-.652.708-.594 1.154-1.035 1.664-1.382 1.134-.772 1.452-1.858 1.346-3.148-.139-1.694-1.471-3.194-2.837-3.175-1.225.017-2.262 1.167-2.4 2.915-.086 1.089.095 2.199.173 3.589-3.446-1.023-4.711-3.525-3.662-7.118zm-12.75-2.251c1.274-1.928 3.197-2.314 5.101-1.024 2.029 1.376 3.547 5.256 2.763 7.576-.285.844-1.127 1.5-1.716 2.241l-.604-.374c-.23-1.253-.276-2.585-.757-3.733-.304-.728-1.257-1.184-1.919-1.762-.622.739-1.693 1.443-1.757 2.228-.088 1.084.477 2.28.969 3.331.311.661 1.001 1.145 1.713 1.916l-1.922 1.51c-3.018-2.7-3.915-8.82-1.871-11.909zm37.664 64.206c-.203 2.604-.5 2.713-3.118 3.098-1.859.272-2.359.756-2.453 2.964-.108 2.581-.101 5.171-.012 7.753.061 1.77-.537 3.158-1.755 4.393-6.764 6.856-14.845 10.105-24.512 8.926-4.17-.509-6.896-3.047-9.097-6.639.98-.363 1.705-.607 2.412-.894 3.122-1.27 3.706-3.955 1.213-6.277-1.884-1.757-3.986-3.283-6.007-4.892-1.954-1.555-3.934-3.078-5.891-4.629-1.668-1.323-2.305-3.028-2.345-5.188-.094-5.182.972-10.03 3.138-14.747 1.932-4.209 3.429-8.617 5.239-12.885.935-2.202 1.906-4.455 3.278-6.388 1.319-1.854 2.134-3.669 1.988-5.94-.084-1.276-.016-2.562-.016-3.843l.707-.352c1.141.985 2.302 1.949 3.423 2.959 4.045 3.646 7.892 3.813 12.319.67 1.888-1.341 3.93-2.47 5.927-3.652.497-.294 1.092-.423 1.934-.738 2.151 5.066 4.262 10.033 6.375 15 1.072 2.524 1.932 5.167 3.264 7.547 2.671 4.775 4.092 9.813 4.07 15.272-.012 2.83.137 5.67-.081 8.482z" clip-rule="evenodd"/>
    </symbol>
  </svg>

  <svg style="display: none;">
   <symbol id="svg-steam" viewBox="0 0 48 48" preserveAspectRatio="xMinYMin meet">
    <path d="M0.986659 31.001L10.0526 34.768C10.5085 36.8197 11.9062 38.6194 13.9682 39.4851C17.342 40.9046 21.232 39.2868 22.6354 35.8879C23.0007 34.9994 23.171 34.0676 23.1463 33.1378L31.5156 27.1148C31.5833 27.1169 31.6531 27.1189 31.7208 27.1189C36.7292 27.1189 40.8 23.0072 40.8 17.9578C40.8 12.908 36.7292 8.8 31.7208 8.8C26.7144 8.8 22.6416 12.908 22.6416 17.9578C22.6416 17.9983 22.6416 18.0388 22.6437 18.0768L16.7944 26.6334C15.8469 26.59 14.8961 26.7573 13.9945 27.1313C13.5971 27.2946 13.2247 27.495 12.8753 27.7264L0.0312094 22.4018C0.0312154 22.4018 0.0301588 22.4194 0.0284312 22.4533C0.0189897 22.4374 0.00951262 22.4214 0 22.4055C0.822857 9.89439 11.2414 0 23.9742 0C37.243 0 48 10.7452 48 24C48 37.2546 37.243 48 23.9742 48C13.1429 48 3.98567 40.8412 0.986659 31.001Z" />
    <path d="M21.2382 35.297C20.1519 37.9231 17.1551 39.169 14.5501 38.076C13.3484 37.5719 12.4411 36.6483 11.9177 35.547L14.8733 36.7805C16.7944 37.5863 18.9984 36.6689 19.797 34.735C20.598 32.7989 19.6893 30.5757 17.7692 29.7699L14.7139 28.495C15.8928 28.0446 17.233 28.0281 18.4853 28.5529C19.7477 29.0818 20.7273 30.0777 21.2464 31.3505C21.7655 32.6233 21.7634 34.0283 21.2382 35.297Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.6721 17.9578C25.6721 21.3233 28.3866 24.061 31.7208 24.061C35.057 24.061 37.7716 21.3233 37.7716 17.9578C37.7716 14.5951 35.057 11.8566 31.7208 11.8566C28.3866 11.8566 25.6721 14.5951 25.6721 17.9578ZM31.7311 22.532C29.2238 22.532 27.1884 20.4805 27.1884 17.9486C27.1884 15.4168 29.2238 13.3634 31.7311 13.3634C34.2404 13.3634 36.2758 15.4168 36.2758 17.9486C36.2758 20.4805 34.2404 22.532 31.7311 22.532Z" />   
   </symbol>
  </svg>

  <svg style="display: none;">
   <symbol id="svg-gog" viewBox="0 0 50 50" preserveAspectRatio="xMinYMin meet">
    <path d="M 6.84375 6 C 5.988281 6.003906 5.527344 6.019531 5.15625 6.0625 C 4.785156 6.105469 4.492188 6.230469 4.3125 6.3125 C 3.515625 6.671875 2.871094 7.304688 2.53125 8.09375 C 2.421875 8.347656 2.308594 8.785156 2.28125 9.40625 C 2.253906 10.027344 2.28125 11.003906 2.28125 12.90625 C 2.28125 14.886719 2.28125 15.882813 2.3125 16.5 C 2.34375 17.117188 2.457031 17.539063 2.5625 17.78125 C 2.933594 18.621094 3.582031 19.28125 4.46875 19.59375 C 4.84375 19.726563 5.097656 19.699219 5.59375 19.71875 C 6.089844 19.738281 6.769531 19.75 7.78125 19.75 L 14 19.75 C 13.996094 20.140625 14.007813 21.167969 14 21.40625 C 13.988281 21.835938 13.980469 22.035156 13.96875 22.09375 C 13.957031 22.152344 13.984375 22.035156 13.9375 22.125 C 13.777344 22.417969 13.496094 22.679688 13.1875 22.8125 C 13.011719 22.886719 13.121094 22.882813 12.46875 22.90625 C 11.816406 22.929688 10.574219 22.9375 8.1875 22.9375 L 3.28125 22.9375 C 2.921875 22.933594 2.585938 23.121094 2.402344 23.433594 C 2.222656 23.746094 2.222656 24.128906 2.402344 24.441406 C 2.585938 24.753906 2.921875 24.941406 3.28125 24.9375 L 8.1875 24.9375 C 10.578125 24.9375 11.828125 24.929688 12.5625 24.90625 C 13.296875 24.882813 13.714844 24.765625 13.96875 24.65625 C 14.714844 24.335938 15.335938 23.773438 15.71875 23.0625 C 15.769531 22.96875 15.890625 22.726563 15.9375 22.46875 C 15.984375 22.210938 15.988281 21.933594 16 21.46875 C 16.011719 21.09375 15.996094 19.722656 16 19.03125 C 16 19.019531 16 19.011719 16 19 C 16.03125 18.855469 16.03125 18.707031 16 18.5625 C 16 18.550781 16 18.542969 16 18.53125 C 16.003906 17.5625 16.03125 17.195313 16.03125 15.46875 C 16.03125 12.085938 16.027344 10.394531 16 9.46875 C 15.988281 9.007813 15.984375 8.726563 15.9375 8.46875 C 15.890625 8.210938 15.769531 7.933594 15.71875 7.84375 C 15.335938 7.136719 14.714844 6.601563 13.96875 6.28125 C 13.714844 6.171875 13.308594 6.058594 12.6875 6.03125 C 12.066406 6.003906 11.058594 6 9.15625 6 C 8.167969 6 7.417969 5.996094 6.84375 6 Z M 22.65625 6 C 21.796875 6.007813 21.304688 6.035156 20.90625 6.09375 C 20.507813 6.152344 20.207031 6.304688 20 6.40625 C 19.214844 6.796875 18.566406 7.472656 18.28125 8.3125 C 18.207031 8.53125 18.230469 8.609375 18.21875 8.71875 C 18.207031 8.828125 18.195313 8.925781 18.1875 9.0625 C 18.171875 9.339844 18.164063 9.691406 18.15625 10.09375 C 18.136719 10.898438 18.121094 11.917969 18.125 12.9375 C 18.128906 13.957031 18.132813 14.976563 18.15625 15.78125 C 18.167969 16.183594 18.199219 16.535156 18.21875 16.8125 C 18.226563 16.949219 18.238281 17.078125 18.25 17.1875 C 18.261719 17.296875 18.234375 17.34375 18.3125 17.5625 C 18.695313 18.648438 19.617188 19.488281 20.75 19.71875 C 20.933594 19.757813 20.972656 19.746094 21.0625 19.75 C 21.152344 19.753906 21.25 19.746094 21.375 19.75 C 21.625 19.757813 21.953125 19.777344 22.34375 19.78125 C 23.125 19.789063 24.132813 19.785156 25.21875 19.78125 C 27.363281 19.773438 28.394531 19.773438 29.125 19.6875 C 29.855469 19.601563 30.433594 19.234375 30.75 18.96875 C 31.117188 18.660156 31.328125 18.371094 31.53125 17.96875 C 31.644531 17.746094 31.785156 17.285156 31.8125 16.65625 C 31.839844 16.027344 31.84375 15.007813 31.84375 12.9375 C 31.84375 10.867188 31.84375 9.820313 31.8125 9.1875 C 31.78125 8.554688 31.640625 8.136719 31.53125 7.90625 C 31.328125 7.46875 31.085938 7.140625 30.6875 6.8125 C 30.335938 6.523438 29.773438 6.179688 29 6.09375 C 28.226563 6.007813 27.113281 6 24.9375 6 C 23.953125 6 23.230469 5.996094 22.65625 6 Z M 38.375 6 C 37.734375 6.011719 37.261719 6.050781 36.875 6.09375 C 36.101563 6.179688 35.507813 6.523438 35.15625 6.8125 C 34.753906 7.140625 34.515625 7.46875 34.3125 7.90625 C 34.203125 8.140625 34.0625 8.558594 34.03125 9.1875 C 34 9.816406 34 10.847656 34 12.90625 C 34 14.964844 34.003906 16 34.03125 16.625 C 34.058594 17.25 34.203125 17.671875 34.3125 17.90625 C 34.515625 18.34375 34.722656 18.65625 35.09375 18.96875 C 35.421875 19.246094 35.945313 19.558594 36.5625 19.65625 C 37.179688 19.753906 37.925781 19.765625 39.40625 19.78125 L 45.6875 19.8125 C 45.6875 19.882813 45.6875 19.992188 45.6875 20.0625 C 45.675781 20.695313 45.671875 21.238281 45.65625 21.625 C 45.648438 21.816406 45.632813 21.960938 45.625 22.0625 C 45.507813 22.382813 45.390625 22.539063 44.96875 22.75 C 44.683594 22.890625 44.875 22.875 44.25 22.90625 C 43.625 22.9375 42.398438 22.9375 39.9375 22.9375 L 35 22.9375 C 34.640625 22.933594 34.304688 23.121094 34.121094 23.433594 C 33.941406 23.746094 33.941406 24.128906 34.121094 24.441406 C 34.304688 24.753906 34.640625 24.941406 35 24.9375 L 39.9375 24.9375 C 42.402344 24.9375 43.625 24.945313 44.375 24.90625 C 45.125 24.867188 45.59375 24.671875 45.875 24.53125 C 46.644531 24.148438 47.253906 23.5 47.53125 22.71875 C 47.648438 22.386719 47.613281 22.394531 47.625 22.25 C 47.636719 22.105469 47.648438 21.925781 47.65625 21.71875 C 47.675781 21.300781 47.675781 20.738281 47.6875 20.09375 C 47.691406 19.816406 47.683594 19.402344 47.6875 19.09375 C 47.6875 19.082031 47.6875 19.074219 47.6875 19.0625 C 47.734375 18.886719 47.734375 18.707031 47.6875 18.53125 C 47.6875 18.519531 47.6875 18.511719 47.6875 18.5 C 47.699219 17.515625 47.71875 16.5625 47.71875 15.46875 C 47.71875 13.804688 47.710938 12.164063 47.6875 10.875 C 47.675781 10.230469 47.675781 9.667969 47.65625 9.25 C 47.648438 9.042969 47.636719 8.863281 47.625 8.71875 C 47.613281 8.574219 47.644531 8.574219 47.53125 8.25 C 47.25 7.449219 46.648438 6.761719 45.875 6.375 C 45.597656 6.234375 45.132813 6.070313 44.5 6.03125 C 43.867188 5.992188 42.878906 6 40.90625 6 C 39.816406 6 39.015625 5.988281 38.375 6 Z M 6.875 8 C 7.433594 7.996094 8.164063 8 9.15625 8 C 11.058594 8 12.066406 8.007813 12.59375 8.03125 C 13.121094 8.054688 13.019531 8.023438 13.1875 8.09375 C 13.492188 8.222656 13.777344 8.519531 13.9375 8.8125 C 13.960938 8.859375 13.96875 8.832031 13.96875 8.8125 C 13.980469 8.867188 13.988281 9.101563 14 9.53125 C 14.023438 10.386719 14.03125 12.085938 14.03125 15.46875 C 14.03125 16.769531 14.03125 16.898438 14.03125 17.75 L 7.78125 17.75 C 6.777344 17.75 6.125 17.734375 5.6875 17.71875 C 5.25 17.703125 5.015625 17.648438 5.125 17.6875 C 4.988281 17.640625 4.527344 17.246094 4.40625 16.96875 C 4.300781 16.726563 4.304688 16.90625 4.28125 16.40625 C 4.257813 15.90625 4.28125 14.886719 4.28125 12.90625 C 4.28125 11.003906 4.257813 9.996094 4.28125 9.46875 C 4.304688 8.941406 4.304688 9.074219 4.375 8.90625 C 4.539063 8.519531 4.746094 8.296875 5.125 8.125 C 5.308594 8.042969 5.214844 8.054688 5.40625 8.03125 C 5.597656 8.007813 6.035156 8.003906 6.875 8 Z M 22.65625 8 C 23.210938 7.996094 23.945313 8 24.9375 8 C 27.113281 8 28.253906 8.003906 28.78125 8.0625 C 29.308594 8.121094 29.113281 8.074219 29.4375 8.34375 C 29.421875 8.332031 29.683594 8.679688 29.71875 8.75 C 29.828125 8.984375 29.789063 8.761719 29.8125 9.28125 C 29.835938 9.800781 29.84375 10.867188 29.84375 12.9375 C 29.84375 15.007813 29.835938 16.046875 29.8125 16.5625 C 29.789063 17.078125 29.859375 16.84375 29.75 17.0625 C 29.707031 17.144531 29.402344 17.46875 29.4375 17.4375 C 29.097656 17.726563 29.375 17.632813 28.90625 17.6875 C 28.4375 17.742188 27.367188 17.773438 25.21875 17.78125 C 24.140625 17.785156 23.109375 17.789063 22.34375 17.78125 C 21.960938 17.777344 21.667969 17.757813 21.4375 17.75 C 21.324219 17.746094 21.214844 17.753906 21.15625 17.75 C 20.753906 17.667969 20.367188 17.328125 20.21875 16.90625 C 20.210938 16.847656 20.226563 16.789063 20.21875 16.6875 C 20.203125 16.453125 20.167969 16.105469 20.15625 15.71875 C 20.132813 14.941406 20.128906 13.945313 20.125 12.9375 C 20.121094 11.929688 20.136719 10.933594 20.15625 10.15625 C 20.164063 9.769531 20.171875 9.421875 20.1875 9.1875 C 20.195313 9.082031 20.214844 8.996094 20.21875 8.9375 C 20.21875 8.929688 20.21875 8.914063 20.21875 8.90625 C 20.347656 8.558594 20.503906 8.371094 20.875 8.1875 C 21.089844 8.078125 21.035156 8.089844 21.21875 8.0625 C 21.402344 8.035156 21.820313 8.007813 22.65625 8 Z M 38.375 8 C 38.988281 7.992188 39.820313 8 40.90625 8 C 42.878906 8 43.882813 8 44.375 8.03125 C 44.867188 8.0625 44.691406 8.050781 44.96875 8.1875 C 45.34375 8.375 45.472656 8.503906 45.59375 8.78125 C 45.597656 8.800781 45.621094 8.855469 45.625 8.90625 C 45.632813 9.007813 45.648438 9.152344 45.65625 9.34375 C 45.671875 9.730469 45.675781 10.269531 45.6875 10.90625 C 45.710938 12.175781 45.71875 13.8125 45.71875 15.46875 C 45.71875 16.3125 45.695313 17.019531 45.6875 17.8125 L 39.4375 17.78125 C 37.960938 17.765625 37.195313 17.738281 36.875 17.6875 C 36.554688 17.636719 36.710938 17.695313 36.40625 17.4375 C 36.4375 17.464844 36.15625 17.132813 36.125 17.0625 C 36.019531 16.835938 36.054688 17.046875 36.03125 16.53125 C 36.007813 16.015625 36 14.964844 36 12.90625 C 36 10.847656 36.007813 9.796875 36.03125 9.28125 C 36.054688 8.765625 36.015625 8.980469 36.125 8.75 C 36.160156 8.679688 36.453125 8.332031 36.4375 8.34375 C 36.761719 8.074219 36.566406 8.121094 37.09375 8.0625 C 37.359375 8.03125 37.761719 8.007813 38.375 8 Z M 12.6875 30.1875 L 8.78125 30.21875 C 7.023438 30.222656 6.035156 30.226563 5.40625 30.25 C 4.777344 30.273438 4.398438 30.3125 4.09375 30.4375 C 3.328125 30.746094 2.699219 31.3125 2.34375 32.03125 C 2.226563 32.269531 2.066406 32.738281 2.03125 33.375 C 1.996094 34.011719 2 35.011719 2 37.0625 C 2 39.285156 1.988281 40.378906 2.0625 41.125 C 2.136719 41.871094 2.464844 42.417969 2.71875 42.75 C 3.234375 43.425781 3.933594 43.769531 4.71875 43.90625 C 4.996094 43.953125 5.039063 43.929688 5.28125 43.9375 C 5.523438 43.945313 5.847656 43.964844 6.21875 43.96875 C 6.964844 43.980469 7.945313 43.972656 8.96875 43.96875 L 12.65625 43.9375 C 13.015625 43.941406 13.351563 43.753906 13.535156 43.441406 C 13.714844 43.128906 13.714844 42.746094 13.535156 42.433594 C 13.351563 42.121094 13.015625 41.933594 12.65625 41.9375 L 8.9375 41.96875 C 7.925781 41.972656 6.980469 41.980469 6.25 41.96875 C 5.886719 41.964844 5.566406 41.945313 5.34375 41.9375 C 5.121094 41.929688 4.882813 41.90625 5.0625 41.9375 C 4.804688 41.894531 4.335938 41.5625 4.3125 41.53125 C 4.050781 41.1875 4.113281 41.449219 4.0625 40.9375 C 4.011719 40.425781 4 39.285156 4 37.0625 C 4 35.011719 4.003906 33.976563 4.03125 33.46875 C 4.058594 32.960938 4.035156 33.179688 4.15625 32.9375 C 4.332031 32.582031 4.429688 32.449219 4.84375 32.28125 C 4.894531 32.261719 4.941406 32.238281 5.5 32.21875 C 6.058594 32.199219 7.027344 32.222656 8.78125 32.21875 L 12.71875 32.1875 C 13.269531 32.179688 13.710938 31.722656 13.703125 31.171875 C 13.695313 30.621094 13.238281 30.179688 12.6875 30.1875 Z M 20.1875 30.1875 C 19.554688 30.199219 19.105469 30.238281 18.71875 30.28125 C 17.949219 30.367188 17.351563 30.707031 17 31 C 16.605469 31.324219 16.359375 31.65625 16.15625 32.09375 C 16.046875 32.324219 15.90625 32.777344 15.875 33.40625 C 15.84375 34.035156 15.875 35.035156 15.875 37.09375 C 15.875 39.066406 15.847656 40.117188 15.875 40.75 C 15.902344 41.382813 16.011719 41.785156 16.125 42.03125 C 16.5625 42.996094 17.46875 43.722656 18.5 43.90625 C 18.769531 43.953125 18.835938 43.929688 19.09375 43.9375 C 19.351563 43.945313 19.703125 43.964844 20.09375 43.96875 C 20.878906 43.980469 21.875 43.972656 22.9375 43.96875 C 24.785156 43.960938 25.742188 43.964844 26.34375 43.9375 C 26.945313 43.910156 27.382813 43.769531 27.625 43.65625 C 28.34375 43.320313 28.902344 42.789063 29.25 42.09375 C 29.390625 41.8125 29.476563 41.402344 29.5 40.75 C 29.523438 40.097656 29.53125 39.027344 29.53125 37.09375 C 29.53125 35.027344 29.527344 33.980469 29.5 33.34375 C 29.488281 33.027344 29.457031 32.820313 29.40625 32.59375 C 29.355469 32.367188 29.273438 32.167969 29.21875 32.0625 C 28.847656 31.371094 28.238281 30.816406 27.53125 30.5 C 27.289063 30.394531 26.859375 30.25 26.25 30.21875 C 25.640625 30.1875 24.675781 30.1875 22.71875 30.1875 C 21.640625 30.1875 20.820313 30.175781 20.1875 30.1875 Z M 37.34375 30.1875 C 36.039063 30.191406 35.320313 30.21875 34.84375 30.25 C 34.367188 30.28125 34.019531 30.359375 33.8125 30.4375 C 33.015625 30.734375 32.378906 31.324219 31.96875 32.09375 C 31.894531 32.234375 31.816406 32.492188 31.78125 32.71875 C 31.746094 32.945313 31.734375 33.164063 31.71875 33.53125 C 31.691406 34.265625 31.667969 35.507813 31.65625 37.8125 C 31.648438 39.167969 31.625 40.457031 31.625 41.40625 C 31.625 41.882813 31.652344 42.28125 31.65625 42.5625 C 31.65625 42.703125 31.652344 42.816406 31.65625 42.90625 C 31.65625 42.949219 31.652344 42.988281 31.65625 43.03125 C 31.65625 43.050781 31.652344 43.058594 31.65625 43.09375 C 31.65625 43.109375 31.648438 43.121094 31.65625 43.15625 C 31.664063 43.191406 31.71875 43.34375 31.71875 43.34375 C 31.882813 43.835938 32.398438 44.125 32.902344 44 C 33.410156 43.878906 33.738281 43.390625 33.65625 42.875 C 33.65625 42.871094 33.65625 42.851563 33.65625 42.84375 C 33.65625 42.777344 33.65625 42.667969 33.65625 42.53125 C 33.652344 42.261719 33.625 41.878906 33.625 41.40625 C 33.625 40.464844 33.648438 39.199219 33.65625 37.84375 C 33.667969 35.542969 33.664063 34.289063 33.6875 33.625 C 33.699219 33.292969 33.738281 33.101563 33.75 33.03125 C 33.90625 32.738281 34.285156 32.402344 34.53125 32.3125 C 34.679688 32.257813 34.628906 32.277344 35 32.25 C 35.371094 32.222656 36.050781 32.191406 37.34375 32.1875 C 37.707031 32.1875 38.347656 32.1875 38.8125 32.1875 L 38.8125 43 C 38.808594 43.359375 38.996094 43.695313 39.308594 43.878906 C 39.621094 44.058594 40.003906 44.058594 40.316406 43.878906 C 40.628906 43.695313 40.816406 43.359375 40.8125 43 L 40.8125 32.1875 L 46 32.1875 L 45.96875 37.0625 L 45.96875 43 C 45.964844 43.359375 46.152344 43.695313 46.464844 43.878906 C 46.777344 44.058594 47.160156 44.058594 47.472656 43.878906 C 47.785156 43.695313 47.972656 43.359375 47.96875 43 L 47.96875 37.0625 L 48 31.1875 L 48 30.1875 L 40.8125 30.1875 C 39.328125 30.1875 38.214844 30.183594 37.34375 30.1875 Z M 22.71875 32.1875 C 24.675781 32.1875 25.664063 32.195313 26.15625 32.21875 C 26.648438 32.242188 26.476563 32.234375 26.71875 32.34375 C 27.117188 32.523438 27.246094 32.640625 27.4375 33 C 27.476563 33.074219 27.464844 33.007813 27.46875 33.03125 C 27.472656 33.054688 27.488281 33.171875 27.5 33.4375 C 27.523438 33.972656 27.53125 35.027344 27.53125 37.09375 C 27.53125 39.023438 27.523438 40.082031 27.5 40.65625 C 27.476563 41.230469 27.480469 41.167969 27.46875 41.1875 C 27.351563 41.425781 27.027344 41.730469 26.78125 41.84375 C 26.628906 41.914063 26.753906 41.914063 26.25 41.9375 C 25.746094 41.960938 24.78125 41.960938 22.9375 41.96875 C 21.886719 41.972656 20.894531 41.980469 20.125 41.96875 C 19.742188 41.964844 19.394531 41.945313 19.15625 41.9375 C 18.917969 41.929688 18.695313 41.910156 18.84375 41.9375 C 18.378906 41.855469 18.1875 41.699219 17.96875 41.21875 C 17.902344 41.070313 17.898438 41.199219 17.875 40.65625 C 17.851563 40.113281 17.875 39.066406 17.875 37.09375 C 17.875 35.035156 17.851563 34.015625 17.875 33.5 C 17.898438 32.984375 17.890625 33.167969 18 32.9375 L 17.96875 32.9375 C 18 32.867188 18.289063 32.523438 18.28125 32.53125 C 18.605469 32.265625 18.410156 32.339844 18.9375 32.28125 C 19.464844 32.222656 20.5625 32.1875 22.71875 32.1875 Z"/>
   </symbol>
  </svg>

  <svg style="display: none;">
   <symbol id="svg-wishlist" viewBox="0 0 512 512" preserveAspectRatio="xMinYMin meet">
     <path d="M405.333,53.333H362.667V42.667a21.356,21.356,0,0,0-21.333-21.333H170.667a21.356,21.356,0,0,0-21.333,21.333V53.333H106.667A42.716,42.716,0,0,0,64,96V448a42.716,42.716,0,0,0,42.667,42.667H405.333A42.716,42.716,0,0,0,448,448V96A42.716,42.716,0,0,0,405.333,53.333ZM170.667,42.667H341.333l.016,42.667H170.667ZM426.667,448a21.354,21.354,0,0,1-21.333,21.333H106.667A21.354,21.354,0,0,1,85.333,448V96a21.356,21.356,0,0,1,21.333-21.333h42.667V85.333a21.356,21.356,0,0,0,21.333,21.333H341.333a21.356,21.356,0,0,0,21.333-21.333V74.667h42.667A21.356,21.356,0,0,1,426.667,96Z"/><path d="M373.333,181.333H224a10.667,10.667,0,0,0,0,21.333H373.333a10.667,10.667,0,1,0,0-21.333Z"/><path d="M170.667,160H149.333A21.356,21.356,0,0,0,128,181.333v21.333A21.356,21.356,0,0,0,149.333,224h21.333A21.356,21.356,0,0,0,192,202.667V181.333A21.356,21.356,0,0,0,170.667,160Zm-21.333,42.667V181.333h21.333l.016,21.333Z"/><path d="M373.333,277.333H224a10.667,10.667,0,0,0,0,21.333H373.333a10.667,10.667,0,1,0,0-21.333Z"/><path d="M170.667,256H149.333A21.354,21.354,0,0,0,128,277.333v21.333A21.354,21.354,0,0,0,149.333,320h21.333A21.354,21.354,0,0,0,192,298.667V277.333A21.354,21.354,0,0,0,170.667,256Zm-21.333,42.667V277.333h21.333l.016,21.333Z"/><path d="M373.333,373.333H224a10.667,10.667,0,0,0,0,21.333H373.333a10.667,10.667,0,1,0,0-21.333Z"/><path d="M170.667,352H149.333A21.354,21.354,0,0,0,128,373.333v21.333A21.354,21.354,0,0,0,149.333,416h21.333A21.354,21.354,0,0,0,192,394.667V373.333A21.354,21.354,0,0,0,170.667,352Zm-21.333,42.667V373.333h21.333l.016,21.333Z"/>
   </symbol>
  </svg>

  <!-- SVG PLAY -->
  <svg style="display: none;">
    <symbol id="svg-play" viewBox="0 0 12 14" preserveAspectRatio="xMinYMin meet">
      <path d="M11.182,5.868l-9.378-5.6C0.751-0.355,0,0.147,0,1.383v11.236c0,1.234,0.751,1.737,1.803,1.112l9.431-5.599C12.291,7.51,12.236,6.491,11.182,5.868z"/>
    </symbol>
  </svg>
  <!-- /SVG PLAY -->

  <!-- SVG SHARE -->
  <svg style="display: none;">
    <symbol id="svg-share" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15.336,12.6c-0.984,0-1.876,0.399-2.536,1.04l-4.602-2.714c0.077-0.297,0.13-0.604,0.13-0.925s-0.054-0.628-0.13-0.925l4.598-2.717C13.457,7,14.35,7.4,15.336,7.4C17.356,7.4,19,5.741,19,3.7S17.356,0,15.336,0s-3.665,1.66-3.665,3.7c0,0.321,0.054,0.628,0.13,0.925L7.203,7.342C6.543,6.7,5.651,6.3,4.665,6.3C2.644,6.3,1,7.959,1,10c0,2.04,1.645,3.699,3.665,3.699c0.986,0,1.878-0.399,2.538-1.041l4.601,2.713c-0.078,0.299-0.132,0.606-0.132,0.93c0,2.04,1.645,3.699,3.665,3.699S19,18.341,19,16.301C19,14.26,17.356,12.6,15.336,12.6z M15.336,2c0.921,0,1.67,0.763,1.67,1.7s-0.749,1.7-1.67,1.7c-0.922,0-1.672-0.763-1.672-1.7S14.414,2,15.336,2z M4.665,11.699c-0.921,0-1.671-0.763-1.671-1.699c0-0.938,0.75-1.7,1.671-1.7s1.67,0.763,1.67,1.7C6.335,10.937,5.586,11.699,4.665,11.699z M15.336,18c-0.922,0-1.672-0.763-1.672-1.699c0-0.308,0.087-0.592,0.228-0.841c0.003-0.005,0.006-0.008,0.009-0.012c0.003-0.005,0.002-0.01,0.005-0.015c0.292-0.497,0.821-0.834,1.431-0.834c0.921,0,1.67,0.763,1.67,1.701C17.006,17.237,16.257,18,15.336,18z"/>
    </symbol>
  </svg>
  <!-- /SVG SHARE -->

  <!-- SVG PINNED -->
  <svg style="display: none;">
    <symbol id="svg-pinned" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M17,20c-0.205,0-0.408-0.063-0.581-0.188L10,15.229l-6.419,4.584c-0.305,0.218-0.706,0.249-1.039,0.077C2.209,19.717,2,19.375,2,19V3c0-1.654,1.346-3,3-3h10c1.654,0,3,1.346,3,3v16c0,0.375-0.209,0.717-0.542,0.89C17.313,19.963,17.156,20,17,20z M10,13c0.203,0,0.407,0.063,0.581,0.186L16,17.057V3c0-0.551-0.448-1-1-1H5C4.448,2,4,2.448,4,3v14.057l5.419-3.871C9.593,13.063,9.796,13,10,13z"/>
    </symbol>
  </svg>
  <!-- /SVG PINNED -->

  <!-- SVG STATUS -->
  <svg style="display: none;">
    <symbol id="svg-status" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,1H4C1.791,1,0,2.791,0,5v4v2v4c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4v-4V9V5C20,2.791,18.209,1,16,1z M18,15c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2v-4h16V15z M18,9H2V5c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V9z"/>
      <rect x="13" y="13" width="2" height="2"/>
      <rect x="9" y="13" width="2" height="2"/>
      <rect x="5" y="5" width="10" height="2"/>
      <rect x="5" y="13" width="2" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG STATUS -->

  <!-- SVG BIG GRID VIEW -->
  <svg style="display: none;">
    <symbol id="svg-big-grid-view" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4V4c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v12C20,18.209,18.209,20,16,20z M2,16c0,1.102,0.896,2,2,2h5v-7H2V16z M4,2C2.896,2,2,2.896,2,4v5h7V2H4z M18,4c0-1.104-0.897-2-2-2h-5v7h7V4z M18,11h-7v7h5c1.103,0,2-0.898,2-2V11z"/>
    </symbol>
  </svg>
  <!-- /SVG BIG GRID VIEW -->

  <!-- SVG SMALL GRID VIEW -->
  <svg style="display: none;">
    <symbol id="svg-small-grid-view" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4V4c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v12C20,18.209,18.209,20,16,20z M12,18v-4H8v4H12z M2,16c0,1.102,0.896,2,2,2h2v-4H2V16z M6,2H4C2.896,2,2,2.896,2,4v2h4V2z M2,8v4h4V8H2z M12,2H8v4h4V2z M8,8v4h4V8H8z M18,4c0-1.103-0.897-2-2-2h-2v4h4V4z M18,8h-4v4h4V8zM18,14h-4v4h2c1.103,0,2-0.898,2-2V14z"/>
    </symbol>
  </svg>
  <!-- /SVG SMALL GRID VIEW -->

  <!-- SVG LIST GRID VIEW -->
  <svg style="display: none;">
    <symbol id="svg-list-grid-view" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4V4c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v12C20,18.209,18.209,20,16,20z M2,16c0,1.102,0.896,2,2,2h2v-4H2V16z M6,2H4C2.896,2,2,2.896,2,4v2h4V2z M2,8v4h4V8H2z M18,4c0-1.103-0.897-2-2-2H8v4h10V4z M18,8H8v4h10V8z M18,14H8v4h8c1.103,0,2-0.898,2-2V14z"/>
    </symbol>
  </svg>
  <!-- /SVG LIST GRID VIEW -->

  <!-- SVG PLUS -->
  <svg style="display: none;">
    <symbol id="svg-plus" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M20,11h-9v9H9v-9H0V9h9V0h2v9h9V11z"/>
    </symbol>
  </svg>
  <!-- /SVG PLUS -->

  <!-- SVG PLUS SMALL -->
  <svg style="display: none;">
    <symbol id="svg-plus-small" viewBox="0 0 8 8" preserveAspectRatio="xMinYMin meet">
      <path d="M8,5H5v3H3V5H0V3h3V0h2v3h3V5z"/>
    </symbol>
  </svg>
  <!-- /SVG PLUS SMALL -->

  <!-- SVG MINUS SMALL -->
  <svg style="display: none;">
    <symbol id="svg-minus-small" viewBox="0 0 8 8" preserveAspectRatio="xMinYMin meet">
      <rect y="3" width="8" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG MINUS SMALL -->

  <!-- SVG POLL -->
  <svg style="display: none;">
    <symbol id="svg-poll" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M12,14H2C0.896,14,0,14.896,0,16v2C0,19.104,0.896,20,2,20h10c1.105,0,2-0.896,2-2v-2C14,14.896,13.105,14,12,14z M12,18H2v-2h10V18z M18,7H2C0.896,7,0,7.896,0,9v2C0,12.104,0.896,13,2,13h16c1.104,0,2-0.896,2-2V9C20,7.896,19.104,7,18,7z M18,11H2V9h16V11z M2,6h4C7.105,6,8,5.104,8,4V2C8,0.896,7.105,0,6,0H2C0.896,0,0,0.896,0,2v2C0,5.104,0.896,6,2,6z M2,2h4v2H2V2z"/>
    </symbol>
  </svg>
  <!-- /SVG POLL -->

  <!-- SVG CAMERA -->
  <svg style="display: none;">
    <symbol id="svg-camera" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M13.018,2C13.505,2,13.81,2.018,14,2.041v1.964h2c1.103,0,2,0.896,2,1.999v9.998C18,17.104,17.103,18,16,18H4c-1.103,0-2-0.896-2-1.999V6.003c0-1.102,0.897-1.999,2-1.999h2V2.041C6.19,2.018,6.496,2,6.983,2l0.473,0.002L8,2.005h4l0.544-0.003L13.018,2 M13.018,0C12.692,0,12.352,0.005,12,0.005H8C7.648,0.005,7.308,0,6.983,0C5.267,0,4,0.148,4,2.005c-2.209,0-4,1.791-4,3.999v9.998C0,18.21,1.791,20,4,20h12c2.209,0,4-1.79,4-3.999V6.003c0-2.208-1.791-3.999-4-3.999C16,0.148,14.733,0,13.018,0L13.018,0z"/>
      <path d="M10,10c1.103,0,2,0.896,2,2c0,1.103-0.897,2-2,2c-1.103,0-2-0.897-2-2C8,10.896,8.897,10,10,10 M10,8c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S12.209,8,10,8L10,8z"/>
      <path d="M15,6c0.553,0,1,0.448,1,1c0,0.553-0.447,1-1,1s-1-0.447-1-1C14,6.448,14.447,6,15,6z"/>
    </symbol>
  </svg>
  <!-- /SVG CAMERA -->

  <!-- SVG GIF -->
  <svg style="display: none;">
    <symbol id="svg-gif" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M3.676,5.098L2.243,3.665C1.025,5.153,0.201,6.975,0,8.995h2.053C2.237,7.534,2.822,6.206,3.676,5.098z M8.995,2.028V0C6.974,0.201,5.152,1.025,3.664,2.243l1.429,1.428
        C6.199,2.807,7.527,2.212,8.995,2.028z M16.336,2.243C14.847,1.025,13.025,0.201,11.006,0v2.028c1.468,0.184,2.795,0.778,3.902,1.643L16.336,2.243z M17.947,8.995H20c-0.201-2.021-1.025-3.842-2.242-5.33l-1.435,1.433C17.179,6.206,17.764,7.534,17.947,8.995z M2.053,11.005H0c0.201,2.021,1.025,3.842,2.243,5.33l1.433-1.434
        C2.822,13.793,2.237,12.466,2.053,11.005z M11.006,17.971V20c2.02-0.2,3.841-1.025,5.33-2.243l-1.428-1.428C13.801,17.193,12.474,17.787,11.006,17.971z M3.664,17.757C5.152,18.975,6.974,19.8,8.995,20v-2.029c-1.468-0.184-2.796-0.777-3.902-1.642L3.664,17.757z M16.323,14.901l1.435,1.434c1.217-1.488,2.041-3.31,2.242-5.33h-2.053C17.764,12.466,17.179,13.793,16.323,14.901z M15.025,11.005v-2.01H10v2.01h2.831c-0.416,1.168-1.521,2.01-2.831,2.01c-1.666,0-3.016-1.35-3.016-3.016c0-1.665,1.35-3.015,3.016-3.015h3.998C13.08,5.771,11.64,4.974,10,4.974c-2.776,0-5.026,2.25-5.026,5.025c0,2.774,2.25,5.025,5.026,5.025C12.432,15.024,14.56,13.298,15.025,11.005z"/>
    </symbol>
  </svg>
  <!-- /SVG GIF -->

  <!-- SVG TAGS -->
  <svg style="display: none;">
    <symbol id="svg-tags" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M20,13.001v2h-6L13,20h-2l1-4.999H6L5,20H3l1-4.999H0v-2h4.4L5.6,7H0V5h6l1-5h2L8,5h6l1-5h2l-1,5h4v2h-4.4L14.4,13.001H20z M13.6,7h-6l-1.2,6.001h6L13.6,7z"/>
    </symbol>
  </svg>
  <!-- /SVG TAGS -->

  <!-- SVG QUOTE -->
  <svg style="display: none;">
    <symbol id="svg-quote" viewBox="0 0 32 22" preserveAspectRatio="xMinYMin meet">
      <path d="M12.998,5l-1-5C3.897,0.622,0,4.275,0,12.904V22h10.998V11H6.997C6.597,7.035,8.106,5.854,12.998,5z M32,5l-1.001-5c-8.1,0.622-11.998,4.275-11.998,12.904V22h10.998V11h-4C25.599,7.035,27.107,5.854,32,5z"/>
    </symbol>
  </svg>
  <!-- /SVG QUOTE -->

  <!-- SVG PIN -->
  <svg style="display: none;">
    <symbol id="svg-pin" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,2c3.309,0,6,2.773,6,6.182c0,4.78-4.517,9.104-5.994,9.768C8.557,17.272,4,12.836,4,8.182C4,4.773,6.691,2,10,2 M10,0C5.581,0,2,3.663,2,8.182C2,14.291,8.192,20,10,20c1.807,0,8-5.596,8-11.818C18,3.663,14.418,0,10,0L10,0z"/>
      <path d="M10,6c1.103,0,2,0.897,2,2c0,1.103-0.897,2-2,2c-1.103,0-2-0.897-2-2C8,6.897,8.897,6,10,6 M10,4C7.791,4,6,5.791,6,8s1.791,4,4,4s4-1.791,4-4S12.209,4,10,4L10,4z"/>
    </symbol>
  </svg>
  <!-- /SVG PIN -->

  <!-- SVG TICKET -->
  <svg style="display: none;">
    <symbol id="svg-ticket" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M15,2v16h-1.537c-0.692-1.194-1.985-2-3.463-2s-2.771,0.806-3.463,2H5V2h1.537C7.229,3.195,8.522,4,10,4s2.771-0.805,3.463-2H15 M17,0h-5c0,1.104-0.896,2-2,2S8,1.104,8,0H3v20h5c0-1.104,0.896-2,2-2s2,0.896,2,2h5V0L17,0z"/>
      <rect x="7" y="7" width="6" height="2"/>
      <rect x="7" y="11" width="4" height="2"/>
    </symbol>
  </svg>
  <!-- /SVG TICKET -->

  <!-- SVG EVENTS MONTHLY -->
  <svg style="display: none;">
    <symbol id="svg-events-monthly" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4.001V6c0-2.209,1.791-4,4-4h1V0h2v2h6V0h2v2h1c2.209,0,4,1.791,4,4v9.999C20,18.209,18.209,20,16,20z M18,6c0-1.103-0.897-2-2-2h-1v2h-2V4H7v2H5V4H4C2.896,4,2,4.897,2,6v9.999C2,17.103,2.896,18,4,18h12c1.103,0,2-0.897,2-2.001V6z M13,13.001h2v2h-2V13.001z M13,9.001h2v2h-2V9.001z M9,13.001h2v2H9V13.001z M9,9.001h2v2H9V9.001z M5,13.001h2v2H5V13.001z M5,9.001h2v2H5V9.001z"/>
    </symbol>
  </svg>
  <!-- /SVG EVENTS MONTHLY -->

  <!-- SVG EVENTS WEEKLY -->
  <svg style="display: none;">
    <symbol id="svg-events-weekly" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4.001V6c0-2.209,1.791-4,4-4h1V0h2v2h6V0h2v2h1c2.209,0,4,1.791,4,4v9.999C20,18.209,18.209,20,16,20z M18,6c0-1.103-0.897-2-2-2h-1v2h-2V4H7v2H5V4H4C2.896,4,2,4.897,2,6v9.999C2,17.103,2.896,18,4,18h12c1.103,0,2-0.897,2-2.001V6z M5,13.001h10v2H5V13.001z M5,9.001h10v2H5V9.001z"/>
    </symbol>
  </svg>
  <!-- /SVG EVENTS WEEKLY -->

  <!-- SVG EVENTS DAILY -->
  <svg style="display: none;">
    <symbol id="svg-events-daily" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20H4c-2.209,0-4-1.791-4-4.001V6c0-2.209,1.791-4,4-4h1V0h2v2h6V0h2v2h1c2.209,0,4,1.791,4,4v9.999C20,18.209,18.209,20,16,20z M18,6c0-1.103-0.897-2-2-2h-1v2h-2V4H7v2H5V4H4C2.896,4,2,4.897,2,6v9.999C2,17.103,2.896,18,4,18h12c1.103,0,2-0.897,2-2.001V6z M7,15.001H5v-2v-2v-2h2h6h2v2v2v2h-2H7zM13,11.001H7v2h6V11.001z"/>
    </symbol>
  </svg>
  <!-- /SVG EVENTS DAILY -->

  <!-- SVG INFO -->
  <svg style="display: none;">
    <symbol id="svg-info" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M9,15h2V9H9V15z M9,7h2V5H9V7z M16-0.001H4c-2.209,0-4,1.791-4,4v12c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4v-12C20,1.79,18.209-0.001,16-0.001z M18,15.999C18,17.102,17.103,18,16,18H4c-1.103,0-2-0.898-2-2.001v-12c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V15.999z"/>
    </symbol>
  </svg>
  <!-- /SVG INFO -->

  <!-- SVG CHECK -->
  <svg style="display: none;">
    <symbol id="svg-check" viewBox="0 0 12 9" preserveAspectRatio="xMinYMin meet">
      <path d="M12,1.5L4.5,9L3,7.499l0,0L0,4.5L1.5,3l3,3l6-6L12,1.5z"/>
    </symbol>
  </svg>
  <!-- /SVG CHECK -->

  <!-- SVG TROPHY -->
  <svg style="display: none;">
    <symbol id="svg-trophy" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M19.968,4.031C19.941,5.666,19.579,11,15.99,11h-0.125c-0.426,2.357-2.111,2.999-5.858,2.999c-3.748,0-5.434-0.642-5.859-2.999H4.009c-3.588,0-3.951-5.333-3.977-6.969L0,2h2.028h1.98h0.015V0H15.99v2l0,0h1.981H20L19.968,4.031z M4.009,3.999L1.994,4c0,0,0.112,4.999,2.015,4.999V3.999z M13.993,2H6.02v7.6c0,2.385,0.741,2.399,3.987,2.399c3.245,0,3.986-0.014,3.986-2.399V2z M17.972,3.999H15.99v5C17.893,8.999,18.006,4,18.006,4L17.972,3.999z M11.005,15.999H13c2.206,0,3.993,1.789,3.993,4h-1.989h-0.006c0-1.104-0.896-2.001-1.998-2.001h-1.995H9.009H7.013c-1.102,0-1.996,0.896-1.996,2.001H4.996H3.02c0-2.211,1.788-4,3.993-4h1.996v-2.001h0.998h0.998V15.999z"/>
    </symbol>
  </svg>
  <!-- /SVG TROPHY -->

  <!-- SVG CLOCK -->
  <svg style="display: none;">
    <symbol id="svg-clock" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M10,0C4.486,0,0,4.485,0,9.999c0,5.515,4.486,10,10,10c5.514,0,10-4.485,10-10C20,4.485,15.514,0,10,0zM10,17.999c-4.414,0-8.005-3.589-8.005-8S5.586,2,10,2c4.414,0,8.005,3.588,8.005,7.999S14.414,17.999,10,17.999z M14.437,12.105l-3.44-1.724V4.999C10.997,4.447,10.551,4,10,4S9.002,4.447,9.002,4.999V11c0,0.379,0.213,0.725,0.551,0.894l3.99,2C13.687,13.966,13.838,14,13.988,14c0.367,0,0.719-0.203,0.894-0.554C15.128,12.953,14.929,12.352,14.437,12.105z"/>
    </symbol>
  </svg>
  <!-- /SVG CLOCK -->

  <!-- SVG RETURN -->
  <svg style="display: none;">
    <symbol id="svg-return" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M19.12,13.852c-1.047,2.187-2.896,3.834-5.203,4.638C12.922,18.835,11.905,19,10.906,19c-3.751,0-7.273-2.313-8.59-6.006c-0.186-0.52,0.086-1.092,0.606-1.277c0.52-0.189,1.092,0.085,1.277,0.605c1.301,3.646,5.367,5.563,9.06,4.278c1.801-0.627,3.241-1.909,4.057-3.614c0.802-1.675,0.9-3.56,0.277-5.308c-1.3-3.644-5.363-5.562-9.06-4.278C7.541,3.746,6.623,4.316,5.877,5.052l-2.33,2.163h2.852c0.553,0,1,0.448,1,1c0,0.552-0.447,1-1,1H1c-0.007,0-0.013-0.004-0.019-0.004C0.901,9.21,0.826,9.185,0.749,9.164C0.699,9.151,0.646,9.149,0.601,9.13C0.555,9.109,0.518,9.071,0.474,9.044c-0.066-0.043-0.137-0.08-0.191-0.138C0.277,8.901,0.271,8.9,0.267,8.896C0.231,8.857,0.218,8.811,0.189,8.769C0.147,8.707,0.101,8.649,0.073,8.579C0.045,8.507,0.039,8.432,0.028,8.355C0.021,8.307,0,8.264,0,8.214V2.882c0-0.552,0.447-1,1-1c0.552,0,1,0.448,1,1v3.041l2.495-2.315c0.935-0.922,2.111-1.653,3.382-2.096c4.728-1.646,9.933,0.819,11.6,5.495C20.281,9.261,20.154,11.69,19.12,13.852z"/>
    </symbol>
  </svg>
  <!-- /SVG RETURN -->

  <!-- SVG DRIBBBLE -->
  <svg style="display: none;">
    <symbol id="svg-dribbble" viewBox="0 0 12 12" preserveAspectRatio="xMinYMin meet">
      <path d="M6,11.999c-3.313,0-6-2.687-6-6c0-3.313,2.687-6,6-6s6,2.686,6,6C12,9.313,9.313,11.999,6,11.999z M7.434,4.992C7.585,5.295,7.728,5.599,7.86,5.896c0.814-0.135,1.696-0.139,2.634,0.046c-0.01-0.874-0.272-1.686-0.713-2.373C9.062,4.167,8.257,4.632,7.434,4.992z M9.104,9.244c0.599-0.573,1.036-1.31,1.247-2.138c-0.484-0.085-1.184-0.15-2.008-0.054C8.681,7.915,8.935,8.684,9.104,9.244z M5.994,10.495c0.708,0,1.375-0.167,1.972-0.459C7.812,9.095,7.532,8.167,7.188,7.285C6.014,7.624,4.701,8.333,3.44,9.7C4.166,10.2,5.045,10.495,5.994,10.495z M2.556,8.897c0.8-0.837,2.245-2.097,4.159-2.722C6.593,5.913,6.466,5.659,6.337,5.409C4.395,6.05,2.505,6.189,1.501,6.212C1.551,7.233,1.938,8.165,2.556,8.897z M1.593,5.048c1.733-0.13,3.096-0.387,4.16-0.7c-0.613-1.05-1.216-1.906-1.624-2.45C2.851,2.481,1.894,3.642,1.593,5.048z M5.994,1.49c-0.258,0-0.509,0.027-0.754,0.068C5.864,2.29,6.409,3.113,6.885,3.955c1.091-0.447,1.737-0.937,2.108-1.311C8.197,1.929,7.148,1.49,5.994,1.49z"/>
    </symbol>
  </svg>
  <!-- /SVG DRIBBBLE -->

  <!-- SVG ITEM -->
  <svg style="display: none;">
    <symbol id="svg-item" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M19,5h-1.952C17.209,4,17.3,3.943,17.3,3.5c0-1.792-1.458-3.375-3.25-3.375c-2.035,0-3.296,1.306-4.049,2.653C9.248,1.431,7.985,0.031,5.95,0.031c-1.792,0-3.25,1.692-3.25,3.484C2.7,3.958,2.791,4,2.952,5H1C0.448,5,0,4.948,0,5.5V10c0,0.552,0.448,1,1,1h1v5c0,2.209,1.791,4,4,4h3h2h3c2.209,0,4-1.791,4-4v-5h1c0.553,0,1-0.448,1-1V5.5C20,4.948,19.553,5,19,5z M14.05,2.25c0.689,0,1.25,0.686,1.25,1.375S14.739,5,14.05,5h-2.693C11.788,3,12.626,2.25,14.05,2.25zM5.95,2.375C7.375,2.375,8.212,3,8.644,5H5.95C5.261,5,4.7,4.189,4.7,3.5S5.261,2.375,5.95,2.375z M9,18H6c-1.103,0-2-0.897-2-2v-5h5V18z M16,16c0,1.103-0.897,2-2,2h-3v-7h5V16z M18,9h-4h-3H9H5H2V7h3h0.95H9h2h3h0.05H18V9z"/>
    </symbol>
  </svg>
  <!-- /SVG ITEM -->

  <!-- SVG WALLET -->
  <svg style="display: none;">
    <symbol id="svg-wallet" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M20,9h-2V8c0-1.999-1.471-3.641-3.387-3.938l-0.395-1.548C13.832,0.999,12.527,0,11.104,0c-0.276,0-0.557,0.038-0.836,0.116l-7.79,2.194C1.155,2.684,0.2,3.72,0.033,5H0v3v1v7c0,2.209,1.791,4,4,4h10c2.209,0,4-1.791,4-4v-1h2V9z M10.81,2.042C10.908,2.014,11.006,2,11.104,2c0.543,0,1.025,0.415,1.178,1.008L12.534,4H4C3.924,4,3.853,4.018,3.778,4.022L10.81,2.042z M16,16c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V9V8c0-1.103,0.897-2,2-2h10c1.103,0,2,0.897,2,2v1h-1c-1.657,0-3,1.344-3,3s1.343,3,3,3h1V16z M18,13h-3c-0.552,0-1-0.448-1-1s0.448-1,1-1h3V13z"/>
    </symbol>
  </svg>
  <!-- /SVG WALLET -->

  <!-- SVG EARNINGS -->
  <svg style="display: none;">
    <symbol id="svg-earnings" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,20h-1v-2h1c1.103,0,2-0.897,2-2v-1h2v1C20,18.209,18.209,20,16,20z M18,11h2v2h-2V11z M18,7h2v2h-2V7z M18,4c0-1.103-0.897-2-2-2h-1V0h1c2.209,0,4,1.791,4,4v1h-2V4zM8.75,9h2.5C12.767,9,14,10.346,14,12s-1.233,3-2.75,3H11v1H9v-1H7c-0.553,0-1-0.447-1-1s0.447-1,1-1h2h2h0.25c0.406,0,0.75-0.458,0.75-1s-0.344-1-0.75-1h-2.5C7.233,11,6,9.654,6,8s1.233-3,2.75-3H9V4h2v1h1.5c0.553,0,1,0.448,1,1s-0.447,1-1,1H11H9H8.75C8.344,7,8,7.458,8,8S8.344,9,8.75,9z M11,0h2v2h-2V0z M7,0h2v2H7V0z M0,16v-1h2v1c0,1.103,0.896,2,2,2h1v2H4C1.791,20,0,18.209,0,16z M2,4v1H0V4c0-2.209,1.791-4,4-4h1v2H4C2.896,2,2,2.897,2,4z M2,7v2H0V7H2z M2,13H0v-2h2V13z M9,20H7v-2h2V20z M13,20h-2v-2h2V20z"/>
    </symbol>
  </svg>
  <!-- /SVG EARNINGS -->

  <!-- SVG REVENUE -->
  <svg style="display: none;">
    <symbol id="svg-revenue" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M16,0H4C1.791,0,0,1.791,0,4v12c0,2.209,1.791,4,4,4h12c2.209,0,4-1.791,4-4V4C20,1.791,18.209,0,16,0zM18,16c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2V16z"/>
      <path d="M11.25,9h-2.5C8.344,9,8,8.542,8,8s0.344-1,0.75-1h3.75c0.553,0,1-0.448,1-1s-0.447-1-1-1H11V4H9v1H8.75C7.233,5,6,6.346,6,8s1.233,3,2.75,3h2.5c0.406,0,0.75,0.458,0.75,1s-0.344,1-0.75,1H7c-0.553,0-1,0.447-1,1s0.447,1,1,1h2v1h2v-1h0.25c1.517,0,2.75-1.346,2.75-3S12.767,9,11.25,9z"/>
    </symbol>
  </svg>
  <!-- /SVG REVENUE -->

  <!-- SVG LOGIN -->
  <svg style="display: none;">
    <symbol id="svg-login" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet">
      <path d="M13,2.523v2.176c2.358,1.126,4,3.513,4,6.301c0,3.866-3.134,7-7,7s-7-3.134-7-7c0-2.788,1.642-5.175,4-6.301V2.523C3.507,3.76,1,7.083,1,11c0,4.971,4.029,9,9,9s9-4.029,9-9
      C19,7.083,16.493,3.76,13,2.523z M11,0H9v10h2V0z"/>
    </symbol>
  </svg>
  <!-- /SVG LOGIN -->
`;
$2a0228d744e2e035$var$svgWrap.innerHTML = $2a0228d744e2e035$var$svgData;
document.body.appendChild($2a0228d744e2e035$var$svgWrap);



$342f7fe00eb414e4$exports.querySelector(".liquid", function(images) {
    for (const image of images)$342f7fe00eb414e4$exports.liquidify(image);
});



$342f7fe00eb414e4$exports.querySelector(".icon-demo-list", function(lists) {
    const icons = [
        {
            name: "Facebook",
            className: "facebook"
        },
        {
            name: "Twitter",
            className: "twitter"
        },
        {
            name: "Twitch",
            className: "twitch"
        },
        {
            name: "Youtube",
            className: "youtube"
        },
        {
            name: "Instagram",
            className: "instagram"
        },
        {
            name: "Discord",
            className: "discord"
        },
        {
            name: "Patreon",
            className: "patreon"
        },
        {
            name: "Google",
            className: "google"
        },
        {
            name: "Behance",
            className: "behance"
        },
        {
            name: "DeviantArt",
            className: "deviantart"
        },
        {
            name: "Artstation",
            className: "artstation"
        },
        {
            name: "Cross",
            className: "cross"
        },
        {
            name: "Logo Vikinger",
            className: "logo-vikinger"
        },
        {
            name: "Grid",
            className: "grid"
        },
        {
            name: "Dots",
            className: "dots"
        },
        {
            name: "Magnifying Glass",
            className: "magnifying-glass"
        },
        {
            name: "Comment",
            className: "comment"
        },
        {
            name: "Thumbs Up",
            className: "thumbs-up"
        },
        {
            name: "Friend",
            className: "friend"
        },
        {
            name: "Group",
            className: "group"
        },
        {
            name: "Marketplace",
            className: "marketplace"
        },
        {
            name: "Add Friend",
            className: "add-friend"
        },
        {
            name: "Remove Friend",
            className: "remove-friend"
        },
        {
            name: "Delete",
            className: "delete"
        },
        {
            name: "Messages",
            className: "messages"
        },
        {
            name: "Send Message",
            className: "send-message"
        },
        {
            name: "Back Arrow",
            className: "back-arrow"
        },
        {
            name: "Shopping Bag",
            className: "shopping-bag"
        },
        {
            name: "Notification",
            className: "notification"
        },
        {
            name: "Settings",
            className: "settings"
        },
        {
            name: "Cross Thin",
            className: "cross-thin"
        },
        {
            name: "Newsfeed",
            className: "newsfeed"
        },
        {
            name: "Overview",
            className: "overview"
        },
        {
            name: "Members",
            className: "members"
        },
        {
            name: "Badges",
            className: "badges"
        },
        {
            name: "Quests",
            className: "quests"
        },
        {
            name: "Streams",
            className: "streams"
        },
        {
            name: "Events",
            className: "events"
        },
        {
            name: "Forums",
            className: "forums"
        },
        {
            name: "Small Arrow",
            className: "small-arrow"
        },
        {
            name: "Big Arrow",
            className: "big-arrow"
        },
        {
            name: "Public",
            className: "public"
        },
        {
            name: "Private",
            className: "private"
        },
        {
            name: "Join Group",
            className: "join-group"
        },
        {
            name: "Leave Group",
            className: "leave-group"
        },
        {
            name: "More Dots",
            className: "more-dots"
        },
        {
            name: "Profile",
            className: "profile"
        },
        {
            name: "Timeline",
            className: "timeline"
        },
        {
            name: "Photos",
            className: "photos"
        },
        {
            name: "Videos",
            className: "videos"
        },
        {
            name: "Blog Posts",
            className: "blog-posts"
        },
        {
            name: "Forum",
            className: "forum"
        },
        {
            name: "Store",
            className: "store"
        },
        {
            name: "Star",
            className: "star"
        },
        {
            name: "Play",
            className: "play"
        },
        {
            name: "Share",
            className: "share"
        },
        {
            name: "Pinned",
            className: "pinned"
        },
        {
            name: "Status",
            className: "status"
        },
        {
            name: "Big Grid View",
            className: "big-grid-view"
        },
        {
            name: "Small Grid View",
            className: "small-grid-view"
        },
        {
            name: "List Grid View",
            className: "list-grid-view"
        },
        {
            name: "Plus",
            className: "plus"
        },
        {
            name: "Plus Small",
            className: "plus-small"
        },
        {
            name: "Minus Small",
            className: "minus-small"
        },
        {
            name: "Poll",
            className: "poll"
        },
        {
            name: "Camera",
            className: "camera"
        },
        {
            name: "Gif",
            className: "gif"
        },
        {
            name: "Tags",
            className: "tags"
        },
        {
            name: "Quote",
            className: "quote"
        },
        {
            name: "Pin",
            className: "pin"
        },
        {
            name: "Ticket",
            className: "ticket"
        },
        {
            name: "Events Monthly",
            className: "events-monthly"
        },
        {
            name: "Events Weekly",
            className: "events-weekly"
        },
        {
            name: "Events Daily",
            className: "events-daily"
        },
        {
            name: "Info",
            className: "info"
        },
        {
            name: "Check",
            className: "check"
        },
        {
            name: "Trophy",
            className: "trophy"
        },
        {
            name: "Clock",
            className: "clock"
        },
        {
            name: "Return",
            className: "return"
        },
        {
            name: "Dribbble",
            className: "dribbble"
        },
        {
            name: "Item",
            className: "item"
        },
        {
            name: "Wallet",
            className: "wallet"
        },
        {
            name: "Earnings",
            className: "earnings"
        },
        {
            name: "Revenue",
            className: "revenue"
        },
        {
            name: "Login",
            className: "login"
        }
    ];
    const createIcon = function(iconName) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), use = document.createElementNS("http://www.w3.org/2000/svg", "use");
        svg.classList.add(`icon-${iconName}`);
        use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `#svg-${iconName}`);
        svg.appendChild(use);
        return svg;
    };
    const createIconString = function(icon) {
        const iconString = `
    <!-- ICON ${icon.name.toUpperCase()} -->
    <svg class="icon-${icon.className}">
      <use xlink:href="#svg-${icon.className}"></use>
    </svg>
    <!-- /ICON ${icon.name.toUpperCase()} -->`;
        return iconString;
    };
    const createDemoIconString = function(icon) {
        const iconString = `
    <!-- ICON ${icon.name.toUpperCase()} -->
    <svg class="icon-${icon.className} demo-icon">
      <use xlink:href="#svg-${icon.className}"></use>
    </svg>
    <!-- /ICON ${icon.name.toUpperCase()} -->`;
        return iconString;
    };
    const createDemoBox = function(iconData) {
        const container = document.createElement("div"), iconContainer = document.createElement("div"), icon = createIcon(iconData.className), title = document.createElement("p"), text = document.createElement("p"), button = document.createElement("p"), buttonInactiveText = document.createElement("span"), buttonActiveText = document.createElement("span");
        container.classList.add("demo-box");
        iconContainer.classList.add("demo-box-icon-wrap");
        icon.classList.add("demo-box-icon");
        title.classList.add("demo-box-title");
        text.classList.add("demo-box-text");
        button.classList.add("button", "full");
        buttonInactiveText.classList.add("inactive-text");
        buttonActiveText.classList.add("active-text");
        title.innerHTML = iconData.name;
        text.innerHTML = `.icon-${iconData.className}`;
        buttonInactiveText.innerHTML = "Copy SVG";
        buttonActiveText.innerHTML = "Copied!";
        iconContainer.appendChild(icon);
        container.appendChild(iconContainer);
        container.appendChild(title);
        container.appendChild(text);
        button.appendChild(buttonInactiveText);
        button.appendChild(buttonActiveText);
        container.appendChild(button);
        return {
            container: container,
            trigger: button
        };
    };
    const copyCode = function(code) {
        const input = document.createElement("textarea");
        input.innerHTML = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        input.remove();
    };
    // ICON BACKLOG
    const divWrap = document.createElement("div");
    divWrap.style.width = "80px";
    divWrap.style.position = "fixed";
    divWrap.style.top = "80px";
    divWrap.style.left = "0";
    document.body.appendChild(divWrap);
    for (const list of lists){
        // Sort icons array
        const sortedIcons = icons.sort(function(firstEl, secondEl) {
            if (firstEl.name < secondEl.name) return -1;
            if (firstEl.name > secondEl.name) return 1;
            return 0;
        });
        for (const icon of sortedIcons){
            const demoBox = createDemoBox(icon);
            list.appendChild(demoBox.container);
            demoBox.trigger.addEventListener("click", function() {
                const iconCode = createIconString(icon);
                copyCode(iconCode);
                demoBox.trigger.classList.add("active");
                window.setTimeout(function() {
                    demoBox.trigger.classList.remove("active");
                }, 2000);
                // ICON BACKLOG
                const div = document.createElement("div");
                div.style.display = "flex";
                div.style.justifyContent = "center";
                div.style.marginTop = "30px";
                div.innerHTML = createDemoIconString(icon);
                divWrap.appendChild(div);
            });
        }
    }
});



$342f7fe00eb414e4$exports.querySelector(".form-rating", function(ratingInputs) {
    for (const ratingInput of ratingInputs){
        const filledClass = "filled", ratingItems = Array.from(ratingInput.children);
        const getStarsRating = function() {
            let rating = 0;
            for (const ratingItem of ratingItems)if (ratingItem.classList.contains(filledClass)) rating++;
            return rating;
        };
        const setStarsRating = function() {
            ratingInput.setAttribute("data-rating", getStarsRating());
        };
        const fillStar = function(item) {
            item.classList.add(filledClass);
        };
        const emptyStar = function(item) {
            item.classList.remove(filledClass);
        };
        const toggleStars = function() {
            const itemIndex = ratingItems.indexOf(this);
            for(let i = 0; i <= itemIndex; i++)fillStar(ratingItems[i]);
            for(let i = itemIndex + 1; i < ratingItems.length; i++)emptyStar(ratingItems[i]);
            setStarsRating();
        };
        for (const ratingItem of ratingItems)ratingItem.addEventListener("click", toggleStars);
        setStarsRating();
    }
});



$342f7fe00eb414e4$exports.querySelector(".form-counter", function(counters) {
    for (const counter of counters){
        const value = counter.querySelector(".form-counter-value"), increaseButton = counter.querySelector(".form-counter-control-increase"), decreaseButton = counter.querySelector(".form-counter-control-decrease"), increaseBy = counter.getAttribute("data-increase-by") ? Number.parseInt(counter.getAttribute("data-increase-by"), 10) : 1, minValue = counter.getAttribute("data-min") ? Number.parseInt(counter.getAttribute("data-min"), 10) : 1;
        const increaseValue = function() {
            value.innerHTML = Number.parseInt(value.innerHTML, 10) + increaseBy;
        };
        const decreaseValue = function() {
            if (Number.parseInt(value.innerHTML) === minValue) return;
            value.innerHTML = Number.parseInt(value.innerHTML, 10) - increaseBy;
        };
        increaseButton.addEventListener("click", increaseValue);
        decreaseButton.addEventListener("click", decreaseValue);
    }
});



$342f7fe00eb414e4$exports.querySelector(".form-switch", function(switchInputs) {
    for (const switchInput of switchInputs){
        const toggleSwitch = function() {
            switchInput.classList.toggle("active");
        };
        switchInput.addEventListener("click", toggleSwitch);
    }
});



$342f7fe00eb414e4$exports.querySelector(".form-input", function(elements) {
    for (const el of elements){
        if (el.classList.contains("always-active")) continue;
        const input = el.querySelector("input"), textarea = el.querySelector("textarea"), activeClass = "active";
        let inputItem = undefined;
        if (input) inputItem = input;
        if (textarea) inputItem = textarea;
        if (inputItem) {
            inputItem.addEventListener("focus", function() {
                el.classList.add(activeClass);
            });
            inputItem.addEventListener("blur", function() {
                if (inputItem.value === "") el.classList.remove(activeClass);
            });
        }
    }
});



$342f7fe00eb414e4$exports.querySelector(".interactive-input", function(elements) {
    for (const el of elements){
        const input = el.querySelector("input"), inputResetIcon = el.querySelector(".interactive-input-action"), activeClass = "active";
        if (input) {
            let previousValue = "";
            const resetInputOnKey = function(e) {
                // ESC key pressed
                if (e.keyCode === 27) {
                    input.value = "";
                    setActiveClass();
                    window.removeEventListener("keydown", resetInputOnKey);
                }
            };
            const setActiveClass = function() {
                if (previousValue === "" && input.value !== "") {
                    el.classList.add(activeClass);
                    window.addEventListener("keydown", resetInputOnKey);
                } else if (input.value === "") {
                    el.classList.remove(activeClass);
                    window.removeEventListener("keydown", resetInputOnKey);
                }
            };
            input.addEventListener("input", setActiveClass);
            if (inputResetIcon) inputResetIcon.addEventListener("click", function() {
                input.value = "";
                input.focus();
                setActiveClass();
            });
        }
    }
});



$007db0a3d89c8a26$exports.createTab({
    triggers: ".login-register-form-trigger",
    elements: ".login-register-form-element",
    animation: {
        type: "slide-in-right"
    },
    onTabChange: function(activeTab) {
        const firstInput = activeTab.querySelector("input");
        firstInput.focus();
    }
});



$007db0a3d89c8a26$exports.createProgressBar({
    container: "#logged-user-level",
    height: 4,
    lineColor: "#5538b5"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#logged-user-level",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 62
    },
    linkText: true,
    linkUnits: "exp",
    invertedProgress: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#logged-user-level-cp",
    height: 4,
    lineColor: "#5538b5"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#logged-user-level-cp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 62
    },
    linkText: true,
    linkUnits: "exp",
    invertedProgress: true
});




/*--------------------
    HEADER SEARCH
--------------------*/ $342f7fe00eb414e4$exports.querySelector("#search-main", function(el) {
    const headerSearchDropdown = $007db0a3d89c8a26$exports.createDropdown({
        container: ".header-search-dropdown",
        offset: {
            top: 57,
            left: 0
        },
        animation: {
            type: "translate-top"
        },
        controlToggle: true,
        closeOnWindowClick: false
    });
    const searchInput = el[0], breakpointWidth = 960;
    let previousValue = "";
    const hideSearchDropdownOnKey = function(e) {
        // ESC key pressed
        if (e.keyCode === 27) {
            headerSearchDropdown.hideDropdowns();
            previousValue = "";
            window.removeEventListener("keydown", hideSearchDropdownOnKey);
        }
    };
    const toggleSearchDropdown = function(e) {
        if (previousValue === "" && e.target.value !== "") {
            headerSearchDropdown.showDropdowns();
            window.addEventListener("keydown", hideSearchDropdownOnKey);
        } else if (e.target.value === "") {
            headerSearchDropdown.hideDropdowns();
            window.removeEventListener("keydown", hideSearchDropdownOnKey);
        }
        previousValue = e.target.value;
    };
    const interactiveInputAction = searchInput.parentElement.querySelector(".interactive-input-action");
    const hideSearchDropdown = function() {
        headerSearchDropdown.hideDropdowns();
        window.removeEventListener("keydown", hideSearchDropdownOnKey);
        previousValue = "";
    };
    if (window.innerWidth > breakpointWidth) {
        searchInput.addEventListener("input", toggleSearchDropdown);
        interactiveInputAction.addEventListener("click", hideSearchDropdown);
    }
});
/*----------------------
    HEADER DROPDOWNS
----------------------*/ $007db0a3d89c8a26$exports.createDropdown({
    trigger: ".header-dropdown-trigger",
    container: ".header-dropdown",
    offset: {
        top: 64,
        right: 6
    },
    animation: {
        type: "translate-top"
    }
});
$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".header-settings-dropdown-trigger",
    container: ".header-settings-dropdown",
    offset: {
        top: 64,
        right: 22
    },
    animation: {
        type: "translate-top"
    }
});



/*-------------------
    CONTENT GRID 
-------------------*/ $342f7fe00eb414e4$exports.querySelector(".content-grid", function(el) {
    const sidebar = {
        chat: {
            active: false,
            minWidth: 80,
            maxWidth: 300
        },
        navigation: {
            active: false,
            minWidth: 80,
            maxWidth: 300
        }
    }, breakpointWidth = 1366;
    const updateGridPosition = function(contentGrid) {
        if (window.innerWidth > breakpointWidth) {
            const chatWidth = sidebar.chat.active ? sidebar.chat.maxWidth : sidebar.chat.minWidth, navigationWidth = sidebar.navigation.active ? sidebar.navigation.maxWidth : sidebar.navigation.minWidth, availableWidth = document.body.clientWidth - contentGrid.offsetWidth - chatWidth - navigationWidth, offsetX = availableWidth / 2 + navigationWidth;
            contentGrid.style.transform = `translate(${offsetX}px, 0)`;
        } else contentGrid.style.transform = `translate(0, 0)`;
    };
    const updateGridPositions = function() {
        for (const grid of el)updateGridPosition(grid);
    };
    const setGridTransition = function(grid) {
        grid.style.transition = `transform .4s ease-in-out`;
    };
    const setGridTransitions = function() {
        for (const grid of el)setGridTransition(grid);
    };
    updateGridPositions();
    window.addEventListener("resize", updateGridPositions);
    // delay transition setup to avoid loading animation
    window.setTimeout(setGridTransitions, 300);
    /*-------------------
      CHAT WIDGET 
  -------------------*/ $342f7fe00eb414e4$exports.querySelector("#chat-widget-messages", function(el) {
        const chatWidget = el[0], topOffset = 80, closedWidth = 80, openWidth = 300, chatWidgetMessages = chatWidget.querySelector(".chat-widget-messages"), chatWidgetForm = chatWidget.querySelector(".chat-widget-form"), chatWidgetButton = chatWidget.querySelector(".chat-widget-button"), closedClass = "closed";
        const setChatMessagesDimensions = function() {
            if (chatWidget.classList.contains(closedClass)) chatWidgetMessages.style.height = `${window.innerHeight - chatWidgetButton.offsetHeight - topOffset}px`;
            else chatWidgetMessages.style.height = `${window.innerHeight - chatWidgetForm.offsetHeight - chatWidgetButton.offsetHeight - topOffset}px`;
        };
        const toggleChatWidget = function() {
            chatWidget.classList.toggle(closedClass);
            setChatMessagesDimensions();
            sidebar.chat.active = !chatWidget.classList.contains(closedClass);
            updateGridPositions();
        };
        const openChatWidget = function() {
            chatWidget.classList.remove(closedClass);
            setChatMessagesDimensions();
            sidebar.chat.active = true;
            updateGridPositions();
        };
        chatWidgetButton.addEventListener("click", toggleChatWidget);
        setChatMessagesDimensions();
        window.addEventListener("resize", setChatMessagesDimensions);
        $342f7fe00eb414e4$exports.querySelector("#chat-widget-message", function(el) {
            const chatMessageWidget = el[0], chatWidgetMessage = chatWidgetMessages.querySelectorAll(".chat-widget-message"), chatMessageWidgetHeader = chatMessageWidget.querySelector(".chat-widget-header"), chatMessageWidgetConversation = chatMessageWidget.querySelector(".chat-widget-conversation"), chatMessageWidgetCloseButton = chatMessageWidget.querySelector(".chat-widget-close-button"), hiddenClass = "hidden";
            const setChatConversationDimensions = function() {
                chatMessageWidgetConversation.style.height = `${window.innerHeight - chatMessageWidgetHeader.offsetHeight - chatWidgetForm.offsetHeight - chatWidgetButton.offsetHeight - topOffset}px`;
            };
            const toggleChatMessageWidget = function() {
                chatMessageWidget.classList.toggle(hiddenClass);
            };
            const closeChatMessageWidget = function() {
                chatMessageWidget.classList.add(hiddenClass);
            };
            for (const widgetMessage of chatWidgetMessage){
                widgetMessage.addEventListener("click", toggleChatMessageWidget);
                widgetMessage.addEventListener("click", openChatWidget);
            }
            chatWidgetButton.addEventListener("click", closeChatMessageWidget);
            chatMessageWidgetCloseButton.addEventListener("click", toggleChatMessageWidget);
            setChatConversationDimensions();
            window.addEventListener("resize", setChatConversationDimensions);
        });
    });
    /*------------------------
      NAVIGATION WIDGET 
  ------------------------*/ $342f7fe00eb414e4$exports.querySelector(".navigation-widget-trigger", function(el) {
        const navigationTrigger = el[0], topOffset = 80, navigationWidget = document.querySelector("#navigation-widget"), navigationWidgetSmall = document.querySelector("#navigation-widget-small"), activeClass = "active", hiddenClass = "hidden", delayedClass = "delayed";
        const setNavigationWidgetDimensions = function() {
            navigationWidget.style.height = `${window.innerHeight - topOffset}px`;
        };
        const toggleNavigationWidget = function() {
            navigationTrigger.classList.toggle(activeClass);
            navigationWidget.classList.toggle(delayedClass);
            navigationWidget.classList.toggle(hiddenClass);
            navigationWidgetSmall.classList.toggle(delayedClass);
            navigationWidgetSmall.classList.toggle(hiddenClass);
            sidebar.navigation.active = !navigationWidget.classList.contains(hiddenClass);
            updateGridPositions();
        };
        navigationTrigger.addEventListener("click", toggleNavigationWidget);
        setNavigationWidgetDimensions();
        window.addEventListener("resize", setNavigationWidgetDimensions);
    });
    /*-------------------------------
      NAVIGATION WIDGET MOBILE
  -------------------------------*/ $342f7fe00eb414e4$exports.querySelector(".navigation-widget-mobile-trigger", function(el) {
        const navigationMobileTrigger = el[0], navigationWidgetMobile = document.querySelector("#navigation-widget-mobile"), navigationWidgetMobileCloseButton = navigationWidgetMobile.querySelector(".navigation-widget-close-button"), hiddenClass = "hidden";
        const overlay = document.createElement("div");
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.zIndex = 99998;
        overlay.style.backgroundColor = "rgba(21, 21, 31, .96)";
        overlay.style.opacity = 0;
        overlay.style.visibility = "hidden";
        overlay.style.transition = "opacity .3s ease-in-out, visibility .3s ease-in-out";
        document.body.appendChild(overlay);
        const showOverlay = function() {
            overlay.style.opacity = 1;
            overlay.style.visibility = "visible";
        };
        const hideOverlay = function() {
            overlay.style.opacity = 0;
            overlay.style.visibility = "hidden";
        };
        const setNavigationWidgetMobileDimensions = function() {
            navigationWidgetMobile.style.height = `${window.innerHeight}px`;
        };
        const toggleNavigationWidgetMobile = function() {
            navigationWidgetMobile.classList.toggle(hiddenClass);
            const toggleOverlay = navigationWidgetMobile.classList.contains(hiddenClass) ? hideOverlay : showOverlay;
            toggleOverlay();
        };
        navigationMobileTrigger.addEventListener("click", toggleNavigationWidgetMobile);
        navigationWidgetMobileCloseButton.addEventListener("click", toggleNavigationWidgetMobile);
        overlay.addEventListener("click", toggleNavigationWidgetMobile);
        setNavigationWidgetMobileDimensions();
        window.addEventListener("resize", setNavigationWidgetMobileDimensions);
    });
});



$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-148-164",
    width: 148,
    height: 164,
    roundedCorners: true,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-progress-124-136",
    width: 124,
    height: 136,
    lineWidth: 8,
    roundedCorners: true,
    gradient: {
        colors: [
            "#d9ff65",
            "#40d04f"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: .74
    }
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-border-124-136",
    width: 124,
    height: 136,
    lineWidth: 8,
    roundedCorners: true,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-100-110",
    width: 100,
    height: 110,
    roundedCorners: true,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-120-132",
    width: 120,
    height: 132,
    roundedCorners: true,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-progress-100-110",
    width: 100,
    height: 110,
    lineWidth: 6,
    roundedCorners: true,
    gradient: {
        colors: [
            "#d9ff65",
            "#40d04f"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: .8
    }
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-border-100-110",
    width: 100,
    height: 110,
    lineWidth: 6,
    roundedCorners: true,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-82-90",
    width: 82,
    height: 90,
    roundedCorners: true,
    roundedCornerRadius: 3,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-100-110",
    width: 100,
    height: 110,
    roundedCorners: true,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-progress-84-92",
    width: 84,
    height: 92,
    lineWidth: 5,
    roundedCorners: true,
    roundedCornerRadius: 3,
    gradient: {
        colors: [
            "#d9ff65",
            "#40d04f"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: .8
    }
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-border-84-92",
    width: 84,
    height: 92,
    lineWidth: 5,
    roundedCorners: true,
    roundedCornerRadius: 3,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-68-74",
    width: 68,
    height: 74,
    roundedCorners: true,
    roundedCornerRadius: 3,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-50-56",
    width: 50,
    height: 56,
    roundedCorners: true,
    roundedCornerRadius: 2,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-progress-40-44",
    width: 40,
    height: 44,
    lineWidth: 3,
    roundedCorners: true,
    roundedCornerRadius: 1,
    gradient: {
        colors: [
            "#d9ff65",
            "#40d04f"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: .8
    }
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-border-40-44",
    width: 40,
    height: 44,
    lineWidth: 3,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-30-32",
    width: 30,
    height: 32,
    roundedCorners: true,
    roundedCornerRadius: 1,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-40-44",
    width: 40,
    height: 44,
    roundedCorners: true,
    roundedCornerRadius: 1,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-dark-32-34",
    width: 32,
    height: 34,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#7750f8",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-32-36",
    width: 32,
    height: 36,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#1d2333",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-dark-26-28",
    width: 26,
    height: 28,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#7750f8",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-28-32",
    width: 28,
    height: 32,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#1d2333",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-dark-22-24",
    width: 22,
    height: 24,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#7750f8",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-22-24",
    width: 22,
    height: 24,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#1d2333",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-dark-16-18",
    width: 16,
    height: 18,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "#7750f8",
    fill: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-120-130",
    width: 120,
    height: 130,
    roundedCorners: true,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-100-108",
    width: 100,
    height: 108,
    roundedCorners: true,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-124-136",
    width: 124,
    height: 136,
    roundedCorners: true,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-84-92",
    width: 84,
    height: 92,
    roundedCorners: true,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-34-36",
    width: 34,
    height: 36,
    roundedCorners: true,
    roundedCornerRadius: 1,
    fill: true,
    lineColor: "#1d2333"
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-40-44",
    width: 40,
    height: 44,
    roundedCorners: true,
    roundedCornerRadius: 1,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-24-26",
    width: 24,
    height: 26,
    roundedCorners: true,
    roundedCornerRadius: 1,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-image-18-20",
    width: 18,
    height: 20,
    roundedCorners: true,
    roundedCornerRadius: 1,
    clip: true
});
$007db0a3d89c8a26$exports.createHexagon({
    container: ".hexagon-overlay-30-32",
    width: 30,
    height: 32,
    roundedCorners: true,
    roundedCornerRadius: 1,
    lineColor: "rgba(97, 93, 250, .9)",
    fill: true
});


window.initMap = function() {
    new google.maps.Map(document.getElementById("g-map"), {
        center: {
            lat: 44.934084,
            lng: -93.252358
        },
        zoom: 15,
        disableDefaultUI: false
    });
};



/*-----------------------
    EXP TO NEXT LEVEL
-----------------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#exp-to-next-level",
    height: 6,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#exp-to-next-level",
    height: 6,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 200,
        stop: 162
    },
    linkText: true,
    linkUnits: "exp",
    invertedProgress: true,
    animateOnScroll: true
});
/*----------------
    BADGE ITEM
----------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-bronze",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-bronze",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-silver",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-silver",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 100
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-gold",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-gold",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 500,
        stop: 461
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-platinum",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-platinum",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1000,
        stop: 461
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-traveller",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-traveller",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 5,
        stop: 4
    },
    invertedProgress: true,
    linkText: true,
    linkUnits: "topics",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-caffeinated",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-caffeinated",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 0
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-upowered",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-upowered",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 42
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-scientist",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-scientist",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-ncreature",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-ncreature",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 100
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-warrior",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-warrior",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-liked",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-liked",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 500,
        stop: 462
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-sloved",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-sloved",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1000,
        stop: 462
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-qconq",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-qconq",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 4
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-villain",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-villain",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 89
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-age",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-age",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 730,
        stop: 605
    },
    invertedProgress: true,
    linkText: true,
    linkUnits: "days",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-tstruck",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-tstruck",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 41
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-uexp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-uexp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 20,
        stop: 17
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-globet",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-globet",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 8
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-verifieds",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-verifieds",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-gempost",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-gempost",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 0
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-peoplesp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-peoplesp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 200,
        stop: 181
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-rulerm",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-rulerm",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 5,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-marketeer",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-marketeer",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 7
    },
    invertedProgress: true,
    linkText: true,
    linkUnits: "items",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-tycoon",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-tycoon",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 32
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-mightiers",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-mightiers",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 26
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-phantom",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-phantom",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-forumsf",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-forumsf",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 20,
        stop: 13
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-fcultivator",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-fcultivator",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 33
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-splanner",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-splanner",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 25,
        stop: 9
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-collector",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-collector",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 5,
        stop: 2
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-prophoto",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-prophoto",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 500,
        stop: 24
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-rmachine",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-rmachine",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 41
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-bronzec",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-bronzec",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-silverc",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-silverc",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-goldc",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-goldc",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 1
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-platinumc",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#badge-platinumc",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 1,
        stop: 0
    },
    linkText: true,
    linkUnits: "/",
    emptyText: "locked",
    completeText: "unlocked!"
});
/*-------------------
    QUEST PREVIEW
-------------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-nth",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-nth",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 65
    },
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-sk",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-sk",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 85
    },
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-bp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-bp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 32
    },
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-htp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-htp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 0
    },
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-sm",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-preview-sm",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 49
    },
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-sk",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-sk",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 8,
        stop: 7
    },
    linkText: true,
    linkUnits: "/"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-fu",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-fu",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 50
    },
    linkText: true,
    linkUnits: "/"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-nth",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-nth",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 67
    },
    linkText: true,
    linkUnits: "%"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-sm",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-sm",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 5
    },
    linkText: true,
    linkUnits: "/"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-ps",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-ps",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 100
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-nth",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-nth",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 67
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-fu",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-fu",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 50,
        stop: 50
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-ph",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-ph",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 20,
        stop: 20
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-tr",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-tr",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 2
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-sk",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-sk",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 8,
        stop: 7
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-bp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-bp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 30,
        stop: 12
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-htp",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-htp",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 0
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-sm",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#quest-line-sm",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 10,
        stop: 5
    },
    linkText: true,
    linkUnits: "/",
    animateOnScroll: true
});
/*------------------
    POLL RESULT
------------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-1",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-1",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 62
    },
    linkText: true,
    linkUnits: "%"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-2",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-2",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 27
    },
    linkText: true,
    linkUnits: "%"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-3",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#poll-result-3",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 11
    },
    linkText: true,
    linkUnits: "%"
});
/*---------------------
    POST ENGAGEMENT
---------------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-1",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-1",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 89
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-2",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-2",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 74
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-3",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-3",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 53
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-4",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-4",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 48
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-5",
    height: 4,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#post-engagement-5",
    height: 4,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 100,
        stop: 21
    },
    linkText: true,
    linkUnits: "%",
    animateOnScroll: true
});
/*-----------------
    TOP COUNTRY
-----------------*/ $007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-1",
    width: 178,
    height: 6,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-1",
    width: 178,
    height: 6,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 25362,
        stop: 25362
    },
    split: {
        parts: 30,
        gap: 2,
        color: "#1d2333"
    },
    linkText: true,
    linkUnits: false,
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-2",
    width: 178,
    height: 6,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-2",
    width: 178,
    height: 6,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 25362,
        stop: 18201
    },
    split: {
        parts: 30,
        gap: 2,
        color: "#1d2333"
    },
    linkText: true,
    linkUnits: false,
    animateOnScroll: true
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-3",
    width: 178,
    height: 6,
    lineColor: "#293249"
});
$007db0a3d89c8a26$exports.createProgressBar({
    container: "#top-country-3",
    width: 178,
    height: 6,
    gradient: {
        colors: [
            "#40d04f",
            "#d9ff65"
        ]
    },
    scale: {
        start: 0,
        end: 25362,
        stop: 9567
    },
    split: {
        parts: 30,
        gap: 2,
        color: "#1d2333"
    },
    linkText: true,
    linkUnits: false,
    animateOnScroll: true
});



/*---------------------
    PROFILE HEADER 
---------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#profile-header-social-links-slider",
    items: 4,
    fixedWidth: 32,
    gutter: 8,
    loop: false,
    nav: false,
    controlsContainer: "#profile-header-social-links-slider-controls",
    responsive: {
        481: {
            fixedWidth: 40,
            gutter: 12
        }
    }
});
/*-------------------------
    SECTION NAVIGATION
-------------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#section-navigation-slider",
    fixedWidth: 122,
    nav: false,
    loop: false,
    controlsContainer: "#section-navigation-slider-controls"
});
/*-------------------------
    SECTION NAVIGATION
-------------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#section-navigation-medium-slider",
    fixedWidth: 160,
    nav: false,
    loop: false,
    controlsContainer: "#section-navigation-medium-slider-controls"
});
/*------------------------
    USER STATS SLIDER
------------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#user-stats-slider",
    fixedWidth: 113,
    nav: false,
    loop: false,
    controlsContainer: "#user-stats-slider-controls"
});
/*---------------------------
    REACTION STATS SLIDER
---------------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#reaction-stats-slider",
    fixedWidth: 146,
    nav: false,
    loop: false,
    controlsContainer: "#reaction-stats-slider-controls"
});
/*---------------------------
    STAT BLOCK SLIDER
---------------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#stat-block-slider",
    fixedWidth: 272,
    nav: false,
    loop: false,
    controlsContainer: "#stat-block-slider-controls"
});
/*-------------------
    STREAM SLIDER
-------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#stream-slider",
    fixedWidth: 184,
    gutter: 16,
    nav: false,
    controlsContainer: "#stream-slider-controls"
});
/*----------------
    STATS BOX
----------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#stats-box-slider-items",
    mode: "gallery",
    nav: false,
    speed: 1000,
    autoplay: true,
    autoplayButtonOutput: false,
    controlsContainer: "#stats-box-slider-controls"
});
/*--------------------
    REACTION STAT
--------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#reaction-stat-slider-items",
    nav: false,
    speed: 600,
    controlsContainer: "#reaction-stat-slider-controls"
});
/*-----------------
    BADGE STAT
-----------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#badge-stat-slider-items",
    nav: false,
    loop: false,
    speed: 600,
    controlsContainer: "#badge-stat-slider-controls"
});
/*-------------------
    PRODUCT BOX
-------------------*/ $007db0a3d89c8a26$exports.createSlider({
    container: "#product-box-slider-items",
    mode: "gallery",
    speed: 1000,
    autoplay: true,
    autoplayButtonOutput: false,
    controlsContainer: "#product-box-slider-controls",
    navContainer: "#product-box-slider-roster"
});
/*-------------------------
    USER PREVIEW STATS 
-------------------------*/ const $6e5e127e70e5eeb6$var$createUserPreviewStatsSliders = function() {
    let i = 1;
    while(true){
        const j = i < 10 ? `0${i}` : i;
        const upStatsSlider = $007db0a3d89c8a26$exports.createSlider({
            container: `#user-preview-stats-slides-${j}`,
            loop: false,
            controls: false,
            navContainer: `#user-preview-stats-roster-${j}`
        });
        if (!upStatsSlider) break;
        i++;
    }
};
$6e5e127e70e5eeb6$var$createUserPreviewStatsSliders();
const $6e5e127e70e5eeb6$var$centerTinySlider = function(sliderInfo, itemWidth, gutterWidth) {
    sliderInfo.container.style.width = `${sliderInfo.slideCount * itemWidth + (sliderInfo.slideCount - 1) * gutterWidth}px`;
};
/*--------------------------------
    USER PREVIEW SOCIAL LINKS
--------------------------------*/ const $6e5e127e70e5eeb6$var$createUserPreviewSocialLinksSliders = function() {
    let i = 1;
    while(true){
        const j = i < 10 ? `0${i}` : i;
        const upSocialLinkSlider = $007db0a3d89c8a26$exports.createSlider({
            container: `#user-preview-social-links-slider-${j}`,
            items: 4,
            fixedWidth: 32,
            gutter: 8,
            loop: false,
            nav: false,
            controlsContainer: `#user-preview-social-links-slider-controls-${j}`
        });
        if (!upSocialLinkSlider) break;
        $6e5e127e70e5eeb6$var$centerTinySlider(upSocialLinkSlider.getInfo(), 32, 8);
        i++;
    }
};
$6e5e127e70e5eeb6$var$createUserPreviewSocialLinksSliders();



$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".widget-box-post-settings-dropdown-trigger",
    container: ".widget-box-post-settings-dropdown",
    offset: {
        top: 30,
        right: 9
    },
    animation: {
        type: "translate-top",
        speed: .3,
        translateOffset: {
            vertical: 20
        }
    }
});
$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".reaction-item-dropdown-trigger",
    container: ".reaction-item-dropdown",
    triggerEvent: "hover",
    offset: {
        bottom: 38,
        left: -16
    },
    animation: {
        type: "translate-bottom",
        speed: .3,
        translateOffset: {
            vertical: 20
        }
    }
});
$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".reaction-options-dropdown-trigger",
    container: ".reaction-options-dropdown",
    triggerEvent: "click",
    offset: {
        bottom: 54,
        left: -16
    },
    animation: {
        type: "translate-bottom",
        speed: .3,
        translateOffset: {
            vertical: 20
        }
    },
    closeOnDropdownClick: true
});
$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".reaction-options-small-dropdown-trigger",
    container: ".reaction-options-small-dropdown",
    triggerEvent: "click",
    offset: {
        bottom: 30,
        left: -80
    },
    animation: {
        type: "translate-bottom",
        speed: .3,
        translateOffset: {
            vertical: 16
        }
    },
    closeOnDropdownClick: true
});
$007db0a3d89c8a26$exports.createDropdown({
    trigger: ".post-settings-dropdown-trigger",
    container: ".post-settings-dropdown",
    offset: {
        bottom: 30,
        right: 0
    },
    animation: {
        type: "translate-bottom",
        speed: .3,
        translateOffset: {
            vertical: 16
        }
    }
});



$007db0a3d89c8a26$exports.createTab({
    triggers: ".tab-box-option",
    elements: ".tab-box-item"
});




const $07e1364b7c9ced68$var$getLabelNumbers = function(count) {
    const labels = [];
    for(let i = 1; i <= count; i++){
        const label = i < 10 ? `0${i}` : i.toString();
        labels.push(label);
    }
    return labels;
};
const $07e1364b7c9ced68$var$getCompleterData = function(datasetsData, maxValue) {
    const completerData = new Array(datasetsData[0].length).fill(maxValue);
    for(let i = 0; i < datasetsData.length; i++)for(let j = 0; j < datasetsData[i].length; j++)completerData[j] -= datasetsData[i][j];
    return completerData;
};
/*------------------------
    ENGAGEMENTS CHART
------------------------*/ $342f7fe00eb414e4$exports.querySelector("#engagements-chart", function(el) {
    const canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        datasets: [
            {
                data: [
                    18.3,
                    5.2,
                    1.4,
                    3.9
                ],
                backgroundColor: [
                    "#7750f8",
                    "#4ff461",
                    "#08b8f1",
                    "#00e2cb"
                ],
                hoverBackgroundColor: [
                    "#7750f8",
                    "#4ff461",
                    "#08b8f1",
                    "#00e2cb"
                ],
                borderWidth: 0
            }
        ],
        labels: [
            "Reactions",
            "Comments",
            "Shares",
            "Replies"
        ]
    }, chartOptions = {
        cutoutPercentage: 88,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            callbacks: {
                label: function(tooltipItem, data) {
                    const labelText = data.datasets[0].data[tooltipItem.index] + "K";
                    return labelText;
                }
            }
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
    });
});
/*-------------------------------------
    VE MONTHLY REPORT RATIO CHART
-------------------------------------*/ $342f7fe00eb414e4$exports.querySelector("#ve-monthly-report-ratio-chart", function(el) {
    const canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        datasets: [
            {
                data: [
                    12.5,
                    87.5
                ],
                backgroundColor: [
                    "#7750f8",
                    "#4ff461"
                ],
                hoverBackgroundColor: [
                    "#7750f8",
                    "#4ff461"
                ],
                borderWidth: 0
            }
        ],
        labels: [
            "Engagements",
            "Visits"
        ]
    }, chartOptions = {
        cutoutPercentage: 74,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            callbacks: {
                label: function(tooltipItem, data) {
                    const labelText = data.datasets[0].data[tooltipItem.index] + "%";
                    return labelText;
                }
            }
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
    });
});
/*-------------------------------
    PROFILE COMPLETION CHART
-------------------------------*/ $342f7fe00eb414e4$exports.querySelector("#profile-completion-chart", function(el) {
    const canvas = el[0], ctx = canvas.getContext("2d"), gradient = ctx.createLinearGradient(0, 70, 140, 70);
    gradient.addColorStop(0, "#d9ff65");
    gradient.addColorStop(1, "#40d04f");
    const chartData = {
        datasets: [
            {
                data: [
                    59,
                    41
                ],
                backgroundColor: [
                    gradient,
                    "#293249"
                ],
                hoverBackgroundColor: [
                    gradient,
                    "#293249"
                ],
                borderWidth: 0
            }
        ]
    }, chartOptions = {
        cutoutPercentage: 88,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        animation: {
            animateRotate: false
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
    });
});
/*-----------------------------
    POSTS ENGAGEMENT CHART
-----------------------------*/ $342f7fe00eb414e4$exports.querySelector("#posts-engagement-chart", function(el) {
    const canvas = el[0], ctx = canvas.getContext("2d"), gradient = ctx.createLinearGradient(0, 40, 80, 40);
    gradient.addColorStop(0, "#41efff");
    gradient.addColorStop(1, "#615dfa");
    const chartData = {
        datasets: [
            {
                data: [
                    87,
                    13
                ],
                backgroundColor: [
                    gradient,
                    "#e8e8ef"
                ],
                hoverBackgroundColor: [
                    gradient,
                    "#e8e8ef"
                ],
                borderWidth: 0
            }
        ]
    }, chartOptions = {
        cutoutPercentage: 85,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        animation: {
            animateRotate: false
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
    });
});
/*-------------------------
    POSTS SHARED CHART
-------------------------*/ $342f7fe00eb414e4$exports.querySelector("#posts-shared-chart", function(el) {
    const canvas = el[0], ctx = canvas.getContext("2d"), gradient = ctx.createLinearGradient(0, 40, 80, 40);
    gradient.addColorStop(0, "#41efff");
    gradient.addColorStop(1, "#615dfa");
    const chartData = {
        datasets: [
            {
                data: [
                    42,
                    58
                ],
                backgroundColor: [
                    gradient,
                    "#e8e8ef"
                ],
                hoverBackgroundColor: [
                    gradient,
                    "#e8e8ef"
                ],
                borderWidth: 0
            }
        ]
    }, chartOptions = {
        cutoutPercentage: 85,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        animation: {
            animateRotate: false
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
    });
});
/*------------------------------
    VE MONTHLY REPORT CHART
------------------------------*/ $342f7fe00eb414e4$exports.querySelector("#ve-monthly-report-chart", function(el) {
    const datasetData1 = [
        20,
        15,
        22,
        26,
        12,
        16,
        24,
        13,
        17,
        9,
        26,
        21,
        14,
        21,
        17,
        23,
        30,
        18,
        24,
        15,
        28,
        17,
        13,
        23,
        16,
        12,
        23,
        16,
        24,
        13,
        22
    ], datasetData2 = [
        9,
        28,
        6,
        9,
        17,
        7,
        16,
        12,
        10,
        11,
        12,
        3,
        13,
        11,
        8,
        17,
        13,
        16,
        5,
        19,
        14,
        11,
        26,
        8,
        4,
        15,
        16,
        25,
        5,
        13,
        12
    ], canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        labels: $07e1364b7c9ced68$var$getLabelNumbers(31),
        datasets: [
            {
                label: "Engagements",
                data: datasetData1,
                maxBarThickness: 16,
                backgroundColor: "#7750f8"
            },
            {
                label: "Visits",
                data: datasetData2,
                maxBarThickness: 16,
                backgroundColor: "#4ff461"
            },
            {
                data: $07e1364b7c9ced68$var$getCompleterData([
                    datasetData1,
                    datasetData2
                ], 55),
                maxBarThickness: 16,
                backgroundColor: "#2f3749"
            }
        ]
    }, chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            displayColors: false,
            callbacks: {
                title: function() {}
            }
        },
        scales: {
            xAxes: [
                {
                    stacked: true,
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500
                    }
                }
            ],
            yAxes: [
                {
                    stacked: true,
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 20,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500,
                        max: 55,
                        stepSize: 5
                    }
                }
            ]
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "bar",
        data: chartData,
        options: chartOptions
    });
});
/*-----------------------------
    RC YEARLY REPORT CHART
-----------------------------*/ $342f7fe00eb414e4$exports.querySelector("#rc-yearly-report-chart", function(el) {
    const datasetData1 = [
        119,
        142,
        110,
        122,
        163,
        139,
        143,
        110,
        141,
        121,
        139,
        190
    ], datasetData2 = [
        98,
        65,
        132,
        78,
        112,
        82,
        100,
        80,
        100,
        58,
        48,
        139
    ], canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        datasets: [
            {
                label: "Reactions",
                data: datasetData1,
                fill: false,
                lineTension: 0,
                borderWidth: 4,
                borderColor: "#4ff461",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "bevel",
                pointBorderColor: "#4ff461",
                pointBackgroundColor: "#1d2333",
                pointBorderWidth: 4,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "#1d2333",
                pointHoverBorderColor: "#4ff461",
                pointHoverBorderWidth: 4,
                pointRadius: 5,
                pointHitRadius: 10
            },
            {
                label: "Comments",
                data: datasetData2,
                fill: false,
                lineTension: 0,
                borderWidth: 4,
                borderColor: "#08b8f1",
                borderCapStyle: "bevel",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "bevel",
                pointBorderColor: "#08b8f1",
                pointBackgroundColor: "#1d2333",
                pointBorderWidth: 4,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "#1d2333",
                pointHoverBorderColor: "#08b8f1",
                pointHoverBorderWidth: 4,
                pointRadius: 5,
                pointHitRadius: 10
            }
        ]
    }, chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            displayColors: false,
            callbacks: {
                title: function() {}
            }
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 14,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false
                    },
                    ticks: {
                        padding: 20,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500,
                        min: 20,
                        max: 220,
                        stepSize: 40
                    }
                }
            ]
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "line",
        data: chartData,
        options: chartOptions
    });
});
/*---------------------------
    VS PERFORMANCE CHART
---------------------------*/ $342f7fe00eb414e4$exports.querySelector("#vs-performance-chart", function(el) {
    const datasetData1 = [
        140,
        90,
        155,
        180
    ], datasetData2 = [
        120,
        25,
        130,
        110
    ], canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        labels: [
            "Aug",
            "Sep",
            "Oct",
            "Nov"
        ],
        datasets: [
            {
                label: "Views",
                data: datasetData1,
                maxBarThickness: 16,
                backgroundColor: "#7750f8"
            },
            {
                label: "Sales",
                data: datasetData2,
                maxBarThickness: 16,
                backgroundColor: "#4ff461"
            }
        ]
    }, chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            displayColors: false,
            callbacks: {
                title: function() {}
            }
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        display: false
                    }
                }
            ]
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "bar",
        data: chartData,
        options: chartOptions
    });
});
/*---------------------------
    EARNINGS REPORT CHART
---------------------------*/ $342f7fe00eb414e4$exports.querySelector("#earnings-report-chart", function(el) {
    const datasetData = [
        0,
        15,
        0,
        0,
        0,
        20,
        10,
        15,
        40,
        20,
        25,
        25,
        15,
        10,
        20,
        23,
        23,
        15,
        30,
        40,
        30,
        20,
        25,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        labels: $07e1364b7c9ced68$var$getLabelNumbers(31),
        datasets: [
            {
                label: "Earnings",
                data: datasetData,
                lineTension: .5,
                borderWidth: 2,
                backgroundColor: "rgba(79, 244, 97, .2)",
                borderColor: "#4ff461",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "bevel",
                pointBorderColor: "#1d2333",
                pointBackgroundColor: "#4ff461",
                pointBorderWidth: 2,
                pointHoverRadius: 4,
                pointHoverBorderColor: "#1d2333",
                pointHoverBackgroundColor: "#4ff461",
                pointHoverBorderWidth: 2,
                pointRadius: 4,
                pointHitRadius: 5
            }
        ]
    }, chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            displayColors: false,
            callbacks: {
                title: function() {}
            }
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 14,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false
                    },
                    ticks: {
                        padding: 20,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500,
                        max: 55,
                        stepSize: 5,
                        callback: function(value, index, values) {
                            return "$" + value;
                        }
                    }
                }
            ]
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "line",
        data: chartData,
        options: chartOptions
    });
});
/*---------------------------
    MEMBERS REPORT CHART
---------------------------*/ $342f7fe00eb414e4$exports.querySelector("#members-report-chart", function(el) {
    const datasetData = [
        8,
        4,
        8,
        5,
        10,
        13,
        11,
        11,
        13,
        17,
        5,
        12
    ], canvas = el[0], ctx = canvas.getContext("2d"), chartData = {
        labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        datasets: [
            {
                label: "Members",
                data: datasetData,
                lineTension: 0,
                borderWidth: 2,
                backgroundColor: "rgba(119, 80, 248, .1)",
                borderColor: "#7750f8",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "bevel",
                pointBorderColor: "#7750f8",
                pointBackgroundColor: "#1d2333",
                pointBorderWidth: 2,
                pointHoverRadius: 4,
                pointHoverBorderColor: "#7750f8",
                pointHoverBackgroundColor: "#1d2333",
                pointHoverBorderWidth: 2,
                pointRadius: 4,
                pointHitRadius: 5
            }
        ]
    }, chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            bodyFontFamily: "'Titillium Web', sans-serif",
            displayColors: false,
            callbacks: {
                title: function() {}
            }
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 14,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        color: "rgba(47, 55, 73, 1)",
                        zeroLineColor: "rgba(47, 55, 73, 1)",
                        drawBorder: false
                    },
                    ticks: {
                        padding: 20,
                        fontFamily: "'Rajdhani', sans-serif",
                        fontColor: "#9aa4bf",
                        fontSize: 12,
                        fontStyle: 500,
                        max: 20,
                        stepSize: 2,
                        beginAtZero: true
                    }
                }
            ]
        }
    };
    $007db0a3d89c8a26$exports.createChart(ctx, {
        type: "line",
        data: chartData,
        options: chartOptions
    });
});



$342f7fe00eb414e4$exports.querySelector(".tweet-feed", function(tweetFeeds) {
    const wrapHashtag = function(text) {
        const regex = /(#\w+)\s/igm;
        return text.replace(regex, '<span class="highlighted">$1</span> ');
    };
    const wrapAt = function(text) {
        const regex = /(@\w+)\s/igm;
        return text.replace(regex, '<span class="highlighted">$1</span> ');
    };
    const createTweetItem = function(tweetData) {
        const tweet = document.createElement("div"), tweetAuthor = document.createElement("a"), tweetAuthorFigure = document.createElement("figure"), tweetAuthorImage = document.createElement("img"), tweetAuthorTitle = document.createElement("p"), tweetAuthorText = document.createElement("p"), tweetText = document.createElement("a"), tweetTimestamp = document.createElement("p");
        tweet.classList.add("tweet");
        tweetAuthor.classList.add("tweet-author");
        tweetAuthorFigure.classList.add("tweet-author-image", "picture", "tiny", "circle", "liquid");
        tweetAuthorTitle.classList.add("tweet-author-title");
        tweetAuthorText.classList.add("tweet-author-text");
        tweetText.classList.add("tweet-text");
        tweetTimestamp.classList.add("tweet-timestamp");
        tweetAuthorFigure.appendChild(tweetAuthorImage);
        tweetAuthor.appendChild(tweetAuthorFigure);
        tweetAuthor.appendChild(tweetAuthorTitle);
        tweetAuthor.appendChild(tweetAuthorText);
        tweet.appendChild(tweetAuthor);
        tweet.appendChild(tweetText);
        tweet.appendChild(tweetTimestamp);
        const authorURL = `https://twitter.com/${tweetData.user.screen_name}`, tweetURL = tweetData.entities.urls.length ? tweetData.entities.urls[0].url : authorURL, tweetDate = $342f7fe00eb414e4$exports.dateDiff(new Date(tweetData.created_at));
        tweetAuthor.setAttribute("href", authorURL);
        tweetAuthor.setAttribute("target", "_blank");
        tweetAuthorImage.setAttribute("src", tweetData.user.profile_image_url_https);
        tweetAuthorTitle.innerHTML = tweetData.user.name;
        tweetAuthorText.innerHTML = `@${tweetData.user.screen_name}`;
        tweetText.setAttribute("href", tweetURL);
        tweetText.setAttribute("target", "_blank");
        tweetText.innerHTML = wrapAt(wrapHashtag(tweetData.text));
        tweetTimestamp.innerHTML = `${tweetDate.value} ${tweetDate.unit} ago`;
        $342f7fe00eb414e4$exports.liquidifyStatic(tweetAuthorFigure, tweetAuthorImage);
        return tweet;
    };
    const TweetComponent = function(tweetsData) {
        const container = document.createElement("div");
        container.classList.add("tweets");
        for (const tweetData of tweetsData)container.appendChild(createTweetItem(tweetData));
        return container;
    };
    $342f7fe00eb414e4$exports.query({
        url: "includes/getTweets.php?screen_name=YOUR_SCREEN_NAME&count=3"
    }).then(function(response) {
        const tweets = JSON.parse(response);
        for (const tweetFeed of tweetFeeds)tweetFeed.appendChild(TweetComponent(tweets));
    }).catch(function(error) {
        console.log(error);
    });
});


 /*---------------
   Service 
---------------*/  //require('./service/service');


//# sourceMappingURL=404.7640e322.js.map
